"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var webTransport_1 = require("../../shared/modules/webTransport");
var DoEditPProgramTemplateBanner = /** @class */ (function () {
    function DoEditPProgramTemplateBanner() {
    }
    DoEditPProgramTemplateBanner.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgramTemplateBanner.api_name = "api.admin.aff.pprograms.control.doeditpprogramtemplatebanner";
    return DoEditPProgramTemplateBanner;
}());
exports.DoEditPProgramTemplateBanner = DoEditPProgramTemplateBanner;
var DoEditInnerPayWallet = /** @class */ (function () {
    function DoEditInnerPayWallet() {
    }
    DoEditInnerPayWallet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditInnerPayWallet.api_name = "api.admin.app.innerpay.wallets.control.doeditinnerpaywallet";
    return DoEditInnerPayWallet;
}());
exports.DoEditInnerPayWallet = DoEditInnerPayWallet;
var DoEditBrandBrandingCountry = /** @class */ (function () {
    function DoEditBrandBrandingCountry() {
    }
    DoEditBrandBrandingCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandBrandingCountry.api_name = "api.admin.aff.brands.brandings.country.doeditbrandbrandingcountry";
    return DoEditBrandBrandingCountry;
}());
exports.DoEditBrandBrandingCountry = DoEditBrandBrandingCountry;
var ListUsrPartnersPromoCodesByUsrPartnerIdGet = /** @class */ (function () {
    function ListUsrPartnersPromoCodesByUsrPartnerIdGet() {
    }
    ListUsrPartnersPromoCodesByUsrPartnerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListUsrPartnersPromoCodesByUsrPartnerIdGet.api_name = "api.admin.aff.pprograms.usr.partners.promocode.codes.listusrpartnerspromocodesbyusrpartneridget";
    return ListUsrPartnersPromoCodesByUsrPartnerIdGet;
}());
exports.ListUsrPartnersPromoCodesByUsrPartnerIdGet = ListUsrPartnersPromoCodesByUsrPartnerIdGet;
var ListPromoTemplateLocalesByPromoTemplateIdGet = /** @class */ (function () {
    function ListPromoTemplateLocalesByPromoTemplateIdGet() {
    }
    ListPromoTemplateLocalesByPromoTemplateIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPromoTemplateLocalesByPromoTemplateIdGet.api_name = "api.admin.bonus.promocodes.templates.locales.listpromotemplatelocalesbypromotemplateidget";
    return ListPromoTemplateLocalesByPromoTemplateIdGet;
}());
exports.ListPromoTemplateLocalesByPromoTemplateIdGet = ListPromoTemplateLocalesByPromoTemplateIdGet;
var DoEditBonusPlayerLevelAttribute = /** @class */ (function () {
    function DoEditBonusPlayerLevelAttribute() {
    }
    DoEditBonusPlayerLevelAttribute.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusPlayerLevelAttribute.api_name = "api.admin.bonus.levels.attributes.doeditbonusplayerlevelattribute";
    return DoEditBonusPlayerLevelAttribute;
}());
exports.DoEditBonusPlayerLevelAttribute = DoEditBonusPlayerLevelAttribute;
var ListAllowedGwsGameProvicersByBrandIdAndCurrencyIdGet = /** @class */ (function () {
    function ListAllowedGwsGameProvicersByBrandIdAndCurrencyIdGet() {
    }
    ListAllowedGwsGameProvicersByBrandIdAndCurrencyIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedGwsGameProvicersByBrandIdAndCurrencyIdGet.api_name = "api.admin.gws.gameprovider.control.listallowedgwsgameprovicersbybrandidandcurrencyidget";
    return ListAllowedGwsGameProvicersByBrandIdAndCurrencyIdGet;
}());
exports.ListAllowedGwsGameProvicersByBrandIdAndCurrencyIdGet = ListAllowedGwsGameProvicersByBrandIdAndCurrencyIdGet;
var DoCheckBrandEmailSetTemplate = /** @class */ (function () {
    function DoCheckBrandEmailSetTemplate() {
    }
    DoCheckBrandEmailSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCheckBrandEmailSetTemplate.api_name = "api.admin.brands.templates.control.email.set.control.docheckbrandemailsettemplate";
    return DoCheckBrandEmailSetTemplate;
}());
exports.DoCheckBrandEmailSetTemplate = DoCheckBrandEmailSetTemplate;
var DoSetCountryIsDeprecated = /** @class */ (function () {
    function DoSetCountryIsDeprecated() {
    }
    DoSetCountryIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetCountryIsDeprecated.api_name = "api.admin.app.country.control.dosetcountryisdeprecated";
    return DoSetCountryIsDeprecated;
}());
exports.DoSetCountryIsDeprecated = DoSetCountryIsDeprecated;
var DoEditGameSetGameBotWin = /** @class */ (function () {
    function DoEditGameSetGameBotWin() {
    }
    DoEditGameSetGameBotWin.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditGameSetGameBotWin.api_name = "api.admin.cms.gameset.games.botwins.doeditgamesetgamebotwin";
    return DoEditGameSetGameBotWin;
}());
exports.DoEditGameSetGameBotWin = DoEditGameSetGameBotWin;
var DetailsWagerNoDepBonusInstanceConfigGet = /** @class */ (function () {
    function DetailsWagerNoDepBonusInstanceConfigGet() {
    }
    DetailsWagerNoDepBonusInstanceConfigGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsWagerNoDepBonusInstanceConfigGet.api_name = "api.admin.users.players.bonuses.config.wager_no_dep.detailswagernodepbonusinstanceconfigget";
    return DetailsWagerNoDepBonusInstanceConfigGet;
}());
exports.DetailsWagerNoDepBonusInstanceConfigGet = DetailsWagerNoDepBonusInstanceConfigGet;
var DoDeleteTournamentAmount = /** @class */ (function () {
    function DoDeleteTournamentAmount() {
    }
    DoDeleteTournamentAmount.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteTournamentAmount.api_name = "api.admin.bonus.tournaments.amounts.dodeletetournamentamount";
    return DoDeleteTournamentAmount;
}());
exports.DoDeleteTournamentAmount = DoDeleteTournamentAmount;
var DoEditAdmin = /** @class */ (function () {
    function DoEditAdmin() {
    }
    DoEditAdmin.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditAdmin.api_name = "api.admin.users.admins.doeditadmin";
    return DoEditAdmin;
}());
exports.DoEditAdmin = DoEditAdmin;
var ListUsrPlayerSmsLogsByPlayerIdAndDateRangeGet = /** @class */ (function () {
    function ListUsrPlayerSmsLogsByPlayerIdAndDateRangeGet() {
    }
    ListUsrPlayerSmsLogsByPlayerIdAndDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListUsrPlayerSmsLogsByPlayerIdAndDateRangeGet.api_name = "api.admin.users.players.logs.sms.listusrplayersmslogsbyplayeridanddaterangeget";
    return ListUsrPlayerSmsLogsByPlayerIdAndDateRangeGet;
}());
exports.ListUsrPlayerSmsLogsByPlayerIdAndDateRangeGet = ListUsrPlayerSmsLogsByPlayerIdAndDateRangeGet;
var DoAddTournamentTicket = /** @class */ (function () {
    function DoAddTournamentTicket() {
    }
    DoAddTournamentTicket.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddTournamentTicket.api_name = "api.admin.bonus.tournaments.tickets.doaddtournamentticket";
    return DoAddTournamentTicket;
}());
exports.DoAddTournamentTicket = DoAddTournamentTicket;
var DoAddBrandGwsGameProvider = /** @class */ (function () {
    function DoAddBrandGwsGameProvider() {
    }
    DoAddBrandGwsGameProvider.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandGwsGameProvider.api_name = "api.admin.brands.gws.gameprovider.control.doaddbrandgwsgameprovider";
    return DoAddBrandGwsGameProvider;
}());
exports.DoAddBrandGwsGameProvider = DoAddBrandGwsGameProvider;
var DoEditBrandBranding = /** @class */ (function () {
    function DoEditBrandBranding() {
    }
    DoEditBrandBranding.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandBranding.api_name = "api.admin.aff.brands.brandings.control.doeditbrandbranding";
    return DoEditBrandBranding;
}());
exports.DoEditBrandBranding = DoEditBrandBranding;
var DoAddPProgramNews = /** @class */ (function () {
    function DoAddPProgramNews() {
    }
    DoAddPProgramNews.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramNews.api_name = "api.admin.aff.pprograms.news.control.doaddpprogramnews";
    return DoAddPProgramNews;
}());
exports.DoAddPProgramNews = DoAddPProgramNews;
var ListUsrPartnerMessageByPartnerIdGet = /** @class */ (function () {
    function ListUsrPartnerMessageByPartnerIdGet() {
    }
    ListUsrPartnerMessageByPartnerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListUsrPartnerMessageByPartnerIdGet.api_name = "api.admin.aff.pprograms.usr.partners.messages.listusrpartnermessagebypartneridget";
    return ListUsrPartnerMessageByPartnerIdGet;
}());
exports.ListUsrPartnerMessageByPartnerIdGet = ListUsrPartnerMessageByPartnerIdGet;
var DoEditWagerOnDepBonusTemplateConfig = /** @class */ (function () {
    function DoEditWagerOnDepBonusTemplateConfig() {
    }
    DoEditWagerOnDepBonusTemplateConfig.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditWagerOnDepBonusTemplateConfig.api_name = "api.admin.bonus.templates.config.wager_on_dep.doeditwagerondepbonustemplateconfig";
    return DoEditWagerOnDepBonusTemplateConfig;
}());
exports.DoEditWagerOnDepBonusTemplateConfig = DoEditWagerOnDepBonusTemplateConfig;
var DoAddBrandBranding = /** @class */ (function () {
    function DoAddBrandBranding() {
    }
    DoAddBrandBranding.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandBranding.api_name = "api.admin.aff.brands.brandings.control.doaddbrandbranding";
    return DoAddBrandBranding;
}());
exports.DoAddBrandBranding = DoAddBrandBranding;
var DoDeleteBonusEventBinding = /** @class */ (function () {
    function DoDeleteBonusEventBinding() {
    }
    DoDeleteBonusEventBinding.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusEventBinding.api_name = "api.admin.bonus.events.bindings.control.dodeletebonuseventbinding";
    return DoDeleteBonusEventBinding;
}());
exports.DoDeleteBonusEventBinding = DoDeleteBonusEventBinding;
var ListBrandAutoWithdrawsByBrandIdGet = /** @class */ (function () {
    function ListBrandAutoWithdrawsByBrandIdGet() {
    }
    ListBrandAutoWithdrawsByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandAutoWithdrawsByBrandIdGet.api_name = "api.admin.brand.auto.withdraw.listbrandautowithdrawsbybrandidget";
    return ListBrandAutoWithdrawsByBrandIdGet;
}());
exports.ListBrandAutoWithdrawsByBrandIdGet = ListBrandAutoWithdrawsByBrandIdGet;
var DoDeleteGwsGameProviderZone = /** @class */ (function () {
    function DoDeleteGwsGameProviderZone() {
    }
    DoDeleteGwsGameProviderZone.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteGwsGameProviderZone.api_name = "api.admin.gws.gameprovider.zones.dodeletegwsgameproviderzone";
    return DoDeleteGwsGameProviderZone;
}());
exports.DoDeleteGwsGameProviderZone = DoDeleteGwsGameProviderZone;
var ListMultiAccountPlayersByPasswordByPlayerIdGet = /** @class */ (function () {
    function ListMultiAccountPlayersByPasswordByPlayerIdGet() {
    }
    ListMultiAccountPlayersByPasswordByPlayerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListMultiAccountPlayersByPasswordByPlayerIdGet.api_name = "api.admin.users.players.multiaccounts.listmultiaccountplayersbypasswordbyplayeridget";
    return ListMultiAccountPlayersByPasswordByPlayerIdGet;
}());
exports.ListMultiAccountPlayersByPasswordByPlayerIdGet = ListMultiAccountPlayersByPasswordByPlayerIdGet;
var DoAddTournamentAmount = /** @class */ (function () {
    function DoAddTournamentAmount() {
    }
    DoAddTournamentAmount.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddTournamentAmount.api_name = "api.admin.bonus.tournaments.amounts.doaddtournamentamount";
    return DoAddTournamentAmount;
}());
exports.DoAddTournamentAmount = DoAddTournamentAmount;
var DoDeletePostCategory = /** @class */ (function () {
    function DoDeletePostCategory() {
    }
    DoDeletePostCategory.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePostCategory.api_name = "api.admin.cms.posts.category.control.dodeletepostcategory";
    return DoDeletePostCategory;
}());
exports.DoDeletePostCategory = DoDeletePostCategory;
var ListAvailBrandMessageActionsGet = /** @class */ (function () {
    function ListAvailBrandMessageActionsGet() {
    }
    ListAvailBrandMessageActionsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailBrandMessageActionsGet.api_name = "api.admin.brands.templates.control.message.set.control.listavailbrandmessageactionsget";
    return ListAvailBrandMessageActionsGet;
}());
exports.ListAvailBrandMessageActionsGet = ListAvailBrandMessageActionsGet;
var DoEditBrandBonusEventBindingConfigOnDep = /** @class */ (function () {
    function DoEditBrandBonusEventBindingConfigOnDep() {
    }
    DoEditBrandBonusEventBindingConfigOnDep.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandBonusEventBindingConfigOnDep.api_name = "api.admin.bonus.events.bindings.config.on_deposit.doeditbrandbonuseventbindingconfigondep";
    return DoEditBrandBonusEventBindingConfigOnDep;
}());
exports.DoEditBrandBonusEventBindingConfigOnDep = DoEditBrandBonusEventBindingConfigOnDep;
var ListBrandPlayerLevelsByBrandIdGet = /** @class */ (function () {
    function ListBrandPlayerLevelsByBrandIdGet() {
    }
    ListBrandPlayerLevelsByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandPlayerLevelsByBrandIdGet.api_name = "api.admin.bonus.levels.control.listbrandplayerlevelsbybrandidget";
    return ListBrandPlayerLevelsByBrandIdGet;
}());
exports.ListBrandPlayerLevelsByBrandIdGet = ListBrandPlayerLevelsByBrandIdGet;
var DoAddBonusEventBindingDescription = /** @class */ (function () {
    function DoAddBonusEventBindingDescription() {
    }
    DoAddBonusEventBindingDescription.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusEventBindingDescription.api_name = "api.admin.bonus.events.bindings.descriptions.doaddbonuseventbindingdescription";
    return DoAddBonusEventBindingDescription;
}());
exports.DoAddBonusEventBindingDescription = DoAddBonusEventBindingDescription;
var DoEditCmsTopGame = /** @class */ (function () {
    function DoEditCmsTopGame() {
    }
    DoEditCmsTopGame.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditCmsTopGame.api_name = "api.admin.cms.top.games.doeditcmstopgame";
    return DoEditCmsTopGame;
}());
exports.DoEditCmsTopGame = DoEditCmsTopGame;
var DoSetPlayerEventHandlerOrderNumber = /** @class */ (function () {
    function DoSetPlayerEventHandlerOrderNumber() {
    }
    DoSetPlayerEventHandlerOrderNumber.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPlayerEventHandlerOrderNumber.api_name = "api.admin.brands.players.events.handlers.dosetplayereventhandlerordernumber";
    return DoSetPlayerEventHandlerOrderNumber;
}());
exports.DoSetPlayerEventHandlerOrderNumber = DoSetPlayerEventHandlerOrderNumber;
var DoSetPProgramAppCountryIsDefault = /** @class */ (function () {
    function DoSetPProgramAppCountryIsDefault() {
    }
    DoSetPProgramAppCountryIsDefault.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPProgramAppCountryIsDefault.api_name = "api.admin.aff.pprograms.app.country.dosetpprogramappcountryisdefault";
    return DoSetPProgramAppCountryIsDefault;
}());
exports.DoSetPProgramAppCountryIsDefault = DoSetPProgramAppCountryIsDefault;
var ListUsrPlayerFavoriteGamesByUsrPlayerIdGet = /** @class */ (function () {
    function ListUsrPlayerFavoriteGamesByUsrPlayerIdGet() {
    }
    ListUsrPlayerFavoriteGamesByUsrPlayerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListUsrPlayerFavoriteGamesByUsrPlayerIdGet.api_name = "api.admin.users.players.favoritegames.listusrplayerfavoritegamesbyusrplayeridget";
    return ListUsrPlayerFavoriteGamesByUsrPlayerIdGet;
}());
exports.ListUsrPlayerFavoriteGamesByUsrPlayerIdGet = ListUsrPlayerFavoriteGamesByUsrPlayerIdGet;
var DoAddPProgramEmailSetTemplateImage = /** @class */ (function () {
    function DoAddPProgramEmailSetTemplateImage() {
    }
    DoAddPProgramEmailSetTemplateImage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramEmailSetTemplateImage.api_name = "api.admin.aff.pprograms.email.set.templates.images.doaddpprogramemailsettemplateimage";
    return DoAddPProgramEmailSetTemplateImage;
}());
exports.DoAddPProgramEmailSetTemplateImage = DoAddPProgramEmailSetTemplateImage;
var ListAvailPromoCodeDepositAgeTypesListGet = /** @class */ (function () {
    function ListAvailPromoCodeDepositAgeTypesListGet() {
    }
    ListAvailPromoCodeDepositAgeTypesListGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailPromoCodeDepositAgeTypesListGet.api_name = "api.admin.bonus.promocodes.templates.control.listavailpromocodedepositagetypeslistget";
    return ListAvailPromoCodeDepositAgeTypesListGet;
}());
exports.ListAvailPromoCodeDepositAgeTypesListGet = ListAvailPromoCodeDepositAgeTypesListGet;
var ListAvailPProgramPartnerOffersByPartnerIdGet = /** @class */ (function () {
    function ListAvailPProgramPartnerOffersByPartnerIdGet() {
    }
    ListAvailPProgramPartnerOffersByPartnerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailPProgramPartnerOffersByPartnerIdGet.api_name = "api.admin.aff.pprograms.usr.partners.offers.listavailpprogrampartneroffersbypartneridget";
    return ListAvailPProgramPartnerOffersByPartnerIdGet;
}());
exports.ListAvailPProgramPartnerOffersByPartnerIdGet = ListAvailPProgramPartnerOffersByPartnerIdGet;
var DoDeleteUsrPartnerPProgramPromoHistory = /** @class */ (function () {
    function DoDeleteUsrPartnerPProgramPromoHistory() {
    }
    DoDeleteUsrPartnerPProgramPromoHistory.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteUsrPartnerPProgramPromoHistory.api_name = "api.admin.aff.pprograms.usr.partners.promo.history.dodeleteusrpartnerpprogrampromohistory";
    return DoDeleteUsrPartnerPProgramPromoHistory;
}());
exports.DoDeleteUsrPartnerPProgramPromoHistory = DoDeleteUsrPartnerPProgramPromoHistory;
var DoUpdatePlayersBonusLevels = /** @class */ (function () {
    function DoUpdatePlayersBonusLevels() {
    }
    DoUpdatePlayersBonusLevels.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoUpdatePlayersBonusLevels.api_name = "api.admin.users.players.control.doupdateplayersbonuslevels";
    return DoUpdatePlayersBonusLevels;
}());
exports.DoUpdatePlayersBonusLevels = DoUpdatePlayersBonusLevels;
var DoDeletePlayer = /** @class */ (function () {
    function DoDeletePlayer() {
    }
    DoDeletePlayer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePlayer.api_name = "api.admin.users.players.control.dodeleteplayer";
    return DoDeletePlayer;
}());
exports.DoDeletePlayer = DoDeletePlayer;
var DoSetTrustEventHandlerOrderNumber = /** @class */ (function () {
    function DoSetTrustEventHandlerOrderNumber() {
    }
    DoSetTrustEventHandlerOrderNumber.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetTrustEventHandlerOrderNumber.api_name = "api.admin.brands.security.trust.handlers.dosettrusteventhandlerordernumber";
    return DoSetTrustEventHandlerOrderNumber;
}());
exports.DoSetTrustEventHandlerOrderNumber = DoSetTrustEventHandlerOrderNumber;
var ListBrandBannerCountryByBannerIdGet = /** @class */ (function () {
    function ListBrandBannerCountryByBannerIdGet() {
    }
    ListBrandBannerCountryByBannerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandBannerCountryByBannerIdGet.api_name = "api.admin.aff.brands.banners.country.listbrandbannercountrybybanneridget";
    return ListBrandBannerCountryByBannerIdGet;
}());
exports.ListBrandBannerCountryByBannerIdGet = ListBrandBannerCountryByBannerIdGet;
var DetailsWagerNoDepBonusTemplateConfigGet = /** @class */ (function () {
    function DetailsWagerNoDepBonusTemplateConfigGet() {
    }
    DetailsWagerNoDepBonusTemplateConfigGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsWagerNoDepBonusTemplateConfigGet.api_name = "api.admin.bonus.templates.config.wager_no_dep.detailswagernodepbonustemplateconfigget";
    return DetailsWagerNoDepBonusTemplateConfigGet;
}());
exports.DetailsWagerNoDepBonusTemplateConfigGet = DetailsWagerNoDepBonusTemplateConfigGet;
var DoSetTrustEventHandlerIsLocked = /** @class */ (function () {
    function DoSetTrustEventHandlerIsLocked() {
    }
    DoSetTrustEventHandlerIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetTrustEventHandlerIsLocked.api_name = "api.admin.brands.security.trust.handlers.dosettrusteventhandlerislocked";
    return DoSetTrustEventHandlerIsLocked;
}());
exports.DoSetTrustEventHandlerIsLocked = DoSetTrustEventHandlerIsLocked;
var DoDeleteBonusTemplateLocale = /** @class */ (function () {
    function DoDeleteBonusTemplateLocale() {
    }
    DoDeleteBonusTemplateLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusTemplateLocale.api_name = "api.admin.bonus.templates.locales.dodeletebonustemplatelocale";
    return DoDeleteBonusTemplateLocale;
}());
exports.DoDeleteBonusTemplateLocale = DoDeleteBonusTemplateLocale;
var DoSetPlayerIsVerifed = /** @class */ (function () {
    function DoSetPlayerIsVerifed() {
    }
    DoSetPlayerIsVerifed.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPlayerIsVerifed.api_name = "api.admin.users.players.control.dosetplayerisverifed";
    return DoSetPlayerIsVerifed;
}());
exports.DoSetPlayerIsVerifed = DoSetPlayerIsVerifed;
var ListBonusTournamentsByUsrPlayerIdGet = /** @class */ (function () {
    function ListBonusTournamentsByUsrPlayerIdGet() {
    }
    ListBonusTournamentsByUsrPlayerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusTournamentsByUsrPlayerIdGet.api_name = "api.admin.users.players.tournaments.listbonustournamentsbyusrplayeridget";
    return ListBonusTournamentsByUsrPlayerIdGet;
}());
exports.ListBonusTournamentsByUsrPlayerIdGet = ListBonusTournamentsByUsrPlayerIdGet;
var DoDeleteUsrPermissionAdminAccess = /** @class */ (function () {
    function DoDeleteUsrPermissionAdminAccess() {
    }
    DoDeleteUsrPermissionAdminAccess.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteUsrPermissionAdminAccess.api_name = "api.admin.access.usr.permissions.dodeleteusrpermissionadminaccess";
    return DoDeleteUsrPermissionAdminAccess;
}());
exports.DoDeleteUsrPermissionAdminAccess = DoDeleteUsrPermissionAdminAccess;
var DoDeleteBonusPlayerLevelOffer = /** @class */ (function () {
    function DoDeleteBonusPlayerLevelOffer() {
    }
    DoDeleteBonusPlayerLevelOffer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusPlayerLevelOffer.api_name = "api.admin.bonus.levels.offers.dodeletebonusplayerleveloffer";
    return DoDeleteBonusPlayerLevelOffer;
}());
exports.DoDeleteBonusPlayerLevelOffer = DoDeleteBonusPlayerLevelOffer;
var DoEditBrandBannerLocale = /** @class */ (function () {
    function DoEditBrandBannerLocale() {
    }
    DoEditBrandBannerLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandBannerLocale.api_name = "api.admin.aff.brands.banners.locales.doeditbrandbannerlocale";
    return DoEditBrandBannerLocale;
}());
exports.DoEditBrandBannerLocale = DoEditBrandBannerLocale;
var ListRestrictionsMessageTypesToPlayerAvailGet = /** @class */ (function () {
    function ListRestrictionsMessageTypesToPlayerAvailGet() {
    }
    ListRestrictionsMessageTypesToPlayerAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListRestrictionsMessageTypesToPlayerAvailGet.api_name = "api.admin.brands.security.firewall.listrestrictionsmessagetypestoplayeravailget";
    return ListRestrictionsMessageTypesToPlayerAvailGet;
}());
exports.ListRestrictionsMessageTypesToPlayerAvailGet = ListRestrictionsMessageTypesToPlayerAvailGet;
var DoEditPayProviderInTrustZone = /** @class */ (function () {
    function DoEditPayProviderInTrustZone() {
    }
    DoEditPayProviderInTrustZone.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPayProviderInTrustZone.api_name = "api.admin.brand.deposit.providers.by.trust.zones.doeditpayproviderintrustzone";
    return DoEditPayProviderInTrustZone;
}());
exports.DoEditPayProviderInTrustZone = DoEditPayProviderInTrustZone;
var DoDeleteUsrPlayerAuthLog = /** @class */ (function () {
    function DoDeleteUsrPlayerAuthLog() {
    }
    DoDeleteUsrPlayerAuthLog.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteUsrPlayerAuthLog.api_name = "api.admin.users.players.logs.auth.dodeleteusrplayerauthlog";
    return DoDeleteUsrPlayerAuthLog;
}());
exports.DoDeleteUsrPlayerAuthLog = DoDeleteUsrPlayerAuthLog;
var DoDeleteCountryLocale = /** @class */ (function () {
    function DoDeleteCountryLocale() {
    }
    DoDeleteCountryLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteCountryLocale.api_name = "api.admin.app.country.locale.dodeletecountrylocale";
    return DoDeleteCountryLocale;
}());
exports.DoDeleteCountryLocale = DoDeleteCountryLocale;
var DetailsPProgramSmtpConfigGet = /** @class */ (function () {
    function DetailsPProgramSmtpConfigGet() {
    }
    DetailsPProgramSmtpConfigGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsPProgramSmtpConfigGet.api_name = "api.admin.aff.pprograms.control.detailspprogramsmtpconfigget";
    return DetailsPProgramSmtpConfigGet;
}());
exports.DetailsPProgramSmtpConfigGet = DetailsPProgramSmtpConfigGet;
var ListPProgramAppCountryByPProgramIdGet = /** @class */ (function () {
    function ListPProgramAppCountryByPProgramIdGet() {
    }
    ListPProgramAppCountryByPProgramIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramAppCountryByPProgramIdGet.api_name = "api.admin.aff.pprograms.app.country.listpprogramappcountrybypprogramidget";
    return ListPProgramAppCountryByPProgramIdGet;
}());
exports.ListPProgramAppCountryByPProgramIdGet = ListPProgramAppCountryByPProgramIdGet;
var DoClearTournamentGames = /** @class */ (function () {
    function DoClearTournamentGames() {
    }
    DoClearTournamentGames.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoClearTournamentGames.api_name = "api.admin.bonus.tournaments.games.docleartournamentgames";
    return DoClearTournamentGames;
}());
exports.DoClearTournamentGames = DoClearTournamentGames;
var DoEditInnerPayService = /** @class */ (function () {
    function DoEditInnerPayService() {
    }
    DoEditInnerPayService.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditInnerPayService.api_name = "api.admin.app.innerpay.services.control.doeditinnerpayservice";
    return DoEditInnerPayService;
}());
exports.DoEditInnerPayService = DoEditInnerPayService;
var ListBonusEventBindingsDescriptionsByBindingIdGet = /** @class */ (function () {
    function ListBonusEventBindingsDescriptionsByBindingIdGet() {
    }
    ListBonusEventBindingsDescriptionsByBindingIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusEventBindingsDescriptionsByBindingIdGet.api_name = "api.admin.bonus.events.bindings.descriptions.listbonuseventbindingsdescriptionsbybindingidget";
    return ListBonusEventBindingsDescriptionsByBindingIdGet;
}());
exports.ListBonusEventBindingsDescriptionsByBindingIdGet = ListBonusEventBindingsDescriptionsByBindingIdGet;
var DoDeleteBrandLocale = /** @class */ (function () {
    function DoDeleteBrandLocale() {
    }
    DoDeleteBrandLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandLocale.api_name = "api.admin.brands.locales.dodeletebrandlocale";
    return DoDeleteBrandLocale;
}());
exports.DoDeleteBrandLocale = DoDeleteBrandLocale;
var DoSetUserPlayerMessageIsReaded = /** @class */ (function () {
    function DoSetUserPlayerMessageIsReaded() {
    }
    DoSetUserPlayerMessageIsReaded.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetUserPlayerMessageIsReaded.api_name = "api.admin.users.players.messages.dosetuserplayermessageisreaded";
    return DoSetUserPlayerMessageIsReaded;
}());
exports.DoSetUserPlayerMessageIsReaded = DoSetUserPlayerMessageIsReaded;
var DoSetPProgramIsLocked = /** @class */ (function () {
    function DoSetPProgramIsLocked() {
    }
    DoSetPProgramIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPProgramIsLocked.api_name = "api.admin.aff.pprograms.control.dosetpprogramislocked";
    return DoSetPProgramIsLocked;
}());
exports.DoSetPProgramIsLocked = DoSetPProgramIsLocked;
var DoAddBrandLocale = /** @class */ (function () {
    function DoAddBrandLocale() {
    }
    DoAddBrandLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandLocale.api_name = "api.admin.brands.locales.doaddbrandlocale";
    return DoAddBrandLocale;
}());
exports.DoAddBrandLocale = DoAddBrandLocale;
var DoAddPageData = /** @class */ (function () {
    function DoAddPageData() {
    }
    DoAddPageData.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPageData.api_name = "api.admin.cms.pages.category.control.doaddpagedata";
    return DoAddPageData;
}());
exports.DoAddPageData = DoAddPageData;
var DoAddPostCategory = /** @class */ (function () {
    function DoAddPostCategory() {
    }
    DoAddPostCategory.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPostCategory.api_name = "api.admin.cms.posts.category.control.doaddpostcategory";
    return DoAddPostCategory;
}());
exports.DoAddPostCategory = DoAddPostCategory;
var DoAddJackpotWinner = /** @class */ (function () {
    function DoAddJackpotWinner() {
    }
    DoAddJackpotWinner.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddJackpotWinner.api_name = "api.admin.bonus.jackpots.winners.doaddjackpotwinner";
    return DoAddJackpotWinner;
}());
exports.DoAddJackpotWinner = DoAddJackpotWinner;
var DoSetGameSetGameIsAllowed = /** @class */ (function () {
    function DoSetGameSetGameIsAllowed() {
    }
    DoSetGameSetGameIsAllowed.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGameSetGameIsAllowed.api_name = "api.admin.cms.gameset.games.control.dosetgamesetgameisallowed";
    return DoSetGameSetGameIsAllowed;
}());
exports.DoSetGameSetGameIsAllowed = DoSetGameSetGameIsAllowed;
var DoSetWhiteIpAddrIsLocked = /** @class */ (function () {
    function DoSetWhiteIpAddrIsLocked() {
    }
    DoSetWhiteIpAddrIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetWhiteIpAddrIsLocked.api_name = "api.admin.users.players.white.ipaddr.dosetwhiteipaddrislocked";
    return DoSetWhiteIpAddrIsLocked;
}());
exports.DoSetWhiteIpAddrIsLocked = DoSetWhiteIpAddrIsLocked;
var ListPromoCodesTemplateBonusesByPromoCodeTemplateIdGet = /** @class */ (function () {
    function ListPromoCodesTemplateBonusesByPromoCodeTemplateIdGet() {
    }
    ListPromoCodesTemplateBonusesByPromoCodeTemplateIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPromoCodesTemplateBonusesByPromoCodeTemplateIdGet.api_name = "api.admin.bonus.promocodes.templates.bonuses.listpromocodestemplatebonusesbypromocodetemplateidget";
    return ListPromoCodesTemplateBonusesByPromoCodeTemplateIdGet;
}());
exports.ListPromoCodesTemplateBonusesByPromoCodeTemplateIdGet = ListPromoCodesTemplateBonusesByPromoCodeTemplateIdGet;
var DoGenerateAdminPassword = /** @class */ (function () {
    function DoGenerateAdminPassword() {
    }
    DoGenerateAdminPassword.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoGenerateAdminPassword.api_name = "api.admin.users.admins.dogenerateadminpassword";
    return DoGenerateAdminPassword;
}());
exports.DoGenerateAdminPassword = DoGenerateAdminPassword;
var DoEditBonusTemplateCurrencyConfig = /** @class */ (function () {
    function DoEditBonusTemplateCurrencyConfig() {
    }
    DoEditBonusTemplateCurrencyConfig.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusTemplateCurrencyConfig.api_name = "api.admin.bonus.templates.currency.config.doeditbonustemplatecurrencyconfig";
    return DoEditBonusTemplateCurrencyConfig;
}());
exports.DoEditBonusTemplateCurrencyConfig = DoEditBonusTemplateCurrencyConfig;
var ListPersonalPromoCodeOfferHandlingTypesAvailGet = /** @class */ (function () {
    function ListPersonalPromoCodeOfferHandlingTypesAvailGet() {
    }
    ListPersonalPromoCodeOfferHandlingTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPersonalPromoCodeOfferHandlingTypesAvailGet.api_name = "api.admin.bonus.personal.promocode.offers.control.listpersonalpromocodeofferhandlingtypesavailget";
    return ListPersonalPromoCodeOfferHandlingTypesAvailGet;
}());
exports.ListPersonalPromoCodeOfferHandlingTypesAvailGet = ListPersonalPromoCodeOfferHandlingTypesAvailGet;
var DoSetBrandDomainIsLocked = /** @class */ (function () {
    function DoSetBrandDomainIsLocked() {
    }
    DoSetBrandDomainIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandDomainIsLocked.api_name = "api.admin.brands.domains.control.dosetbranddomainislocked";
    return DoSetBrandDomainIsLocked;
}());
exports.DoSetBrandDomainIsLocked = DoSetBrandDomainIsLocked;
var ListPromoCodeTemplateAmountsByPromoCodeTemplateIdGet = /** @class */ (function () {
    function ListPromoCodeTemplateAmountsByPromoCodeTemplateIdGet() {
    }
    ListPromoCodeTemplateAmountsByPromoCodeTemplateIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPromoCodeTemplateAmountsByPromoCodeTemplateIdGet.api_name = "api.admin.bonus.promocodes.templates.amounts.listpromocodetemplateamountsbypromocodetemplateidget";
    return ListPromoCodeTemplateAmountsByPromoCodeTemplateIdGet;
}());
exports.ListPromoCodeTemplateAmountsByPromoCodeTemplateIdGet = ListPromoCodeTemplateAmountsByPromoCodeTemplateIdGet;
var DoPlayerStreamerChangeBalance = /** @class */ (function () {
    function DoPlayerStreamerChangeBalance() {
    }
    DoPlayerStreamerChangeBalance.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoPlayerStreamerChangeBalance.api_name = "api.admin.users.players.finance.doplayerstreamerchangebalance";
    return DoPlayerStreamerChangeBalance;
}());
exports.DoPlayerStreamerChangeBalance = DoPlayerStreamerChangeBalance;
var ListUsrPlayerAuthLogsByUsrPlayerIdAndRangeGet = /** @class */ (function () {
    function ListUsrPlayerAuthLogsByUsrPlayerIdAndRangeGet() {
    }
    ListUsrPlayerAuthLogsByUsrPlayerIdAndRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListUsrPlayerAuthLogsByUsrPlayerIdAndRangeGet.api_name = "api.admin.users.players.logs.auth.listusrplayerauthlogsbyusrplayeridandrangeget";
    return ListUsrPlayerAuthLogsByUsrPlayerIdAndRangeGet;
}());
exports.ListUsrPlayerAuthLogsByUsrPlayerIdAndRangeGet = ListUsrPlayerAuthLogsByUsrPlayerIdAndRangeGet;
var DoCloneBonusCurrencyConfig = /** @class */ (function () {
    function DoCloneBonusCurrencyConfig() {
    }
    DoCloneBonusCurrencyConfig.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCloneBonusCurrencyConfig.api_name = "api.admin.bonus.templates.currency.config.doclonebonuscurrencyconfig";
    return DoCloneBonusCurrencyConfig;
}());
exports.DoCloneBonusCurrencyConfig = DoCloneBonusCurrencyConfig;
var DoDeletePageRecord = /** @class */ (function () {
    function DoDeletePageRecord() {
    }
    DoDeletePageRecord.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePageRecord.api_name = "api.admin.cms.pages.records.control.dodeletepagerecord";
    return DoDeletePageRecord;
}());
exports.DoDeletePageRecord = DoDeletePageRecord;
var DoAddBonusTournamentSession = /** @class */ (function () {
    function DoAddBonusTournamentSession() {
    }
    DoAddBonusTournamentSession.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusTournamentSession.api_name = "api.admin.bonus.tournaments.sessions.control.doaddbonustournamentsession";
    return DoAddBonusTournamentSession;
}());
exports.DoAddBonusTournamentSession = DoAddBonusTournamentSession;
var ListGwsGameProviderZonesByGameProviderIdGet = /** @class */ (function () {
    function ListGwsGameProviderZonesByGameProviderIdGet() {
    }
    ListGwsGameProviderZonesByGameProviderIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListGwsGameProviderZonesByGameProviderIdGet.api_name = "api.admin.gws.gameprovider.zones.listgwsgameproviderzonesbygameprovideridget";
    return ListGwsGameProviderZonesByGameProviderIdGet;
}());
exports.ListGwsGameProviderZonesByGameProviderIdGet = ListGwsGameProviderZonesByGameProviderIdGet;
var DoCmsPProgramContentDirectoryDelete = /** @class */ (function () {
    function DoCmsPProgramContentDirectoryDelete() {
    }
    DoCmsPProgramContentDirectoryDelete.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsPProgramContentDirectoryDelete.api_name = "api.admin.aff.pprograms.cms.content.docmspprogramcontentdirectorydelete";
    return DoCmsPProgramContentDirectoryDelete;
}());
exports.DoCmsPProgramContentDirectoryDelete = DoCmsPProgramContentDirectoryDelete;
var DoAddCurrency = /** @class */ (function () {
    function DoAddCurrency() {
    }
    DoAddCurrency.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddCurrency.api_name = "api.admin.app.currency.doaddcurrency";
    return DoAddCurrency;
}());
exports.DoAddCurrency = DoAddCurrency;
var ListBonusPlayerLevelOffersByLevelIdGet = /** @class */ (function () {
    function ListBonusPlayerLevelOffersByLevelIdGet() {
    }
    ListBonusPlayerLevelOffersByLevelIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusPlayerLevelOffersByLevelIdGet.api_name = "api.admin.bonus.levels.offers.listbonusplayerleveloffersbylevelidget";
    return ListBonusPlayerLevelOffersByLevelIdGet;
}());
exports.ListBonusPlayerLevelOffersByLevelIdGet = ListBonusPlayerLevelOffersByLevelIdGet;
var ListAllowedBonusTemplatesForPromoTplTypeByBrandIdGet = /** @class */ (function () {
    function ListAllowedBonusTemplatesForPromoTplTypeByBrandIdGet() {
    }
    ListAllowedBonusTemplatesForPromoTplTypeByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedBonusTemplatesForPromoTplTypeByBrandIdGet.api_name = "api.admin.bonus.templates.control.listallowedbonustemplatesforpromotpltypebybrandidget";
    return ListAllowedBonusTemplatesForPromoTplTypeByBrandIdGet;
}());
exports.ListAllowedBonusTemplatesForPromoTplTypeByBrandIdGet = ListAllowedBonusTemplatesForPromoTplTypeByBrandIdGet;
var DoDeletePProgramPartnerPromoCodeTemplate = /** @class */ (function () {
    function DoDeletePProgramPartnerPromoCodeTemplate() {
    }
    DoDeletePProgramPartnerPromoCodeTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramPartnerPromoCodeTemplate.api_name = "api.admin.aff.pprograms.usr.partners.promocode.templates.dodeletepprogrampartnerpromocodetemplate";
    return DoDeletePProgramPartnerPromoCodeTemplate;
}());
exports.DoDeletePProgramPartnerPromoCodeTemplate = DoDeletePProgramPartnerPromoCodeTemplate;
var DoDeletePageData = /** @class */ (function () {
    function DoDeletePageData() {
    }
    DoDeletePageData.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePageData.api_name = "api.admin.cms.pages.category.control.dodeletepagedata";
    return DoDeletePageData;
}());
exports.DoDeletePageData = DoDeletePageData;
var DoEditBrandMessageSetTestJSONData = /** @class */ (function () {
    function DoEditBrandMessageSetTestJSONData() {
    }
    DoEditBrandMessageSetTestJSONData.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandMessageSetTestJSONData.api_name = "api.admin.brands.templates.control.message.set.control.doeditbrandmessagesettestjsondata";
    return DoEditBrandMessageSetTestJSONData;
}());
exports.DoEditBrandMessageSetTestJSONData = DoEditBrandMessageSetTestJSONData;
var ListReconciliationPartnersByReconciliationIdGet = /** @class */ (function () {
    function ListReconciliationPartnersByReconciliationIdGet() {
    }
    ListReconciliationPartnersByReconciliationIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListReconciliationPartnersByReconciliationIdGet.api_name = "api.admin.aff.pprograms.reconciliations.partners.listreconciliationpartnersbyreconciliationidget";
    return ListReconciliationPartnersByReconciliationIdGet;
}());
exports.ListReconciliationPartnersByReconciliationIdGet = ListReconciliationPartnersByReconciliationIdGet;
var DoSetPProgramNewsIsPublished = /** @class */ (function () {
    function DoSetPProgramNewsIsPublished() {
    }
    DoSetPProgramNewsIsPublished.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPProgramNewsIsPublished.api_name = "api.admin.aff.pprograms.news.control.dosetpprogramnewsispublished";
    return DoSetPProgramNewsIsPublished;
}());
exports.DoSetPProgramNewsIsPublished = DoSetPProgramNewsIsPublished;
var DoSetCmsGameSetIsLocked = /** @class */ (function () {
    function DoSetCmsGameSetIsLocked() {
    }
    DoSetCmsGameSetIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetCmsGameSetIsLocked.api_name = "api.admin.cms.gameset.control.dosetcmsgamesetislocked";
    return DoSetCmsGameSetIsLocked;
}());
exports.DoSetCmsGameSetIsLocked = DoSetCmsGameSetIsLocked;
var ListGwsGameProviderGameGroupsByGameProviderIdGet = /** @class */ (function () {
    function ListGwsGameProviderGameGroupsByGameProviderIdGet() {
    }
    ListGwsGameProviderGameGroupsByGameProviderIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListGwsGameProviderGameGroupsByGameProviderIdGet.api_name = "api.admin.gws.gameprovider.games.listgwsgameprovidergamegroupsbygameprovideridget";
    return ListGwsGameProviderGameGroupsByGameProviderIdGet;
}());
exports.ListGwsGameProviderGameGroupsByGameProviderIdGet = ListGwsGameProviderGameGroupsByGameProviderIdGet;
var DoRenderTournamentLocalePreview = /** @class */ (function () {
    function DoRenderTournamentLocalePreview() {
    }
    DoRenderTournamentLocalePreview.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoRenderTournamentLocalePreview.api_name = "api.admin.bonus.tournaments.locales.dorendertournamentlocalepreview";
    return DoRenderTournamentLocalePreview;
}());
exports.DoRenderTournamentLocalePreview = DoRenderTournamentLocalePreview;
var DoEditBrandLandingLocale = /** @class */ (function () {
    function DoEditBrandLandingLocale() {
    }
    DoEditBrandLandingLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandLandingLocale.api_name = "api.admin.aff.brands.landings.locales.doeditbrandlandinglocale";
    return DoEditBrandLandingLocale;
}());
exports.DoEditBrandLandingLocale = DoEditBrandLandingLocale;
var ListCmsGameSetTypesListGet = /** @class */ (function () {
    function ListCmsGameSetTypesListGet() {
    }
    ListCmsGameSetTypesListGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListCmsGameSetTypesListGet.api_name = "api.admin.cms.gameset.control.listcmsgamesettypeslistget";
    return ListCmsGameSetTypesListGet;
}());
exports.ListCmsGameSetTypesListGet = ListCmsGameSetTypesListGet;
var DoDeletePartnerPromoCodeCode = /** @class */ (function () {
    function DoDeletePartnerPromoCodeCode() {
    }
    DoDeletePartnerPromoCodeCode.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePartnerPromoCodeCode.api_name = "api.admin.aff.pprograms.usr.partners.promocode.codes.dodeletepartnerpromocodecode";
    return DoDeletePartnerPromoCodeCode;
}());
exports.DoDeletePartnerPromoCodeCode = DoDeletePartnerPromoCodeCode;
var DoEditBrandPlayerLevel = /** @class */ (function () {
    function DoEditBrandPlayerLevel() {
    }
    DoEditBrandPlayerLevel.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandPlayerLevel.api_name = "api.admin.bonus.levels.control.doeditbrandplayerlevel";
    return DoEditBrandPlayerLevel;
}());
exports.DoEditBrandPlayerLevel = DoEditBrandPlayerLevel;
var ListAllowedBrandsByObtainAdminIdGet = /** @class */ (function () {
    function ListAllowedBrandsByObtainAdminIdGet() {
    }
    ListAllowedBrandsByObtainAdminIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedBrandsByObtainAdminIdGet.api_name = "api.admin.access.brands.listallowedbrandsbyobtainadminidget";
    return ListAllowedBrandsByObtainAdminIdGet;
}());
exports.ListAllowedBrandsByObtainAdminIdGet = ListAllowedBrandsByObtainAdminIdGet;
var DoEditBrandBonusEventBindingConfigOnCachBack = /** @class */ (function () {
    function DoEditBrandBonusEventBindingConfigOnCachBack() {
    }
    DoEditBrandBonusEventBindingConfigOnCachBack.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandBonusEventBindingConfigOnCachBack.api_name = "api.admin.bonus.events.bindings.config.on_cashback.doeditbrandbonuseventbindingconfigoncachback";
    return DoEditBrandBonusEventBindingConfigOnCachBack;
}());
exports.DoEditBrandBonusEventBindingConfigOnCachBack = DoEditBrandBonusEventBindingConfigOnCachBack;
var ListCountryLocalesByCountryIdGet = /** @class */ (function () {
    function ListCountryLocalesByCountryIdGet() {
    }
    ListCountryLocalesByCountryIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListCountryLocalesByCountryIdGet.api_name = "api.admin.app.country.locale.listcountrylocalesbycountryidget";
    return ListCountryLocalesByCountryIdGet;
}());
exports.ListCountryLocalesByCountryIdGet = ListCountryLocalesByCountryIdGet;
var DoDeleteTournamentBot = /** @class */ (function () {
    function DoDeleteTournamentBot() {
    }
    DoDeleteTournamentBot.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteTournamentBot.api_name = "api.admin.bonus.tournaments.bots.control.dodeletetournamentbot";
    return DoDeleteTournamentBot;
}());
exports.DoDeleteTournamentBot = DoDeleteTournamentBot;
var DoEditPostCategory = /** @class */ (function () {
    function DoEditPostCategory() {
    }
    DoEditPostCategory.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPostCategory.api_name = "api.admin.cms.posts.category.control.doeditpostcategory";
    return DoEditPostCategory;
}());
exports.DoEditPostCategory = DoEditPostCategory;
var DoEditPProgramPartnerPromoCodeTemplate = /** @class */ (function () {
    function DoEditPProgramPartnerPromoCodeTemplate() {
    }
    DoEditPProgramPartnerPromoCodeTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgramPartnerPromoCodeTemplate.api_name = "api.admin.aff.pprograms.usr.partners.promocode.templates.doeditpprogrampartnerpromocodetemplate";
    return DoEditPProgramPartnerPromoCodeTemplate;
}());
exports.DoEditPProgramPartnerPromoCodeTemplate = DoEditPProgramPartnerPromoCodeTemplate;
var ListPaySystemStatsReportByDateRangeGet = /** @class */ (function () {
    function ListPaySystemStatsReportByDateRangeGet() {
    }
    ListPaySystemStatsReportByDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPaySystemStatsReportByDateRangeGet.api_name = "api.admin.report.paysystems.listpaysystemstatsreportbydaterangeget";
    return ListPaySystemStatsReportByDateRangeGet;
}());
exports.ListPaySystemStatsReportByDateRangeGet = ListPaySystemStatsReportByDateRangeGet;
var DoAddCountryLocale = /** @class */ (function () {
    function DoAddCountryLocale() {
    }
    DoAddCountryLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddCountryLocale.api_name = "api.admin.app.country.locale.doaddcountrylocale";
    return DoAddCountryLocale;
}());
exports.DoAddCountryLocale = DoAddCountryLocale;
var LisyBonusJackpotsAvailByUsrPlayerIdGet = /** @class */ (function () {
    function LisyBonusJackpotsAvailByUsrPlayerIdGet() {
    }
    LisyBonusJackpotsAvailByUsrPlayerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    LisyBonusJackpotsAvailByUsrPlayerIdGet.api_name = "api.admin.users.players.jackpot_wins.lisybonusjackpotsavailbyusrplayeridget";
    return LisyBonusJackpotsAvailByUsrPlayerIdGet;
}());
exports.LisyBonusJackpotsAvailByUsrPlayerIdGet = LisyBonusJackpotsAvailByUsrPlayerIdGet;
var DoSetBonusEventBindingIsLocked = /** @class */ (function () {
    function DoSetBonusEventBindingIsLocked() {
    }
    DoSetBonusEventBindingIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBonusEventBindingIsLocked.api_name = "api.admin.bonus.events.bindings.control.dosetbonuseventbindingislocked";
    return DoSetBonusEventBindingIsLocked;
}());
exports.DoSetBonusEventBindingIsLocked = DoSetBonusEventBindingIsLocked;
var DoDeletePProgramEmailSetTemplateImage = /** @class */ (function () {
    function DoDeletePProgramEmailSetTemplateImage() {
    }
    DoDeletePProgramEmailSetTemplateImage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramEmailSetTemplateImage.api_name = "api.admin.aff.pprograms.email.set.templates.images.dodeletepprogramemailsettemplateimage";
    return DoDeletePProgramEmailSetTemplateImage;
}());
exports.DoDeletePProgramEmailSetTemplateImage = DoDeletePProgramEmailSetTemplateImage;
var DoAddBonusTemplateRestrictedPlayerTag = /** @class */ (function () {
    function DoAddBonusTemplateRestrictedPlayerTag() {
    }
    DoAddBonusTemplateRestrictedPlayerTag.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusTemplateRestrictedPlayerTag.api_name = "api.admin.bonus.templates.restricted_player_tags.doaddbonustemplaterestrictedplayertag";
    return DoAddBonusTemplateRestrictedPlayerTag;
}());
exports.DoAddBonusTemplateRestrictedPlayerTag = DoAddBonusTemplateRestrictedPlayerTag;
var ListBrandGwsGameProviderByBrandIdGet = /** @class */ (function () {
    function ListBrandGwsGameProviderByBrandIdGet() {
    }
    ListBrandGwsGameProviderByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandGwsGameProviderByBrandIdGet.api_name = "api.admin.brands.gws.gameprovider.control.listbrandgwsgameproviderbybrandidget";
    return ListBrandGwsGameProviderByBrandIdGet;
}());
exports.ListBrandGwsGameProviderByBrandIdGet = ListBrandGwsGameProviderByBrandIdGet;
var ListPProgramAppPayoutsByPProgramIdGet = /** @class */ (function () {
    function ListPProgramAppPayoutsByPProgramIdGet() {
    }
    ListPProgramAppPayoutsByPProgramIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramAppPayoutsByPProgramIdGet.api_name = "api.admin.aff.pprograms.app.payout.listpprogramapppayoutsbypprogramidget";
    return ListPProgramAppPayoutsByPProgramIdGet;
}());
exports.ListPProgramAppPayoutsByPProgramIdGet = ListPProgramAppPayoutsByPProgramIdGet;
var ListGwsGameProviderZonesAvailGet = /** @class */ (function () {
    function ListGwsGameProviderZonesAvailGet() {
    }
    ListGwsGameProviderZonesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListGwsGameProviderZonesAvailGet.api_name = "api.admin.gws.gameprovider.zones.listgwsgameproviderzonesavailget";
    return ListGwsGameProviderZonesAvailGet;
}());
exports.ListGwsGameProviderZonesAvailGet = ListGwsGameProviderZonesAvailGet;
var ListAllowedAffilatesByObtainAdminIdGet = /** @class */ (function () {
    function ListAllowedAffilatesByObtainAdminIdGet() {
    }
    ListAllowedAffilatesByObtainAdminIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedAffilatesByObtainAdminIdGet.api_name = "api.admin.access.affilates.listallowedaffilatesbyobtainadminidget";
    return ListAllowedAffilatesByObtainAdminIdGet;
}());
exports.ListAllowedAffilatesByObtainAdminIdGet = ListAllowedAffilatesByObtainAdminIdGet;
var DoDeleteJackpotWinner = /** @class */ (function () {
    function DoDeleteJackpotWinner() {
    }
    DoDeleteJackpotWinner.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteJackpotWinner.api_name = "api.admin.bonus.jackpots.winners.dodeletejackpotwinner";
    return DoDeleteJackpotWinner;
}());
exports.DoDeleteJackpotWinner = DoDeleteJackpotWinner;
var ListBonusTemplatesTypesAvailGet = /** @class */ (function () {
    function ListBonusTemplatesTypesAvailGet() {
    }
    ListBonusTemplatesTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusTemplatesTypesAvailGet.api_name = "api.admin.bonus.templates.control.listbonustemplatestypesavailget";
    return ListBonusTemplatesTypesAvailGet;
}());
exports.ListBonusTemplatesTypesAvailGet = ListBonusTemplatesTypesAvailGet;
var ListAuthStateTypesAvailGet = /** @class */ (function () {
    function ListAuthStateTypesAvailGet() {
    }
    ListAuthStateTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAuthStateTypesAvailGet.api_name = "api.admin.cms.banners.routes.images.listauthstatetypesavailget";
    return ListAuthStateTypesAvailGet;
}());
exports.ListAuthStateTypesAvailGet = ListAuthStateTypesAvailGet;
var DoSetAppCurrencyIsFun = /** @class */ (function () {
    function DoSetAppCurrencyIsFun() {
    }
    DoSetAppCurrencyIsFun.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetAppCurrencyIsFun.api_name = "api.admin.app.currency.dosetappcurrencyisfun";
    return DoSetAppCurrencyIsFun;
}());
exports.DoSetAppCurrencyIsFun = DoSetAppCurrencyIsFun;
var DoDeleteCmsGameProviderGameSetLocale = /** @class */ (function () {
    function DoDeleteCmsGameProviderGameSetLocale() {
    }
    DoDeleteCmsGameProviderGameSetLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteCmsGameProviderGameSetLocale.api_name = "api.admin.cms.gameset.locales.dodeletecmsgameprovidergamesetlocale";
    return DoDeleteCmsGameProviderGameSetLocale;
}());
exports.DoDeleteCmsGameProviderGameSetLocale = DoDeleteCmsGameProviderGameSetLocale;
var DetailsBrandSmsConfigGet = /** @class */ (function () {
    function DetailsBrandSmsConfigGet() {
    }
    DetailsBrandSmsConfigGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsBrandSmsConfigGet.api_name = "api.admin.brands.sms.config.control.detailsbrandsmsconfigget";
    return DetailsBrandSmsConfigGet;
}());
exports.DetailsBrandSmsConfigGet = DetailsBrandSmsConfigGet;
var DoAddBannerRoute = /** @class */ (function () {
    function DoAddBannerRoute() {
    }
    DoAddBannerRoute.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBannerRoute.api_name = "api.admin.cms.banners.routes.control.doaddbannerroute";
    return DoAddBannerRoute;
}());
exports.DoAddBannerRoute = DoAddBannerRoute;
var ListPersonalPromoCodesByBrandIdAndAdminId = /** @class */ (function () {
    function ListPersonalPromoCodesByBrandIdAndAdminId() {
    }
    ListPersonalPromoCodesByBrandIdAndAdminId.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPersonalPromoCodesByBrandIdAndAdminId.api_name = "api.admin.support.personal.listpersonalpromocodesbybrandidandadminid";
    return ListPersonalPromoCodesByBrandIdAndAdminId;
}());
exports.ListPersonalPromoCodesByBrandIdAndAdminId = ListPersonalPromoCodesByBrandIdAndAdminId;
var DoEditWagerCashBackBonusTemplateConfig = /** @class */ (function () {
    function DoEditWagerCashBackBonusTemplateConfig() {
    }
    DoEditWagerCashBackBonusTemplateConfig.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditWagerCashBackBonusTemplateConfig.api_name = "api.admin.bonus.templates.config.wager_cashback.doeditwagercashbackbonustemplateconfig";
    return DoEditWagerCashBackBonusTemplateConfig;
}());
exports.DoEditWagerCashBackBonusTemplateConfig = DoEditWagerCashBackBonusTemplateConfig;
var ListTournamentLocalesByTournamentIdGet = /** @class */ (function () {
    function ListTournamentLocalesByTournamentIdGet() {
    }
    ListTournamentLocalesByTournamentIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTournamentLocalesByTournamentIdGet.api_name = "api.admin.bonus.tournaments.locales.listtournamentlocalesbytournamentidget";
    return ListTournamentLocalesByTournamentIdGet;
}());
exports.ListTournamentLocalesByTournamentIdGet = ListTournamentLocalesByTournamentIdGet;
var ListPlayersAvailByFilterGet = /** @class */ (function () {
    function ListPlayersAvailByFilterGet() {
    }
    ListPlayersAvailByFilterGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayersAvailByFilterGet.api_name = "api.admin.users.players.control.listplayersavailbyfilterget";
    return ListPlayersAvailByFilterGet;
}());
exports.ListPlayersAvailByFilterGet = ListPlayersAvailByFilterGet;
var DoDeleteBrandAdminAccess = /** @class */ (function () {
    function DoDeleteBrandAdminAccess() {
    }
    DoDeleteBrandAdminAccess.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandAdminAccess.api_name = "api.admin.access.brands.dodeletebrandadminaccess";
    return DoDeleteBrandAdminAccess;
}());
exports.DoDeleteBrandAdminAccess = DoDeleteBrandAdminAccess;
var DoUpdateBonusTemplateLocaleWagerDescriptionTpl = /** @class */ (function () {
    function DoUpdateBonusTemplateLocaleWagerDescriptionTpl() {
    }
    DoUpdateBonusTemplateLocaleWagerDescriptionTpl.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoUpdateBonusTemplateLocaleWagerDescriptionTpl.api_name = "api.admin.bonus.templates.locales.doupdatebonustemplatelocalewagerdescriptiontpl";
    return DoUpdateBonusTemplateLocaleWagerDescriptionTpl;
}());
exports.DoUpdateBonusTemplateLocaleWagerDescriptionTpl = DoUpdateBonusTemplateLocaleWagerDescriptionTpl;
var DoEditGwsGameProviderZone = /** @class */ (function () {
    function DoEditGwsGameProviderZone() {
    }
    DoEditGwsGameProviderZone.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditGwsGameProviderZone.api_name = "api.admin.gws.gameprovider.zones.doeditgwsgameproviderzone";
    return DoEditGwsGameProviderZone;
}());
exports.DoEditGwsGameProviderZone = DoEditGwsGameProviderZone;
var DoEditBonusPromocodeTemplateLocale = /** @class */ (function () {
    function DoEditBonusPromocodeTemplateLocale() {
    }
    DoEditBonusPromocodeTemplateLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusPromocodeTemplateLocale.api_name = "api.admin.bonus.promocodes.templates.locales.doeditbonuspromocodetemplatelocale";
    return DoEditBonusPromocodeTemplateLocale;
}());
exports.DoEditBonusPromocodeTemplateLocale = DoEditBonusPromocodeTemplateLocale;
var ListTrustEventHandlerTypesAvailGet = /** @class */ (function () {
    function ListTrustEventHandlerTypesAvailGet() {
    }
    ListTrustEventHandlerTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTrustEventHandlerTypesAvailGet.api_name = "api.admin.brands.security.trust.handlers.listtrusteventhandlertypesavailget";
    return ListTrustEventHandlerTypesAvailGet;
}());
exports.ListTrustEventHandlerTypesAvailGet = ListTrustEventHandlerTypesAvailGet;
var DoEditBrandOfferLocale = /** @class */ (function () {
    function DoEditBrandOfferLocale() {
    }
    DoEditBrandOfferLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandOfferLocale.api_name = "api.admin.aff.brands.offers.locales.doeditbrandofferlocale";
    return DoEditBrandOfferLocale;
}());
exports.DoEditBrandOfferLocale = DoEditBrandOfferLocale;
var ListPlayerProfitTypesAvailGet = /** @class */ (function () {
    function ListPlayerProfitTypesAvailGet() {
    }
    ListPlayerProfitTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayerProfitTypesAvailGet.api_name = "api.admin.brands.players.segmentation.listplayerprofittypesavailget";
    return ListPlayerProfitTypesAvailGet;
}());
exports.ListPlayerProfitTypesAvailGet = ListPlayerProfitTypesAvailGet;
var ListPProgramPartnersPayDetailsGet = /** @class */ (function () {
    function ListPProgramPartnersPayDetailsGet() {
    }
    ListPProgramPartnersPayDetailsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramPartnersPayDetailsGet.api_name = "api.admin.aff.pprograms.usr.partners.paydetails.listpprogrampartnerspaydetailsget";
    return ListPProgramPartnersPayDetailsGet;
}());
exports.ListPProgramPartnersPayDetailsGet = ListPProgramPartnersPayDetailsGet;
var DoDeleteBrandBrandingCountry = /** @class */ (function () {
    function DoDeleteBrandBrandingCountry() {
    }
    DoDeleteBrandBrandingCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandBrandingCountry.api_name = "api.admin.aff.brands.brandings.country.dodeletebrandbrandingcountry";
    return DoDeleteBrandBrandingCountry;
}());
exports.DoDeleteBrandBrandingCountry = DoDeleteBrandBrandingCountry;
var DoDeleteBrandBanner = /** @class */ (function () {
    function DoDeleteBrandBanner() {
    }
    DoDeleteBrandBanner.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandBanner.api_name = "api.admin.aff.brands.banners.control.dodeletebrandbanner";
    return DoDeleteBrandBanner;
}());
exports.DoDeleteBrandBanner = DoDeleteBrandBanner;
var DoSetBonusJackpotIsLocked = /** @class */ (function () {
    function DoSetBonusJackpotIsLocked() {
    }
    DoSetBonusJackpotIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBonusJackpotIsLocked.api_name = "api.admin.bonus.jackpots.control.dosetbonusjackpotislocked";
    return DoSetBonusJackpotIsLocked;
}());
exports.DoSetBonusJackpotIsLocked = DoSetBonusJackpotIsLocked;
var DoDeleteBonusPlayerLevelBetAmount = /** @class */ (function () {
    function DoDeleteBonusPlayerLevelBetAmount() {
    }
    DoDeleteBonusPlayerLevelBetAmount.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusPlayerLevelBetAmount.api_name = "api.admin.bonus.levels.betamounts.dodeletebonusplayerlevelbetamount";
    return DoDeleteBonusPlayerLevelBetAmount;
}());
exports.DoDeleteBonusPlayerLevelBetAmount = DoDeleteBonusPlayerLevelBetAmount;
var ListTresholdBehaviorTypesAvailGet = /** @class */ (function () {
    function ListTresholdBehaviorTypesAvailGet() {
    }
    ListTresholdBehaviorTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTresholdBehaviorTypesAvailGet.api_name = "api.admin.brands.gws.gameprovider.segmentation.listtresholdbehaviortypesavailget";
    return ListTresholdBehaviorTypesAvailGet;
}());
exports.ListTresholdBehaviorTypesAvailGet = ListTresholdBehaviorTypesAvailGet;
var DoEditBrandDomain = /** @class */ (function () {
    function DoEditBrandDomain() {
    }
    DoEditBrandDomain.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandDomain.api_name = "api.admin.brands.domains.control.doeditbranddomain";
    return DoEditBrandDomain;
}());
exports.DoEditBrandDomain = DoEditBrandDomain;
var DoSetCmsGameSetSortOrderCategory = /** @class */ (function () {
    function DoSetCmsGameSetSortOrderCategory() {
    }
    DoSetCmsGameSetSortOrderCategory.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetCmsGameSetSortOrderCategory.api_name = "api.admin.cms.gameset.control.dosetcmsgamesetsortordercategory";
    return DoSetCmsGameSetSortOrderCategory;
}());
exports.DoSetCmsGameSetSortOrderCategory = DoSetCmsGameSetSortOrderCategory;
var ListAllowedCmsGameSetsByBrandIdForTournamentsGet = /** @class */ (function () {
    function ListAllowedCmsGameSetsByBrandIdForTournamentsGet() {
    }
    ListAllowedCmsGameSetsByBrandIdForTournamentsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedCmsGameSetsByBrandIdForTournamentsGet.api_name = "api.admin.cms.gameset.control.listallowedcmsgamesetsbybrandidfortournamentsget";
    return ListAllowedCmsGameSetsByBrandIdForTournamentsGet;
}());
exports.ListAllowedCmsGameSetsByBrandIdForTournamentsGet = ListAllowedCmsGameSetsByBrandIdForTournamentsGet;
var ListPageDataByBrandIdGet = /** @class */ (function () {
    function ListPageDataByBrandIdGet() {
    }
    ListPageDataByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPageDataByBrandIdGet.api_name = "api.admin.cms.pages.category.control.listpagedatabybrandidget";
    return ListPageDataByBrandIdGet;
}());
exports.ListPageDataByBrandIdGet = ListPageDataByBrandIdGet;
var DoSetAdminNewPassword = /** @class */ (function () {
    function DoSetAdminNewPassword() {
    }
    DoSetAdminNewPassword.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetAdminNewPassword.api_name = "api.admin.users.admins.dosetadminnewpassword";
    return DoSetAdminNewPassword;
}());
exports.DoSetAdminNewPassword = DoSetAdminNewPassword;
var DetailsPlayerStatisticsGet = /** @class */ (function () {
    function DetailsPlayerStatisticsGet() {
    }
    DetailsPlayerStatisticsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsPlayerStatisticsGet.api_name = "api.admin.users.players.control.detailsplayerstatisticsget";
    return DetailsPlayerStatisticsGet;
}());
exports.DetailsPlayerStatisticsGet = DetailsPlayerStatisticsGet;
var DoEditPProgramEmailSetTemplate = /** @class */ (function () {
    function DoEditPProgramEmailSetTemplate() {
    }
    DoEditPProgramEmailSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgramEmailSetTemplate.api_name = "api.admin.aff.pprograms.email.set.templates.control.doeditpprogramemailsettemplate";
    return DoEditPProgramEmailSetTemplate;
}());
exports.DoEditPProgramEmailSetTemplate = DoEditPProgramEmailSetTemplate;
var DoAddBrandEmailSetTemplateImage = /** @class */ (function () {
    function DoAddBrandEmailSetTemplateImage() {
    }
    DoAddBrandEmailSetTemplateImage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandEmailSetTemplateImage.api_name = "api.admin.brands.templates.control.email.set.images.doaddbrandemailsettemplateimage";
    return DoAddBrandEmailSetTemplateImage;
}());
exports.DoAddBrandEmailSetTemplateImage = DoAddBrandEmailSetTemplateImage;
var DoAddBrandMessageSetTemplate = /** @class */ (function () {
    function DoAddBrandMessageSetTemplate() {
    }
    DoAddBrandMessageSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandMessageSetTemplate.api_name = "api.admin.brands.templates.control.message.set.control.doaddbrandmessagesettemplate";
    return DoAddBrandMessageSetTemplate;
}());
exports.DoAddBrandMessageSetTemplate = DoAddBrandMessageSetTemplate;
var DoEditPProgramPartner = /** @class */ (function () {
    function DoEditPProgramPartner() {
    }
    DoEditPProgramPartner.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgramPartner.api_name = "api.admin.aff.pprograms.usr.partners.control.doeditpprogrampartner";
    return DoEditPProgramPartner;
}());
exports.DoEditPProgramPartner = DoEditPProgramPartner;
var DoAddPProgramAppCurrency = /** @class */ (function () {
    function DoAddPProgramAppCurrency() {
    }
    DoAddPProgramAppCurrency.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramAppCurrency.api_name = "api.admin.aff.pprograms.app.currency.doaddpprogramappcurrency";
    return DoAddPProgramAppCurrency;
}());
exports.DoAddPProgramAppCurrency = DoAddPProgramAppCurrency;
var DoDeleteBrandGwsGameProvider = /** @class */ (function () {
    function DoDeleteBrandGwsGameProvider() {
    }
    DoDeleteBrandGwsGameProvider.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandGwsGameProvider.api_name = "api.admin.brands.gws.gameprovider.control.dodeletebrandgwsgameprovider";
    return DoDeleteBrandGwsGameProvider;
}());
exports.DoDeleteBrandGwsGameProvider = DoDeleteBrandGwsGameProvider;
var DetailsBrandBonusEventBindingConfigOnLogin = /** @class */ (function () {
    function DetailsBrandBonusEventBindingConfigOnLogin() {
    }
    DetailsBrandBonusEventBindingConfigOnLogin.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsBrandBonusEventBindingConfigOnLogin.api_name = "api.admin.bonus.events.bindings.config.on_login.detailsbrandbonuseventbindingconfigonlogin";
    return DetailsBrandBonusEventBindingConfigOnLogin;
}());
exports.DetailsBrandBonusEventBindingConfigOnLogin = DetailsBrandBonusEventBindingConfigOnLogin;
var DoAddUserPlayerJackpotWin = /** @class */ (function () {
    function DoAddUserPlayerJackpotWin() {
    }
    DoAddUserPlayerJackpotWin.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddUserPlayerJackpotWin.api_name = "api.admin.users.players.jackpot_wins.doadduserplayerjackpotwin";
    return DoAddUserPlayerJackpotWin;
}());
exports.DoAddUserPlayerJackpotWin = DoAddUserPlayerJackpotWin;
var ListAllowedCountryGet = /** @class */ (function () {
    function ListAllowedCountryGet() {
    }
    ListAllowedCountryGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedCountryGet.api_name = "api.admin.app.country.control.listallowedcountryget";
    return ListAllowedCountryGet;
}());
exports.ListAllowedCountryGet = ListAllowedCountryGet;
var DoEditSmsConfigRestriction = /** @class */ (function () {
    function DoEditSmsConfigRestriction() {
    }
    DoEditSmsConfigRestriction.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditSmsConfigRestriction.api_name = "api.admin.brands.sms.config.restrictions.doeditsmsconfigrestriction";
    return DoEditSmsConfigRestriction;
}());
exports.DoEditSmsConfigRestriction = DoEditSmsConfigRestriction;
var DoEditPProgramPartnerOffer = /** @class */ (function () {
    function DoEditPProgramPartnerOffer() {
    }
    DoEditPProgramPartnerOffer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgramPartnerOffer.api_name = "api.admin.aff.pprograms.usr.partners.offers.doeditpprogrampartneroffer";
    return DoEditPProgramPartnerOffer;
}());
exports.DoEditPProgramPartnerOffer = DoEditPProgramPartnerOffer;
var DoDeleteBrandSmsSetTemplate = /** @class */ (function () {
    function DoDeleteBrandSmsSetTemplate() {
    }
    DoDeleteBrandSmsSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandSmsSetTemplate.api_name = "api.admin.brands.templates.control.sms.set.control.dodeletebrandsmssettemplate";
    return DoDeleteBrandSmsSetTemplate;
}());
exports.DoDeleteBrandSmsSetTemplate = DoDeleteBrandSmsSetTemplate;
var DoAddPProgramEmailSetTemplate = /** @class */ (function () {
    function DoAddPProgramEmailSetTemplate() {
    }
    DoAddPProgramEmailSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramEmailSetTemplate.api_name = "api.admin.aff.pprograms.email.set.templates.control.doaddpprogramemailsettemplate";
    return DoAddPProgramEmailSetTemplate;
}());
exports.DoAddPProgramEmailSetTemplate = DoAddPProgramEmailSetTemplate;
var DoCmsPProgramContentDirectoryRename = /** @class */ (function () {
    function DoCmsPProgramContentDirectoryRename() {
    }
    DoCmsPProgramContentDirectoryRename.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsPProgramContentDirectoryRename.api_name = "api.admin.aff.pprograms.cms.content.docmspprogramcontentdirectoryrename";
    return DoCmsPProgramContentDirectoryRename;
}());
exports.DoCmsPProgramContentDirectoryRename = DoCmsPProgramContentDirectoryRename;
var ListPlayerMessagesUnreadByPlayerIdGet = /** @class */ (function () {
    function ListPlayerMessagesUnreadByPlayerIdGet() {
    }
    ListPlayerMessagesUnreadByPlayerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayerMessagesUnreadByPlayerIdGet.api_name = "api.admin.users.players.messages.listplayermessagesunreadbyplayeridget";
    return ListPlayerMessagesUnreadByPlayerIdGet;
}());
exports.ListPlayerMessagesUnreadByPlayerIdGet = ListPlayerMessagesUnreadByPlayerIdGet;
var ListAllowedEventTypesToBindGet = /** @class */ (function () {
    function ListAllowedEventTypesToBindGet() {
    }
    ListAllowedEventTypesToBindGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedEventTypesToBindGet.api_name = "api.admin.bonus.events.bindings.control.listallowedeventtypestobindget";
    return ListAllowedEventTypesToBindGet;
}());
exports.ListAllowedEventTypesToBindGet = ListAllowedEventTypesToBindGet;
var DoDeleteBrandPayProvider = /** @class */ (function () {
    function DoDeleteBrandPayProvider() {
    }
    DoDeleteBrandPayProvider.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandPayProvider.api_name = "api.admin.brand.deposit.providers.control.dodeletebrandpayprovider";
    return DoDeleteBrandPayProvider;
}());
exports.DoDeleteBrandPayProvider = DoDeleteBrandPayProvider;
var DoSetAllCountryIsDeprecated = /** @class */ (function () {
    function DoSetAllCountryIsDeprecated() {
    }
    DoSetAllCountryIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetAllCountryIsDeprecated.api_name = "api.admin.app.country.control.dosetallcountryisdeprecated";
    return DoSetAllCountryIsDeprecated;
}());
exports.DoSetAllCountryIsDeprecated = DoSetAllCountryIsDeprecated;
var ListPlayersByBrandIdGet = /** @class */ (function () {
    function ListPlayersByBrandIdGet() {
    }
    ListPlayersByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayersByBrandIdGet.api_name = "api.admin.users.players.control.listplayersbybrandidget";
    return ListPlayersByBrandIdGet;
}());
exports.ListPlayersByBrandIdGet = ListPlayersByBrandIdGet;
var DoSetAccessPermissionOnDocControl = /** @class */ (function () {
    function DoSetAccessPermissionOnDocControl() {
    }
    DoSetAccessPermissionOnDocControl.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetAccessPermissionOnDocControl.api_name = "api.admin.permissions.docs.control.dosetaccesspermissionondoccontrol";
    return DoSetAccessPermissionOnDocControl;
}());
exports.DoSetAccessPermissionOnDocControl = DoSetAccessPermissionOnDocControl;
var DoSetCmsGameSetSortOrderMenu = /** @class */ (function () {
    function DoSetCmsGameSetSortOrderMenu() {
    }
    DoSetCmsGameSetSortOrderMenu.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetCmsGameSetSortOrderMenu.api_name = "api.admin.cms.gameset.control.dosetcmsgamesetsortordermenu";
    return DoSetCmsGameSetSortOrderMenu;
}());
exports.DoSetCmsGameSetSortOrderMenu = DoSetCmsGameSetSortOrderMenu;
var DoSetGwsGameProviderGamePercentPoints = /** @class */ (function () {
    function DoSetGwsGameProviderGamePercentPoints() {
    }
    DoSetGwsGameProviderGamePercentPoints.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGwsGameProviderGamePercentPoints.api_name = "api.admin.gws.gameprovider.games.dosetgwsgameprovidergamepercentpoints";
    return DoSetGwsGameProviderGamePercentPoints;
}());
exports.DoSetGwsGameProviderGamePercentPoints = DoSetGwsGameProviderGamePercentPoints;
var ListAllowedPromoCodeTemplatesForLevelsGet = /** @class */ (function () {
    function ListAllowedPromoCodeTemplatesForLevelsGet() {
    }
    ListAllowedPromoCodeTemplatesForLevelsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedPromoCodeTemplatesForLevelsGet.api_name = "api.admin.bonus.promocodes.templates.control.listallowedpromocodetemplatesforlevelsget";
    return ListAllowedPromoCodeTemplatesForLevelsGet;
}());
exports.ListAllowedPromoCodeTemplatesForLevelsGet = ListAllowedPromoCodeTemplatesForLevelsGet;
var DoSetBannerRouteImageIsLocked = /** @class */ (function () {
    function DoSetBannerRouteImageIsLocked() {
    }
    DoSetBannerRouteImageIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBannerRouteImageIsLocked.api_name = "api.admin.cms.banners.routes.images.dosetbannerrouteimageislocked";
    return DoSetBannerRouteImageIsLocked;
}());
exports.DoSetBannerRouteImageIsLocked = DoSetBannerRouteImageIsLocked;
var DoAddCmsTopGame = /** @class */ (function () {
    function DoAddCmsTopGame() {
    }
    DoAddCmsTopGame.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddCmsTopGame.api_name = "api.admin.cms.top.games.doaddcmstopgame";
    return DoAddCmsTopGame;
}());
exports.DoAddCmsTopGame = DoAddCmsTopGame;
var DoUpdateBonusTemplateLocaleWagerConditionTpl = /** @class */ (function () {
    function DoUpdateBonusTemplateLocaleWagerConditionTpl() {
    }
    DoUpdateBonusTemplateLocaleWagerConditionTpl.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoUpdateBonusTemplateLocaleWagerConditionTpl.api_name = "api.admin.bonus.templates.locales.doupdatebonustemplatelocalewagerconditiontpl";
    return DoUpdateBonusTemplateLocaleWagerConditionTpl;
}());
exports.DoUpdateBonusTemplateLocaleWagerConditionTpl = DoUpdateBonusTemplateLocaleWagerConditionTpl;
var DoDeleteBrandEmailSetTemplateImage = /** @class */ (function () {
    function DoDeleteBrandEmailSetTemplateImage() {
    }
    DoDeleteBrandEmailSetTemplateImage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandEmailSetTemplateImage.api_name = "api.admin.brands.templates.control.email.set.images.dodeletebrandemailsettemplateimage";
    return DoDeleteBrandEmailSetTemplateImage;
}());
exports.DoDeleteBrandEmailSetTemplateImage = DoDeleteBrandEmailSetTemplateImage;
var ListBonusTemplateConfigSegmentItemsByTemplateIdGet = /** @class */ (function () {
    function ListBonusTemplateConfigSegmentItemsByTemplateIdGet() {
    }
    ListBonusTemplateConfigSegmentItemsByTemplateIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusTemplateConfigSegmentItemsByTemplateIdGet.api_name = "api.admin.bonus.templates.config.segmentations.listbonustemplateconfigsegmentitemsbytemplateidget";
    return ListBonusTemplateConfigSegmentItemsByTemplateIdGet;
}());
exports.ListBonusTemplateConfigSegmentItemsByTemplateIdGet = ListBonusTemplateConfigSegmentItemsByTemplateIdGet;
var DoAddTournamentPrize = /** @class */ (function () {
    function DoAddTournamentPrize() {
    }
    DoAddTournamentPrize.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddTournamentPrize.api_name = "api.admin.bonus.tournaments.prizes.doaddtournamentprize";
    return DoAddTournamentPrize;
}());
exports.DoAddTournamentPrize = DoAddTournamentPrize;
var DoDeletePromoCodeTemplateAmount = /** @class */ (function () {
    function DoDeletePromoCodeTemplateAmount() {
    }
    DoDeletePromoCodeTemplateAmount.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePromoCodeTemplateAmount.api_name = "api.admin.bonus.promocodes.templates.amounts.dodeletepromocodetemplateamount";
    return DoDeletePromoCodeTemplateAmount;
}());
exports.DoDeletePromoCodeTemplateAmount = DoDeletePromoCodeTemplateAmount;
var ListNewWithdrawsByBrandIdGet = /** @class */ (function () {
    function ListNewWithdrawsByBrandIdGet() {
    }
    ListNewWithdrawsByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListNewWithdrawsByBrandIdGet.api_name = "api.admin.finance.control.listnewwithdrawsbybrandidget";
    return ListNewWithdrawsByBrandIdGet;
}());
exports.ListNewWithdrawsByBrandIdGet = ListNewWithdrawsByBrandIdGet;
var DoAddPProgramPromoTemplate = /** @class */ (function () {
    function DoAddPProgramPromoTemplate() {
    }
    DoAddPProgramPromoTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramPromoTemplate.api_name = "api.admin.aff.pprograms.pub.promo.templates.doaddpprogrampromotemplate";
    return DoAddPProgramPromoTemplate;
}());
exports.DoAddPProgramPromoTemplate = DoAddPProgramPromoTemplate;
var DoGeneratePlayerPassword = /** @class */ (function () {
    function DoGeneratePlayerPassword() {
    }
    DoGeneratePlayerPassword.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoGeneratePlayerPassword.api_name = "api.admin.users.players.control.dogenerateplayerpassword";
    return DoGeneratePlayerPassword;
}());
exports.DoGeneratePlayerPassword = DoGeneratePlayerPassword;
var DoAddBonusJackpotTarget = /** @class */ (function () {
    function DoAddBonusJackpotTarget() {
    }
    DoAddBonusJackpotTarget.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusJackpotTarget.api_name = "api.admin.bonus.jackpots.targets.doaddbonusjackpottarget";
    return DoAddBonusJackpotTarget;
}());
exports.DoAddBonusJackpotTarget = DoAddBonusJackpotTarget;
var ListAvailPProgramPartnerTrackersByPartnerIdGet = /** @class */ (function () {
    function ListAvailPProgramPartnerTrackersByPartnerIdGet() {
    }
    ListAvailPProgramPartnerTrackersByPartnerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailPProgramPartnerTrackersByPartnerIdGet.api_name = "api.admin.aff.pprograms.usr.partners.trackers.listavailpprogrampartnertrackersbypartneridget";
    return ListAvailPProgramPartnerTrackersByPartnerIdGet;
}());
exports.ListAvailPProgramPartnerTrackersByPartnerIdGet = ListAvailPProgramPartnerTrackersByPartnerIdGet;
var ListAllowedWithdrawTypesGet = /** @class */ (function () {
    function ListAllowedWithdrawTypesGet() {
    }
    ListAllowedWithdrawTypesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedWithdrawTypesGet.api_name = "api.admin.finance.control.listallowedwithdrawtypesget";
    return ListAllowedWithdrawTypesGet;
}());
exports.ListAllowedWithdrawTypesGet = ListAllowedWithdrawTypesGet;
var ListAllowedUsrPermissionsByGrantAdminIdGet = /** @class */ (function () {
    function ListAllowedUsrPermissionsByGrantAdminIdGet() {
    }
    ListAllowedUsrPermissionsByGrantAdminIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedUsrPermissionsByGrantAdminIdGet.api_name = "api.admin.access.usr.permissions.listallowedusrpermissionsbygrantadminidget";
    return ListAllowedUsrPermissionsByGrantAdminIdGet;
}());
exports.ListAllowedUsrPermissionsByGrantAdminIdGet = ListAllowedUsrPermissionsByGrantAdminIdGet;
var DoAddUsrPermissionAdminAccess = /** @class */ (function () {
    function DoAddUsrPermissionAdminAccess() {
    }
    DoAddUsrPermissionAdminAccess.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddUsrPermissionAdminAccess.api_name = "api.admin.access.usr.permissions.doaddusrpermissionadminaccess";
    return DoAddUsrPermissionAdminAccess;
}());
exports.DoAddUsrPermissionAdminAccess = DoAddUsrPermissionAdminAccess;
var DoSetPromoCodeTemplateCodeIsReserved = /** @class */ (function () {
    function DoSetPromoCodeTemplateCodeIsReserved() {
    }
    DoSetPromoCodeTemplateCodeIsReserved.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPromoCodeTemplateCodeIsReserved.api_name = "api.admin.bonus.promocodes.templates.codes.dosetpromocodetemplatecodeisreserved";
    return DoSetPromoCodeTemplateCodeIsReserved;
}());
exports.DoSetPromoCodeTemplateCodeIsReserved = DoSetPromoCodeTemplateCodeIsReserved;
var DoCloneBonusTemplate = /** @class */ (function () {
    function DoCloneBonusTemplate() {
    }
    DoCloneBonusTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCloneBonusTemplate.api_name = "api.admin.bonus.templates.control.doclonebonustemplate";
    return DoCloneBonusTemplate;
}());
exports.DoCloneBonusTemplate = DoCloneBonusTemplate;
var DoRenderBonusTemplateLocalePreview = /** @class */ (function () {
    function DoRenderBonusTemplateLocalePreview() {
    }
    DoRenderBonusTemplateLocalePreview.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoRenderBonusTemplateLocalePreview.api_name = "api.admin.bonus.templates.locales.dorenderbonustemplatelocalepreview";
    return DoRenderBonusTemplateLocalePreview;
}());
exports.DoRenderBonusTemplateLocalePreview = DoRenderBonusTemplateLocalePreview;
var DoDeleteTournamentBet = /** @class */ (function () {
    function DoDeleteTournamentBet() {
    }
    DoDeleteTournamentBet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteTournamentBet.api_name = "api.admin.bonus.tournaments.bets.dodeletetournamentbet";
    return DoDeleteTournamentBet;
}());
exports.DoDeleteTournamentBet = DoDeleteTournamentBet;
var ListBrandsGet = /** @class */ (function () {
    function ListBrandsGet() {
    }
    ListBrandsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandsGet.api_name = "api.admin.brands.control.listbrandsget";
    return ListBrandsGet;
}());
exports.ListBrandsGet = ListBrandsGet;
var DoCmsBrandContentFileExists = /** @class */ (function () {
    function DoCmsBrandContentFileExists() {
    }
    DoCmsBrandContentFileExists.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsBrandContentFileExists.api_name = "api.admin.cms.brands.content.docmsbrandcontentfileexists";
    return DoCmsBrandContentFileExists;
}());
exports.DoCmsBrandContentFileExists = DoCmsBrandContentFileExists;
var DoDeleteBonusTemplateRestrictedPlayerTag = /** @class */ (function () {
    function DoDeleteBonusTemplateRestrictedPlayerTag() {
    }
    DoDeleteBonusTemplateRestrictedPlayerTag.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusTemplateRestrictedPlayerTag.api_name = "api.admin.bonus.templates.restricted_player_tags.dodeletebonustemplaterestrictedplayertag";
    return DoDeleteBonusTemplateRestrictedPlayerTag;
}());
exports.DoDeleteBonusTemplateRestrictedPlayerTag = DoDeleteBonusTemplateRestrictedPlayerTag;
var ListPromoCodeTemplateCodesByPromoCodeTemplateIdGet = /** @class */ (function () {
    function ListPromoCodeTemplateCodesByPromoCodeTemplateIdGet() {
    }
    ListPromoCodeTemplateCodesByPromoCodeTemplateIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPromoCodeTemplateCodesByPromoCodeTemplateIdGet.api_name = "api.admin.bonus.promocodes.templates.codes.listpromocodetemplatecodesbypromocodetemplateidget";
    return ListPromoCodeTemplateCodesByPromoCodeTemplateIdGet;
}());
exports.ListPromoCodeTemplateCodesByPromoCodeTemplateIdGet = ListPromoCodeTemplateCodesByPromoCodeTemplateIdGet;
var DoSetBrandBrandingPriority = /** @class */ (function () {
    function DoSetBrandBrandingPriority() {
    }
    DoSetBrandBrandingPriority.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandBrandingPriority.api_name = "api.admin.aff.brands.brandings.control.dosetbrandbrandingpriority";
    return DoSetBrandBrandingPriority;
}());
exports.DoSetBrandBrandingPriority = DoSetBrandBrandingPriority;
var DoAddPProgramPartnerOffer = /** @class */ (function () {
    function DoAddPProgramPartnerOffer() {
    }
    DoAddPProgramPartnerOffer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramPartnerOffer.api_name = "api.admin.aff.pprograms.usr.partners.offers.doaddpprogrampartneroffer";
    return DoAddPProgramPartnerOffer;
}());
exports.DoAddPProgramPartnerOffer = DoAddPProgramPartnerOffer;
var DoCmsPProgramContentFileDelete = /** @class */ (function () {
    function DoCmsPProgramContentFileDelete() {
    }
    DoCmsPProgramContentFileDelete.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsPProgramContentFileDelete.api_name = "api.admin.aff.pprograms.cms.content.docmspprogramcontentfiledelete";
    return DoCmsPProgramContentFileDelete;
}());
exports.DoCmsPProgramContentFileDelete = DoCmsPProgramContentFileDelete;
var DoEditTournamentPrize = /** @class */ (function () {
    function DoEditTournamentPrize() {
    }
    DoEditTournamentPrize.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditTournamentPrize.api_name = "api.admin.bonus.tournaments.prizes.doedittournamentprize";
    return DoEditTournamentPrize;
}());
exports.DoEditTournamentPrize = DoEditTournamentPrize;
var DoAddSmsConfigRestriction = /** @class */ (function () {
    function DoAddSmsConfigRestriction() {
    }
    DoAddSmsConfigRestriction.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddSmsConfigRestriction.api_name = "api.admin.brands.sms.config.restrictions.doaddsmsconfigrestriction";
    return DoAddSmsConfigRestriction;
}());
exports.DoAddSmsConfigRestriction = DoAddSmsConfigRestriction;
var DoDeletePProgram = /** @class */ (function () {
    function DoDeletePProgram() {
    }
    DoDeletePProgram.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgram.api_name = "api.admin.aff.pprograms.control.dodeletepprogram";
    return DoDeletePProgram;
}());
exports.DoDeletePProgram = DoDeletePProgram;
var ListBrandBrandingLocalesByBrandingIdGet = /** @class */ (function () {
    function ListBrandBrandingLocalesByBrandingIdGet() {
    }
    ListBrandBrandingLocalesByBrandingIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandBrandingLocalesByBrandingIdGet.api_name = "api.admin.aff.brands.brandings.locales.listbrandbrandinglocalesbybrandingidget";
    return ListBrandBrandingLocalesByBrandingIdGet;
}());
exports.ListBrandBrandingLocalesByBrandingIdGet = ListBrandBrandingLocalesByBrandingIdGet;
var DoSetAllPayoutsIsDeprecated = /** @class */ (function () {
    function DoSetAllPayoutsIsDeprecated() {
    }
    DoSetAllPayoutsIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetAllPayoutsIsDeprecated.api_name = "api.admin.app.payout.dosetallpayoutsisdeprecated";
    return DoSetAllPayoutsIsDeprecated;
}());
exports.DoSetAllPayoutsIsDeprecated = DoSetAllPayoutsIsDeprecated;
var DoDeleteBrandOfferLocale = /** @class */ (function () {
    function DoDeleteBrandOfferLocale() {
    }
    DoDeleteBrandOfferLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandOfferLocale.api_name = "api.admin.aff.brands.offers.locales.dodeletebrandofferlocale";
    return DoDeleteBrandOfferLocale;
}());
exports.DoDeleteBrandOfferLocale = DoDeleteBrandOfferLocale;
var DoDeleteTournamentPrize = /** @class */ (function () {
    function DoDeleteTournamentPrize() {
    }
    DoDeleteTournamentPrize.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteTournamentPrize.api_name = "api.admin.bonus.tournaments.prizes.dodeletetournamentprize";
    return DoDeleteTournamentPrize;
}());
exports.DoDeleteTournamentPrize = DoDeleteTournamentPrize;
var ListPProgramAppCurrencyByPProgramIdGet = /** @class */ (function () {
    function ListPProgramAppCurrencyByPProgramIdGet() {
    }
    ListPProgramAppCurrencyByPProgramIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramAppCurrencyByPProgramIdGet.api_name = "api.admin.aff.pprograms.app.currency.listpprogramappcurrencybypprogramidget";
    return ListPProgramAppCurrencyByPProgramIdGet;
}());
exports.ListPProgramAppCurrencyByPProgramIdGet = ListPProgramAppCurrencyByPProgramIdGet;
var DoSetPProgramBrandIsDeprecated = /** @class */ (function () {
    function DoSetPProgramBrandIsDeprecated() {
    }
    DoSetPProgramBrandIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPProgramBrandIsDeprecated.api_name = "api.admin.aff.pprograms.brands.dosetpprogrambrandisdeprecated";
    return DoSetPProgramBrandIsDeprecated;
}());
exports.DoSetPProgramBrandIsDeprecated = DoSetPProgramBrandIsDeprecated;
var ListTournamentActionTypesAvailGet = /** @class */ (function () {
    function ListTournamentActionTypesAvailGet() {
    }
    ListTournamentActionTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTournamentActionTypesAvailGet.api_name = "api.admin.bonus.tournaments.sessions.actionlogs.listtournamentactiontypesavailget";
    return ListTournamentActionTypesAvailGet;
}());
exports.ListTournamentActionTypesAvailGet = ListTournamentActionTypesAvailGet;
var ListAvailFSRangesByBrandIdGet = /** @class */ (function () {
    function ListAvailFSRangesByBrandIdGet() {
    }
    ListAvailFSRangesByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailFSRangesByBrandIdGet.api_name = "api.admin.bonus.fsranges.control.listavailfsrangesbybrandidget";
    return ListAvailFSRangesByBrandIdGet;
}());
exports.ListAvailFSRangesByBrandIdGet = ListAvailFSRangesByBrandIdGet;
var ListInnerPayServicesGet = /** @class */ (function () {
    function ListInnerPayServicesGet() {
    }
    ListInnerPayServicesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListInnerPayServicesGet.api_name = "api.admin.app.innerpay.services.control.listinnerpayservicesget";
    return ListInnerPayServicesGet;
}());
exports.ListInnerPayServicesGet = ListInnerPayServicesGet;
var DoUpdateBonusTemplateLocaleWagerPreCreateTeaserTpl = /** @class */ (function () {
    function DoUpdateBonusTemplateLocaleWagerPreCreateTeaserTpl() {
    }
    DoUpdateBonusTemplateLocaleWagerPreCreateTeaserTpl.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoUpdateBonusTemplateLocaleWagerPreCreateTeaserTpl.api_name = "api.admin.bonus.templates.locales.doupdatebonustemplatelocalewagerprecreateteasertpl";
    return DoUpdateBonusTemplateLocaleWagerPreCreateTeaserTpl;
}());
exports.DoUpdateBonusTemplateLocaleWagerPreCreateTeaserTpl = DoUpdateBonusTemplateLocaleWagerPreCreateTeaserTpl;
var DoSetAppUsrPlayerTagIsDeprecated = /** @class */ (function () {
    function DoSetAppUsrPlayerTagIsDeprecated() {
    }
    DoSetAppUsrPlayerTagIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetAppUsrPlayerTagIsDeprecated.api_name = "api.admin.app.usr.players.tags.dosetappusrplayertagisdeprecated";
    return DoSetAppUsrPlayerTagIsDeprecated;
}());
exports.DoSetAppUsrPlayerTagIsDeprecated = DoSetAppUsrPlayerTagIsDeprecated;
var ListGameSetGameBotWinsByGameIdGet = /** @class */ (function () {
    function ListGameSetGameBotWinsByGameIdGet() {
    }
    ListGameSetGameBotWinsByGameIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListGameSetGameBotWinsByGameIdGet.api_name = "api.admin.cms.gameset.games.botwins.listgamesetgamebotwinsbygameidget";
    return ListGameSetGameBotWinsByGameIdGet;
}());
exports.ListGameSetGameBotWinsByGameIdGet = ListGameSetGameBotWinsByGameIdGet;
var DoAddPromoCodeTemplateAmount = /** @class */ (function () {
    function DoAddPromoCodeTemplateAmount() {
    }
    DoAddPromoCodeTemplateAmount.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPromoCodeTemplateAmount.api_name = "api.admin.bonus.promocodes.templates.amounts.doaddpromocodetemplateamount";
    return DoAddPromoCodeTemplateAmount;
}());
exports.DoAddPromoCodeTemplateAmount = DoAddPromoCodeTemplateAmount;
var DoEditBrandSmtpConfig = /** @class */ (function () {
    function DoEditBrandSmtpConfig() {
    }
    DoEditBrandSmtpConfig.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandSmtpConfig.api_name = "api.admin.brands.email.config.control.doeditbrandsmtpconfig";
    return DoEditBrandSmtpConfig;
}());
exports.DoEditBrandSmtpConfig = DoEditBrandSmtpConfig;
var DoAddAppTrustZone = /** @class */ (function () {
    function DoAddAppTrustZone() {
    }
    DoAddAppTrustZone.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddAppTrustZone.api_name = "api.admin.app.trust.zones.doaddapptrustzone";
    return DoAddAppTrustZone;
}());
exports.DoAddAppTrustZone = DoAddAppTrustZone;
var ListPromoCodeTemplateCodesActivationLogsByDateRangeGet = /** @class */ (function () {
    function ListPromoCodeTemplateCodesActivationLogsByDateRangeGet() {
    }
    ListPromoCodeTemplateCodesActivationLogsByDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPromoCodeTemplateCodesActivationLogsByDateRangeGet.api_name = "api.admin.bonus.promocodes.templates.codes.listpromocodetemplatecodesactivationlogsbydaterangeget";
    return ListPromoCodeTemplateCodesActivationLogsByDateRangeGet;
}());
exports.ListPromoCodeTemplateCodesActivationLogsByDateRangeGet = ListPromoCodeTemplateCodesActivationLogsByDateRangeGet;
var ListUsrPlayerBonusEventsLogsByPlayerIdAndDateRangeGet = /** @class */ (function () {
    function ListUsrPlayerBonusEventsLogsByPlayerIdAndDateRangeGet() {
    }
    ListUsrPlayerBonusEventsLogsByPlayerIdAndDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListUsrPlayerBonusEventsLogsByPlayerIdAndDateRangeGet.api_name = "api.admin.users.players.logs.bonusevents.listusrplayerbonuseventslogsbyplayeridanddaterangeget";
    return ListUsrPlayerBonusEventsLogsByPlayerIdAndDateRangeGet;
}());
exports.ListUsrPlayerBonusEventsLogsByPlayerIdAndDateRangeGet = ListUsrPlayerBonusEventsLogsByPlayerIdAndDateRangeGet;
var DoAddPProgramAppLanguage = /** @class */ (function () {
    function DoAddPProgramAppLanguage() {
    }
    DoAddPProgramAppLanguage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramAppLanguage.api_name = "api.admin.aff.pprograms.app.language.doaddpprogramapplanguage";
    return DoAddPProgramAppLanguage;
}());
exports.DoAddPProgramAppLanguage = DoAddPProgramAppLanguage;
var DoAddBrandAppLanguage = /** @class */ (function () {
    function DoAddBrandAppLanguage() {
    }
    DoAddBrandAppLanguage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandAppLanguage.api_name = "api.admin.brands.app.languages.doaddbrandapplanguage";
    return DoAddBrandAppLanguage;
}());
exports.DoAddBrandAppLanguage = DoAddBrandAppLanguage;
var DoDeleteBrandLandingCountry = /** @class */ (function () {
    function DoDeleteBrandLandingCountry() {
    }
    DoDeleteBrandLandingCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandLandingCountry.api_name = "api.admin.aff.brands.landings.country.dodeletebrandlandingcountry";
    return DoDeleteBrandLandingCountry;
}());
exports.DoDeleteBrandLandingCountry = DoDeleteBrandLandingCountry;
var DoDeleteAffilateAdminAccess = /** @class */ (function () {
    function DoDeleteAffilateAdminAccess() {
    }
    DoDeleteAffilateAdminAccess.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteAffilateAdminAccess.api_name = "api.admin.access.affilates.dodeleteaffilateadminaccess";
    return DoDeleteAffilateAdminAccess;
}());
exports.DoDeleteAffilateAdminAccess = DoDeleteAffilateAdminAccess;
var DoSetPProgramPartnerNewPassword = /** @class */ (function () {
    function DoSetPProgramPartnerNewPassword() {
    }
    DoSetPProgramPartnerNewPassword.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPProgramPartnerNewPassword.api_name = "api.admin.aff.pprograms.usr.partners.control.dosetpprogrampartnernewpassword";
    return DoSetPProgramPartnerNewPassword;
}());
exports.DoSetPProgramPartnerNewPassword = DoSetPProgramPartnerNewPassword;
var DoSetInnerPayServicePayWayIsLocked = /** @class */ (function () {
    function DoSetInnerPayServicePayWayIsLocked() {
    }
    DoSetInnerPayServicePayWayIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetInnerPayServicePayWayIsLocked.api_name = "api.admin.app.innerpay.services.payways.dosetinnerpayservicepaywayislocked";
    return DoSetInnerPayServicePayWayIsLocked;
}());
exports.DoSetInnerPayServicePayWayIsLocked = DoSetInnerPayServicePayWayIsLocked;
var DoEditFSRangeGameSet = /** @class */ (function () {
    function DoEditFSRangeGameSet() {
    }
    DoEditFSRangeGameSet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditFSRangeGameSet.api_name = "api.admin.bonus.fsranges.gamesets.doeditfsrangegameset";
    return DoEditFSRangeGameSet;
}());
exports.DoEditFSRangeGameSet = DoEditFSRangeGameSet;
var DoEditPProgramSmtpConfig = /** @class */ (function () {
    function DoEditPProgramSmtpConfig() {
    }
    DoEditPProgramSmtpConfig.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgramSmtpConfig.api_name = "api.admin.aff.pprograms.control.doeditpprogramsmtpconfig";
    return DoEditPProgramSmtpConfig;
}());
exports.DoEditPProgramSmtpConfig = DoEditPProgramSmtpConfig;
var ListPProgramPartnerBalancesByPartnerIdGet = /** @class */ (function () {
    function ListPProgramPartnerBalancesByPartnerIdGet() {
    }
    ListPProgramPartnerBalancesByPartnerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramPartnerBalancesByPartnerIdGet.api_name = "api.admin.aff.pprograms.usr.partners.balances.listpprogrampartnerbalancesbypartneridget";
    return ListPProgramPartnerBalancesByPartnerIdGet;
}());
exports.ListPProgramPartnerBalancesByPartnerIdGet = ListPProgramPartnerBalancesByPartnerIdGet;
var DoSetBrandLandingPriority = /** @class */ (function () {
    function DoSetBrandLandingPriority() {
    }
    DoSetBrandLandingPriority.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandLandingPriority.api_name = "api.admin.aff.brands.landings.control.dosetbrandlandingpriority";
    return DoSetBrandLandingPriority;
}());
exports.DoSetBrandLandingPriority = DoSetBrandLandingPriority;
var DoSetBrandPayProviderInTrustZoneIsLocked = /** @class */ (function () {
    function DoSetBrandPayProviderInTrustZoneIsLocked() {
    }
    DoSetBrandPayProviderInTrustZoneIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandPayProviderInTrustZoneIsLocked.api_name = "api.admin.brand.deposit.providers.by.trust.zones.dosetbrandpayproviderintrustzoneislocked";
    return DoSetBrandPayProviderInTrustZoneIsLocked;
}());
exports.DoSetBrandPayProviderInTrustZoneIsLocked = DoSetBrandPayProviderInTrustZoneIsLocked;
var DoSetGwsGameProviderGamePercentTournament = /** @class */ (function () {
    function DoSetGwsGameProviderGamePercentTournament() {
    }
    DoSetGwsGameProviderGamePercentTournament.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGwsGameProviderGamePercentTournament.api_name = "api.admin.gws.gameprovider.games.dosetgwsgameprovidergamepercenttournament";
    return DoSetGwsGameProviderGamePercentTournament;
}());
exports.DoSetGwsGameProviderGamePercentTournament = DoSetGwsGameProviderGamePercentTournament;
var ListAdminAccessByUsrPermissionId = /** @class */ (function () {
    function ListAdminAccessByUsrPermissionId() {
    }
    ListAdminAccessByUsrPermissionId.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAdminAccessByUsrPermissionId.api_name = "api.admin.access.usr.permissions.listadminaccessbyusrpermissionid";
    return ListAdminAccessByUsrPermissionId;
}());
exports.ListAdminAccessByUsrPermissionId = ListAdminAccessByUsrPermissionId;
var DoSetGwsGameProviderGamePercentJackpot = /** @class */ (function () {
    function DoSetGwsGameProviderGamePercentJackpot() {
    }
    DoSetGwsGameProviderGamePercentJackpot.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGwsGameProviderGamePercentJackpot.api_name = "api.admin.gws.gameprovider.games.dosetgwsgameprovidergamepercentjackpot";
    return DoSetGwsGameProviderGamePercentJackpot;
}());
exports.DoSetGwsGameProviderGamePercentJackpot = DoSetGwsGameProviderGamePercentJackpot;
var ListGwsGameProvidersGet = /** @class */ (function () {
    function ListGwsGameProvidersGet() {
    }
    ListGwsGameProvidersGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListGwsGameProvidersGet.api_name = "api.admin.gws.gameprovider.control.listgwsgameprovidersget";
    return ListGwsGameProvidersGet;
}());
exports.ListGwsGameProvidersGet = ListGwsGameProvidersGet;
var DoEditBrandAutoWithdraw = /** @class */ (function () {
    function DoEditBrandAutoWithdraw() {
    }
    DoEditBrandAutoWithdraw.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandAutoWithdraw.api_name = "api.admin.brand.auto.withdraw.doeditbrandautowithdraw";
    return DoEditBrandAutoWithdraw;
}());
exports.DoEditBrandAutoWithdraw = DoEditBrandAutoWithdraw;
var DoDeleteBonusTemplateConfigSegmentItem = /** @class */ (function () {
    function DoDeleteBonusTemplateConfigSegmentItem() {
    }
    DoDeleteBonusTemplateConfigSegmentItem.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusTemplateConfigSegmentItem.api_name = "api.admin.bonus.templates.config.segmentations.dodeletebonustemplateconfigsegmentitem";
    return DoDeleteBonusTemplateConfigSegmentItem;
}());
exports.DoDeleteBonusTemplateConfigSegmentItem = DoDeleteBonusTemplateConfigSegmentItem;
var ListBonusStateTypesAvailGet = /** @class */ (function () {
    function ListBonusStateTypesAvailGet() {
    }
    ListBonusStateTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusStateTypesAvailGet.api_name = "api.admin.report.bonuses.listbonusstatetypesavailget";
    return ListBonusStateTypesAvailGet;
}());
exports.ListBonusStateTypesAvailGet = ListBonusStateTypesAvailGet;
var ListPProgramEmailSetTemplateImagesGet = /** @class */ (function () {
    function ListPProgramEmailSetTemplateImagesGet() {
    }
    ListPProgramEmailSetTemplateImagesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramEmailSetTemplateImagesGet.api_name = "api.admin.aff.pprograms.email.set.templates.images.listpprogramemailsettemplateimagesget";
    return ListPProgramEmailSetTemplateImagesGet;
}());
exports.ListPProgramEmailSetTemplateImagesGet = ListPProgramEmailSetTemplateImagesGet;
var ListAllowedBonusTemplatesForEventBindingsByBrandIdGet = /** @class */ (function () {
    function ListAllowedBonusTemplatesForEventBindingsByBrandIdGet() {
    }
    ListAllowedBonusTemplatesForEventBindingsByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedBonusTemplatesForEventBindingsByBrandIdGet.api_name = "api.admin.bonus.templates.control.listallowedbonustemplatesforeventbindingsbybrandidget";
    return ListAllowedBonusTemplatesForEventBindingsByBrandIdGet;
}());
exports.ListAllowedBonusTemplatesForEventBindingsByBrandIdGet = ListAllowedBonusTemplatesForEventBindingsByBrandIdGet;
var ListBonusJackpotTargetsByJpIdGet = /** @class */ (function () {
    function ListBonusJackpotTargetsByJpIdGet() {
    }
    ListBonusJackpotTargetsByJpIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusJackpotTargetsByJpIdGet.api_name = "api.admin.bonus.jackpots.targets.listbonusjackpottargetsbyjpidget";
    return ListBonusJackpotTargetsByJpIdGet;
}());
exports.ListBonusJackpotTargetsByJpIdGet = ListBonusJackpotTargetsByJpIdGet;
var ListBonusLevelSourceTypesAvail = /** @class */ (function () {
    function ListBonusLevelSourceTypesAvail() {
    }
    ListBonusLevelSourceTypesAvail.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusLevelSourceTypesAvail.api_name = "api.admin.bonus.templates.control.listbonuslevelsourcetypesavail";
    return ListBonusLevelSourceTypesAvail;
}());
exports.ListBonusLevelSourceTypesAvail = ListBonusLevelSourceTypesAvail;
var DoDeleteBrandPayProviderFromTrustZone = /** @class */ (function () {
    function DoDeleteBrandPayProviderFromTrustZone() {
    }
    DoDeleteBrandPayProviderFromTrustZone.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandPayProviderFromTrustZone.api_name = "api.admin.brand.deposit.providers.by.trust.zones.dodeletebrandpayproviderfromtrustzone";
    return DoDeleteBrandPayProviderFromTrustZone;
}());
exports.DoDeleteBrandPayProviderFromTrustZone = DoDeleteBrandPayProviderFromTrustZone;
var ListAllowedPProgramNewsByPProgramId = /** @class */ (function () {
    function ListAllowedPProgramNewsByPProgramId() {
    }
    ListAllowedPProgramNewsByPProgramId.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedPProgramNewsByPProgramId.api_name = "api.admin.aff.pprograms.news.control.listallowedpprogramnewsbypprogramid";
    return ListAllowedPProgramNewsByPProgramId;
}());
exports.ListAllowedPProgramNewsByPProgramId = ListAllowedPProgramNewsByPProgramId;
var DoDeleteCountry = /** @class */ (function () {
    function DoDeleteCountry() {
    }
    DoDeleteCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteCountry.api_name = "api.admin.app.country.control.dodeletecountry";
    return DoDeleteCountry;
}());
exports.DoDeleteCountry = DoDeleteCountry;
var DoAddTournamentBot = /** @class */ (function () {
    function DoAddTournamentBot() {
    }
    DoAddTournamentBot.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddTournamentBot.api_name = "api.admin.bonus.tournaments.bots.control.doaddtournamentbot";
    return DoAddTournamentBot;
}());
exports.DoAddTournamentBot = DoAddTournamentBot;
var ListBrandPayProvidsByBrandAndTrustZoneGet = /** @class */ (function () {
    function ListBrandPayProvidsByBrandAndTrustZoneGet() {
    }
    ListBrandPayProvidsByBrandAndTrustZoneGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandPayProvidsByBrandAndTrustZoneGet.api_name = "api.admin.brand.deposit.providers.control.listbrandpayprovidsbybrandandtrustzoneget";
    return ListBrandPayProvidsByBrandAndTrustZoneGet;
}());
exports.ListBrandPayProvidsByBrandAndTrustZoneGet = ListBrandPayProvidsByBrandAndTrustZoneGet;
var DoDeleteBrandBrandingLocale = /** @class */ (function () {
    function DoDeleteBrandBrandingLocale() {
    }
    DoDeleteBrandBrandingLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandBrandingLocale.api_name = "api.admin.aff.brands.brandings.locales.dodeletebrandbrandinglocale";
    return DoDeleteBrandBrandingLocale;
}());
exports.DoDeleteBrandBrandingLocale = DoDeleteBrandBrandingLocale;
var DoEditBrandBonusEventBindingConfigOnLogin = /** @class */ (function () {
    function DoEditBrandBonusEventBindingConfigOnLogin() {
    }
    DoEditBrandBonusEventBindingConfigOnLogin.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandBonusEventBindingConfigOnLogin.api_name = "api.admin.bonus.events.bindings.config.on_login.doeditbrandbonuseventbindingconfigonlogin";
    return DoEditBrandBonusEventBindingConfigOnLogin;
}());
exports.DoEditBrandBonusEventBindingConfigOnLogin = DoEditBrandBonusEventBindingConfigOnLogin;
var DetailsBrandEmailSetTemplateDataGet = /** @class */ (function () {
    function DetailsBrandEmailSetTemplateDataGet() {
    }
    DetailsBrandEmailSetTemplateDataGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsBrandEmailSetTemplateDataGet.api_name = "api.admin.brands.templates.control.email.set.control.detailsbrandemailsettemplatedataget";
    return DetailsBrandEmailSetTemplateDataGet;
}());
exports.DetailsBrandEmailSetTemplateDataGet = DetailsBrandEmailSetTemplateDataGet;
var DoDeleteBrandDomain = /** @class */ (function () {
    function DoDeleteBrandDomain() {
    }
    DoDeleteBrandDomain.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandDomain.api_name = "api.admin.brands.domains.control.dodeletebranddomain";
    return DoDeleteBrandDomain;
}());
exports.DoDeleteBrandDomain = DoDeleteBrandDomain;
var DoClearGwsGameProviderGames = /** @class */ (function () {
    function DoClearGwsGameProviderGames() {
    }
    DoClearGwsGameProviderGames.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoClearGwsGameProviderGames.api_name = "api.admin.gws.gameprovider.control.docleargwsgameprovidergames";
    return DoClearGwsGameProviderGames;
}());
exports.DoClearGwsGameProviderGames = DoClearGwsGameProviderGames;
var ListInnerPayWalletReceivesByFiltersGet = /** @class */ (function () {
    function ListInnerPayWalletReceivesByFiltersGet() {
    }
    ListInnerPayWalletReceivesByFiltersGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListInnerPayWalletReceivesByFiltersGet.api_name = "api.admin.app.innerpay.wallets.receive.listinnerpaywalletreceivesbyfiltersget";
    return ListInnerPayWalletReceivesByFiltersGet;
}());
exports.ListInnerPayWalletReceivesByFiltersGet = ListInnerPayWalletReceivesByFiltersGet;
var DoSetBannerRouteIsLocked = /** @class */ (function () {
    function DoSetBannerRouteIsLocked() {
    }
    DoSetBannerRouteIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBannerRouteIsLocked.api_name = "api.admin.cms.banners.routes.control.dosetbannerrouteislocked";
    return DoSetBannerRouteIsLocked;
}());
exports.DoSetBannerRouteIsLocked = DoSetBannerRouteIsLocked;
var ListUserPlayerTagsByUserIdGet = /** @class */ (function () {
    function ListUserPlayerTagsByUserIdGet() {
    }
    ListUserPlayerTagsByUserIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListUserPlayerTagsByUserIdGet.api_name = "api.admin.users.players.tags.listuserplayertagsbyuseridget";
    return ListUserPlayerTagsByUserIdGet;
}());
exports.ListUserPlayerTagsByUserIdGet = ListUserPlayerTagsByUserIdGet;
var DetailsActiveAdminGet = /** @class */ (function () {
    function DetailsActiveAdminGet() {
    }
    DetailsActiveAdminGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsActiveAdminGet.api_name = "api.admin.profile.detailsactiveadminget";
    return DetailsActiveAdminGet;
}());
exports.DetailsActiveAdminGet = DetailsActiveAdminGet;
var DoEditBonusEventBindingDescription = /** @class */ (function () {
    function DoEditBonusEventBindingDescription() {
    }
    DoEditBonusEventBindingDescription.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusEventBindingDescription.api_name = "api.admin.bonus.events.bindings.descriptions.doeditbonuseventbindingdescription";
    return DoEditBonusEventBindingDescription;
}());
exports.DoEditBonusEventBindingDescription = DoEditBonusEventBindingDescription;
var ListAvailGameSetGamesByGameSetIdGet = /** @class */ (function () {
    function ListAvailGameSetGamesByGameSetIdGet() {
    }
    ListAvailGameSetGamesByGameSetIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailGameSetGamesByGameSetIdGet.api_name = "api.admin.cms.gameset.games.control.listavailgamesetgamesbygamesetidget";
    return ListAvailGameSetGamesByGameSetIdGet;
}());
exports.ListAvailGameSetGamesByGameSetIdGet = ListAvailGameSetGamesByGameSetIdGet;
var DoAddBrandPayProvider = /** @class */ (function () {
    function DoAddBrandPayProvider() {
    }
    DoAddBrandPayProvider.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandPayProvider.api_name = "api.admin.brand.deposit.providers.control.doaddbrandpayprovider";
    return DoAddBrandPayProvider;
}());
exports.DoAddBrandPayProvider = DoAddBrandPayProvider;
var DoEditBrandBonusEventBindingConfigOnLevel = /** @class */ (function () {
    function DoEditBrandBonusEventBindingConfigOnLevel() {
    }
    DoEditBrandBonusEventBindingConfigOnLevel.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandBonusEventBindingConfigOnLevel.api_name = "api.admin.bonus.events.bindings.config.on_level.doeditbrandbonuseventbindingconfigonlevel";
    return DoEditBrandBonusEventBindingConfigOnLevel;
}());
exports.DoEditBrandBonusEventBindingConfigOnLevel = DoEditBrandBonusEventBindingConfigOnLevel;
var DoSetGameSetAllGamesIsAllowed = /** @class */ (function () {
    function DoSetGameSetAllGamesIsAllowed() {
    }
    DoSetGameSetAllGamesIsAllowed.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGameSetAllGamesIsAllowed.api_name = "api.admin.cms.gameset.games.control.dosetgamesetallgamesisallowed";
    return DoSetGameSetAllGamesIsAllowed;
}());
exports.DoSetGameSetAllGamesIsAllowed = DoSetGameSetAllGamesIsAllowed;
var DoAdminLogoutAction = /** @class */ (function () {
    function DoAdminLogoutAction() {
    }
    DoAdminLogoutAction.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAdminLogoutAction.api_name = "api.admin.auth.doadminlogoutaction";
    return DoAdminLogoutAction;
}());
exports.DoAdminLogoutAction = DoAdminLogoutAction;
var ListAllowedPromoTemplatesByPProgramIdGet = /** @class */ (function () {
    function ListAllowedPromoTemplatesByPProgramIdGet() {
    }
    ListAllowedPromoTemplatesByPProgramIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedPromoTemplatesByPProgramIdGet.api_name = "api.admin.aff.pprograms.pub.promo.templates.listallowedpromotemplatesbypprogramidget";
    return ListAllowedPromoTemplatesByPProgramIdGet;
}());
exports.ListAllowedPromoTemplatesByPProgramIdGet = ListAllowedPromoTemplatesByPProgramIdGet;
var ListPProgramNewsLocalesByNewsIdGet = /** @class */ (function () {
    function ListPProgramNewsLocalesByNewsIdGet() {
    }
    ListPProgramNewsLocalesByNewsIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramNewsLocalesByNewsIdGet.api_name = "api.admin.aff.pprograms.news.locales.listpprogramnewslocalesbynewsidget";
    return ListPProgramNewsLocalesByNewsIdGet;
}());
exports.ListPProgramNewsLocalesByNewsIdGet = ListPProgramNewsLocalesByNewsIdGet;
var ListTournamentJoinTypesAvailGet = /** @class */ (function () {
    function ListTournamentJoinTypesAvailGet() {
    }
    ListTournamentJoinTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTournamentJoinTypesAvailGet.api_name = "api.admin.bonus.tournaments.bots.control.listtournamentjointypesavailget";
    return ListTournamentJoinTypesAvailGet;
}());
exports.ListTournamentJoinTypesAvailGet = ListTournamentJoinTypesAvailGet;
var DoAddBrandAppPayout = /** @class */ (function () {
    function DoAddBrandAppPayout() {
    }
    DoAddBrandAppPayout.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandAppPayout.api_name = "api.admin.brands.partners.payout.control.doaddbrandapppayout";
    return DoAddBrandAppPayout;
}());
exports.DoAddBrandAppPayout = DoAddBrandAppPayout;
var ListBannerRouteImagesByBannerRouteIdGet = /** @class */ (function () {
    function ListBannerRouteImagesByBannerRouteIdGet() {
    }
    ListBannerRouteImagesByBannerRouteIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBannerRouteImagesByBannerRouteIdGet.api_name = "api.admin.cms.banners.routes.images.listbannerrouteimagesbybannerrouteidget";
    return ListBannerRouteImagesByBannerRouteIdGet;
}());
exports.ListBannerRouteImagesByBannerRouteIdGet = ListBannerRouteImagesByBannerRouteIdGet;
var DoSetBrandPayProviderIsLocked = /** @class */ (function () {
    function DoSetBrandPayProviderIsLocked() {
    }
    DoSetBrandPayProviderIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandPayProviderIsLocked.api_name = "api.admin.brand.deposit.providers.control.dosetbrandpayproviderislocked";
    return DoSetBrandPayProviderIsLocked;
}());
exports.DoSetBrandPayProviderIsLocked = DoSetBrandPayProviderIsLocked;
var DoDeleteGwsGameProviderAdminAccess = /** @class */ (function () {
    function DoDeleteGwsGameProviderAdminAccess() {
    }
    DoDeleteGwsGameProviderAdminAccess.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteGwsGameProviderAdminAccess.api_name = "api.admin.access.gws.gameproviders.dodeletegwsgameprovideradminaccess";
    return DoDeleteGwsGameProviderAdminAccess;
}());
exports.DoDeleteGwsGameProviderAdminAccess = DoDeleteGwsGameProviderAdminAccess;
var DoDeletePProgramPartrnerPayDetails = /** @class */ (function () {
    function DoDeletePProgramPartrnerPayDetails() {
    }
    DoDeletePProgramPartrnerPayDetails.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramPartrnerPayDetails.api_name = "api.admin.aff.pprograms.usr.partners.paydetails.dodeletepprogrampartrnerpaydetails";
    return DoDeletePProgramPartrnerPayDetails;
}());
exports.DoDeletePProgramPartrnerPayDetails = DoDeletePProgramPartrnerPayDetails;
var DoDeleteCurrency = /** @class */ (function () {
    function DoDeleteCurrency() {
    }
    DoDeleteCurrency.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteCurrency.api_name = "api.admin.app.currency.dodeletecurrency";
    return DoDeleteCurrency;
}());
exports.DoDeleteCurrency = DoDeleteCurrency;
var DoSetAllAppCurrencyIsDeprecated = /** @class */ (function () {
    function DoSetAllAppCurrencyIsDeprecated() {
    }
    DoSetAllAppCurrencyIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetAllAppCurrencyIsDeprecated.api_name = "api.admin.app.currency.dosetallappcurrencyisdeprecated";
    return DoSetAllAppCurrencyIsDeprecated;
}());
exports.DoSetAllAppCurrencyIsDeprecated = DoSetAllAppCurrencyIsDeprecated;
var DoDeletePromoCodeTemplate = /** @class */ (function () {
    function DoDeletePromoCodeTemplate() {
    }
    DoDeletePromoCodeTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePromoCodeTemplate.api_name = "api.admin.bonus.promocodes.templates.control.dodeletepromocodetemplate";
    return DoDeletePromoCodeTemplate;
}());
exports.DoDeletePromoCodeTemplate = DoDeletePromoCodeTemplate;
var DoAddGwsGameProvider = /** @class */ (function () {
    function DoAddGwsGameProvider() {
    }
    DoAddGwsGameProvider.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddGwsGameProvider.api_name = "api.admin.gws.gameprovider.control.doaddgwsgameprovider";
    return DoAddGwsGameProvider;
}());
exports.DoAddGwsGameProvider = DoAddGwsGameProvider;
var ListPlayerEventHandlerTypesAvailGet = /** @class */ (function () {
    function ListPlayerEventHandlerTypesAvailGet() {
    }
    ListPlayerEventHandlerTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayerEventHandlerTypesAvailGet.api_name = "api.admin.brands.players.events.handlers.listplayereventhandlertypesavailget";
    return ListPlayerEventHandlerTypesAvailGet;
}());
exports.ListPlayerEventHandlerTypesAvailGet = ListPlayerEventHandlerTypesAvailGet;
var ListPProgramPartnersPromoCodeTemplatesGet = /** @class */ (function () {
    function ListPProgramPartnersPromoCodeTemplatesGet() {
    }
    ListPProgramPartnersPromoCodeTemplatesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramPartnersPromoCodeTemplatesGet.api_name = "api.admin.aff.pprograms.usr.partners.promocode.templates.listpprogrampartnerspromocodetemplatesget";
    return ListPProgramPartnersPromoCodeTemplatesGet;
}());
exports.ListPProgramPartnersPromoCodeTemplatesGet = ListPProgramPartnersPromoCodeTemplatesGet;
var DetailsPProgramNewsLocaleContentGet = /** @class */ (function () {
    function DetailsPProgramNewsLocaleContentGet() {
    }
    DetailsPProgramNewsLocaleContentGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsPProgramNewsLocaleContentGet.api_name = "api.admin.aff.pprograms.news.locales.detailspprogramnewslocalecontentget";
    return DetailsPProgramNewsLocaleContentGet;
}());
exports.DetailsPProgramNewsLocaleContentGet = DetailsPProgramNewsLocaleContentGet;
var DoEditBrand = /** @class */ (function () {
    function DoEditBrand() {
    }
    DoEditBrand.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrand.api_name = "api.admin.brands.control.doeditbrand";
    return DoEditBrand;
}());
exports.DoEditBrand = DoEditBrand;
var ListAllowedBrandsGet = /** @class */ (function () {
    function ListAllowedBrandsGet() {
    }
    ListAllowedBrandsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedBrandsGet.api_name = "api.admin.brands.control.listallowedbrandsget";
    return ListAllowedBrandsGet;
}());
exports.ListAllowedBrandsGet = ListAllowedBrandsGet;
var DoDeletePProgramPublicOffer = /** @class */ (function () {
    function DoDeletePProgramPublicOffer() {
    }
    DoDeletePProgramPublicOffer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramPublicOffer.api_name = "api.admin.aff.pprograms.pub.offers.dodeletepprogrampublicoffer";
    return DoDeletePProgramPublicOffer;
}());
exports.DoDeletePProgramPublicOffer = DoDeletePProgramPublicOffer;
var ListAvailBrandSecurityParsingActionsGet = /** @class */ (function () {
    function ListAvailBrandSecurityParsingActionsGet() {
    }
    ListAvailBrandSecurityParsingActionsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailBrandSecurityParsingActionsGet.api_name = "api.admin.brands.control.listavailbrandsecurityparsingactionsget";
    return ListAvailBrandSecurityParsingActionsGet;
}());
exports.ListAvailBrandSecurityParsingActionsGet = ListAvailBrandSecurityParsingActionsGet;
var ListAdminAccessByGwsGameProviderGet = /** @class */ (function () {
    function ListAdminAccessByGwsGameProviderGet() {
    }
    ListAdminAccessByGwsGameProviderGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAdminAccessByGwsGameProviderGet.api_name = "api.admin.access.gws.gameproviders.listadminaccessbygwsgameproviderget";
    return ListAdminAccessByGwsGameProviderGet;
}());
exports.ListAdminAccessByGwsGameProviderGet = ListAdminAccessByGwsGameProviderGet;
var DoSetPromoCodeTemplateCodeExpireParams = /** @class */ (function () {
    function DoSetPromoCodeTemplateCodeExpireParams() {
    }
    DoSetPromoCodeTemplateCodeExpireParams.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPromoCodeTemplateCodeExpireParams.api_name = "api.admin.bonus.promocodes.templates.codes.dosetpromocodetemplatecodeexpireparams";
    return DoSetPromoCodeTemplateCodeExpireParams;
}());
exports.DoSetPromoCodeTemplateCodeExpireParams = DoSetPromoCodeTemplateCodeExpireParams;
var DoAddBonusTemplateCurrencyConfig = /** @class */ (function () {
    function DoAddBonusTemplateCurrencyConfig() {
    }
    DoAddBonusTemplateCurrencyConfig.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusTemplateCurrencyConfig.api_name = "api.admin.bonus.templates.currency.config.doaddbonustemplatecurrencyconfig";
    return DoAddBonusTemplateCurrencyConfig;
}());
exports.DoAddBonusTemplateCurrencyConfig = DoAddBonusTemplateCurrencyConfig;
var ListAdminPermissionsGet = /** @class */ (function () {
    function ListAdminPermissionsGet() {
    }
    ListAdminPermissionsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAdminPermissionsGet.api_name = "api.admin.permissions.control.listadminpermissionsget";
    return ListAdminPermissionsGet;
}());
exports.ListAdminPermissionsGet = ListAdminPermissionsGet;
var DoDeleteBonusPlayerLevelLocale = /** @class */ (function () {
    function DoDeleteBonusPlayerLevelLocale() {
    }
    DoDeleteBonusPlayerLevelLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusPlayerLevelLocale.api_name = "api.admin.bonus.levels.locales.dodeletebonusplayerlevellocale";
    return DoDeleteBonusPlayerLevelLocale;
}());
exports.DoDeleteBonusPlayerLevelLocale = DoDeleteBonusPlayerLevelLocale;
var DoSetCountryIsUnknown = /** @class */ (function () {
    function DoSetCountryIsUnknown() {
    }
    DoSetCountryIsUnknown.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetCountryIsUnknown.api_name = "api.admin.app.country.control.dosetcountryisunknown";
    return DoSetCountryIsUnknown;
}());
exports.DoSetCountryIsUnknown = DoSetCountryIsUnknown;
var DoSetBrandBannerIsDeprecated = /** @class */ (function () {
    function DoSetBrandBannerIsDeprecated() {
    }
    DoSetBrandBannerIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandBannerIsDeprecated.api_name = "api.admin.aff.brands.banners.control.dosetbrandbannerisdeprecated";
    return DoSetBrandBannerIsDeprecated;
}());
exports.DoSetBrandBannerIsDeprecated = DoSetBrandBannerIsDeprecated;
var DoSetPlayerBonusStatusCompleted = /** @class */ (function () {
    function DoSetPlayerBonusStatusCompleted() {
    }
    DoSetPlayerBonusStatusCompleted.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPlayerBonusStatusCompleted.api_name = "api.admin.users.players.bonuses.control.dosetplayerbonusstatuscompleted";
    return DoSetPlayerBonusStatusCompleted;
}());
exports.DoSetPlayerBonusStatusCompleted = DoSetPlayerBonusStatusCompleted;
var DetailsPlayerStatisticsByWithdrawalReqGet = /** @class */ (function () {
    function DetailsPlayerStatisticsByWithdrawalReqGet() {
    }
    DetailsPlayerStatisticsByWithdrawalReqGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsPlayerStatisticsByWithdrawalReqGet.api_name = "api.admin.users.players.control.detailsplayerstatisticsbywithdrawalreqget";
    return DetailsPlayerStatisticsByWithdrawalReqGet;
}());
exports.DetailsPlayerStatisticsByWithdrawalReqGet = DetailsPlayerStatisticsByWithdrawalReqGet;
var DoSetGwsGameProviderGamePercentLevel = /** @class */ (function () {
    function DoSetGwsGameProviderGamePercentLevel() {
    }
    DoSetGwsGameProviderGamePercentLevel.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGwsGameProviderGamePercentLevel.api_name = "api.admin.gws.gameprovider.games.dosetgwsgameprovidergamepercentlevel";
    return DoSetGwsGameProviderGamePercentLevel;
}());
exports.DoSetGwsGameProviderGamePercentLevel = DoSetGwsGameProviderGamePercentLevel;
var DoDeletePayout = /** @class */ (function () {
    function DoDeletePayout() {
    }
    DoDeletePayout.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePayout.api_name = "api.admin.app.payout.dodeletepayout";
    return DoDeletePayout;
}());
exports.DoDeletePayout = DoDeletePayout;
var DoEditPostRecordContent = /** @class */ (function () {
    function DoEditPostRecordContent() {
    }
    DoEditPostRecordContent.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPostRecordContent.api_name = "api.admin.cms.posts.records.control.doeditpostrecordcontent";
    return DoEditPostRecordContent;
}());
exports.DoEditPostRecordContent = DoEditPostRecordContent;
var DoSetPermissionIsDeprecated = /** @class */ (function () {
    function DoSetPermissionIsDeprecated() {
    }
    DoSetPermissionIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPermissionIsDeprecated.api_name = "api.admin.permissions.control.dosetpermissionisdeprecated";
    return DoSetPermissionIsDeprecated;
}());
exports.DoSetPermissionIsDeprecated = DoSetPermissionIsDeprecated;
var DoSetBrandAppCountryIsDefault = /** @class */ (function () {
    function DoSetBrandAppCountryIsDefault() {
    }
    DoSetBrandAppCountryIsDefault.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandAppCountryIsDefault.api_name = "api.admin.brands.app.country.dosetbrandappcountryisdefault";
    return DoSetBrandAppCountryIsDefault;
}());
exports.DoSetBrandAppCountryIsDefault = DoSetBrandAppCountryIsDefault;
var DoDeleteBonusJackpot = /** @class */ (function () {
    function DoDeleteBonusJackpot() {
    }
    DoDeleteBonusJackpot.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusJackpot.api_name = "api.admin.bonus.jackpots.control.dodeletebonusjackpot";
    return DoDeleteBonusJackpot;
}());
exports.DoDeleteBonusJackpot = DoDeleteBonusJackpot;
var DoAddCssClass = /** @class */ (function () {
    function DoAddCssClass() {
    }
    DoAddCssClass.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddCssClass.api_name = "api.admin.app.cssclass.doaddcssclass";
    return DoAddCssClass;
}());
exports.DoAddCssClass = DoAddCssClass;
var DoAddBrandDomain = /** @class */ (function () {
    function DoAddBrandDomain() {
    }
    DoAddBrandDomain.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandDomain.api_name = "api.admin.brands.domains.control.doaddbranddomain";
    return DoAddBrandDomain;
}());
exports.DoAddBrandDomain = DoAddBrandDomain;
var DoAddAdminPermission = /** @class */ (function () {
    function DoAddAdminPermission() {
    }
    DoAddAdminPermission.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddAdminPermission.api_name = "api.admin.permissions.control.doaddadminpermission";
    return DoAddAdminPermission;
}());
exports.DoAddAdminPermission = DoAddAdminPermission;
var DoEditBrandPayProvider = /** @class */ (function () {
    function DoEditBrandPayProvider() {
    }
    DoEditBrandPayProvider.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandPayProvider.api_name = "api.admin.brand.deposit.providers.control.doeditbrandpayprovider";
    return DoEditBrandPayProvider;
}());
exports.DoEditBrandPayProvider = DoEditBrandPayProvider;
var ListAvailBrandSmsActionsGet = /** @class */ (function () {
    function ListAvailBrandSmsActionsGet() {
    }
    ListAvailBrandSmsActionsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailBrandSmsActionsGet.api_name = "api.admin.brands.templates.control.sms.set.control.listavailbrandsmsactionsget";
    return ListAvailBrandSmsActionsGet;
}());
exports.ListAvailBrandSmsActionsGet = ListAvailBrandSmsActionsGet;
var DoTestOfferFormula = /** @class */ (function () {
    function DoTestOfferFormula() {
    }
    DoTestOfferFormula.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoTestOfferFormula.api_name = "api.admin.aff.brands.offers.control.dotestofferformula";
    return DoTestOfferFormula;
}());
exports.DoTestOfferFormula = DoTestOfferFormula;
var DoImportAllTournamentGames = /** @class */ (function () {
    function DoImportAllTournamentGames() {
    }
    DoImportAllTournamentGames.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoImportAllTournamentGames.api_name = "api.admin.bonus.tournaments.games.doimportalltournamentgames";
    return DoImportAllTournamentGames;
}());
exports.DoImportAllTournamentGames = DoImportAllTournamentGames;
var DoSetGwsGameProviderGameIsHot = /** @class */ (function () {
    function DoSetGwsGameProviderGameIsHot() {
    }
    DoSetGwsGameProviderGameIsHot.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGwsGameProviderGameIsHot.api_name = "api.admin.gws.gameprovider.games.dosetgwsgameprovidergameishot";
    return DoSetGwsGameProviderGameIsHot;
}());
exports.DoSetGwsGameProviderGameIsHot = DoSetGwsGameProviderGameIsHot;
var DoDeleteInnerPayServicePayWay = /** @class */ (function () {
    function DoDeleteInnerPayServicePayWay() {
    }
    DoDeleteInnerPayServicePayWay.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteInnerPayServicePayWay.api_name = "api.admin.app.innerpay.services.payways.dodeleteinnerpayservicepayway";
    return DoDeleteInnerPayServicePayWay;
}());
exports.DoDeleteInnerPayServicePayWay = DoDeleteInnerPayServicePayWay;
var DoEditBonusTemplateLocale = /** @class */ (function () {
    function DoEditBonusTemplateLocale() {
    }
    DoEditBonusTemplateLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusTemplateLocale.api_name = "api.admin.bonus.templates.locales.doeditbonustemplatelocale";
    return DoEditBonusTemplateLocale;
}());
exports.DoEditBonusTemplateLocale = DoEditBonusTemplateLocale;
var DoLockAllPlayersCoveredByRule = /** @class */ (function () {
    function DoLockAllPlayersCoveredByRule() {
    }
    DoLockAllPlayersCoveredByRule.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoLockAllPlayersCoveredByRule.api_name = "api.admin.brands.security.firewall.dolockallplayerscoveredbyrule";
    return DoLockAllPlayersCoveredByRule;
}());
exports.DoLockAllPlayersCoveredByRule = DoLockAllPlayersCoveredByRule;
var ListTournamentKindsAvailGet = /** @class */ (function () {
    function ListTournamentKindsAvailGet() {
    }
    ListTournamentKindsAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTournamentKindsAvailGet.api_name = "api.admin.bonus.tournaments.control.listtournamentkindsavailget";
    return ListTournamentKindsAvailGet;
}());
exports.ListTournamentKindsAvailGet = ListTournamentKindsAvailGet;
var ListAllowedGameSetGamesByTournamentId = /** @class */ (function () {
    function ListAllowedGameSetGamesByTournamentId() {
    }
    ListAllowedGameSetGamesByTournamentId.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedGameSetGamesByTournamentId.api_name = "api.admin.bonus.tournaments.games.listallowedgamesetgamesbytournamentid";
    return ListAllowedGameSetGamesByTournamentId;
}());
exports.ListAllowedGameSetGamesByTournamentId = ListAllowedGameSetGamesByTournamentId;
var DoDeletePersonalPromoCodeOffer = /** @class */ (function () {
    function DoDeletePersonalPromoCodeOffer() {
    }
    DoDeletePersonalPromoCodeOffer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePersonalPromoCodeOffer.api_name = "api.admin.bonus.personal.promocode.offers.control.dodeletepersonalpromocodeoffer";
    return DoDeletePersonalPromoCodeOffer;
}());
exports.DoDeletePersonalPromoCodeOffer = DoDeletePersonalPromoCodeOffer;
var DoAddGwsGameProviderZone = /** @class */ (function () {
    function DoAddGwsGameProviderZone() {
    }
    DoAddGwsGameProviderZone.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddGwsGameProviderZone.api_name = "api.admin.gws.gameprovider.zones.doaddgwsgameproviderzone";
    return DoAddGwsGameProviderZone;
}());
exports.DoAddGwsGameProviderZone = DoAddGwsGameProviderZone;
var DoAddBrandBannerLocale = /** @class */ (function () {
    function DoAddBrandBannerLocale() {
    }
    DoAddBrandBannerLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandBannerLocale.api_name = "api.admin.aff.brands.banners.locales.doaddbrandbannerlocale";
    return DoAddBrandBannerLocale;
}());
exports.DoAddBrandBannerLocale = DoAddBrandBannerLocale;
var DoAddCmsGameProviderGameSetLocale = /** @class */ (function () {
    function DoAddCmsGameProviderGameSetLocale() {
    }
    DoAddCmsGameProviderGameSetLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddCmsGameProviderGameSetLocale.api_name = "api.admin.cms.gameset.locales.doaddcmsgameprovidergamesetlocale";
    return DoAddCmsGameProviderGameSetLocale;
}());
exports.DoAddCmsGameProviderGameSetLocale = DoAddCmsGameProviderGameSetLocale;
var DoDeleteSmsConfigRestriction = /** @class */ (function () {
    function DoDeleteSmsConfigRestriction() {
    }
    DoDeleteSmsConfigRestriction.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteSmsConfigRestriction.api_name = "api.admin.brands.sms.config.restrictions.dodeletesmsconfigrestriction";
    return DoDeleteSmsConfigRestriction;
}());
exports.DoDeleteSmsConfigRestriction = DoDeleteSmsConfigRestriction;
var DoSetUsrPartnerMessageIsReaded = /** @class */ (function () {
    function DoSetUsrPartnerMessageIsReaded() {
    }
    DoSetUsrPartnerMessageIsReaded.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetUsrPartnerMessageIsReaded.api_name = "api.admin.aff.pprograms.usr.partners.messages.dosetusrpartnermessageisreaded";
    return DoSetUsrPartnerMessageIsReaded;
}());
exports.DoSetUsrPartnerMessageIsReaded = DoSetUsrPartnerMessageIsReaded;
var DoCmsBrandContentFileDelete = /** @class */ (function () {
    function DoCmsBrandContentFileDelete() {
    }
    DoCmsBrandContentFileDelete.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsBrandContentFileDelete.api_name = "api.admin.cms.brands.content.docmsbrandcontentfiledelete";
    return DoCmsBrandContentFileDelete;
}());
exports.DoCmsBrandContentFileDelete = DoCmsBrandContentFileDelete;
var DoCmsBrandContentFileUploadReset = /** @class */ (function () {
    function DoCmsBrandContentFileUploadReset() {
    }
    DoCmsBrandContentFileUploadReset.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsBrandContentFileUploadReset.api_name = "api.admin.cms.brands.content.docmsbrandcontentfileuploadreset";
    return DoCmsBrandContentFileUploadReset;
}());
exports.DoCmsBrandContentFileUploadReset = DoCmsBrandContentFileUploadReset;
var DoSetGwsGameProviderGamePercentWager = /** @class */ (function () {
    function DoSetGwsGameProviderGamePercentWager() {
    }
    DoSetGwsGameProviderGamePercentWager.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGwsGameProviderGamePercentWager.api_name = "api.admin.gws.gameprovider.games.dosetgwsgameprovidergamepercentwager";
    return DoSetGwsGameProviderGamePercentWager;
}());
exports.DoSetGwsGameProviderGamePercentWager = DoSetGwsGameProviderGamePercentWager;
var DoEditBrandOfferAppCountry = /** @class */ (function () {
    function DoEditBrandOfferAppCountry() {
    }
    DoEditBrandOfferAppCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandOfferAppCountry.api_name = "api.admin.aff.brands.offers.country.doeditbrandofferappcountry";
    return DoEditBrandOfferAppCountry;
}());
exports.DoEditBrandOfferAppCountry = DoEditBrandOfferAppCountry;
var DoSetPromoCodeTemplateIsLocked = /** @class */ (function () {
    function DoSetPromoCodeTemplateIsLocked() {
    }
    DoSetPromoCodeTemplateIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPromoCodeTemplateIsLocked.api_name = "api.admin.bonus.promocodes.templates.control.dosetpromocodetemplateislocked";
    return DoSetPromoCodeTemplateIsLocked;
}());
exports.DoSetPromoCodeTemplateIsLocked = DoSetPromoCodeTemplateIsLocked;
var ListTournamentGamesAvailGet = /** @class */ (function () {
    function ListTournamentGamesAvailGet() {
    }
    ListTournamentGamesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTournamentGamesAvailGet.api_name = "api.admin.bonus.tournaments.bots.control.listtournamentgamesavailget";
    return ListTournamentGamesAvailGet;
}());
exports.ListTournamentGamesAvailGet = ListTournamentGamesAvailGet;
var DoDeleteBrandAppLanguage = /** @class */ (function () {
    function DoDeleteBrandAppLanguage() {
    }
    DoDeleteBrandAppLanguage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandAppLanguage.api_name = "api.admin.brands.app.languages.dodeletebrandapplanguage";
    return DoDeleteBrandAppLanguage;
}());
exports.DoDeleteBrandAppLanguage = DoDeleteBrandAppLanguage;
var ListCssClassesGet = /** @class */ (function () {
    function ListCssClassesGet() {
    }
    ListCssClassesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListCssClassesGet.api_name = "api.admin.app.cssclass.listcssclassesget";
    return ListCssClassesGet;
}());
exports.ListCssClassesGet = ListCssClassesGet;
var ListAllowedGameSetGamesByGameSetIdGet = /** @class */ (function () {
    function ListAllowedGameSetGamesByGameSetIdGet() {
    }
    ListAllowedGameSetGamesByGameSetIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedGameSetGamesByGameSetIdGet.api_name = "api.admin.cms.gameset.games.control.listallowedgamesetgamesbygamesetidget";
    return ListAllowedGameSetGamesByGameSetIdGet;
}());
exports.ListAllowedGameSetGamesByGameSetIdGet = ListAllowedGameSetGamesByGameSetIdGet;
var ListPartnerMessagesUnreadByPartnerIdGet = /** @class */ (function () {
    function ListPartnerMessagesUnreadByPartnerIdGet() {
    }
    ListPartnerMessagesUnreadByPartnerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPartnerMessagesUnreadByPartnerIdGet.api_name = "api.admin.aff.pprograms.usr.partners.messages.listpartnermessagesunreadbypartneridget";
    return ListPartnerMessagesUnreadByPartnerIdGet;
}());
exports.ListPartnerMessagesUnreadByPartnerIdGet = ListPartnerMessagesUnreadByPartnerIdGet;
var DoEditBrandGwsGameProviderSegmentation = /** @class */ (function () {
    function DoEditBrandGwsGameProviderSegmentation() {
    }
    DoEditBrandGwsGameProviderSegmentation.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandGwsGameProviderSegmentation.api_name = "api.admin.brands.gws.gameprovider.segmentation.doeditbrandgwsgameprovidersegmentation";
    return DoEditBrandGwsGameProviderSegmentation;
}());
exports.DoEditBrandGwsGameProviderSegmentation = DoEditBrandGwsGameProviderSegmentation;
var ListBrandBlackIpByBrandIdAndDateRangeGet = /** @class */ (function () {
    function ListBrandBlackIpByBrandIdAndDateRangeGet() {
    }
    ListBrandBlackIpByBrandIdAndDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandBlackIpByBrandIdAndDateRangeGet.api_name = "api.admin.brand.black.ip.listbrandblackipbybrandidanddaterangeget";
    return ListBrandBlackIpByBrandIdAndDateRangeGet;
}());
exports.ListBrandBlackIpByBrandIdAndDateRangeGet = ListBrandBlackIpByBrandIdAndDateRangeGet;
var DoSetBrandBrandingIsDeprecated = /** @class */ (function () {
    function DoSetBrandBrandingIsDeprecated() {
    }
    DoSetBrandBrandingIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandBrandingIsDeprecated.api_name = "api.admin.aff.brands.brandings.control.dosetbrandbrandingisdeprecated";
    return DoSetBrandBrandingIsDeprecated;
}());
exports.DoSetBrandBrandingIsDeprecated = DoSetBrandBrandingIsDeprecated;
var DetailsPProgramTemplateBannerGet = /** @class */ (function () {
    function DetailsPProgramTemplateBannerGet() {
    }
    DetailsPProgramTemplateBannerGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsPProgramTemplateBannerGet.api_name = "api.admin.aff.pprograms.control.detailspprogramtemplatebannerget";
    return DetailsPProgramTemplateBannerGet;
}());
exports.DetailsPProgramTemplateBannerGet = DetailsPProgramTemplateBannerGet;
var ListForBrandStatPartnersAvailGet = /** @class */ (function () {
    function ListForBrandStatPartnersAvailGet() {
    }
    ListForBrandStatPartnersAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListForBrandStatPartnersAvailGet.api_name = "api.admin.brands.partners.forstat.listforbrandstatpartnersavailget";
    return ListForBrandStatPartnersAvailGet;
}());
exports.ListForBrandStatPartnersAvailGet = ListForBrandStatPartnersAvailGet;
var DoEditBrandSmsConfig = /** @class */ (function () {
    function DoEditBrandSmsConfig() {
    }
    DoEditBrandSmsConfig.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandSmsConfig.api_name = "api.admin.brands.sms.config.control.doeditbrandsmsconfig";
    return DoEditBrandSmsConfig;
}());
exports.DoEditBrandSmsConfig = DoEditBrandSmsConfig;
var DoAddPlayer = /** @class */ (function () {
    function DoAddPlayer() {
    }
    DoAddPlayer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPlayer.api_name = "api.admin.users.players.control.doaddplayer";
    return DoAddPlayer;
}());
exports.DoAddPlayer = DoAddPlayer;
var DoDeleteBannerRoute = /** @class */ (function () {
    function DoDeleteBannerRoute() {
    }
    DoDeleteBannerRoute.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBannerRoute.api_name = "api.admin.cms.banners.routes.control.dodeletebannerroute";
    return DoDeleteBannerRoute;
}());
exports.DoDeleteBannerRoute = DoDeleteBannerRoute;
var DoAddBrandLandingCountry = /** @class */ (function () {
    function DoAddBrandLandingCountry() {
    }
    DoAddBrandLandingCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandLandingCountry.api_name = "api.admin.aff.brands.landings.country.doaddbrandlandingcountry";
    return DoAddBrandLandingCountry;
}());
exports.DoAddBrandLandingCountry = DoAddBrandLandingCountry;
var DoEditBonusTournamentSession = /** @class */ (function () {
    function DoEditBonusTournamentSession() {
    }
    DoEditBonusTournamentSession.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusTournamentSession.api_name = "api.admin.bonus.tournaments.sessions.control.doeditbonustournamentsession";
    return DoEditBonusTournamentSession;
}());
exports.DoEditBonusTournamentSession = DoEditBonusTournamentSession;
var ListInnerPayTransactionsByFiltersGet = /** @class */ (function () {
    function ListInnerPayTransactionsByFiltersGet() {
    }
    ListInnerPayTransactionsByFiltersGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListInnerPayTransactionsByFiltersGet.api_name = "api.admin.app.innerpay.transactions.listinnerpaytransactionsbyfiltersget";
    return ListInnerPayTransactionsByFiltersGet;
}());
exports.ListInnerPayTransactionsByFiltersGet = ListInnerPayTransactionsByFiltersGet;
var ListPProgramPartnerPlayersStatsByDateRangeGet = /** @class */ (function () {
    function ListPProgramPartnerPlayersStatsByDateRangeGet() {
    }
    ListPProgramPartnerPlayersStatsByDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramPartnerPlayersStatsByDateRangeGet.api_name = "api.admin.aff.pprograms.usr.partners.players.stats.listpprogrampartnerplayersstatsbydaterangeget";
    return ListPProgramPartnerPlayersStatsByDateRangeGet;
}());
exports.ListPProgramPartnerPlayersStatsByDateRangeGet = ListPProgramPartnerPlayersStatsByDateRangeGet;
var DoAddBrandLanding = /** @class */ (function () {
    function DoAddBrandLanding() {
    }
    DoAddBrandLanding.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandLanding.api_name = "api.admin.aff.brands.landings.control.doaddbrandlanding";
    return DoAddBrandLanding;
}());
exports.DoAddBrandLanding = DoAddBrandLanding;
var DoDeleteBrandBannerLocale = /** @class */ (function () {
    function DoDeleteBrandBannerLocale() {
    }
    DoDeleteBrandBannerLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandBannerLocale.api_name = "api.admin.aff.brands.banners.locales.dodeletebrandbannerlocale";
    return DoDeleteBrandBannerLocale;
}());
exports.DoDeleteBrandBannerLocale = DoDeleteBrandBannerLocale;
var DoDeleteBrandBranding = /** @class */ (function () {
    function DoDeleteBrandBranding() {
    }
    DoDeleteBrandBranding.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandBranding.api_name = "api.admin.aff.brands.brandings.control.dodeletebrandbranding";
    return DoDeleteBrandBranding;
}());
exports.DoDeleteBrandBranding = DoDeleteBrandBranding;
var ListPromoCodeTemplatesByBrandIdGet = /** @class */ (function () {
    function ListPromoCodeTemplatesByBrandIdGet() {
    }
    ListPromoCodeTemplatesByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPromoCodeTemplatesByBrandIdGet.api_name = "api.admin.bonus.promocodes.templates.control.listpromocodetemplatesbybrandidget";
    return ListPromoCodeTemplatesByBrandIdGet;
}());
exports.ListPromoCodeTemplatesByBrandIdGet = ListPromoCodeTemplatesByBrandIdGet;
var DoAddPProgramPartnerPayDetails = /** @class */ (function () {
    function DoAddPProgramPartnerPayDetails() {
    }
    DoAddPProgramPartnerPayDetails.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramPartnerPayDetails.api_name = "api.admin.aff.pprograms.usr.partners.paydetails.doaddpprogrampartnerpaydetails";
    return DoAddPProgramPartnerPayDetails;
}());
exports.DoAddPProgramPartnerPayDetails = DoAddPProgramPartnerPayDetails;
var DoSetPayoutIsDeprecated = /** @class */ (function () {
    function DoSetPayoutIsDeprecated() {
    }
    DoSetPayoutIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPayoutIsDeprecated.api_name = "api.admin.app.payout.dosetpayoutisdeprecated";
    return DoSetPayoutIsDeprecated;
}());
exports.DoSetPayoutIsDeprecated = DoSetPayoutIsDeprecated;
var DoDeleteBonusPromocodeTemplateCountry = /** @class */ (function () {
    function DoDeleteBonusPromocodeTemplateCountry() {
    }
    DoDeleteBonusPromocodeTemplateCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusPromocodeTemplateCountry.api_name = "api.admin.bonus.promocodes.templates.countries.dodeletebonuspromocodetemplatecountry";
    return DoDeleteBonusPromocodeTemplateCountry;
}());
exports.DoDeleteBonusPromocodeTemplateCountry = DoDeleteBonusPromocodeTemplateCountry;
var ListInnerPayServicesAvailGet = /** @class */ (function () {
    function ListInnerPayServicesAvailGet() {
    }
    ListInnerPayServicesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListInnerPayServicesAvailGet.api_name = "api.admin.app.innerpay.services.control.listinnerpayservicesavailget";
    return ListInnerPayServicesAvailGet;
}());
exports.ListInnerPayServicesAvailGet = ListInnerPayServicesAvailGet;
var ListBotPlayersByBrandIdGet = /** @class */ (function () {
    function ListBotPlayersByBrandIdGet() {
    }
    ListBotPlayersByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBotPlayersByBrandIdGet.api_name = "api.admin.users.players.control.listbotplayersbybrandidget";
    return ListBotPlayersByBrandIdGet;
}());
exports.ListBotPlayersByBrandIdGet = ListBotPlayersByBrandIdGet;
var ListPlayersProfitReportByDateRangeGet = /** @class */ (function () {
    function ListPlayersProfitReportByDateRangeGet() {
    }
    ListPlayersProfitReportByDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayersProfitReportByDateRangeGet.api_name = "api.admin.report.players.listplayersprofitreportbydaterangeget";
    return ListPlayersProfitReportByDateRangeGet;
}());
exports.ListPlayersProfitReportByDateRangeGet = ListPlayersProfitReportByDateRangeGet;
var DoNewWithdrawMarkCommited = /** @class */ (function () {
    function DoNewWithdrawMarkCommited() {
    }
    DoNewWithdrawMarkCommited.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoNewWithdrawMarkCommited.api_name = "api.admin.finance.control.donewwithdrawmarkcommited";
    return DoNewWithdrawMarkCommited;
}());
exports.DoNewWithdrawMarkCommited = DoNewWithdrawMarkCommited;
var ListBonusJackpotsByBrandIdGet = /** @class */ (function () {
    function ListBonusJackpotsByBrandIdGet() {
    }
    ListBonusJackpotsByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusJackpotsByBrandIdGet.api_name = "api.admin.bonus.jackpots.control.listbonusjackpotsbybrandidget";
    return ListBonusJackpotsByBrandIdGet;
}());
exports.ListBonusJackpotsByBrandIdGet = ListBonusJackpotsByBrandIdGet;
var DoCmsBrandContentFileUploadAll = /** @class */ (function () {
    function DoCmsBrandContentFileUploadAll() {
    }
    DoCmsBrandContentFileUploadAll.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsBrandContentFileUploadAll.api_name = "api.admin.cms.brands.content.docmsbrandcontentfileuploadall";
    return DoCmsBrandContentFileUploadAll;
}());
exports.DoCmsBrandContentFileUploadAll = DoCmsBrandContentFileUploadAll;
var DoEditCapchaTemplate = /** @class */ (function () {
    function DoEditCapchaTemplate() {
    }
    DoEditCapchaTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditCapchaTemplate.api_name = "api.admin.app.capchas.templates.control.doeditcapchatemplate";
    return DoEditCapchaTemplate;
}());
exports.DoEditCapchaTemplate = DoEditCapchaTemplate;
var DoSetPProgramPromoTemplateIsDeprecated = /** @class */ (function () {
    function DoSetPProgramPromoTemplateIsDeprecated() {
    }
    DoSetPProgramPromoTemplateIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPProgramPromoTemplateIsDeprecated.api_name = "api.admin.aff.pprograms.pub.promo.templates.dosetpprogrampromotemplateisdeprecated";
    return DoSetPProgramPromoTemplateIsDeprecated;
}());
exports.DoSetPProgramPromoTemplateIsDeprecated = DoSetPProgramPromoTemplateIsDeprecated;
var ListUsrPlayerAuthLogsByUsrPlayerIdGet = /** @class */ (function () {
    function ListUsrPlayerAuthLogsByUsrPlayerIdGet() {
    }
    ListUsrPlayerAuthLogsByUsrPlayerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListUsrPlayerAuthLogsByUsrPlayerIdGet.api_name = "api.admin.users.players.logs.auth.listusrplayerauthlogsbyusrplayeridget";
    return ListUsrPlayerAuthLogsByUsrPlayerIdGet;
}());
exports.ListUsrPlayerAuthLogsByUsrPlayerIdGet = ListUsrPlayerAuthLogsByUsrPlayerIdGet;
var ListBrandOffersByBrandsGet = /** @class */ (function () {
    function ListBrandOffersByBrandsGet() {
    }
    ListBrandOffersByBrandsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandOffersByBrandsGet.api_name = "api.admin.aff.brands.offers.control.listbrandoffersbybrandsget";
    return ListBrandOffersByBrandsGet;
}());
exports.ListBrandOffersByBrandsGet = ListBrandOffersByBrandsGet;
var DetailsBrandBonusEventBindingConfigOnLevelGet = /** @class */ (function () {
    function DetailsBrandBonusEventBindingConfigOnLevelGet() {
    }
    DetailsBrandBonusEventBindingConfigOnLevelGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsBrandBonusEventBindingConfigOnLevelGet.api_name = "api.admin.bonus.events.bindings.config.on_level.detailsbrandbonuseventbindingconfigonlevelget";
    return DetailsBrandBonusEventBindingConfigOnLevelGet;
}());
exports.DetailsBrandBonusEventBindingConfigOnLevelGet = DetailsBrandBonusEventBindingConfigOnLevelGet;
var DoSetGameSetGameFreeSpinDenomination = /** @class */ (function () {
    function DoSetGameSetGameFreeSpinDenomination() {
    }
    DoSetGameSetGameFreeSpinDenomination.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGameSetGameFreeSpinDenomination.api_name = "api.admin.cms.gameset.games.fsconfig.dosetgamesetgamefreespindenomination";
    return DoSetGameSetGameFreeSpinDenomination;
}());
exports.DoSetGameSetGameFreeSpinDenomination = DoSetGameSetGameFreeSpinDenomination;
var ListAllowedPayoutsGet = /** @class */ (function () {
    function ListAllowedPayoutsGet() {
    }
    ListAllowedPayoutsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedPayoutsGet.api_name = "api.admin.app.payout.listallowedpayoutsget";
    return ListAllowedPayoutsGet;
}());
exports.ListAllowedPayoutsGet = ListAllowedPayoutsGet;
var DoSetAllLanguagesIsDeprecated = /** @class */ (function () {
    function DoSetAllLanguagesIsDeprecated() {
    }
    DoSetAllLanguagesIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetAllLanguagesIsDeprecated.api_name = "api.admin.app.language.dosetalllanguagesisdeprecated";
    return DoSetAllLanguagesIsDeprecated;
}());
exports.DoSetAllLanguagesIsDeprecated = DoSetAllLanguagesIsDeprecated;
var DoNewWithdrawMarkRejected = /** @class */ (function () {
    function DoNewWithdrawMarkRejected() {
    }
    DoNewWithdrawMarkRejected.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoNewWithdrawMarkRejected.api_name = "api.admin.finance.control.donewwithdrawmarkrejected";
    return DoNewWithdrawMarkRejected;
}());
exports.DoNewWithdrawMarkRejected = DoNewWithdrawMarkRejected;
var ListPlayersGameLogsByPlayerIdAndDateRangeGet = /** @class */ (function () {
    function ListPlayersGameLogsByPlayerIdAndDateRangeGet() {
    }
    ListPlayersGameLogsByPlayerIdAndDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayersGameLogsByPlayerIdAndDateRangeGet.api_name = "api.admin.users.players.logs.games.listplayersgamelogsbyplayeridanddaterangeget";
    return ListPlayersGameLogsByPlayerIdAndDateRangeGet;
}());
exports.ListPlayersGameLogsByPlayerIdAndDateRangeGet = ListPlayersGameLogsByPlayerIdAndDateRangeGet;
var DoEditBonusJackpotLocale = /** @class */ (function () {
    function DoEditBonusJackpotLocale() {
    }
    DoEditBonusJackpotLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusJackpotLocale.api_name = "api.admin.bonus.jackpots.locales.doeditbonusjackpotlocale";
    return DoEditBonusJackpotLocale;
}());
exports.DoEditBonusJackpotLocale = DoEditBonusJackpotLocale;
var DoSetBrandAppPayoutIsLocked = /** @class */ (function () {
    function DoSetBrandAppPayoutIsLocked() {
    }
    DoSetBrandAppPayoutIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandAppPayoutIsLocked.api_name = "api.admin.brands.partners.payout.control.dosetbrandapppayoutislocked";
    return DoSetBrandAppPayoutIsLocked;
}());
exports.DoSetBrandAppPayoutIsLocked = DoSetBrandAppPayoutIsLocked;
var DoAddPProgramNewsLocale = /** @class */ (function () {
    function DoAddPProgramNewsLocale() {
    }
    DoAddPProgramNewsLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramNewsLocale.api_name = "api.admin.aff.pprograms.news.locales.doaddpprogramnewslocale";
    return DoAddPProgramNewsLocale;
}());
exports.DoAddPProgramNewsLocale = DoAddPProgramNewsLocale;
var DoSetPersonalPromoCodeOfferIsLocked = /** @class */ (function () {
    function DoSetPersonalPromoCodeOfferIsLocked() {
    }
    DoSetPersonalPromoCodeOfferIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPersonalPromoCodeOfferIsLocked.api_name = "api.admin.bonus.personal.promocode.offers.control.dosetpersonalpromocodeofferislocked";
    return DoSetPersonalPromoCodeOfferIsLocked;
}());
exports.DoSetPersonalPromoCodeOfferIsLocked = DoSetPersonalPromoCodeOfferIsLocked;
var ListAdminsGet = /** @class */ (function () {
    function ListAdminsGet() {
    }
    ListAdminsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAdminsGet.api_name = "api.admin.users.admins.listadminsget";
    return ListAdminsGet;
}());
exports.ListAdminsGet = ListAdminsGet;
var DoDeleteBrandAppCurrency = /** @class */ (function () {
    function DoDeleteBrandAppCurrency() {
    }
    DoDeleteBrandAppCurrency.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandAppCurrency.api_name = "api.admin.brands.app.currency.dodeletebrandappcurrency";
    return DoDeleteBrandAppCurrency;
}());
exports.DoDeleteBrandAppCurrency = DoDeleteBrandAppCurrency;
var DoDeleteCmsBot = /** @class */ (function () {
    function DoDeleteCmsBot() {
    }
    DoDeleteCmsBot.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteCmsBot.api_name = "api.admin.cms.bots.dodeletecmsbot";
    return DoDeleteCmsBot;
}());
exports.DoDeleteCmsBot = DoDeleteCmsBot;
var DoDeleteBonusTemplateZone = /** @class */ (function () {
    function DoDeleteBonusTemplateZone() {
    }
    DoDeleteBonusTemplateZone.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusTemplateZone.api_name = "api.admin.bonus.templates.zones.dodeletebonustemplatezone";
    return DoDeleteBonusTemplateZone;
}());
exports.DoDeleteBonusTemplateZone = DoDeleteBonusTemplateZone;
var DoSetPartnerPromoCodeDescription = /** @class */ (function () {
    function DoSetPartnerPromoCodeDescription() {
    }
    DoSetPartnerPromoCodeDescription.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPartnerPromoCodeDescription.api_name = "api.admin.aff.pprograms.usr.partners.promocode.codes.dosetpartnerpromocodedescription";
    return DoSetPartnerPromoCodeDescription;
}());
exports.DoSetPartnerPromoCodeDescription = DoSetPartnerPromoCodeDescription;
var ListBonusJackpotRestrictedPlayerTagsGet = /** @class */ (function () {
    function ListBonusJackpotRestrictedPlayerTagsGet() {
    }
    ListBonusJackpotRestrictedPlayerTagsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusJackpotRestrictedPlayerTagsGet.api_name = "api.admin.bonus.jackpots.restricted_player_tags.listbonusjackpotrestrictedplayertagsget";
    return ListBonusJackpotRestrictedPlayerTagsGet;
}());
exports.ListBonusJackpotRestrictedPlayerTagsGet = ListBonusJackpotRestrictedPlayerTagsGet;
var DoEditWagerOnDepBonusInstanceConfig = /** @class */ (function () {
    function DoEditWagerOnDepBonusInstanceConfig() {
    }
    DoEditWagerOnDepBonusInstanceConfig.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditWagerOnDepBonusInstanceConfig.api_name = "api.admin.users.players.bonuses.config.wager_on_dep.doeditwagerondepbonusinstanceconfig";
    return DoEditWagerOnDepBonusInstanceConfig;
}());
exports.DoEditWagerOnDepBonusInstanceConfig = DoEditWagerOnDepBonusInstanceConfig;
var DoDeletePProgramPartnerOffer = /** @class */ (function () {
    function DoDeletePProgramPartnerOffer() {
    }
    DoDeletePProgramPartnerOffer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramPartnerOffer.api_name = "api.admin.aff.pprograms.usr.partners.offers.dodeletepprogrampartneroffer";
    return DoDeletePProgramPartnerOffer;
}());
exports.DoDeletePProgramPartnerOffer = DoDeletePProgramPartnerOffer;
var DoAddBonusJackpotRestrictedPlayerTag = /** @class */ (function () {
    function DoAddBonusJackpotRestrictedPlayerTag() {
    }
    DoAddBonusJackpotRestrictedPlayerTag.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusJackpotRestrictedPlayerTag.api_name = "api.admin.bonus.jackpots.restricted_player_tags.doaddbonusjackpotrestrictedplayertag";
    return DoAddBonusJackpotRestrictedPlayerTag;
}());
exports.DoAddBonusJackpotRestrictedPlayerTag = DoAddBonusJackpotRestrictedPlayerTag;
var DoDeleteTournamentGame = /** @class */ (function () {
    function DoDeleteTournamentGame() {
    }
    DoDeleteTournamentGame.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteTournamentGame.api_name = "api.admin.bonus.tournaments.games.dodeletetournamentgame";
    return DoDeleteTournamentGame;
}());
exports.DoDeleteTournamentGame = DoDeleteTournamentGame;
var DoSetPProgramPartnerIsLocked = /** @class */ (function () {
    function DoSetPProgramPartnerIsLocked() {
    }
    DoSetPProgramPartnerIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPProgramPartnerIsLocked.api_name = "api.admin.aff.pprograms.usr.partners.control.dosetpprogrampartnerislocked";
    return DoSetPProgramPartnerIsLocked;
}());
exports.DoSetPProgramPartnerIsLocked = DoSetPProgramPartnerIsLocked;
var ListWinnersTopByBrandIdGetGet = /** @class */ (function () {
    function ListWinnersTopByBrandIdGetGet() {
    }
    ListWinnersTopByBrandIdGetGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListWinnersTopByBrandIdGetGet.api_name = "api.admin.cms.winners.top.listwinnerstopbybrandidgetget";
    return ListWinnersTopByBrandIdGetGet;
}());
exports.ListWinnersTopByBrandIdGetGet = ListWinnersTopByBrandIdGetGet;
var DoAddTournamentBet = /** @class */ (function () {
    function DoAddTournamentBet() {
    }
    DoAddTournamentBet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddTournamentBet.api_name = "api.admin.bonus.tournaments.bets.doaddtournamentbet";
    return DoAddTournamentBet;
}());
exports.DoAddTournamentBet = DoAddTournamentBet;
var ListPlayerPromocodesByPlayerIdAndDateRangeGet = /** @class */ (function () {
    function ListPlayerPromocodesByPlayerIdAndDateRangeGet() {
    }
    ListPlayerPromocodesByPlayerIdAndDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayerPromocodesByPlayerIdAndDateRangeGet.api_name = "api.admin.users.players.promocodes.listplayerpromocodesbyplayeridanddaterangeget";
    return ListPlayerPromocodesByPlayerIdAndDateRangeGet;
}());
exports.ListPlayerPromocodesByPlayerIdAndDateRangeGet = ListPlayerPromocodesByPlayerIdAndDateRangeGet;
var DoAddBannerRouteImage = /** @class */ (function () {
    function DoAddBannerRouteImage() {
    }
    DoAddBannerRouteImage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBannerRouteImage.api_name = "api.admin.cms.banners.routes.images.doaddbannerrouteimage";
    return DoAddBannerRouteImage;
}());
exports.DoAddBannerRouteImage = DoAddBannerRouteImage;
var DoUpdateBonusTournamentLocaleDescriptionTpl = /** @class */ (function () {
    function DoUpdateBonusTournamentLocaleDescriptionTpl() {
    }
    DoUpdateBonusTournamentLocaleDescriptionTpl.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoUpdateBonusTournamentLocaleDescriptionTpl.api_name = "api.admin.bonus.tournaments.locales.doupdatebonustournamentlocaledescriptiontpl";
    return DoUpdateBonusTournamentLocaleDescriptionTpl;
}());
exports.DoUpdateBonusTournamentLocaleDescriptionTpl = DoUpdateBonusTournamentLocaleDescriptionTpl;
var DoSetWinnerTopIsLocked = /** @class */ (function () {
    function DoSetWinnerTopIsLocked() {
    }
    DoSetWinnerTopIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetWinnerTopIsLocked.api_name = "api.admin.cms.winners.top.dosetwinnertopislocked";
    return DoSetWinnerTopIsLocked;
}());
exports.DoSetWinnerTopIsLocked = DoSetWinnerTopIsLocked;
var DoSetPProgramIsDeprecated = /** @class */ (function () {
    function DoSetPProgramIsDeprecated() {
    }
    DoSetPProgramIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPProgramIsDeprecated.api_name = "api.admin.aff.pprograms.control.dosetpprogramisdeprecated";
    return DoSetPProgramIsDeprecated;
}());
exports.DoSetPProgramIsDeprecated = DoSetPProgramIsDeprecated;
var DoEditPartnerReconciliation = /** @class */ (function () {
    function DoEditPartnerReconciliation() {
    }
    DoEditPartnerReconciliation.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPartnerReconciliation.api_name = "api.admin.aff.pprograms.reconciliations.control.doeditpartnerreconciliation";
    return DoEditPartnerReconciliation;
}());
exports.DoEditPartnerReconciliation = DoEditPartnerReconciliation;
var ListTournamentStatesTypesAvailGet = /** @class */ (function () {
    function ListTournamentStatesTypesAvailGet() {
    }
    ListTournamentStatesTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTournamentStatesTypesAvailGet.api_name = "api.admin.bonus.tournaments.control.listtournamentstatestypesavailget";
    return ListTournamentStatesTypesAvailGet;
}());
exports.ListTournamentStatesTypesAvailGet = ListTournamentStatesTypesAvailGet;
var DoDeleteTournamentTicket = /** @class */ (function () {
    function DoDeleteTournamentTicket() {
    }
    DoDeleteTournamentTicket.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteTournamentTicket.api_name = "api.admin.bonus.tournaments.tickets.dodeletetournamentticket";
    return DoDeleteTournamentTicket;
}());
exports.DoDeleteTournamentTicket = DoDeleteTournamentTicket;
var DoDeleteBrandGwsGameproviderSegmentation = /** @class */ (function () {
    function DoDeleteBrandGwsGameproviderSegmentation() {
    }
    DoDeleteBrandGwsGameproviderSegmentation.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandGwsGameproviderSegmentation.api_name = "api.admin.brands.gws.gameprovider.segmentation.dodeletebrandgwsgameprovidersegmentation";
    return DoDeleteBrandGwsGameproviderSegmentation;
}());
exports.DoDeleteBrandGwsGameproviderSegmentation = DoDeleteBrandGwsGameproviderSegmentation;
var ListCmsBotsByBrandIdGet = /** @class */ (function () {
    function ListCmsBotsByBrandIdGet() {
    }
    ListCmsBotsByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListCmsBotsByBrandIdGet.api_name = "api.admin.cms.bots.listcmsbotsbybrandidget";
    return ListCmsBotsByBrandIdGet;
}());
exports.ListCmsBotsByBrandIdGet = ListCmsBotsByBrandIdGet;
var DoAddAppUsrPlayerTag = /** @class */ (function () {
    function DoAddAppUsrPlayerTag() {
    }
    DoAddAppUsrPlayerTag.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddAppUsrPlayerTag.api_name = "api.admin.app.usr.players.tags.doaddappusrplayertag";
    return DoAddAppUsrPlayerTag;
}());
exports.DoAddAppUsrPlayerTag = DoAddAppUsrPlayerTag;
var ListBrandLandingLocalesByLandingIdGet = /** @class */ (function () {
    function ListBrandLandingLocalesByLandingIdGet() {
    }
    ListBrandLandingLocalesByLandingIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandLandingLocalesByLandingIdGet.api_name = "api.admin.aff.brands.landings.locales.listbrandlandinglocalesbylandingidget";
    return ListBrandLandingLocalesByLandingIdGet;
}());
exports.ListBrandLandingLocalesByLandingIdGet = ListBrandLandingLocalesByLandingIdGet;
var DoGeneratePromoCodeTemplateCodes = /** @class */ (function () {
    function DoGeneratePromoCodeTemplateCodes() {
    }
    DoGeneratePromoCodeTemplateCodes.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoGeneratePromoCodeTemplateCodes.api_name = "api.admin.bonus.promocodes.templates.codes.dogeneratepromocodetemplatecodes";
    return DoGeneratePromoCodeTemplateCodes;
}());
exports.DoGeneratePromoCodeTemplateCodes = DoGeneratePromoCodeTemplateCodes;
var DoDeletReconciliationPartner = /** @class */ (function () {
    function DoDeletReconciliationPartner() {
    }
    DoDeletReconciliationPartner.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletReconciliationPartner.api_name = "api.admin.aff.pprograms.reconciliations.partners.dodeletreconciliationpartner";
    return DoDeletReconciliationPartner;
}());
exports.DoDeletReconciliationPartner = DoDeletReconciliationPartner;
var ListTrustEventHandlersByBrandIdGet = /** @class */ (function () {
    function ListTrustEventHandlersByBrandIdGet() {
    }
    ListTrustEventHandlersByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTrustEventHandlersByBrandIdGet.api_name = "api.admin.brands.security.trust.handlers.listtrusteventhandlersbybrandidget";
    return ListTrustEventHandlersByBrandIdGet;
}());
exports.ListTrustEventHandlersByBrandIdGet = ListTrustEventHandlersByBrandIdGet;
var DoPlusGameSetGamePriority = /** @class */ (function () {
    function DoPlusGameSetGamePriority() {
    }
    DoPlusGameSetGamePriority.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoPlusGameSetGamePriority.api_name = "api.admin.cms.gameset.games.control.doplusgamesetgamepriority";
    return DoPlusGameSetGamePriority;
}());
exports.DoPlusGameSetGamePriority = DoPlusGameSetGamePriority;
var DoSetPlayerIsLocked = /** @class */ (function () {
    function DoSetPlayerIsLocked() {
    }
    DoSetPlayerIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPlayerIsLocked.api_name = "api.admin.users.players.control.dosetplayerislocked";
    return DoSetPlayerIsLocked;
}());
exports.DoSetPlayerIsLocked = DoSetPlayerIsLocked;
var DoGetRawBrandSmsSetMockObjectForTest = /** @class */ (function () {
    function DoGetRawBrandSmsSetMockObjectForTest() {
    }
    DoGetRawBrandSmsSetMockObjectForTest.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoGetRawBrandSmsSetMockObjectForTest.api_name = "api.admin.brands.templates.control.sms.set.control.dogetrawbrandsmssetmockobjectfortest";
    return DoGetRawBrandSmsSetMockObjectForTest;
}());
exports.DoGetRawBrandSmsSetMockObjectForTest = DoGetRawBrandSmsSetMockObjectForTest;
var ListAvailPProgramEmailActionsGet = /** @class */ (function () {
    function ListAvailPProgramEmailActionsGet() {
    }
    ListAvailPProgramEmailActionsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailPProgramEmailActionsGet.api_name = "api.admin.aff.pprograms.email.set.templates.control.listavailpprogramemailactionsget";
    return ListAvailPProgramEmailActionsGet;
}());
exports.ListAvailPProgramEmailActionsGet = ListAvailPProgramEmailActionsGet;
var DoEditPProgramEmailSetTemplateData = /** @class */ (function () {
    function DoEditPProgramEmailSetTemplateData() {
    }
    DoEditPProgramEmailSetTemplateData.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgramEmailSetTemplateData.api_name = "api.admin.aff.pprograms.email.set.templates.control.doeditpprogramemailsettemplatedata";
    return DoEditPProgramEmailSetTemplateData;
}());
exports.DoEditPProgramEmailSetTemplateData = DoEditPProgramEmailSetTemplateData;
var DoSetPProgramBrandPriority = /** @class */ (function () {
    function DoSetPProgramBrandPriority() {
    }
    DoSetPProgramBrandPriority.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPProgramBrandPriority.api_name = "api.admin.aff.pprograms.brands.dosetpprogrambrandpriority";
    return DoSetPProgramBrandPriority;
}());
exports.DoSetPProgramBrandPriority = DoSetPProgramBrandPriority;
var DoSetGwsGameProviderGameIsFreeSpin = /** @class */ (function () {
    function DoSetGwsGameProviderGameIsFreeSpin() {
    }
    DoSetGwsGameProviderGameIsFreeSpin.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGwsGameProviderGameIsFreeSpin.api_name = "api.admin.gws.gameprovider.games.dosetgwsgameprovidergameisfreespin";
    return DoSetGwsGameProviderGameIsFreeSpin;
}());
exports.DoSetGwsGameProviderGameIsFreeSpin = DoSetGwsGameProviderGameIsFreeSpin;
var ListAllowedUsrPermissionsByObtainAdminIdGet = /** @class */ (function () {
    function ListAllowedUsrPermissionsByObtainAdminIdGet() {
    }
    ListAllowedUsrPermissionsByObtainAdminIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedUsrPermissionsByObtainAdminIdGet.api_name = "api.admin.access.usr.permissions.listallowedusrpermissionsbyobtainadminidget";
    return ListAllowedUsrPermissionsByObtainAdminIdGet;
}());
exports.ListAllowedUsrPermissionsByObtainAdminIdGet = ListAllowedUsrPermissionsByObtainAdminIdGet;
var DoImportCurrency = /** @class */ (function () {
    function DoImportCurrency() {
    }
    DoImportCurrency.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoImportCurrency.api_name = "api.admin.app.currency.doimportcurrency";
    return DoImportCurrency;
}());
exports.DoImportCurrency = DoImportCurrency;
var ListAvailSmsProvidersGet = /** @class */ (function () {
    function ListAvailSmsProvidersGet() {
    }
    ListAvailSmsProvidersGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailSmsProvidersGet.api_name = "api.admin.brands.sms.config.control.listavailsmsprovidersget";
    return ListAvailSmsProvidersGet;
}());
exports.ListAvailSmsProvidersGet = ListAvailSmsProvidersGet;
var ListBrandPayProvidersInTrustZoneByBrandIdAndZoneGet = /** @class */ (function () {
    function ListBrandPayProvidersInTrustZoneByBrandIdAndZoneGet() {
    }
    ListBrandPayProvidersInTrustZoneByBrandIdAndZoneGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandPayProvidersInTrustZoneByBrandIdAndZoneGet.api_name = "api.admin.brand.deposit.providers.by.trust.zones.listbrandpayprovidersintrustzonebybrandidandzoneget";
    return ListBrandPayProvidersInTrustZoneByBrandIdAndZoneGet;
}());
exports.ListBrandPayProvidersInTrustZoneByBrandIdAndZoneGet = ListBrandPayProvidersInTrustZoneByBrandIdAndZoneGet;
var DoGenerateBrandApiSecret = /** @class */ (function () {
    function DoGenerateBrandApiSecret() {
    }
    DoGenerateBrandApiSecret.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoGenerateBrandApiSecret.api_name = "api.admin.brands.control.dogeneratebrandapisecret";
    return DoGenerateBrandApiSecret;
}());
exports.DoGenerateBrandApiSecret = DoGenerateBrandApiSecret;
var ListBrandDomainsByBrandAndCountryGet = /** @class */ (function () {
    function ListBrandDomainsByBrandAndCountryGet() {
    }
    ListBrandDomainsByBrandAndCountryGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandDomainsByBrandAndCountryGet.api_name = "api.admin.brands.domains.control.listbranddomainsbybrandandcountryget";
    return ListBrandDomainsByBrandAndCountryGet;
}());
exports.ListBrandDomainsByBrandAndCountryGet = ListBrandDomainsByBrandAndCountryGet;
var DoGetRawBrandMessageSetMockObjectForTest = /** @class */ (function () {
    function DoGetRawBrandMessageSetMockObjectForTest() {
    }
    DoGetRawBrandMessageSetMockObjectForTest.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoGetRawBrandMessageSetMockObjectForTest.api_name = "api.admin.brands.templates.control.message.set.control.dogetrawbrandmessagesetmockobjectfortest";
    return DoGetRawBrandMessageSetMockObjectForTest;
}());
exports.DoGetRawBrandMessageSetMockObjectForTest = DoGetRawBrandMessageSetMockObjectForTest;
var DoAddPProgramBrand = /** @class */ (function () {
    function DoAddPProgramBrand() {
    }
    DoAddPProgramBrand.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramBrand.api_name = "api.admin.aff.pprograms.brands.doaddpprogrambrand";
    return DoAddPProgramBrand;
}());
exports.DoAddPProgramBrand = DoAddPProgramBrand;
var DoAdminLoginAction = /** @class */ (function () {
    function DoAdminLoginAction() {
    }
    DoAdminLoginAction.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAdminLoginAction.api_name = "api.admin.auth.doadminloginaction";
    return DoAdminLoginAction;
}());
exports.DoAdminLoginAction = DoAdminLoginAction;
var DoCmsBrandContentDirectoryRename = /** @class */ (function () {
    function DoCmsBrandContentDirectoryRename() {
    }
    DoCmsBrandContentDirectoryRename.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsBrandContentDirectoryRename.api_name = "api.admin.cms.brands.content.docmsbrandcontentdirectoryrename";
    return DoCmsBrandContentDirectoryRename;
}());
exports.DoCmsBrandContentDirectoryRename = DoCmsBrandContentDirectoryRename;
var ListReconciliationSubPartnersByReconciliationPartnerIdGet = /** @class */ (function () {
    function ListReconciliationSubPartnersByReconciliationPartnerIdGet() {
    }
    ListReconciliationSubPartnersByReconciliationPartnerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListReconciliationSubPartnersByReconciliationPartnerIdGet.api_name = "api.admin.aff.pprograms.reconciliations.partners.listreconciliationsubpartnersbyreconciliationpartneridget";
    return ListReconciliationSubPartnersByReconciliationPartnerIdGet;
}());
exports.ListReconciliationSubPartnersByReconciliationPartnerIdGet = ListReconciliationSubPartnersByReconciliationPartnerIdGet;
var DoSetBannerRouteImagePriority = /** @class */ (function () {
    function DoSetBannerRouteImagePriority() {
    }
    DoSetBannerRouteImagePriority.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBannerRouteImagePriority.api_name = "api.admin.cms.banners.routes.images.dosetbannerrouteimagepriority";
    return DoSetBannerRouteImagePriority;
}());
exports.DoSetBannerRouteImagePriority = DoSetBannerRouteImagePriority;
var DetailsPProgramEmailSetTemplateDataGet = /** @class */ (function () {
    function DetailsPProgramEmailSetTemplateDataGet() {
    }
    DetailsPProgramEmailSetTemplateDataGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsPProgramEmailSetTemplateDataGet.api_name = "api.admin.aff.pprograms.email.set.templates.control.detailspprogramemailsettemplatedataget";
    return DetailsPProgramEmailSetTemplateDataGet;
}());
exports.DetailsPProgramEmailSetTemplateDataGet = DetailsPProgramEmailSetTemplateDataGet;
var ListJackpotWinnersByJpIdAndDateRangeGet = /** @class */ (function () {
    function ListJackpotWinnersByJpIdAndDateRangeGet() {
    }
    ListJackpotWinnersByJpIdAndDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListJackpotWinnersByJpIdAndDateRangeGet.api_name = "api.admin.bonus.jackpots.winners.listjackpotwinnersbyjpidanddaterangeget";
    return ListJackpotWinnersByJpIdAndDateRangeGet;
}());
exports.ListJackpotWinnersByJpIdAndDateRangeGet = ListJackpotWinnersByJpIdAndDateRangeGet;
var DoSetInnerPayServiceIsLocked = /** @class */ (function () {
    function DoSetInnerPayServiceIsLocked() {
    }
    DoSetInnerPayServiceIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetInnerPayServiceIsLocked.api_name = "api.admin.app.innerpay.services.control.dosetinnerpayserviceislocked";
    return DoSetInnerPayServiceIsLocked;
}());
exports.DoSetInnerPayServiceIsLocked = DoSetInnerPayServiceIsLocked;
var DoSetBrandIsLocked = /** @class */ (function () {
    function DoSetBrandIsLocked() {
    }
    DoSetBrandIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandIsLocked.api_name = "api.admin.brands.control.dosetbrandislocked";
    return DoSetBrandIsLocked;
}());
exports.DoSetBrandIsLocked = DoSetBrandIsLocked;
var DoAddPayout = /** @class */ (function () {
    function DoAddPayout() {
    }
    DoAddPayout.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPayout.api_name = "api.admin.app.payout.doaddpayout";
    return DoAddPayout;
}());
exports.DoAddPayout = DoAddPayout;
var DoEditTournamentGame = /** @class */ (function () {
    function DoEditTournamentGame() {
    }
    DoEditTournamentGame.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditTournamentGame.api_name = "api.admin.bonus.tournaments.games.doedittournamentgame";
    return DoEditTournamentGame;
}());
exports.DoEditTournamentGame = DoEditTournamentGame;
var DoSetGwsGameProviderGameIsLocked = /** @class */ (function () {
    function DoSetGwsGameProviderGameIsLocked() {
    }
    DoSetGwsGameProviderGameIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGwsGameProviderGameIsLocked.api_name = "api.admin.gws.gameprovider.games.dosetgwsgameprovidergameislocked";
    return DoSetGwsGameProviderGameIsLocked;
}());
exports.DoSetGwsGameProviderGameIsLocked = DoSetGwsGameProviderGameIsLocked;
var ListBrandAppPayoutsByBrandIdGet = /** @class */ (function () {
    function ListBrandAppPayoutsByBrandIdGet() {
    }
    ListBrandAppPayoutsByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandAppPayoutsByBrandIdGet.api_name = "api.admin.brands.partners.payout.control.listbrandapppayoutsbybrandidget";
    return ListBrandAppPayoutsByBrandIdGet;
}());
exports.ListBrandAppPayoutsByBrandIdGet = ListBrandAppPayoutsByBrandIdGet;
var DoImportGwsGameProviderGames = /** @class */ (function () {
    function DoImportGwsGameProviderGames() {
    }
    DoImportGwsGameProviderGames.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoImportGwsGameProviderGames.api_name = "api.admin.gws.gameprovider.control.doimportgwsgameprovidergames";
    return DoImportGwsGameProviderGames;
}());
exports.DoImportGwsGameProviderGames = DoImportGwsGameProviderGames;
var DoDeleteUserPlayerMessage = /** @class */ (function () {
    function DoDeleteUserPlayerMessage() {
    }
    DoDeleteUserPlayerMessage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteUserPlayerMessage.api_name = "api.admin.users.players.messages.dodeleteuserplayermessage";
    return DoDeleteUserPlayerMessage;
}());
exports.DoDeleteUserPlayerMessage = DoDeleteUserPlayerMessage;
var DoCloneBonusTemplateLocale = /** @class */ (function () {
    function DoCloneBonusTemplateLocale() {
    }
    DoCloneBonusTemplateLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCloneBonusTemplateLocale.api_name = "api.admin.bonus.templates.locales.doclonebonustemplatelocale";
    return DoCloneBonusTemplateLocale;
}());
exports.DoCloneBonusTemplateLocale = DoCloneBonusTemplateLocale;
var ListAllowedPromoCodeTemplateCodesByPromoCodeTemplateIdGet = /** @class */ (function () {
    function ListAllowedPromoCodeTemplateCodesByPromoCodeTemplateIdGet() {
    }
    ListAllowedPromoCodeTemplateCodesByPromoCodeTemplateIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedPromoCodeTemplateCodesByPromoCodeTemplateIdGet.api_name = "api.admin.bonus.promocodes.templates.codes.listallowedpromocodetemplatecodesbypromocodetemplateidget";
    return ListAllowedPromoCodeTemplateCodesByPromoCodeTemplateIdGet;
}());
exports.ListAllowedPromoCodeTemplateCodesByPromoCodeTemplateIdGet = ListAllowedPromoCodeTemplateCodesByPromoCodeTemplateIdGet;
var DoEditBonusJackpot = /** @class */ (function () {
    function DoEditBonusJackpot() {
    }
    DoEditBonusJackpot.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusJackpot.api_name = "api.admin.bonus.jackpots.control.doeditbonusjackpot";
    return DoEditBonusJackpot;
}());
exports.DoEditBonusJackpot = DoEditBonusJackpot;
var DoSetPlayerBonusFromCancelledToActive = /** @class */ (function () {
    function DoSetPlayerBonusFromCancelledToActive() {
    }
    DoSetPlayerBonusFromCancelledToActive.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPlayerBonusFromCancelledToActive.api_name = "api.admin.users.players.bonuses.control.dosetplayerbonusfromcancelledtoactive";
    return DoSetPlayerBonusFromCancelledToActive;
}());
exports.DoSetPlayerBonusFromCancelledToActive = DoSetPlayerBonusFromCancelledToActive;
var DoAddTournamentGame = /** @class */ (function () {
    function DoAddTournamentGame() {
    }
    DoAddTournamentGame.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddTournamentGame.api_name = "api.admin.bonus.tournaments.games.doaddtournamentgame";
    return DoAddTournamentGame;
}());
exports.DoAddTournamentGame = DoAddTournamentGame;
var DoSetGameSetGameFreeSpinMultiplier = /** @class */ (function () {
    function DoSetGameSetGameFreeSpinMultiplier() {
    }
    DoSetGameSetGameFreeSpinMultiplier.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGameSetGameFreeSpinMultiplier.api_name = "api.admin.cms.gameset.games.fsconfig.dosetgamesetgamefreespinmultiplier";
    return DoSetGameSetGameFreeSpinMultiplier;
}());
exports.DoSetGameSetGameFreeSpinMultiplier = DoSetGameSetGameFreeSpinMultiplier;
var DoDeleteAdminPermission = /** @class */ (function () {
    function DoDeleteAdminPermission() {
    }
    DoDeleteAdminPermission.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteAdminPermission.api_name = "api.admin.permissions.control.dodeleteadminpermission";
    return DoDeleteAdminPermission;
}());
exports.DoDeleteAdminPermission = DoDeleteAdminPermission;
var DoAddPartnerPromoCodeCode = /** @class */ (function () {
    function DoAddPartnerPromoCodeCode() {
    }
    DoAddPartnerPromoCodeCode.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPartnerPromoCodeCode.api_name = "api.admin.aff.pprograms.usr.partners.promocode.codes.doaddpartnerpromocodecode";
    return DoAddPartnerPromoCodeCode;
}());
exports.DoAddPartnerPromoCodeCode = DoAddPartnerPromoCodeCode;
var ListAllowedGwsGameProvidersByBrandIdGet = /** @class */ (function () {
    function ListAllowedGwsGameProvidersByBrandIdGet() {
    }
    ListAllowedGwsGameProvidersByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedGwsGameProvidersByBrandIdGet.api_name = "api.admin.gws.gameprovider.control.listallowedgwsgameprovidersbybrandidget";
    return ListAllowedGwsGameProvidersByBrandIdGet;
}());
exports.ListAllowedGwsGameProvidersByBrandIdGet = ListAllowedGwsGameProvidersByBrandIdGet;
var ListPersonalPromoCodeOfferCodesByCodeOfferIdGet = /** @class */ (function () {
    function ListPersonalPromoCodeOfferCodesByCodeOfferIdGet() {
    }
    ListPersonalPromoCodeOfferCodesByCodeOfferIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPersonalPromoCodeOfferCodesByCodeOfferIdGet.api_name = "api.admin.bonus.personal.promocode.offers.history.listpersonalpromocodeoffercodesbycodeofferidget";
    return ListPersonalPromoCodeOfferCodesByCodeOfferIdGet;
}());
exports.ListPersonalPromoCodeOfferCodesByCodeOfferIdGet = ListPersonalPromoCodeOfferCodesByCodeOfferIdGet;
var DoChangeActiveAdminPassword = /** @class */ (function () {
    function DoChangeActiveAdminPassword() {
    }
    DoChangeActiveAdminPassword.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoChangeActiveAdminPassword.api_name = "api.admin.profile.dochangeactiveadminpassword";
    return DoChangeActiveAdminPassword;
}());
exports.DoChangeActiveAdminPassword = DoChangeActiveAdminPassword;
var DetailGameLinesBetsDenomsByGameSetGameIdGet = /** @class */ (function () {
    function DetailGameLinesBetsDenomsByGameSetGameIdGet() {
    }
    DetailGameLinesBetsDenomsByGameSetGameIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailGameLinesBetsDenomsByGameSetGameIdGet.api_name = "api.admin.cms.gameset.games.fsconfig.detailgamelinesbetsdenomsbygamesetgameidget";
    return DetailGameLinesBetsDenomsByGameSetGameIdGet;
}());
exports.DetailGameLinesBetsDenomsByGameSetGameIdGet = DetailGameLinesBetsDenomsByGameSetGameIdGet;
var DetailsPromoCodeForPlayerGet = /** @class */ (function () {
    function DetailsPromoCodeForPlayerGet() {
    }
    DetailsPromoCodeForPlayerGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsPromoCodeForPlayerGet.api_name = "api.admin.users.players.promocodes.detailspromocodeforplayerget";
    return DetailsPromoCodeForPlayerGet;
}());
exports.DetailsPromoCodeForPlayerGet = DetailsPromoCodeForPlayerGet;
var DoCmsPProgramContentFileExists = /** @class */ (function () {
    function DoCmsPProgramContentFileExists() {
    }
    DoCmsPProgramContentFileExists.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsPProgramContentFileExists.api_name = "api.admin.aff.pprograms.cms.content.docmspprogramcontentfileexists";
    return DoCmsPProgramContentFileExists;
}());
exports.DoCmsPProgramContentFileExists = DoCmsPProgramContentFileExists;
var DoEditWagerCashBackBonusInstanceConfig = /** @class */ (function () {
    function DoEditWagerCashBackBonusInstanceConfig() {
    }
    DoEditWagerCashBackBonusInstanceConfig.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditWagerCashBackBonusInstanceConfig.api_name = "api.admin.users.players.bonuses.config.wager_cashback.doeditwagercashbackbonusinstanceconfig";
    return DoEditWagerCashBackBonusInstanceConfig;
}());
exports.DoEditWagerCashBackBonusInstanceConfig = DoEditWagerCashBackBonusInstanceConfig;
var DoEditBonusTemplateZone = /** @class */ (function () {
    function DoEditBonusTemplateZone() {
    }
    DoEditBonusTemplateZone.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusTemplateZone.api_name = "api.admin.bonus.templates.zones.doeditbonustemplatezone";
    return DoEditBonusTemplateZone;
}());
exports.DoEditBonusTemplateZone = DoEditBonusTemplateZone;
var DoEditInnerPayServicePayWay = /** @class */ (function () {
    function DoEditInnerPayServicePayWay() {
    }
    DoEditInnerPayServicePayWay.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditInnerPayServicePayWay.api_name = "api.admin.app.innerpay.services.payways.doeditinnerpayservicepayway";
    return DoEditInnerPayServicePayWay;
}());
exports.DoEditInnerPayServicePayWay = DoEditInnerPayServicePayWay;
var DoAddBrandLandingLocale = /** @class */ (function () {
    function DoAddBrandLandingLocale() {
    }
    DoAddBrandLandingLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandLandingLocale.api_name = "api.admin.aff.brands.landings.locales.doaddbrandlandinglocale";
    return DoAddBrandLandingLocale;
}());
exports.DoAddBrandLandingLocale = DoAddBrandLandingLocale;
var DoEditPersonalPromoCodeOffer = /** @class */ (function () {
    function DoEditPersonalPromoCodeOffer() {
    }
    DoEditPersonalPromoCodeOffer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPersonalPromoCodeOffer.api_name = "api.admin.bonus.personal.promocode.offers.control.doeditpersonalpromocodeoffer";
    return DoEditPersonalPromoCodeOffer;
}());
exports.DoEditPersonalPromoCodeOffer = DoEditPersonalPromoCodeOffer;
var DoDeleteWhiteIpAddr = /** @class */ (function () {
    function DoDeleteWhiteIpAddr() {
    }
    DoDeleteWhiteIpAddr.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteWhiteIpAddr.api_name = "api.admin.users.players.white.ipaddr.dodeletewhiteipaddr";
    return DoDeleteWhiteIpAddr;
}());
exports.DoDeleteWhiteIpAddr = DoDeleteWhiteIpAddr;
var DoProvidePersonalPromoCodeToPlayer = /** @class */ (function () {
    function DoProvidePersonalPromoCodeToPlayer() {
    }
    DoProvidePersonalPromoCodeToPlayer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoProvidePersonalPromoCodeToPlayer.api_name = "api.admin.support.personal.doprovidepersonalpromocodetoplayer";
    return DoProvidePersonalPromoCodeToPlayer;
}());
exports.DoProvidePersonalPromoCodeToPlayer = DoProvidePersonalPromoCodeToPlayer;
var DoManualPlayerWithdrawCreate = /** @class */ (function () {
    function DoManualPlayerWithdrawCreate() {
    }
    DoManualPlayerWithdrawCreate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoManualPlayerWithdrawCreate.api_name = "api.admin.users.players.finance.domanualplayerwithdrawcreate";
    return DoManualPlayerWithdrawCreate;
}());
exports.DoManualPlayerWithdrawCreate = DoManualPlayerWithdrawCreate;
var DoAddBrandBanner = /** @class */ (function () {
    function DoAddBrandBanner() {
    }
    DoAddBrandBanner.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandBanner.api_name = "api.admin.aff.brands.banners.control.doaddbrandbanner";
    return DoAddBrandBanner;
}());
exports.DoAddBrandBanner = DoAddBrandBanner;
var ListAdminAccessByAffilateGet = /** @class */ (function () {
    function ListAdminAccessByAffilateGet() {
    }
    ListAdminAccessByAffilateGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAdminAccessByAffilateGet.api_name = "api.admin.access.affilates.listadminaccessbyaffilateget";
    return ListAdminAccessByAffilateGet;
}());
exports.ListAdminAccessByAffilateGet = ListAdminAccessByAffilateGet;
var DoSetCmsBotIsLocked = /** @class */ (function () {
    function DoSetCmsBotIsLocked() {
    }
    DoSetCmsBotIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetCmsBotIsLocked.api_name = "api.admin.cms.bots.dosetcmsbotislocked";
    return DoSetCmsBotIsLocked;
}());
exports.DoSetCmsBotIsLocked = DoSetCmsBotIsLocked;
var ListAvailBannersGeometryGet = /** @class */ (function () {
    function ListAvailBannersGeometryGet() {
    }
    ListAvailBannersGeometryGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailBannersGeometryGet.api_name = "api.admin.aff.brands.banners.control.listavailbannersgeometryget";
    return ListAvailBannersGeometryGet;
}());
exports.ListAvailBannersGeometryGet = ListAvailBannersGeometryGet;
var DoEditBrandLanding = /** @class */ (function () {
    function DoEditBrandLanding() {
    }
    DoEditBrandLanding.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandLanding.api_name = "api.admin.aff.brands.landings.control.doeditbrandlanding";
    return DoEditBrandLanding;
}());
exports.DoEditBrandLanding = DoEditBrandLanding;
var ListAppUsrPlayerTagsGet = /** @class */ (function () {
    function ListAppUsrPlayerTagsGet() {
    }
    ListAppUsrPlayerTagsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAppUsrPlayerTagsGet.api_name = "api.admin.app.usr.players.tags.listappusrplayertagsget";
    return ListAppUsrPlayerTagsGet;
}());
exports.ListAppUsrPlayerTagsGet = ListAppUsrPlayerTagsGet;
var DoDeleteGameSetGameBotWin = /** @class */ (function () {
    function DoDeleteGameSetGameBotWin() {
    }
    DoDeleteGameSetGameBotWin.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteGameSetGameBotWin.api_name = "api.admin.cms.gameset.games.botwins.dodeletegamesetgamebotwin";
    return DoDeleteGameSetGameBotWin;
}());
exports.DoDeleteGameSetGameBotWin = DoDeleteGameSetGameBotWin;
var ListAllowedDepositTypesGet = /** @class */ (function () {
    function ListAllowedDepositTypesGet() {
    }
    ListAllowedDepositTypesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedDepositTypesGet.api_name = "api.admin.finance.control.listalloweddeposittypesget";
    return ListAllowedDepositTypesGet;
}());
exports.ListAllowedDepositTypesGet = ListAllowedDepositTypesGet;
var DoCmsBrandContentDirectoryCreate = /** @class */ (function () {
    function DoCmsBrandContentDirectoryCreate() {
    }
    DoCmsBrandContentDirectoryCreate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsBrandContentDirectoryCreate.api_name = "api.admin.cms.brands.content.docmsbrandcontentdirectorycreate";
    return DoCmsBrandContentDirectoryCreate;
}());
exports.DoCmsBrandContentDirectoryCreate = DoCmsBrandContentDirectoryCreate;
var DoBindPromoCodeTemplateCodeToPartner = /** @class */ (function () {
    function DoBindPromoCodeTemplateCodeToPartner() {
    }
    DoBindPromoCodeTemplateCodeToPartner.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoBindPromoCodeTemplateCodeToPartner.api_name = "api.admin.bonus.promocodes.templates.codes.dobindpromocodetemplatecodetopartner";
    return DoBindPromoCodeTemplateCodeToPartner;
}());
exports.DoBindPromoCodeTemplateCodeToPartner = DoBindPromoCodeTemplateCodeToPartner;
var ListAdminAllowedPermissionsGet = /** @class */ (function () {
    function ListAdminAllowedPermissionsGet() {
    }
    ListAdminAllowedPermissionsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAdminAllowedPermissionsGet.api_name = "api.admin.permissions.control.listadminallowedpermissionsget";
    return ListAdminAllowedPermissionsGet;
}());
exports.ListAdminAllowedPermissionsGet = ListAdminAllowedPermissionsGet;
var ListBonusTournamentGameLogsByTournamentIdGet = /** @class */ (function () {
    function ListBonusTournamentGameLogsByTournamentIdGet() {
    }
    ListBonusTournamentGameLogsByTournamentIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusTournamentGameLogsByTournamentIdGet.api_name = "api.admin.users.players.tournaments.listbonustournamentgamelogsbytournamentidget";
    return ListBonusTournamentGameLogsByTournamentIdGet;
}());
exports.ListBonusTournamentGameLogsByTournamentIdGet = ListBonusTournamentGameLogsByTournamentIdGet;
var DoAddGameToAllCategory = /** @class */ (function () {
    function DoAddGameToAllCategory() {
    }
    DoAddGameToAllCategory.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddGameToAllCategory.api_name = "api.admin.cms.gameset.control.doaddgametoallcategory";
    return DoAddGameToAllCategory;
}());
exports.DoAddGameToAllCategory = DoAddGameToAllCategory;
var DoDeleteInnerPayWalletLock = /** @class */ (function () {
    function DoDeleteInnerPayWalletLock() {
    }
    DoDeleteInnerPayWalletLock.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteInnerPayWalletLock.api_name = "api.admin.app.innerpay.wallets.locks.dodeleteinnerpaywalletlock";
    return DoDeleteInnerPayWalletLock;
}());
exports.DoDeleteInnerPayWalletLock = DoDeleteInnerPayWalletLock;
var DetailsBrandPayProviderLimitGet = /** @class */ (function () {
    function DetailsBrandPayProviderLimitGet() {
    }
    DetailsBrandPayProviderLimitGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsBrandPayProviderLimitGet.api_name = "api.admin.brand.deposit.providers.control.detailsbrandpayproviderlimitget";
    return DetailsBrandPayProviderLimitGet;
}());
exports.DetailsBrandPayProviderLimitGet = DetailsBrandPayProviderLimitGet;
var ListGwsGameProviderAllowedGamesByGameProviderIdGet = /** @class */ (function () {
    function ListGwsGameProviderAllowedGamesByGameProviderIdGet() {
    }
    ListGwsGameProviderAllowedGamesByGameProviderIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListGwsGameProviderAllowedGamesByGameProviderIdGet.api_name = "api.admin.gws.gameprovider.games.listgwsgameproviderallowedgamesbygameprovideridget";
    return ListGwsGameProviderAllowedGamesByGameProviderIdGet;
}());
exports.ListGwsGameProviderAllowedGamesByGameProviderIdGet = ListGwsGameProviderAllowedGamesByGameProviderIdGet;
var DoSetGwsGameProviderGameIsBonus = /** @class */ (function () {
    function DoSetGwsGameProviderGameIsBonus() {
    }
    DoSetGwsGameProviderGameIsBonus.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGwsGameProviderGameIsBonus.api_name = "api.admin.gws.gameprovider.games.dosetgwsgameprovidergameisbonus";
    return DoSetGwsGameProviderGameIsBonus;
}());
exports.DoSetGwsGameProviderGameIsBonus = DoSetGwsGameProviderGameIsBonus;
var DoAddPProgramAppPayout = /** @class */ (function () {
    function DoAddPProgramAppPayout() {
    }
    DoAddPProgramAppPayout.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramAppPayout.api_name = "api.admin.aff.pprograms.app.payout.doaddpprogramapppayout";
    return DoAddPProgramAppPayout;
}());
exports.DoAddPProgramAppPayout = DoAddPProgramAppPayout;
var ListAllowedCssClassesByTypeGet = /** @class */ (function () {
    function ListAllowedCssClassesByTypeGet() {
    }
    ListAllowedCssClassesByTypeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedCssClassesByTypeGet.api_name = "api.admin.app.cssclass.listallowedcssclassesbytypeget";
    return ListAllowedCssClassesByTypeGet;
}());
exports.ListAllowedCssClassesByTypeGet = ListAllowedCssClassesByTypeGet;
var ListForBrandStatPartnerOffersAvailGet = /** @class */ (function () {
    function ListForBrandStatPartnerOffersAvailGet() {
    }
    ListForBrandStatPartnerOffersAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListForBrandStatPartnerOffersAvailGet.api_name = "api.admin.brands.partners.forstat.listforbrandstatpartneroffersavailget";
    return ListForBrandStatPartnerOffersAvailGet;
}());
exports.ListForBrandStatPartnerOffersAvailGet = ListForBrandStatPartnerOffersAvailGet;
var ListAllowedViewTypesByDocIdGet = /** @class */ (function () {
    function ListAllowedViewTypesByDocIdGet() {
    }
    ListAllowedViewTypesByDocIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedViewTypesByDocIdGet.api_name = "api.admin.permissions.docs.control.listallowedviewtypesbydocidget";
    return ListAllowedViewTypesByDocIdGet;
}());
exports.ListAllowedViewTypesByDocIdGet = ListAllowedViewTypesByDocIdGet;
var ListAllowedPProgramOffersByPartnerIdGet = /** @class */ (function () {
    function ListAllowedPProgramOffersByPartnerIdGet() {
    }
    ListAllowedPProgramOffersByPartnerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedPProgramOffersByPartnerIdGet.api_name = "api.admin.aff.pprograms.usr.partners.offers.listallowedpprogramoffersbypartneridget";
    return ListAllowedPProgramOffersByPartnerIdGet;
}());
exports.ListAllowedPProgramOffersByPartnerIdGet = ListAllowedPProgramOffersByPartnerIdGet;
var DoCmsPProgramContentFileRename = /** @class */ (function () {
    function DoCmsPProgramContentFileRename() {
    }
    DoCmsPProgramContentFileRename.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsPProgramContentFileRename.api_name = "api.admin.aff.pprograms.cms.content.docmspprogramcontentfilerename";
    return DoCmsPProgramContentFileRename;
}());
exports.DoCmsPProgramContentFileRename = DoCmsPProgramContentFileRename;
var DoDeletePProgramAppPayout = /** @class */ (function () {
    function DoDeletePProgramAppPayout() {
    }
    DoDeletePProgramAppPayout.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramAppPayout.api_name = "api.admin.aff.pprograms.app.payout.dodeletepprogramapppayout";
    return DoDeletePProgramAppPayout;
}());
exports.DoDeletePProgramAppPayout = DoDeletePProgramAppPayout;
var DoAddBonusEventBindingBonus = /** @class */ (function () {
    function DoAddBonusEventBindingBonus() {
    }
    DoAddBonusEventBindingBonus.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusEventBindingBonus.api_name = "api.admin.bonus.events.bindings.bonuses.doaddbonuseventbindingbonus";
    return DoAddBonusEventBindingBonus;
}());
exports.DoAddBonusEventBindingBonus = DoAddBonusEventBindingBonus;
var DoSetBannerRoutePriority = /** @class */ (function () {
    function DoSetBannerRoutePriority() {
    }
    DoSetBannerRoutePriority.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBannerRoutePriority.api_name = "api.admin.cms.banners.routes.control.dosetbannerroutepriority";
    return DoSetBannerRoutePriority;
}());
exports.DoSetBannerRoutePriority = DoSetBannerRoutePriority;
var ListBrandBonusReportByDateRangeGet = /** @class */ (function () {
    function ListBrandBonusReportByDateRangeGet() {
    }
    ListBrandBonusReportByDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandBonusReportByDateRangeGet.api_name = "api.admin.report.bonuses.listbrandbonusreportbydaterangeget";
    return ListBrandBonusReportByDateRangeGet;
}());
exports.ListBrandBonusReportByDateRangeGet = ListBrandBonusReportByDateRangeGet;
var DoAddPProgramAppCountry = /** @class */ (function () {
    function DoAddPProgramAppCountry() {
    }
    DoAddPProgramAppCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramAppCountry.api_name = "api.admin.aff.pprograms.app.country.doaddpprogramappcountry";
    return DoAddPProgramAppCountry;
}());
exports.DoAddPProgramAppCountry = DoAddPProgramAppCountry;
var DoDeleteBonusJackpotLocale = /** @class */ (function () {
    function DoDeleteBonusJackpotLocale() {
    }
    DoDeleteBonusJackpotLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusJackpotLocale.api_name = "api.admin.bonus.jackpots.locales.dodeletebonusjackpotlocale";
    return DoDeleteBonusJackpotLocale;
}());
exports.DoDeleteBonusJackpotLocale = DoDeleteBonusJackpotLocale;
var DoAddBonusJackpotLocale = /** @class */ (function () {
    function DoAddBonusJackpotLocale() {
    }
    DoAddBonusJackpotLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusJackpotLocale.api_name = "api.admin.bonus.jackpots.locales.doaddbonusjackpotlocale";
    return DoAddBonusJackpotLocale;
}());
exports.DoAddBonusJackpotLocale = DoAddBonusJackpotLocale;
var DoEditBannerRoute = /** @class */ (function () {
    function DoEditBannerRoute() {
    }
    DoEditBannerRoute.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBannerRoute.api_name = "api.admin.cms.banners.routes.control.doeditbannerroute";
    return DoEditBannerRoute;
}());
exports.DoEditBannerRoute = DoEditBannerRoute;
var ListBonusPlayerLevelsAttributesByLevelIdGet = /** @class */ (function () {
    function ListBonusPlayerLevelsAttributesByLevelIdGet() {
    }
    ListBonusPlayerLevelsAttributesByLevelIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusPlayerLevelsAttributesByLevelIdGet.api_name = "api.admin.bonus.levels.attributes.listbonusplayerlevelsattributesbylevelidget";
    return ListBonusPlayerLevelsAttributesByLevelIdGet;
}());
exports.ListBonusPlayerLevelsAttributesByLevelIdGet = ListBonusPlayerLevelsAttributesByLevelIdGet;
var DoEditBannerRouteImage = /** @class */ (function () {
    function DoEditBannerRouteImage() {
    }
    DoEditBannerRouteImage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBannerRouteImage.api_name = "api.admin.cms.banners.routes.images.doeditbannerrouteimage";
    return DoEditBannerRouteImage;
}());
exports.DoEditBannerRouteImage = DoEditBannerRouteImage;
var DoDeletePProgramPartnerRevshare = /** @class */ (function () {
    function DoDeletePProgramPartnerRevshare() {
    }
    DoDeletePProgramPartnerRevshare.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramPartnerRevshare.api_name = "api.admin.aff.pprograms.usr.partners.revshares.dodeletepprogrampartnerrevshare";
    return DoDeletePProgramPartnerRevshare;
}());
exports.DoDeletePProgramPartnerRevshare = DoDeletePProgramPartnerRevshare;
var DoEditCountryLocale = /** @class */ (function () {
    function DoEditCountryLocale() {
    }
    DoEditCountryLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditCountryLocale.api_name = "api.admin.app.country.locale.doeditcountrylocale";
    return DoEditCountryLocale;
}());
exports.DoEditCountryLocale = DoEditCountryLocale;
var DoDeleteBonusTournament = /** @class */ (function () {
    function DoDeleteBonusTournament() {
    }
    DoDeleteBonusTournament.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusTournament.api_name = "api.admin.bonus.tournaments.control.dodeletebonustournament";
    return DoDeleteBonusTournament;
}());
exports.DoDeleteBonusTournament = DoDeleteBonusTournament;
var DoSetPlayerEventHandlerIsLocked = /** @class */ (function () {
    function DoSetPlayerEventHandlerIsLocked() {
    }
    DoSetPlayerEventHandlerIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPlayerEventHandlerIsLocked.api_name = "api.admin.brands.players.events.handlers.dosetplayereventhandlerislocked";
    return DoSetPlayerEventHandlerIsLocked;
}());
exports.DoSetPlayerEventHandlerIsLocked = DoSetPlayerEventHandlerIsLocked;
var DoSetBonusEventBindingPriority = /** @class */ (function () {
    function DoSetBonusEventBindingPriority() {
    }
    DoSetBonusEventBindingPriority.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBonusEventBindingPriority.api_name = "api.admin.bonus.events.bindings.control.dosetbonuseventbindingpriority";
    return DoSetBonusEventBindingPriority;
}());
exports.DoSetBonusEventBindingPriority = DoSetBonusEventBindingPriority;
var DoGetAdminPassword = /** @class */ (function () {
    function DoGetAdminPassword() {
    }
    DoGetAdminPassword.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoGetAdminPassword.api_name = "api.admin.users.admins.dogetadminpassword";
    return DoGetAdminPassword;
}());
exports.DoGetAdminPassword = DoGetAdminPassword;
var ListBrandMessageSetTemplatesByBrandIdGet = /** @class */ (function () {
    function ListBrandMessageSetTemplatesByBrandIdGet() {
    }
    ListBrandMessageSetTemplatesByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandMessageSetTemplatesByBrandIdGet.api_name = "api.admin.brands.templates.control.message.set.control.listbrandmessagesettemplatesbybrandidget";
    return ListBrandMessageSetTemplatesByBrandIdGet;
}());
exports.ListBrandMessageSetTemplatesByBrandIdGet = ListBrandMessageSetTemplatesByBrandIdGet;
var ListBonusPermissionTypesAvailGet = /** @class */ (function () {
    function ListBonusPermissionTypesAvailGet() {
    }
    ListBonusPermissionTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusPermissionTypesAvailGet.api_name = "api.admin.bonus.templates.control.listbonuspermissiontypesavailget";
    return ListBonusPermissionTypesAvailGet;
}());
exports.ListBonusPermissionTypesAvailGet = ListBonusPermissionTypesAvailGet;
var DoEditPlayerEventHandler = /** @class */ (function () {
    function DoEditPlayerEventHandler() {
    }
    DoEditPlayerEventHandler.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPlayerEventHandler.api_name = "api.admin.brands.players.events.handlers.doeditplayereventhandler";
    return DoEditPlayerEventHandler;
}());
exports.DoEditPlayerEventHandler = DoEditPlayerEventHandler;
var ListPersonalPromoCodeOffersByBrandIdGet = /** @class */ (function () {
    function ListPersonalPromoCodeOffersByBrandIdGet() {
    }
    ListPersonalPromoCodeOffersByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPersonalPromoCodeOffersByBrandIdGet.api_name = "api.admin.bonus.personal.promocode.offers.control.listpersonalpromocodeoffersbybrandidget";
    return ListPersonalPromoCodeOffersByBrandIdGet;
}());
exports.ListPersonalPromoCodeOffersByBrandIdGet = ListPersonalPromoCodeOffersByBrandIdGet;
var DoDeleteBonusTournamentSession = /** @class */ (function () {
    function DoDeleteBonusTournamentSession() {
    }
    DoDeleteBonusTournamentSession.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusTournamentSession.api_name = "api.admin.bonus.tournaments.sessions.control.dodeletebonustournamentsession";
    return DoDeleteBonusTournamentSession;
}());
exports.DoDeleteBonusTournamentSession = DoDeleteBonusTournamentSession;
var ListBrandDomainsByBrandIdGet = /** @class */ (function () {
    function ListBrandDomainsByBrandIdGet() {
    }
    ListBrandDomainsByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandDomainsByBrandIdGet.api_name = "api.admin.brands.domains.control.listbranddomainsbybrandidget";
    return ListBrandDomainsByBrandIdGet;
}());
exports.ListBrandDomainsByBrandIdGet = ListBrandDomainsByBrandIdGet;
var DoAddBonusTournament = /** @class */ (function () {
    function DoAddBonusTournament() {
    }
    DoAddBonusTournament.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusTournament.api_name = "api.admin.bonus.tournaments.control.doaddbonustournament";
    return DoAddBonusTournament;
}());
exports.DoAddBonusTournament = DoAddBonusTournament;
var DoSetBrandAppLanguageIsDefault = /** @class */ (function () {
    function DoSetBrandAppLanguageIsDefault() {
    }
    DoSetBrandAppLanguageIsDefault.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandAppLanguageIsDefault.api_name = "api.admin.brands.app.languages.dosetbrandapplanguageisdefault";
    return DoSetBrandAppLanguageIsDefault;
}());
exports.DoSetBrandAppLanguageIsDefault = DoSetBrandAppLanguageIsDefault;
var DoAddBrandOfferLocale = /** @class */ (function () {
    function DoAddBrandOfferLocale() {
    }
    DoAddBrandOfferLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandOfferLocale.api_name = "api.admin.aff.brands.offers.locales.doaddbrandofferlocale";
    return DoAddBrandOfferLocale;
}());
exports.DoAddBrandOfferLocale = DoAddBrandOfferLocale;
var DoSetAppTrustZoneIsDefault = /** @class */ (function () {
    function DoSetAppTrustZoneIsDefault() {
    }
    DoSetAppTrustZoneIsDefault.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetAppTrustZoneIsDefault.api_name = "api.admin.app.trust.zones.dosetapptrustzoneisdefault";
    return DoSetAppTrustZoneIsDefault;
}());
exports.DoSetAppTrustZoneIsDefault = DoSetAppTrustZoneIsDefault;
var ListDepositsByBrandIdAndDateRangeGet = /** @class */ (function () {
    function ListDepositsByBrandIdAndDateRangeGet() {
    }
    ListDepositsByBrandIdAndDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListDepositsByBrandIdAndDateRangeGet.api_name = "api.admin.finance.control.listdepositsbybrandidanddaterangeget";
    return ListDepositsByBrandIdAndDateRangeGet;
}());
exports.ListDepositsByBrandIdAndDateRangeGet = ListDepositsByBrandIdAndDateRangeGet;
var ListBrandBrandingCountryByBrandingIdGet = /** @class */ (function () {
    function ListBrandBrandingCountryByBrandingIdGet() {
    }
    ListBrandBrandingCountryByBrandingIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandBrandingCountryByBrandingIdGet.api_name = "api.admin.aff.brands.brandings.country.listbrandbrandingcountrybybrandingidget";
    return ListBrandBrandingCountryByBrandingIdGet;
}());
exports.ListBrandBrandingCountryByBrandingIdGet = ListBrandBrandingCountryByBrandingIdGet;
var ListCapchaTemplatesGet = /** @class */ (function () {
    function ListCapchaTemplatesGet() {
    }
    ListCapchaTemplatesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListCapchaTemplatesGet.api_name = "api.admin.app.capchas.templates.control.listcapchatemplatesget";
    return ListCapchaTemplatesGet;
}());
exports.ListCapchaTemplatesGet = ListCapchaTemplatesGet;
var ListUsrPartnerPProgramPromoHistoryGet = /** @class */ (function () {
    function ListUsrPartnerPProgramPromoHistoryGet() {
    }
    ListUsrPartnerPProgramPromoHistoryGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListUsrPartnerPProgramPromoHistoryGet.api_name = "api.admin.aff.pprograms.usr.partners.promo.history.listusrpartnerpprogrampromohistoryget";
    return ListUsrPartnerPProgramPromoHistoryGet;
}());
exports.ListUsrPartnerPProgramPromoHistoryGet = ListUsrPartnerPProgramPromoHistoryGet;
var DoDeleteAppTrustZone = /** @class */ (function () {
    function DoDeleteAppTrustZone() {
    }
    DoDeleteAppTrustZone.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteAppTrustZone.api_name = "api.admin.app.trust.zones.dodeleteapptrustzone";
    return DoDeleteAppTrustZone;
}());
exports.DoDeleteAppTrustZone = DoDeleteAppTrustZone;
var DoEditPromoCodeTemplateAmount = /** @class */ (function () {
    function DoEditPromoCodeTemplateAmount() {
    }
    DoEditPromoCodeTemplateAmount.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPromoCodeTemplateAmount.api_name = "api.admin.bonus.promocodes.templates.amounts.doeditpromocodetemplateamount";
    return DoEditPromoCodeTemplateAmount;
}());
exports.DoEditPromoCodeTemplateAmount = DoEditPromoCodeTemplateAmount;
var DetailsBrandBonusEventBindingConfigOnCashBackGet = /** @class */ (function () {
    function DetailsBrandBonusEventBindingConfigOnCashBackGet() {
    }
    DetailsBrandBonusEventBindingConfigOnCashBackGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsBrandBonusEventBindingConfigOnCashBackGet.api_name = "api.admin.bonus.events.bindings.config.on_cashback.detailsbrandbonuseventbindingconfigoncashbackget";
    return DetailsBrandBonusEventBindingConfigOnCashBackGet;
}());
exports.DetailsBrandBonusEventBindingConfigOnCashBackGet = DetailsBrandBonusEventBindingConfigOnCashBackGet;
var DoAddBrandPayProviderToTrustZone = /** @class */ (function () {
    function DoAddBrandPayProviderToTrustZone() {
    }
    DoAddBrandPayProviderToTrustZone.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandPayProviderToTrustZone.api_name = "api.admin.brand.deposit.providers.by.trust.zones.doaddbrandpayprovidertotrustzone";
    return DoAddBrandPayProviderToTrustZone;
}());
exports.DoAddBrandPayProviderToTrustZone = DoAddBrandPayProviderToTrustZone;
var ListBrandPProgramsByBrandIdGet = /** @class */ (function () {
    function ListBrandPProgramsByBrandIdGet() {
    }
    ListBrandPProgramsByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandPProgramsByBrandIdGet.api_name = "api.admin.aff.pprograms.brands.listbrandpprogramsbybrandidget";
    return ListBrandPProgramsByBrandIdGet;
}());
exports.ListBrandPProgramsByBrandIdGet = ListBrandPProgramsByBrandIdGet;
var DetailsBrandBonusEventBindingConfigOnDepGet = /** @class */ (function () {
    function DetailsBrandBonusEventBindingConfigOnDepGet() {
    }
    DetailsBrandBonusEventBindingConfigOnDepGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsBrandBonusEventBindingConfigOnDepGet.api_name = "api.admin.bonus.events.bindings.config.on_deposit.detailsbrandbonuseventbindingconfigondepget";
    return DetailsBrandBonusEventBindingConfigOnDepGet;
}());
exports.DetailsBrandBonusEventBindingConfigOnDepGet = DetailsBrandBonusEventBindingConfigOnDepGet;
var ListPProgramBrandsByPProgramIdGet = /** @class */ (function () {
    function ListPProgramBrandsByPProgramIdGet() {
    }
    ListPProgramBrandsByPProgramIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramBrandsByPProgramIdGet.api_name = "api.admin.aff.pprograms.brands.listpprogrambrandsbypprogramidget";
    return ListPProgramBrandsByPProgramIdGet;
}());
exports.ListPProgramBrandsByPProgramIdGet = ListPProgramBrandsByPProgramIdGet;
var ListAvailPromoCodeReActivationTypesListGet = /** @class */ (function () {
    function ListAvailPromoCodeReActivationTypesListGet() {
    }
    ListAvailPromoCodeReActivationTypesListGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailPromoCodeReActivationTypesListGet.api_name = "api.admin.bonus.promocodes.templates.control.listavailpromocodereactivationtypeslistget";
    return ListAvailPromoCodeReActivationTypesListGet;
}());
exports.ListAvailPromoCodeReActivationTypesListGet = ListAvailPromoCodeReActivationTypesListGet;
var DoSetSmsConfigRestrictionIsLocked = /** @class */ (function () {
    function DoSetSmsConfigRestrictionIsLocked() {
    }
    DoSetSmsConfigRestrictionIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetSmsConfigRestrictionIsLocked.api_name = "api.admin.brands.sms.config.restrictions.dosetsmsconfigrestrictionislocked";
    return DoSetSmsConfigRestrictionIsLocked;
}());
exports.DoSetSmsConfigRestrictionIsLocked = DoSetSmsConfigRestrictionIsLocked;
var ListPersonalPromoCodeOffersAvailByBrandIdGet = /** @class */ (function () {
    function ListPersonalPromoCodeOffersAvailByBrandIdGet() {
    }
    ListPersonalPromoCodeOffersAvailByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPersonalPromoCodeOffersAvailByBrandIdGet.api_name = "api.admin.bonus.personal.promocode.offers.control.listpersonalpromocodeoffersavailbybrandidget";
    return ListPersonalPromoCodeOffersAvailByBrandIdGet;
}());
exports.ListPersonalPromoCodeOffersAvailByBrandIdGet = ListPersonalPromoCodeOffersAvailByBrandIdGet;
var ListCmsGameSetsByGameProviderIdGet = /** @class */ (function () {
    function ListCmsGameSetsByGameProviderIdGet() {
    }
    ListCmsGameSetsByGameProviderIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListCmsGameSetsByGameProviderIdGet.api_name = "api.admin.cms.gameset.control.listcmsgamesetsbygameprovideridget";
    return ListCmsGameSetsByGameProviderIdGet;
}());
exports.ListCmsGameSetsByGameProviderIdGet = ListCmsGameSetsByGameProviderIdGet;
var DoSetBrandBannerPriority = /** @class */ (function () {
    function DoSetBrandBannerPriority() {
    }
    DoSetBrandBannerPriority.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandBannerPriority.api_name = "api.admin.aff.brands.banners.control.dosetbrandbannerpriority";
    return DoSetBrandBannerPriority;
}());
exports.DoSetBrandBannerPriority = DoSetBrandBannerPriority;
var DoEditBrandMessageSetTemplate = /** @class */ (function () {
    function DoEditBrandMessageSetTemplate() {
    }
    DoEditBrandMessageSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandMessageSetTemplate.api_name = "api.admin.brands.templates.control.message.set.control.doeditbrandmessagesettemplate";
    return DoEditBrandMessageSetTemplate;
}());
exports.DoEditBrandMessageSetTemplate = DoEditBrandMessageSetTemplate;
var ListUsrPartnerAuthLogsByUsrPartnerIdAndRangeGet = /** @class */ (function () {
    function ListUsrPartnerAuthLogsByUsrPartnerIdAndRangeGet() {
    }
    ListUsrPartnerAuthLogsByUsrPartnerIdAndRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListUsrPartnerAuthLogsByUsrPartnerIdAndRangeGet.api_name = "api.admin.aff.pprograms.usr.partners.authlogs.listusrpartnerauthlogsbyusrpartneridandrangeget";
    return ListUsrPartnerAuthLogsByUsrPartnerIdAndRangeGet;
}());
exports.ListUsrPartnerAuthLogsByUsrPartnerIdAndRangeGet = ListUsrPartnerAuthLogsByUsrPartnerIdAndRangeGet;
var ListAllowedAffilatesByGrantAdminIdGet = /** @class */ (function () {
    function ListAllowedAffilatesByGrantAdminIdGet() {
    }
    ListAllowedAffilatesByGrantAdminIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedAffilatesByGrantAdminIdGet.api_name = "api.admin.access.affilates.listallowedaffilatesbygrantadminidget";
    return ListAllowedAffilatesByGrantAdminIdGet;
}());
exports.ListAllowedAffilatesByGrantAdminIdGet = ListAllowedAffilatesByGrantAdminIdGet;
var ListBrandOfferLocalesByOfferIdGet = /** @class */ (function () {
    function ListBrandOfferLocalesByOfferIdGet() {
    }
    ListBrandOfferLocalesByOfferIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandOfferLocalesByOfferIdGet.api_name = "api.admin.aff.brands.offers.locales.listbrandofferlocalesbyofferidget";
    return ListBrandOfferLocalesByOfferIdGet;
}());
exports.ListBrandOfferLocalesByOfferIdGet = ListBrandOfferLocalesByOfferIdGet;
var DoGetRawBrandEmailSetMockObjectForTest = /** @class */ (function () {
    function DoGetRawBrandEmailSetMockObjectForTest() {
    }
    DoGetRawBrandEmailSetMockObjectForTest.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoGetRawBrandEmailSetMockObjectForTest.api_name = "api.admin.brands.templates.control.email.set.control.dogetrawbrandemailsetmockobjectfortest";
    return DoGetRawBrandEmailSetMockObjectForTest;
}());
exports.DoGetRawBrandEmailSetMockObjectForTest = DoGetRawBrandEmailSetMockObjectForTest;
var ListAllowedGwsGameProviderGamesGet = /** @class */ (function () {
    function ListAllowedGwsGameProviderGamesGet() {
    }
    ListAllowedGwsGameProviderGamesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedGwsGameProviderGamesGet.api_name = "api.admin.gws.gameprovider.games.listallowedgwsgameprovidergamesget";
    return ListAllowedGwsGameProviderGamesGet;
}());
exports.ListAllowedGwsGameProviderGamesGet = ListAllowedGwsGameProviderGamesGet;
var DoSetBrandPayProviderInTrustZoneOrderNumber = /** @class */ (function () {
    function DoSetBrandPayProviderInTrustZoneOrderNumber() {
    }
    DoSetBrandPayProviderInTrustZoneOrderNumber.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandPayProviderInTrustZoneOrderNumber.api_name = "api.admin.brand.deposit.providers.by.trust.zones.dosetbrandpayproviderintrustzoneordernumber";
    return DoSetBrandPayProviderInTrustZoneOrderNumber;
}());
exports.DoSetBrandPayProviderInTrustZoneOrderNumber = DoSetBrandPayProviderInTrustZoneOrderNumber;
var DetailsBrandMessageSetTemplateDataGet = /** @class */ (function () {
    function DetailsBrandMessageSetTemplateDataGet() {
    }
    DetailsBrandMessageSetTemplateDataGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsBrandMessageSetTemplateDataGet.api_name = "api.admin.brands.templates.control.message.set.control.detailsbrandmessagesettemplatedataget";
    return DetailsBrandMessageSetTemplateDataGet;
}());
exports.DetailsBrandMessageSetTemplateDataGet = DetailsBrandMessageSetTemplateDataGet;
var DoAddUserPlayerMessage = /** @class */ (function () {
    function DoAddUserPlayerMessage() {
    }
    DoAddUserPlayerMessage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddUserPlayerMessage.api_name = "api.admin.users.players.messages.doadduserplayermessage";
    return DoAddUserPlayerMessage;
}());
exports.DoAddUserPlayerMessage = DoAddUserPlayerMessage;
var DoCmsBrandContentFileRename = /** @class */ (function () {
    function DoCmsBrandContentFileRename() {
    }
    DoCmsBrandContentFileRename.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsBrandContentFileRename.api_name = "api.admin.cms.brands.content.docmsbrandcontentfilerename";
    return DoCmsBrandContentFileRename;
}());
exports.DoCmsBrandContentFileRename = DoCmsBrandContentFileRename;
var DoSendUsrPlayersBroadcastMessageRaw = /** @class */ (function () {
    function DoSendUsrPlayersBroadcastMessageRaw() {
    }
    DoSendUsrPlayersBroadcastMessageRaw.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSendUsrPlayersBroadcastMessageRaw.api_name = "api.admin.users.players.messages.dosendusrplayersbroadcastmessageraw";
    return DoSendUsrPlayersBroadcastMessageRaw;
}());
exports.DoSendUsrPlayersBroadcastMessageRaw = DoSendUsrPlayersBroadcastMessageRaw;
var DoSetBrandOfferPriority = /** @class */ (function () {
    function DoSetBrandOfferPriority() {
    }
    DoSetBrandOfferPriority.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandOfferPriority.api_name = "api.admin.aff.brands.offers.control.dosetbrandofferpriority";
    return DoSetBrandOfferPriority;
}());
exports.DoSetBrandOfferPriority = DoSetBrandOfferPriority;
var DoDeleteBonusPlayerLevelAttribute = /** @class */ (function () {
    function DoDeleteBonusPlayerLevelAttribute() {
    }
    DoDeleteBonusPlayerLevelAttribute.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusPlayerLevelAttribute.api_name = "api.admin.bonus.levels.attributes.dodeletebonusplayerlevelattribute";
    return DoDeleteBonusPlayerLevelAttribute;
}());
exports.DoDeleteBonusPlayerLevelAttribute = DoDeleteBonusPlayerLevelAttribute;
var DoCloneTournament = /** @class */ (function () {
    function DoCloneTournament() {
    }
    DoCloneTournament.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCloneTournament.api_name = "api.admin.bonus.tournaments.control.doclonetournament";
    return DoCloneTournament;
}());
exports.DoCloneTournament = DoCloneTournament;
var DoEditBonusEventBinding = /** @class */ (function () {
    function DoEditBonusEventBinding() {
    }
    DoEditBonusEventBinding.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusEventBinding.api_name = "api.admin.bonus.events.bindings.control.doeditbonuseventbinding";
    return DoEditBonusEventBinding;
}());
exports.DoEditBonusEventBinding = DoEditBonusEventBinding;
var DoAddPartnersReconciliation = /** @class */ (function () {
    function DoAddPartnersReconciliation() {
    }
    DoAddPartnersReconciliation.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPartnersReconciliation.api_name = "api.admin.aff.pprograms.reconciliations.control.doaddpartnersreconciliation";
    return DoAddPartnersReconciliation;
}());
exports.DoAddPartnersReconciliation = DoAddPartnersReconciliation;
var DoEditLanguage = /** @class */ (function () {
    function DoEditLanguage() {
    }
    DoEditLanguage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditLanguage.api_name = "api.admin.app.language.doeditlanguage";
    return DoEditLanguage;
}());
exports.DoEditLanguage = DoEditLanguage;
var ListDocumentsByPermissionIdGet = /** @class */ (function () {
    function ListDocumentsByPermissionIdGet() {
    }
    ListDocumentsByPermissionIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListDocumentsByPermissionIdGet.api_name = "api.admin.permissions.docs.control.listdocumentsbypermissionidget";
    return ListDocumentsByPermissionIdGet;
}());
exports.ListDocumentsByPermissionIdGet = ListDocumentsByPermissionIdGet;
var DoEditActiveAdminDetails = /** @class */ (function () {
    function DoEditActiveAdminDetails() {
    }
    DoEditActiveAdminDetails.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditActiveAdminDetails.api_name = "api.admin.profile.doeditactiveadmindetails";
    return DoEditActiveAdminDetails;
}());
exports.DoEditActiveAdminDetails = DoEditActiveAdminDetails;
var ListBonusTournamentActionsByTournamentIdGet = /** @class */ (function () {
    function ListBonusTournamentActionsByTournamentIdGet() {
    }
    ListBonusTournamentActionsByTournamentIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusTournamentActionsByTournamentIdGet.api_name = "api.admin.users.players.tournaments.listbonustournamentactionsbytournamentidget";
    return ListBonusTournamentActionsByTournamentIdGet;
}());
exports.ListBonusTournamentActionsByTournamentIdGet = ListBonusTournamentActionsByTournamentIdGet;
var ListAllowedAppUsrPlayerTagsGet = /** @class */ (function () {
    function ListAllowedAppUsrPlayerTagsGet() {
    }
    ListAllowedAppUsrPlayerTagsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedAppUsrPlayerTagsGet.api_name = "api.admin.app.usr.players.tags.listallowedappusrplayertagsget";
    return ListAllowedAppUsrPlayerTagsGet;
}());
exports.ListAllowedAppUsrPlayerTagsGet = ListAllowedAppUsrPlayerTagsGet;
var ListPartnersReconciliationsByDateRangeGet = /** @class */ (function () {
    function ListPartnersReconciliationsByDateRangeGet() {
    }
    ListPartnersReconciliationsByDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPartnersReconciliationsByDateRangeGet.api_name = "api.admin.aff.pprograms.reconciliations.control.listpartnersreconciliationsbydaterangeget";
    return ListPartnersReconciliationsByDateRangeGet;
}());
exports.ListPartnersReconciliationsByDateRangeGet = ListPartnersReconciliationsByDateRangeGet;
var DoSetBonusEventBindingBonusIsLocked = /** @class */ (function () {
    function DoSetBonusEventBindingBonusIsLocked() {
    }
    DoSetBonusEventBindingBonusIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBonusEventBindingBonusIsLocked.api_name = "api.admin.bonus.events.bindings.bonuses.dosetbonuseventbindingbonusislocked";
    return DoSetBonusEventBindingBonusIsLocked;
}());
exports.DoSetBonusEventBindingBonusIsLocked = DoSetBonusEventBindingBonusIsLocked;
var DoEditBrandEmailSetTemplateData = /** @class */ (function () {
    function DoEditBrandEmailSetTemplateData() {
    }
    DoEditBrandEmailSetTemplateData.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandEmailSetTemplateData.api_name = "api.admin.brands.templates.control.email.set.control.doeditbrandemailsettemplatedata";
    return DoEditBrandEmailSetTemplateData;
}());
exports.DoEditBrandEmailSetTemplateData = DoEditBrandEmailSetTemplateData;
var ListAllowedBrandsByGrantAdminIdGet = /** @class */ (function () {
    function ListAllowedBrandsByGrantAdminIdGet() {
    }
    ListAllowedBrandsByGrantAdminIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedBrandsByGrantAdminIdGet.api_name = "api.admin.access.brands.listallowedbrandsbygrantadminidget";
    return ListAllowedBrandsByGrantAdminIdGet;
}());
exports.ListAllowedBrandsByGrantAdminIdGet = ListAllowedBrandsByGrantAdminIdGet;
var ListBrandAppCurrencyByBrandIdGet = /** @class */ (function () {
    function ListBrandAppCurrencyByBrandIdGet() {
    }
    ListBrandAppCurrencyByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandAppCurrencyByBrandIdGet.api_name = "api.admin.brands.app.currency.listbrandappcurrencybybrandidget";
    return ListBrandAppCurrencyByBrandIdGet;
}());
exports.ListBrandAppCurrencyByBrandIdGet = ListBrandAppCurrencyByBrandIdGet;
var DoRenderBrandAppTemplateByTestData = /** @class */ (function () {
    function DoRenderBrandAppTemplateByTestData() {
    }
    DoRenderBrandAppTemplateByTestData.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoRenderBrandAppTemplateByTestData.api_name = "api.admin.brands.partners.payout.control.dorenderbrandapptemplatebytestdata";
    return DoRenderBrandAppTemplateByTestData;
}());
exports.DoRenderBrandAppTemplateByTestData = DoRenderBrandAppTemplateByTestData;
var DoSetGameSetGameFSBetLineDenom = /** @class */ (function () {
    function DoSetGameSetGameFSBetLineDenom() {
    }
    DoSetGameSetGameFSBetLineDenom.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGameSetGameFSBetLineDenom.api_name = "api.admin.cms.gameset.games.fsconfig.dosetgamesetgamefsbetlinedenom";
    return DoSetGameSetGameFSBetLineDenom;
}());
exports.DoSetGameSetGameFSBetLineDenom = DoSetGameSetGameFSBetLineDenom;
var ListBonusPlayerLevelLocalesByLevelIdGet = /** @class */ (function () {
    function ListBonusPlayerLevelLocalesByLevelIdGet() {
    }
    ListBonusPlayerLevelLocalesByLevelIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusPlayerLevelLocalesByLevelIdGet.api_name = "api.admin.bonus.levels.locales.listbonusplayerlevellocalesbylevelidget";
    return ListBonusPlayerLevelLocalesByLevelIdGet;
}());
exports.ListBonusPlayerLevelLocalesByLevelIdGet = ListBonusPlayerLevelLocalesByLevelIdGet;
var ListPProgramRevsharesMoneyFlowTypesAvailGet = /** @class */ (function () {
    function ListPProgramRevsharesMoneyFlowTypesAvailGet() {
    }
    ListPProgramRevsharesMoneyFlowTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramRevsharesMoneyFlowTypesAvailGet.api_name = "api.admin.aff.pprograms.usr.partners.revshares.listpprogramrevsharesmoneyflowtypesavailget";
    return ListPProgramRevsharesMoneyFlowTypesAvailGet;
}());
exports.ListPProgramRevsharesMoneyFlowTypesAvailGet = ListPProgramRevsharesMoneyFlowTypesAvailGet;
var DoCloneFSRangeToCurrency = /** @class */ (function () {
    function DoCloneFSRangeToCurrency() {
    }
    DoCloneFSRangeToCurrency.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCloneFSRangeToCurrency.api_name = "api.admin.bonus.fsranges.control.doclonefsrangetocurrency";
    return DoCloneFSRangeToCurrency;
}());
exports.DoCloneFSRangeToCurrency = DoCloneFSRangeToCurrency;
var DoDeleteBannerRouteImage = /** @class */ (function () {
    function DoDeleteBannerRouteImage() {
    }
    DoDeleteBannerRouteImage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBannerRouteImage.api_name = "api.admin.cms.banners.routes.images.dodeletebannerrouteimage";
    return DoDeleteBannerRouteImage;
}());
exports.DoDeleteBannerRouteImage = DoDeleteBannerRouteImage;
var DoAddPostRecord = /** @class */ (function () {
    function DoAddPostRecord() {
    }
    DoAddPostRecord.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPostRecord.api_name = "api.admin.cms.posts.records.control.doaddpostrecord";
    return DoAddPostRecord;
}());
exports.DoAddPostRecord = DoAddPostRecord;
var DoPublishBonusTournament = /** @class */ (function () {
    function DoPublishBonusTournament() {
    }
    DoPublishBonusTournament.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoPublishBonusTournament.api_name = "api.admin.bonus.tournaments.control.dopublishbonustournament";
    return DoPublishBonusTournament;
}());
exports.DoPublishBonusTournament = DoPublishBonusTournament;
var DoDeleteBrand = /** @class */ (function () {
    function DoDeleteBrand() {
    }
    DoDeleteBrand.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrand.api_name = "api.admin.brands.control.dodeletebrand";
    return DoDeleteBrand;
}());
exports.DoDeleteBrand = DoDeleteBrand;
var ListBonusDebitTypesAvailGet = /** @class */ (function () {
    function ListBonusDebitTypesAvailGet() {
    }
    ListBonusDebitTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusDebitTypesAvailGet.api_name = "api.admin.bonus.templates.control.listbonusdebittypesavailget";
    return ListBonusDebitTypesAvailGet;
}());
exports.ListBonusDebitTypesAvailGet = ListBonusDebitTypesAvailGet;
var DoEditPProgramEmailSetTestJSONData = /** @class */ (function () {
    function DoEditPProgramEmailSetTestJSONData() {
    }
    DoEditPProgramEmailSetTestJSONData.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgramEmailSetTestJSONData.api_name = "api.admin.aff.pprograms.email.set.templates.control.doeditpprogramemailsettestjsondata";
    return DoEditPProgramEmailSetTestJSONData;
}());
exports.DoEditPProgramEmailSetTestJSONData = DoEditPProgramEmailSetTestJSONData;
var DoEditBonusTemplate = /** @class */ (function () {
    function DoEditBonusTemplate() {
    }
    DoEditBonusTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusTemplate.api_name = "api.admin.bonus.templates.control.doeditbonustemplate";
    return DoEditBonusTemplate;
}());
exports.DoEditBonusTemplate = DoEditBonusTemplate;
var DoSetAllGameSetsEqualOrLessFreeSpinTotalBet = /** @class */ (function () {
    function DoSetAllGameSetsEqualOrLessFreeSpinTotalBet() {
    }
    DoSetAllGameSetsEqualOrLessFreeSpinTotalBet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetAllGameSetsEqualOrLessFreeSpinTotalBet.api_name = "api.admin.cms.gameset.games.fsconfig.dosetallgamesetsequalorlessfreespintotalbet";
    return DoSetAllGameSetsEqualOrLessFreeSpinTotalBet;
}());
exports.DoSetAllGameSetsEqualOrLessFreeSpinTotalBet = DoSetAllGameSetsEqualOrLessFreeSpinTotalBet;
var ListCountryGet = /** @class */ (function () {
    function ListCountryGet() {
    }
    ListCountryGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListCountryGet.api_name = "api.admin.app.country.control.listcountryget";
    return ListCountryGet;
}());
exports.ListCountryGet = ListCountryGet;
var ListBrandPlayerLevelsAvailByBrandIdGet = /** @class */ (function () {
    function ListBrandPlayerLevelsAvailByBrandIdGet() {
    }
    ListBrandPlayerLevelsAvailByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandPlayerLevelsAvailByBrandIdGet.api_name = "api.admin.bonus.levels.control.listbrandplayerlevelsavailbybrandidget";
    return ListBrandPlayerLevelsAvailByBrandIdGet;
}());
exports.ListBrandPlayerLevelsAvailByBrandIdGet = ListBrandPlayerLevelsAvailByBrandIdGet;
var DoEditBrandBrandingLocale = /** @class */ (function () {
    function DoEditBrandBrandingLocale() {
    }
    DoEditBrandBrandingLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandBrandingLocale.api_name = "api.admin.aff.brands.brandings.locales.doeditbrandbrandinglocale";
    return DoEditBrandBrandingLocale;
}());
exports.DoEditBrandBrandingLocale = DoEditBrandBrandingLocale;
var DoDeleteGwsGameProviderGame = /** @class */ (function () {
    function DoDeleteGwsGameProviderGame() {
    }
    DoDeleteGwsGameProviderGame.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteGwsGameProviderGame.api_name = "api.admin.gws.gameprovider.games.dodeletegwsgameprovidergame";
    return DoDeleteGwsGameProviderGame;
}());
exports.DoDeleteGwsGameProviderGame = DoDeleteGwsGameProviderGame;
var ListBonusesTemplatesByBrandIdGet = /** @class */ (function () {
    function ListBonusesTemplatesByBrandIdGet() {
    }
    ListBonusesTemplatesByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusesTemplatesByBrandIdGet.api_name = "api.admin.bonus.templates.control.listbonusestemplatesbybrandidget";
    return ListBonusesTemplatesByBrandIdGet;
}());
exports.ListBonusesTemplatesByBrandIdGet = ListBonusesTemplatesByBrandIdGet;
var ListPProgramPartnerTrackersByPartnerIdGet = /** @class */ (function () {
    function ListPProgramPartnerTrackersByPartnerIdGet() {
    }
    ListPProgramPartnerTrackersByPartnerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramPartnerTrackersByPartnerIdGet.api_name = "api.admin.aff.pprograms.usr.partners.trackers.listpprogrampartnertrackersbypartneridget";
    return ListPProgramPartnerTrackersByPartnerIdGet;
}());
exports.ListPProgramPartnerTrackersByPartnerIdGet = ListPProgramPartnerTrackersByPartnerIdGet;
var ListSmsConfigRestrictionsByBrandIdGet = /** @class */ (function () {
    function ListSmsConfigRestrictionsByBrandIdGet() {
    }
    ListSmsConfigRestrictionsByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListSmsConfigRestrictionsByBrandIdGet.api_name = "api.admin.brands.sms.config.restrictions.listsmsconfigrestrictionsbybrandidget";
    return ListSmsConfigRestrictionsByBrandIdGet;
}());
exports.ListSmsConfigRestrictionsByBrandIdGet = ListSmsConfigRestrictionsByBrandIdGet;
var DetailsPProgramTemplateBrandingGet = /** @class */ (function () {
    function DetailsPProgramTemplateBrandingGet() {
    }
    DetailsPProgramTemplateBrandingGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsPProgramTemplateBrandingGet.api_name = "api.admin.aff.pprograms.control.detailspprogramtemplatebrandingget";
    return DetailsPProgramTemplateBrandingGet;
}());
exports.DetailsPProgramTemplateBrandingGet = DetailsPProgramTemplateBrandingGet;
var ListPlayerBonusesByPlayerIdAndDateRangeGet = /** @class */ (function () {
    function ListPlayerBonusesByPlayerIdAndDateRangeGet() {
    }
    ListPlayerBonusesByPlayerIdAndDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayerBonusesByPlayerIdAndDateRangeGet.api_name = "api.admin.users.players.bonuses.control.listplayerbonusesbyplayeridanddaterangeget";
    return ListPlayerBonusesByPlayerIdAndDateRangeGet;
}());
exports.ListPlayerBonusesByPlayerIdAndDateRangeGet = ListPlayerBonusesByPlayerIdAndDateRangeGet;
var ListBonusEventBindingsBonusesByEventBindingIdGet = /** @class */ (function () {
    function ListBonusEventBindingsBonusesByEventBindingIdGet() {
    }
    ListBonusEventBindingsBonusesByEventBindingIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusEventBindingsBonusesByEventBindingIdGet.api_name = "api.admin.bonus.events.bindings.bonuses.listbonuseventbindingsbonusesbyeventbindingidget";
    return ListBonusEventBindingsBonusesByEventBindingIdGet;
}());
exports.ListBonusEventBindingsBonusesByEventBindingIdGet = ListBonusEventBindingsBonusesByEventBindingIdGet;
var DoCmsPProgramContentDirectoryCreate = /** @class */ (function () {
    function DoCmsPProgramContentDirectoryCreate() {
    }
    DoCmsPProgramContentDirectoryCreate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsPProgramContentDirectoryCreate.api_name = "api.admin.aff.pprograms.cms.content.docmspprogramcontentdirectorycreate";
    return DoCmsPProgramContentDirectoryCreate;
}());
exports.DoCmsPProgramContentDirectoryCreate = DoCmsPProgramContentDirectoryCreate;
var DoEditWinnerTop = /** @class */ (function () {
    function DoEditWinnerTop() {
    }
    DoEditWinnerTop.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditWinnerTop.api_name = "api.admin.cms.winners.top.doeditwinnertop";
    return DoEditWinnerTop;
}());
exports.DoEditWinnerTop = DoEditWinnerTop;
var DetailsBrandSmsSetTemplateDataGet = /** @class */ (function () {
    function DetailsBrandSmsSetTemplateDataGet() {
    }
    DetailsBrandSmsSetTemplateDataGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsBrandSmsSetTemplateDataGet.api_name = "api.admin.brands.templates.control.sms.set.control.detailsbrandsmssettemplatedataget";
    return DetailsBrandSmsSetTemplateDataGet;
}());
exports.DetailsBrandSmsSetTemplateDataGet = DetailsBrandSmsSetTemplateDataGet;
var DoGetPProgramPartnerPassword = /** @class */ (function () {
    function DoGetPProgramPartnerPassword() {
    }
    DoGetPProgramPartnerPassword.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoGetPProgramPartnerPassword.api_name = "api.admin.aff.pprograms.usr.partners.control.dogetpprogrampartnerpassword";
    return DoGetPProgramPartnerPassword;
}());
exports.DoGetPProgramPartnerPassword = DoGetPProgramPartnerPassword;
var ListInnerPayServicePayWaysByPayServiceIdGet = /** @class */ (function () {
    function ListInnerPayServicePayWaysByPayServiceIdGet() {
    }
    ListInnerPayServicePayWaysByPayServiceIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListInnerPayServicePayWaysByPayServiceIdGet.api_name = "api.admin.app.innerpay.services.payways.listinnerpayservicepaywaysbypayserviceidget";
    return ListInnerPayServicePayWaysByPayServiceIdGet;
}());
exports.ListInnerPayServicePayWaysByPayServiceIdGet = ListInnerPayServicePayWaysByPayServiceIdGet;
var DoEditTournamentAmount = /** @class */ (function () {
    function DoEditTournamentAmount() {
    }
    DoEditTournamentAmount.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditTournamentAmount.api_name = "api.admin.bonus.tournaments.amounts.doedittournamentamount";
    return DoEditTournamentAmount;
}());
exports.DoEditTournamentAmount = DoEditTournamentAmount;
var DoSetAppCurrencyIsDeprecated = /** @class */ (function () {
    function DoSetAppCurrencyIsDeprecated() {
    }
    DoSetAppCurrencyIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetAppCurrencyIsDeprecated.api_name = "api.admin.app.currency.dosetappcurrencyisdeprecated";
    return DoSetAppCurrencyIsDeprecated;
}());
exports.DoSetAppCurrencyIsDeprecated = DoSetAppCurrencyIsDeprecated;
var ListAdminAccessByBrandGet = /** @class */ (function () {
    function ListAdminAccessByBrandGet() {
    }
    ListAdminAccessByBrandGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAdminAccessByBrandGet.api_name = "api.admin.access.brands.listadminaccessbybrandget";
    return ListAdminAccessByBrandGet;
}());
exports.ListAdminAccessByBrandGet = ListAdminAccessByBrandGet;
var ListAllowedGwsGameProviderByObtainAdminIdGet = /** @class */ (function () {
    function ListAllowedGwsGameProviderByObtainAdminIdGet() {
    }
    ListAllowedGwsGameProviderByObtainAdminIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedGwsGameProviderByObtainAdminIdGet.api_name = "api.admin.access.gws.gameproviders.listallowedgwsgameproviderbyobtainadminidget";
    return ListAllowedGwsGameProviderByObtainAdminIdGet;
}());
exports.ListAllowedGwsGameProviderByObtainAdminIdGet = ListAllowedGwsGameProviderByObtainAdminIdGet;
var DoMakeFlowObjectsByReconciliationPartnerId = /** @class */ (function () {
    function DoMakeFlowObjectsByReconciliationPartnerId() {
    }
    DoMakeFlowObjectsByReconciliationPartnerId.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoMakeFlowObjectsByReconciliationPartnerId.api_name = "api.admin.aff.pprograms.reconciliations.partners.domakeflowobjectsbyreconciliationpartnerid";
    return DoMakeFlowObjectsByReconciliationPartnerId;
}());
exports.DoMakeFlowObjectsByReconciliationPartnerId = DoMakeFlowObjectsByReconciliationPartnerId;
var DoDeleteBonusJackpotRestrictedPlayerTag = /** @class */ (function () {
    function DoDeleteBonusJackpotRestrictedPlayerTag() {
    }
    DoDeleteBonusJackpotRestrictedPlayerTag.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusJackpotRestrictedPlayerTag.api_name = "api.admin.bonus.jackpots.restricted_player_tags.dodeletebonusjackpotrestrictedplayertag";
    return DoDeleteBonusJackpotRestrictedPlayerTag;
}());
exports.DoDeleteBonusJackpotRestrictedPlayerTag = DoDeleteBonusJackpotRestrictedPlayerTag;
var DoDeletePromoCodeTemplateBonus = /** @class */ (function () {
    function DoDeletePromoCodeTemplateBonus() {
    }
    DoDeletePromoCodeTemplateBonus.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePromoCodeTemplateBonus.api_name = "api.admin.bonus.promocodes.templates.bonuses.dodeletepromocodetemplatebonus";
    return DoDeletePromoCodeTemplateBonus;
}());
exports.DoDeletePromoCodeTemplateBonus = DoDeletePromoCodeTemplateBonus;
var ListBrandSmsSetTemplatesByBrandIdGet = /** @class */ (function () {
    function ListBrandSmsSetTemplatesByBrandIdGet() {
    }
    ListBrandSmsSetTemplatesByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandSmsSetTemplatesByBrandIdGet.api_name = "api.admin.brands.templates.control.sms.set.control.listbrandsmssettemplatesbybrandidget";
    return ListBrandSmsSetTemplatesByBrandIdGet;
}());
exports.ListBrandSmsSetTemplatesByBrandIdGet = ListBrandSmsSetTemplatesByBrandIdGet;
var ListTournamentPrizeTypesAvailGet = /** @class */ (function () {
    function ListTournamentPrizeTypesAvailGet() {
    }
    ListTournamentPrizeTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTournamentPrizeTypesAvailGet.api_name = "api.admin.bonus.tournaments.prizes.listtournamentprizetypesavailget";
    return ListTournamentPrizeTypesAvailGet;
}());
exports.ListTournamentPrizeTypesAvailGet = ListTournamentPrizeTypesAvailGet;
var ListCssClassTypesGet = /** @class */ (function () {
    function ListCssClassTypesGet() {
    }
    ListCssClassTypesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListCssClassTypesGet.api_name = "api.admin.app.cssclass.listcssclasstypesget";
    return ListCssClassTypesGet;
}());
exports.ListCssClassTypesGet = ListCssClassTypesGet;
var DoDeleteInnerPayService = /** @class */ (function () {
    function DoDeleteInnerPayService() {
    }
    DoDeleteInnerPayService.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteInnerPayService.api_name = "api.admin.app.innerpay.services.control.dodeleteinnerpayservice";
    return DoDeleteInnerPayService;
}());
exports.DoDeleteInnerPayService = DoDeleteInnerPayService;
var DoAddGameSetGameBotWin = /** @class */ (function () {
    function DoAddGameSetGameBotWin() {
    }
    DoAddGameSetGameBotWin.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddGameSetGameBotWin.api_name = "api.admin.cms.gameset.games.botwins.doaddgamesetgamebotwin";
    return DoAddGameSetGameBotWin;
}());
exports.DoAddGameSetGameBotWin = DoAddGameSetGameBotWin;
var DoEditTournamentLocale = /** @class */ (function () {
    function DoEditTournamentLocale() {
    }
    DoEditTournamentLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditTournamentLocale.api_name = "api.admin.bonus.tournaments.locales.doedittournamentlocale";
    return DoEditTournamentLocale;
}());
exports.DoEditTournamentLocale = DoEditTournamentLocale;
var ListPostCategoryByBrandIdGet = /** @class */ (function () {
    function ListPostCategoryByBrandIdGet() {
    }
    ListPostCategoryByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPostCategoryByBrandIdGet.api_name = "api.admin.cms.posts.category.control.listpostcategorybybrandidget";
    return ListPostCategoryByBrandIdGet;
}());
exports.ListPostCategoryByBrandIdGet = ListPostCategoryByBrandIdGet;
var DoSetGwsGameProviderIsDeprecated = /** @class */ (function () {
    function DoSetGwsGameProviderIsDeprecated() {
    }
    DoSetGwsGameProviderIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGwsGameProviderIsDeprecated.api_name = "api.admin.gws.gameprovider.control.dosetgwsgameproviderisdeprecated";
    return DoSetGwsGameProviderIsDeprecated;
}());
exports.DoSetGwsGameProviderIsDeprecated = DoSetGwsGameProviderIsDeprecated;
var ListPlayerMessagesByPlayerIdAndDateRangeGet = /** @class */ (function () {
    function ListPlayerMessagesByPlayerIdAndDateRangeGet() {
    }
    ListPlayerMessagesByPlayerIdAndDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayerMessagesByPlayerIdAndDateRangeGet.api_name = "api.admin.users.players.messages.listplayermessagesbyplayeridanddaterangeget";
    return ListPlayerMessagesByPlayerIdAndDateRangeGet;
}());
exports.ListPlayerMessagesByPlayerIdAndDateRangeGet = ListPlayerMessagesByPlayerIdAndDateRangeGet;
var DoEditCssClass = /** @class */ (function () {
    function DoEditCssClass() {
    }
    DoEditCssClass.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditCssClass.api_name = "api.admin.app.cssclass.doeditcssclass";
    return DoEditCssClass;
}());
exports.DoEditCssClass = DoEditCssClass;
var DoPProgramPartnerRevshareCommit = /** @class */ (function () {
    function DoPProgramPartnerRevshareCommit() {
    }
    DoPProgramPartnerRevshareCommit.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoPProgramPartnerRevshareCommit.api_name = "api.admin.aff.pprograms.usr.partners.revshares.dopprogrampartnerrevsharecommit";
    return DoPProgramPartnerRevshareCommit;
}());
exports.DoPProgramPartnerRevshareCommit = DoPProgramPartnerRevshareCommit;
var ListBonusTemplateLocalesByBonusTemplateIdGet = /** @class */ (function () {
    function ListBonusTemplateLocalesByBonusTemplateIdGet() {
    }
    ListBonusTemplateLocalesByBonusTemplateIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusTemplateLocalesByBonusTemplateIdGet.api_name = "api.admin.bonus.templates.locales.listbonustemplatelocalesbybonustemplateidget";
    return ListBonusTemplateLocalesByBonusTemplateIdGet;
}());
exports.ListBonusTemplateLocalesByBonusTemplateIdGet = ListBonusTemplateLocalesByBonusTemplateIdGet;
var DoCmsPProgramContentFileUploadAppend = /** @class */ (function () {
    function DoCmsPProgramContentFileUploadAppend() {
    }
    DoCmsPProgramContentFileUploadAppend.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsPProgramContentFileUploadAppend.api_name = "api.admin.aff.pprograms.cms.content.docmspprogramcontentfileuploadappend";
    return DoCmsPProgramContentFileUploadAppend;
}());
exports.DoCmsPProgramContentFileUploadAppend = DoCmsPProgramContentFileUploadAppend;
var DoEditCmsBot = /** @class */ (function () {
    function DoEditCmsBot() {
    }
    DoEditCmsBot.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditCmsBot.api_name = "api.admin.cms.bots.doeditcmsbot";
    return DoEditCmsBot;
}());
exports.DoEditCmsBot = DoEditCmsBot;
var DetailsWagerCashBackBonusInstanceConfigGet = /** @class */ (function () {
    function DetailsWagerCashBackBonusInstanceConfigGet() {
    }
    DetailsWagerCashBackBonusInstanceConfigGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsWagerCashBackBonusInstanceConfigGet.api_name = "api.admin.users.players.bonuses.config.wager_cashback.detailswagercashbackbonusinstanceconfigget";
    return DetailsWagerCashBackBonusInstanceConfigGet;
}());
exports.DetailsWagerCashBackBonusInstanceConfigGet = DetailsWagerCashBackBonusInstanceConfigGet;
var ListBrandBannerLocalesByBannerIdGet = /** @class */ (function () {
    function ListBrandBannerLocalesByBannerIdGet() {
    }
    ListBrandBannerLocalesByBannerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandBannerLocalesByBannerIdGet.api_name = "api.admin.aff.brands.banners.locales.listbrandbannerlocalesbybanneridget";
    return ListBrandBannerLocalesByBannerIdGet;
}());
exports.ListBrandBannerLocalesByBannerIdGet = ListBrandBannerLocalesByBannerIdGet;
var ListJackpotWinHistoryByUsrPlayerIdGet = /** @class */ (function () {
    function ListJackpotWinHistoryByUsrPlayerIdGet() {
    }
    ListJackpotWinHistoryByUsrPlayerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListJackpotWinHistoryByUsrPlayerIdGet.api_name = "api.admin.users.players.jackpot_wins.listjackpotwinhistorybyusrplayeridget";
    return ListJackpotWinHistoryByUsrPlayerIdGet;
}());
exports.ListJackpotWinHistoryByUsrPlayerIdGet = ListJackpotWinHistoryByUsrPlayerIdGet;
var DetailsBrandSmtpConfigGet = /** @class */ (function () {
    function DetailsBrandSmtpConfigGet() {
    }
    DetailsBrandSmtpConfigGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsBrandSmtpConfigGet.api_name = "api.admin.brands.email.config.control.detailsbrandsmtpconfigget";
    return DetailsBrandSmtpConfigGet;
}());
exports.DetailsBrandSmtpConfigGet = DetailsBrandSmtpConfigGet;
var DoDeleteBrandMessageSetTemplate = /** @class */ (function () {
    function DoDeleteBrandMessageSetTemplate() {
    }
    DoDeleteBrandMessageSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandMessageSetTemplate.api_name = "api.admin.brands.templates.control.message.set.control.dodeletebrandmessagesettemplate";
    return DoDeleteBrandMessageSetTemplate;
}());
exports.DoDeleteBrandMessageSetTemplate = DoDeleteBrandMessageSetTemplate;
var DoAddPProgram = /** @class */ (function () {
    function DoAddPProgram() {
    }
    DoAddPProgram.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgram.api_name = "api.admin.aff.pprograms.control.doaddpprogram";
    return DoAddPProgram;
}());
exports.DoAddPProgram = DoAddPProgram;
var DoEditBonusPlayerLevelOffer = /** @class */ (function () {
    function DoEditBonusPlayerLevelOffer() {
    }
    DoEditBonusPlayerLevelOffer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusPlayerLevelOffer.api_name = "api.admin.bonus.levels.offers.doeditbonusplayerleveloffer";
    return DoEditBonusPlayerLevelOffer;
}());
exports.DoEditBonusPlayerLevelOffer = DoEditBonusPlayerLevelOffer;
var DoAdminLoginRequest = /** @class */ (function () {
    function DoAdminLoginRequest() {
    }
    DoAdminLoginRequest.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAdminLoginRequest.api_name = "api.admin.auth.doadminloginrequest";
    return DoAdminLoginRequest;
}());
exports.DoAdminLoginRequest = DoAdminLoginRequest;
var DoCmsBrandContentFileUploadAppend = /** @class */ (function () {
    function DoCmsBrandContentFileUploadAppend() {
    }
    DoCmsBrandContentFileUploadAppend.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsBrandContentFileUploadAppend.api_name = "api.admin.cms.brands.content.docmsbrandcontentfileuploadappend";
    return DoCmsBrandContentFileUploadAppend;
}());
exports.DoCmsBrandContentFileUploadAppend = DoCmsBrandContentFileUploadAppend;
var ListBonusTournamentActionsByTournamentSessionIdGet = /** @class */ (function () {
    function ListBonusTournamentActionsByTournamentSessionIdGet() {
    }
    ListBonusTournamentActionsByTournamentSessionIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusTournamentActionsByTournamentSessionIdGet.api_name = "api.admin.bonus.tournaments.sessions.actionlogs.listbonustournamentactionsbytournamentsessionidget";
    return ListBonusTournamentActionsByTournamentSessionIdGet;
}());
exports.ListBonusTournamentActionsByTournamentSessionIdGet = ListBonusTournamentActionsByTournamentSessionIdGet;
var DoDeletePProgramPartner = /** @class */ (function () {
    function DoDeletePProgramPartner() {
    }
    DoDeletePProgramPartner.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramPartner.api_name = "api.admin.aff.pprograms.usr.partners.control.dodeletepprogrampartner";
    return DoDeletePProgramPartner;
}());
exports.DoDeletePProgramPartner = DoDeletePProgramPartner;
var DoAddBrandAutoWithdraw = /** @class */ (function () {
    function DoAddBrandAutoWithdraw() {
    }
    DoAddBrandAutoWithdraw.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandAutoWithdraw.api_name = "api.admin.brand.auto.withdraw.doaddbrandautowithdraw";
    return DoAddBrandAutoWithdraw;
}());
exports.DoAddBrandAutoWithdraw = DoAddBrandAutoWithdraw;
var ListCmsGameSetFreeSpinBetTargetsByCmsGameSetIdGet = /** @class */ (function () {
    function ListCmsGameSetFreeSpinBetTargetsByCmsGameSetIdGet() {
    }
    ListCmsGameSetFreeSpinBetTargetsByCmsGameSetIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListCmsGameSetFreeSpinBetTargetsByCmsGameSetIdGet.api_name = "api.admin.cms.gameset.freespin.bettargets.listcmsgamesetfreespinbettargetsbycmsgamesetidget";
    return ListCmsGameSetFreeSpinBetTargetsByCmsGameSetIdGet;
}());
exports.ListCmsGameSetFreeSpinBetTargetsByCmsGameSetIdGet = ListCmsGameSetFreeSpinBetTargetsByCmsGameSetIdGet;
var DoDeleteBonusJackpotTarget = /** @class */ (function () {
    function DoDeleteBonusJackpotTarget() {
    }
    DoDeleteBonusJackpotTarget.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusJackpotTarget.api_name = "api.admin.bonus.jackpots.targets.dodeletebonusjackpottarget";
    return DoDeleteBonusJackpotTarget;
}());
exports.DoDeleteBonusJackpotTarget = DoDeleteBonusJackpotTarget;
var ListPProgramPartnersRevsharesByDateRangeGet = /** @class */ (function () {
    function ListPProgramPartnersRevsharesByDateRangeGet() {
    }
    ListPProgramPartnersRevsharesByDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramPartnersRevsharesByDateRangeGet.api_name = "api.admin.aff.pprograms.usr.partners.revshares.listpprogrampartnersrevsharesbydaterangeget";
    return ListPProgramPartnersRevsharesByDateRangeGet;
}());
exports.ListPProgramPartnersRevsharesByDateRangeGet = ListPProgramPartnersRevsharesByDateRangeGet;
var DoAddPersonalPromoCodeOffer = /** @class */ (function () {
    function DoAddPersonalPromoCodeOffer() {
    }
    DoAddPersonalPromoCodeOffer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPersonalPromoCodeOffer.api_name = "api.admin.bonus.personal.promocode.offers.control.doaddpersonalpromocodeoffer";
    return DoAddPersonalPromoCodeOffer;
}());
exports.DoAddPersonalPromoCodeOffer = DoAddPersonalPromoCodeOffer;
var ListPayoutsGet = /** @class */ (function () {
    function ListPayoutsGet() {
    }
    ListPayoutsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPayoutsGet.api_name = "api.admin.app.payout.listpayoutsget";
    return ListPayoutsGet;
}());
exports.ListPayoutsGet = ListPayoutsGet;
var DetailBrandAppPayoutTemplateDataGet = /** @class */ (function () {
    function DetailBrandAppPayoutTemplateDataGet() {
    }
    DetailBrandAppPayoutTemplateDataGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailBrandAppPayoutTemplateDataGet.api_name = "api.admin.brands.partners.payout.control.detailbrandapppayouttemplatedataget";
    return DetailBrandAppPayoutTemplateDataGet;
}());
exports.DetailBrandAppPayoutTemplateDataGet = DetailBrandAppPayoutTemplateDataGet;
var DoEditPProgramPartnerTracker = /** @class */ (function () {
    function DoEditPProgramPartnerTracker() {
    }
    DoEditPProgramPartnerTracker.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgramPartnerTracker.api_name = "api.admin.aff.pprograms.usr.partners.trackers.doeditpprogrampartnertracker";
    return DoEditPProgramPartnerTracker;
}());
exports.DoEditPProgramPartnerTracker = DoEditPProgramPartnerTracker;
var ListBonusActivationTypesAvailGet = /** @class */ (function () {
    function ListBonusActivationTypesAvailGet() {
    }
    ListBonusActivationTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusActivationTypesAvailGet.api_name = "api.admin.bonus.templates.control.listbonusactivationtypesavailget";
    return ListBonusActivationTypesAvailGet;
}());
exports.ListBonusActivationTypesAvailGet = ListBonusActivationTypesAvailGet;
var ListBonusTemplateZonesGet = /** @class */ (function () {
    function ListBonusTemplateZonesGet() {
    }
    ListBonusTemplateZonesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusTemplateZonesGet.api_name = "api.admin.bonus.templates.zones.listbonustemplatezonesget";
    return ListBonusTemplateZonesGet;
}());
exports.ListBonusTemplateZonesGet = ListBonusTemplateZonesGet;
var DoAddBrandEmailSetTemplate = /** @class */ (function () {
    function DoAddBrandEmailSetTemplate() {
    }
    DoAddBrandEmailSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandEmailSetTemplate.api_name = "api.admin.brands.templates.control.email.set.control.doaddbrandemailsettemplate";
    return DoAddBrandEmailSetTemplate;
}());
exports.DoAddBrandEmailSetTemplate = DoAddBrandEmailSetTemplate;
var DoSetPromoCodeTemplateCodeDescription = /** @class */ (function () {
    function DoSetPromoCodeTemplateCodeDescription() {
    }
    DoSetPromoCodeTemplateCodeDescription.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPromoCodeTemplateCodeDescription.api_name = "api.admin.bonus.promocodes.templates.codes.dosetpromocodetemplatecodedescription";
    return DoSetPromoCodeTemplateCodeDescription;
}());
exports.DoSetPromoCodeTemplateCodeDescription = DoSetPromoCodeTemplateCodeDescription;
var DoEditGameProviderGwsConfig = /** @class */ (function () {
    function DoEditGameProviderGwsConfig() {
    }
    DoEditGameProviderGwsConfig.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditGameProviderGwsConfig.api_name = "api.admin.gws.gameprovider.config.doeditgameprovidergwsconfig";
    return DoEditGameProviderGwsConfig;
}());
exports.DoEditGameProviderGwsConfig = DoEditGameProviderGwsConfig;
var ListAllowedGwsGameProvidersGet = /** @class */ (function () {
    function ListAllowedGwsGameProvidersGet() {
    }
    ListAllowedGwsGameProvidersGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedGwsGameProvidersGet.api_name = "api.admin.gws.gameprovider.control.listallowedgwsgameprovidersget";
    return ListAllowedGwsGameProvidersGet;
}());
exports.ListAllowedGwsGameProvidersGet = ListAllowedGwsGameProvidersGet;
var DoAddPProgramPartnerPromoCodeTemplate = /** @class */ (function () {
    function DoAddPProgramPartnerPromoCodeTemplate() {
    }
    DoAddPProgramPartnerPromoCodeTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramPartnerPromoCodeTemplate.api_name = "api.admin.aff.pprograms.usr.partners.promocode.templates.doaddpprogrampartnerpromocodetemplate";
    return DoAddPProgramPartnerPromoCodeTemplate;
}());
exports.DoAddPProgramPartnerPromoCodeTemplate = DoAddPProgramPartnerPromoCodeTemplate;
var ListAllowedPProgramsGet = /** @class */ (function () {
    function ListAllowedPProgramsGet() {
    }
    ListAllowedPProgramsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedPProgramsGet.api_name = "api.admin.aff.pprograms.control.listallowedpprogramsget";
    return ListAllowedPProgramsGet;
}());
exports.ListAllowedPProgramsGet = ListAllowedPProgramsGet;
var ListBrandPayProvidersAvailGet = /** @class */ (function () {
    function ListBrandPayProvidersAvailGet() {
    }
    ListBrandPayProvidersAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandPayProvidersAvailGet.api_name = "api.admin.brand.deposit.providers.control.listbrandpayprovidersavailget";
    return ListBrandPayProvidersAvailGet;
}());
exports.ListBrandPayProvidersAvailGet = ListBrandPayProvidersAvailGet;
var DoEditBrandLocale = /** @class */ (function () {
    function DoEditBrandLocale() {
    }
    DoEditBrandLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandLocale.api_name = "api.admin.brands.locales.doeditbrandlocale";
    return DoEditBrandLocale;
}());
exports.DoEditBrandLocale = DoEditBrandLocale;
var ListLanguagesGet = /** @class */ (function () {
    function ListLanguagesGet() {
    }
    ListLanguagesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListLanguagesGet.api_name = "api.admin.app.language.listlanguagesget";
    return ListLanguagesGet;
}());
exports.ListLanguagesGet = ListLanguagesGet;
var DoEditPProgramTemplateBranding = /** @class */ (function () {
    function DoEditPProgramTemplateBranding() {
    }
    DoEditPProgramTemplateBranding.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgramTemplateBranding.api_name = "api.admin.aff.pprograms.control.doeditpprogramtemplatebranding";
    return DoEditPProgramTemplateBranding;
}());
exports.DoEditPProgramTemplateBranding = DoEditPProgramTemplateBranding;
var DoSetCapchaTemplateIsLocked = /** @class */ (function () {
    function DoSetCapchaTemplateIsLocked() {
    }
    DoSetCapchaTemplateIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetCapchaTemplateIsLocked.api_name = "api.admin.app.capchas.templates.control.dosetcapchatemplateislocked";
    return DoSetCapchaTemplateIsLocked;
}());
exports.DoSetCapchaTemplateIsLocked = DoSetCapchaTemplateIsLocked;
var DoEditWagerNoDepBonusTemplateConfig = /** @class */ (function () {
    function DoEditWagerNoDepBonusTemplateConfig() {
    }
    DoEditWagerNoDepBonusTemplateConfig.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditWagerNoDepBonusTemplateConfig.api_name = "api.admin.bonus.templates.config.wager_no_dep.doeditwagernodepbonustemplateconfig";
    return DoEditWagerNoDepBonusTemplateConfig;
}());
exports.DoEditWagerNoDepBonusTemplateConfig = DoEditWagerNoDepBonusTemplateConfig;
var DoEditPayout = /** @class */ (function () {
    function DoEditPayout() {
    }
    DoEditPayout.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPayout.api_name = "api.admin.app.payout.doeditpayout";
    return DoEditPayout;
}());
exports.DoEditPayout = DoEditPayout;
var DoEditAdminPermission = /** @class */ (function () {
    function DoEditAdminPermission() {
    }
    DoEditAdminPermission.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditAdminPermission.api_name = "api.admin.permissions.control.doeditadminpermission";
    return DoEditAdminPermission;
}());
exports.DoEditAdminPermission = DoEditAdminPermission;
var DetailsPlayerStatisticsByDepositReqGet = /** @class */ (function () {
    function DetailsPlayerStatisticsByDepositReqGet() {
    }
    DetailsPlayerStatisticsByDepositReqGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsPlayerStatisticsByDepositReqGet.api_name = "api.admin.users.players.control.detailsplayerstatisticsbydepositreqget";
    return DetailsPlayerStatisticsByDepositReqGet;
}());
exports.DetailsPlayerStatisticsByDepositReqGet = DetailsPlayerStatisticsByDepositReqGet;
var DoEditBrandEmailSetTestJSONData = /** @class */ (function () {
    function DoEditBrandEmailSetTestJSONData() {
    }
    DoEditBrandEmailSetTestJSONData.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandEmailSetTestJSONData.api_name = "api.admin.brands.templates.control.email.set.control.doeditbrandemailsettestjsondata";
    return DoEditBrandEmailSetTestJSONData;
}());
exports.DoEditBrandEmailSetTestJSONData = DoEditBrandEmailSetTestJSONData;
var DoSetBrandDomainPriority = /** @class */ (function () {
    function DoSetBrandDomainPriority() {
    }
    DoSetBrandDomainPriority.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandDomainPriority.api_name = "api.admin.brands.domains.control.dosetbranddomainpriority";
    return DoSetBrandDomainPriority;
}());
exports.DoSetBrandDomainPriority = DoSetBrandDomainPriority;
var DoSetPromoCodeTemplateBonusDescription = /** @class */ (function () {
    function DoSetPromoCodeTemplateBonusDescription() {
    }
    DoSetPromoCodeTemplateBonusDescription.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPromoCodeTemplateBonusDescription.api_name = "api.admin.bonus.promocodes.templates.bonuses.dosetpromocodetemplatebonusdescription";
    return DoSetPromoCodeTemplateBonusDescription;
}());
exports.DoSetPromoCodeTemplateBonusDescription = DoSetPromoCodeTemplateBonusDescription;
var DoEditBrandEmailSetTemplate = /** @class */ (function () {
    function DoEditBrandEmailSetTemplate() {
    }
    DoEditBrandEmailSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandEmailSetTemplate.api_name = "api.admin.brands.templates.control.email.set.control.doeditbrandemailsettemplate";
    return DoEditBrandEmailSetTemplate;
}());
exports.DoEditBrandEmailSetTemplate = DoEditBrandEmailSetTemplate;
var DoEditCmsGameSet = /** @class */ (function () {
    function DoEditCmsGameSet() {
    }
    DoEditCmsGameSet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditCmsGameSet.api_name = "api.admin.cms.gameset.control.doeditcmsgameset";
    return DoEditCmsGameSet;
}());
exports.DoEditCmsGameSet = DoEditCmsGameSet;
var ListBonusTournamentsByBrandIdGet = /** @class */ (function () {
    function ListBonusTournamentsByBrandIdGet() {
    }
    ListBonusTournamentsByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusTournamentsByBrandIdGet.api_name = "api.admin.bonus.tournaments.control.listbonustournamentsbybrandidget";
    return ListBonusTournamentsByBrandIdGet;
}());
exports.ListBonusTournamentsByBrandIdGet = ListBonusTournamentsByBrandIdGet;
var DoAddBrandPartnerForStat = /** @class */ (function () {
    function DoAddBrandPartnerForStat() {
    }
    DoAddBrandPartnerForStat.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandPartnerForStat.api_name = "api.admin.brands.partners.forstat.doaddbrandpartnerforstat";
    return DoAddBrandPartnerForStat;
}());
exports.DoAddBrandPartnerForStat = DoAddBrandPartnerForStat;
var DoAddBrandOffer = /** @class */ (function () {
    function DoAddBrandOffer() {
    }
    DoAddBrandOffer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandOffer.api_name = "api.admin.aff.brands.offers.control.doaddbrandoffer";
    return DoAddBrandOffer;
}());
exports.DoAddBrandOffer = DoAddBrandOffer;
var DoSetPlayerIsConfirmedEmail = /** @class */ (function () {
    function DoSetPlayerIsConfirmedEmail() {
    }
    DoSetPlayerIsConfirmedEmail.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPlayerIsConfirmedEmail.api_name = "api.admin.users.players.control.dosetplayerisconfirmedemail";
    return DoSetPlayerIsConfirmedEmail;
}());
exports.DoSetPlayerIsConfirmedEmail = DoSetPlayerIsConfirmedEmail;
var ListBonusTemplateCurrencyConfigByBonusTemplateIdGet = /** @class */ (function () {
    function ListBonusTemplateCurrencyConfigByBonusTemplateIdGet() {
    }
    ListBonusTemplateCurrencyConfigByBonusTemplateIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusTemplateCurrencyConfigByBonusTemplateIdGet.api_name = "api.admin.bonus.templates.currency.config.listbonustemplatecurrencyconfigbybonustemplateidget";
    return ListBonusTemplateCurrencyConfigByBonusTemplateIdGet;
}());
exports.ListBonusTemplateCurrencyConfigByBonusTemplateIdGet = ListBonusTemplateCurrencyConfigByBonusTemplateIdGet;
var DoEditGwsGameProvider = /** @class */ (function () {
    function DoEditGwsGameProvider() {
    }
    DoEditGwsGameProvider.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditGwsGameProvider.api_name = "api.admin.gws.gameprovider.control.doeditgwsgameprovider";
    return DoEditGwsGameProvider;
}());
exports.DoEditGwsGameProvider = DoEditGwsGameProvider;
var DoSetViewPermissionOnDocControl = /** @class */ (function () {
    function DoSetViewPermissionOnDocControl() {
    }
    DoSetViewPermissionOnDocControl.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetViewPermissionOnDocControl.api_name = "api.admin.permissions.docs.control.dosetviewpermissionondoccontrol";
    return DoSetViewPermissionOnDocControl;
}());
exports.DoSetViewPermissionOnDocControl = DoSetViewPermissionOnDocControl;
var ListUsrPartnerMessageByPartnerIdAndDateRangeGet = /** @class */ (function () {
    function ListUsrPartnerMessageByPartnerIdAndDateRangeGet() {
    }
    ListUsrPartnerMessageByPartnerIdAndDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListUsrPartnerMessageByPartnerIdAndDateRangeGet.api_name = "api.admin.aff.pprograms.usr.partners.messages.listusrpartnermessagebypartneridanddaterangeget";
    return ListUsrPartnerMessageByPartnerIdAndDateRangeGet;
}());
exports.ListUsrPartnerMessageByPartnerIdAndDateRangeGet = ListUsrPartnerMessageByPartnerIdAndDateRangeGet;
var DoAddBonusPlayerLevelAttribute = /** @class */ (function () {
    function DoAddBonusPlayerLevelAttribute() {
    }
    DoAddBonusPlayerLevelAttribute.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusPlayerLevelAttribute.api_name = "api.admin.bonus.levels.attributes.doaddbonusplayerlevelattribute";
    return DoAddBonusPlayerLevelAttribute;
}());
exports.DoAddBonusPlayerLevelAttribute = DoAddBonusPlayerLevelAttribute;
var DoAddPromoCodeTemplateBonus = /** @class */ (function () {
    function DoAddPromoCodeTemplateBonus() {
    }
    DoAddPromoCodeTemplateBonus.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPromoCodeTemplateBonus.api_name = "api.admin.bonus.promocodes.templates.bonuses.doaddpromocodetemplatebonus";
    return DoAddPromoCodeTemplateBonus;
}());
exports.DoAddPromoCodeTemplateBonus = DoAddPromoCodeTemplateBonus;
var DoAddBrandBrandingCountry = /** @class */ (function () {
    function DoAddBrandBrandingCountry() {
    }
    DoAddBrandBrandingCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandBrandingCountry.api_name = "api.admin.aff.brands.brandings.country.doaddbrandbrandingcountry";
    return DoAddBrandBrandingCountry;
}());
exports.DoAddBrandBrandingCountry = DoAddBrandBrandingCountry;
var DetailsWagerOnDepBonusTemplateConfigGet = /** @class */ (function () {
    function DetailsWagerOnDepBonusTemplateConfigGet() {
    }
    DetailsWagerOnDepBonusTemplateConfigGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsWagerOnDepBonusTemplateConfigGet.api_name = "api.admin.bonus.templates.config.wager_on_dep.detailswagerondepbonustemplateconfigget";
    return DetailsWagerOnDepBonusTemplateConfigGet;
}());
exports.DetailsWagerOnDepBonusTemplateConfigGet = DetailsWagerOnDepBonusTemplateConfigGet;
var DoDeleteBonusTemplateCurrencyConfig = /** @class */ (function () {
    function DoDeleteBonusTemplateCurrencyConfig() {
    }
    DoDeleteBonusTemplateCurrencyConfig.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusTemplateCurrencyConfig.api_name = "api.admin.bonus.templates.currency.config.dodeletebonustemplatecurrencyconfig";
    return DoDeleteBonusTemplateCurrencyConfig;
}());
exports.DoDeleteBonusTemplateCurrencyConfig = DoDeleteBonusTemplateCurrencyConfig;
var DoDeleteAppUsrPlayerTag = /** @class */ (function () {
    function DoDeleteAppUsrPlayerTag() {
    }
    DoDeleteAppUsrPlayerTag.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteAppUsrPlayerTag.api_name = "api.admin.app.usr.players.tags.dodeleteappusrplayertag";
    return DoDeleteAppUsrPlayerTag;
}());
exports.DoDeleteAppUsrPlayerTag = DoDeleteAppUsrPlayerTag;
var ListBonusJackpotLocalesGet = /** @class */ (function () {
    function ListBonusJackpotLocalesGet() {
    }
    ListBonusJackpotLocalesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusJackpotLocalesGet.api_name = "api.admin.bonus.jackpots.locales.listbonusjackpotlocalesget";
    return ListBonusJackpotLocalesGet;
}());
exports.ListBonusJackpotLocalesGet = ListBonusJackpotLocalesGet;
var ListFSRangesByBrandIdGet = /** @class */ (function () {
    function ListFSRangesByBrandIdGet() {
    }
    ListFSRangesByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListFSRangesByBrandIdGet.api_name = "api.admin.bonus.fsranges.control.listfsrangesbybrandidget";
    return ListFSRangesByBrandIdGet;
}());
exports.ListFSRangesByBrandIdGet = ListFSRangesByBrandIdGet;
var DoEditBonusJackpotTarget = /** @class */ (function () {
    function DoEditBonusJackpotTarget() {
    }
    DoEditBonusJackpotTarget.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusJackpotTarget.api_name = "api.admin.bonus.jackpots.targets.doeditbonusjackpottarget";
    return DoEditBonusJackpotTarget;
}());
exports.DoEditBonusJackpotTarget = DoEditBonusJackpotTarget;
var ListTournamentGamesByTournamentIdGet = /** @class */ (function () {
    function ListTournamentGamesByTournamentIdGet() {
    }
    ListTournamentGamesByTournamentIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTournamentGamesByTournamentIdGet.api_name = "api.admin.bonus.tournaments.games.listtournamentgamesbytournamentidget";
    return ListTournamentGamesByTournamentIdGet;
}());
exports.ListTournamentGamesByTournamentIdGet = ListTournamentGamesByTournamentIdGet;
var DoTestBlockChainApi = /** @class */ (function () {
    function DoTestBlockChainApi() {
    }
    DoTestBlockChainApi.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoTestBlockChainApi.api_name = "api.admin.app.innerpay.test.dotestblockchainapi";
    return DoTestBlockChainApi;
}());
exports.DoTestBlockChainApi = DoTestBlockChainApi;
var ListAvailBrandRegistrationBehaviorTypesGet = /** @class */ (function () {
    function ListAvailBrandRegistrationBehaviorTypesGet() {
    }
    ListAvailBrandRegistrationBehaviorTypesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailBrandRegistrationBehaviorTypesGet.api_name = "api.admin.brands.control.listavailbrandregistrationbehaviortypesget";
    return ListAvailBrandRegistrationBehaviorTypesGet;
}());
exports.ListAvailBrandRegistrationBehaviorTypesGet = ListAvailBrandRegistrationBehaviorTypesGet;
var DoExportPlayersSubscribersList = /** @class */ (function () {
    function DoExportPlayersSubscribersList() {
    }
    DoExportPlayersSubscribersList.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoExportPlayersSubscribersList.api_name = "api.admin.users.players.control.doexportplayerssubscriberslist";
    return DoExportPlayersSubscribersList;
}());
exports.DoExportPlayersSubscribersList = DoExportPlayersSubscribersList;
var DoEditCmsGameSetFreeSpinBetTarget = /** @class */ (function () {
    function DoEditCmsGameSetFreeSpinBetTarget() {
    }
    DoEditCmsGameSetFreeSpinBetTarget.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditCmsGameSetFreeSpinBetTarget.api_name = "api.admin.cms.gameset.freespin.bettargets.doeditcmsgamesetfreespinbettarget";
    return DoEditCmsGameSetFreeSpinBetTarget;
}());
exports.DoEditCmsGameSetFreeSpinBetTarget = DoEditCmsGameSetFreeSpinBetTarget;
var ListWithdrawalsStatsReportByDateRangeGet = /** @class */ (function () {
    function ListWithdrawalsStatsReportByDateRangeGet() {
    }
    ListWithdrawalsStatsReportByDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListWithdrawalsStatsReportByDateRangeGet.api_name = "api.admin.report.withdrawals.listwithdrawalsstatsreportbydaterangeget";
    return ListWithdrawalsStatsReportByDateRangeGet;
}());
exports.ListWithdrawalsStatsReportByDateRangeGet = ListWithdrawalsStatsReportByDateRangeGet;
var DoAddAffilateAdminAccess = /** @class */ (function () {
    function DoAddAffilateAdminAccess() {
    }
    DoAddAffilateAdminAccess.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddAffilateAdminAccess.api_name = "api.admin.access.affilates.doaddaffilateadminaccess";
    return DoAddAffilateAdminAccess;
}());
exports.DoAddAffilateAdminAccess = DoAddAffilateAdminAccess;
var DoSetTournamentBotIsLocked = /** @class */ (function () {
    function DoSetTournamentBotIsLocked() {
    }
    DoSetTournamentBotIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetTournamentBotIsLocked.api_name = "api.admin.bonus.tournaments.bots.control.dosettournamentbotislocked";
    return DoSetTournamentBotIsLocked;
}());
exports.DoSetTournamentBotIsLocked = DoSetTournamentBotIsLocked;
var ListFireWallActionsAvailGet = /** @class */ (function () {
    function ListFireWallActionsAvailGet() {
    }
    ListFireWallActionsAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListFireWallActionsAvailGet.api_name = "api.admin.brands.security.firewall.listfirewallactionsavailget";
    return ListFireWallActionsAvailGet;
}());
exports.ListFireWallActionsAvailGet = ListFireWallActionsAvailGet;
var DoEditGwsGameProviderGame = /** @class */ (function () {
    function DoEditGwsGameProviderGame() {
    }
    DoEditGwsGameProviderGame.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditGwsGameProviderGame.api_name = "api.admin.gws.gameprovider.games.doeditgwsgameprovidergame";
    return DoEditGwsGameProviderGame;
}());
exports.DoEditGwsGameProviderGame = DoEditGwsGameProviderGame;
var ListTournamentBetsByTournamentIdGet = /** @class */ (function () {
    function ListTournamentBetsByTournamentIdGet() {
    }
    ListTournamentBetsByTournamentIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTournamentBetsByTournamentIdGet.api_name = "api.admin.bonus.tournaments.bets.listtournamentbetsbytournamentidget";
    return ListTournamentBetsByTournamentIdGet;
}());
exports.ListTournamentBetsByTournamentIdGet = ListTournamentBetsByTournamentIdGet;
var ListPayoutTypesAvailGet = /** @class */ (function () {
    function ListPayoutTypesAvailGet() {
    }
    ListPayoutTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPayoutTypesAvailGet.api_name = "api.admin.brands.partners.payout.control.listpayouttypesavailget";
    return ListPayoutTypesAvailGet;
}());
exports.ListPayoutTypesAvailGet = ListPayoutTypesAvailGet;
var DoClearReconciliationPartnersByReconciliationId = /** @class */ (function () {
    function DoClearReconciliationPartnersByReconciliationId() {
    }
    DoClearReconciliationPartnersByReconciliationId.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoClearReconciliationPartnersByReconciliationId.api_name = "api.admin.aff.pprograms.reconciliations.control.doclearreconciliationpartnersbyreconciliationid";
    return DoClearReconciliationPartnersByReconciliationId;
}());
exports.DoClearReconciliationPartnersByReconciliationId = DoClearReconciliationPartnersByReconciliationId;
var DoEditBrandPartnerForStat = /** @class */ (function () {
    function DoEditBrandPartnerForStat() {
    }
    DoEditBrandPartnerForStat.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandPartnerForStat.api_name = "api.admin.brands.partners.forstat.doeditbrandpartnerforstat";
    return DoEditBrandPartnerForStat;
}());
exports.DoEditBrandPartnerForStat = DoEditBrandPartnerForStat;
var ListBonusTournamentSessionsByBonusTournamentIdGet = /** @class */ (function () {
    function ListBonusTournamentSessionsByBonusTournamentIdGet() {
    }
    ListBonusTournamentSessionsByBonusTournamentIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusTournamentSessionsByBonusTournamentIdGet.api_name = "api.admin.bonus.tournaments.sessions.control.listbonustournamentsessionsbybonustournamentidget";
    return ListBonusTournamentSessionsByBonusTournamentIdGet;
}());
exports.ListBonusTournamentSessionsByBonusTournamentIdGet = ListBonusTournamentSessionsByBonusTournamentIdGet;
var DoDeletePProgramBrand = /** @class */ (function () {
    function DoDeletePProgramBrand() {
    }
    DoDeletePProgramBrand.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramBrand.api_name = "api.admin.aff.pprograms.brands.dodeletepprogrambrand";
    return DoDeletePProgramBrand;
}());
exports.DoDeletePProgramBrand = DoDeletePProgramBrand;
var ListAvailOfferTypesGet = /** @class */ (function () {
    function ListAvailOfferTypesGet() {
    }
    ListAvailOfferTypesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailOfferTypesGet.api_name = "api.admin.aff.brands.offers.control.listavailoffertypesget";
    return ListAvailOfferTypesGet;
}());
exports.ListAvailOfferTypesGet = ListAvailOfferTypesGet;
var DoActivatePromoCode = /** @class */ (function () {
    function DoActivatePromoCode() {
    }
    DoActivatePromoCode.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoActivatePromoCode.api_name = "api.admin.users.players.promocodes.doactivatepromocode";
    return DoActivatePromoCode;
}());
exports.DoActivatePromoCode = DoActivatePromoCode;
var DoDeleteBrandAppCountry = /** @class */ (function () {
    function DoDeleteBrandAppCountry() {
    }
    DoDeleteBrandAppCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandAppCountry.api_name = "api.admin.brands.app.country.dodeletebrandappcountry";
    return DoDeleteBrandAppCountry;
}());
exports.DoDeleteBrandAppCountry = DoDeleteBrandAppCountry;
var DoAddGwsGameProviderGame = /** @class */ (function () {
    function DoAddGwsGameProviderGame() {
    }
    DoAddGwsGameProviderGame.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddGwsGameProviderGame.api_name = "api.admin.gws.gameprovider.games.doaddgwsgameprovidergame";
    return DoAddGwsGameProviderGame;
}());
exports.DoAddGwsGameProviderGame = DoAddGwsGameProviderGame;
var DoCmsPProgramContentFileUploadReset = /** @class */ (function () {
    function DoCmsPProgramContentFileUploadReset() {
    }
    DoCmsPProgramContentFileUploadReset.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsPProgramContentFileUploadReset.api_name = "api.admin.aff.pprograms.cms.content.docmspprogramcontentfileuploadreset";
    return DoCmsPProgramContentFileUploadReset;
}());
exports.DoCmsPProgramContentFileUploadReset = DoCmsPProgramContentFileUploadReset;
var ListCurrencyGet = /** @class */ (function () {
    function ListCurrencyGet() {
    }
    ListCurrencyGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListCurrencyGet.api_name = "api.admin.app.currency.listcurrencyget";
    return ListCurrencyGet;
}());
exports.ListCurrencyGet = ListCurrencyGet;
var ListMultiAccountPlayersByIpAddrByPlayerIdGet = /** @class */ (function () {
    function ListMultiAccountPlayersByIpAddrByPlayerIdGet() {
    }
    ListMultiAccountPlayersByIpAddrByPlayerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListMultiAccountPlayersByIpAddrByPlayerIdGet.api_name = "api.admin.users.players.multiaccounts.listmultiaccountplayersbyipaddrbyplayeridget";
    return ListMultiAccountPlayersByIpAddrByPlayerIdGet;
}());
exports.ListMultiAccountPlayersByIpAddrByPlayerIdGet = ListMultiAccountPlayersByIpAddrByPlayerIdGet;
var DoDeleteBonusPromocodeTemplateLocale = /** @class */ (function () {
    function DoDeleteBonusPromocodeTemplateLocale() {
    }
    DoDeleteBonusPromocodeTemplateLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusPromocodeTemplateLocale.api_name = "api.admin.bonus.promocodes.templates.locales.dodeletebonuspromocodetemplatelocale";
    return DoDeleteBonusPromocodeTemplateLocale;
}());
exports.DoDeleteBonusPromocodeTemplateLocale = DoDeleteBonusPromocodeTemplateLocale;
var DoDeletePProgramPromoTemplate = /** @class */ (function () {
    function DoDeletePProgramPromoTemplate() {
    }
    DoDeletePProgramPromoTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramPromoTemplate.api_name = "api.admin.aff.pprograms.pub.promo.templates.dodeletepprogrampromotemplate";
    return DoDeletePProgramPromoTemplate;
}());
exports.DoDeletePProgramPromoTemplate = DoDeletePProgramPromoTemplate;
var DetailsDefaultOfferFormulaAndTestDataGet = /** @class */ (function () {
    function DetailsDefaultOfferFormulaAndTestDataGet() {
    }
    DetailsDefaultOfferFormulaAndTestDataGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsDefaultOfferFormulaAndTestDataGet.api_name = "api.admin.aff.brands.offers.control.detailsdefaultofferformulaandtestdataget";
    return DetailsDefaultOfferFormulaAndTestDataGet;
}());
exports.DetailsDefaultOfferFormulaAndTestDataGet = DetailsDefaultOfferFormulaAndTestDataGet;
var ListBrandGwsSegmentationGet = /** @class */ (function () {
    function ListBrandGwsSegmentationGet() {
    }
    ListBrandGwsSegmentationGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandGwsSegmentationGet.api_name = "api.admin.brands.gws.gameprovider.segmentation.listbrandgwssegmentationget";
    return ListBrandGwsSegmentationGet;
}());
exports.ListBrandGwsSegmentationGet = ListBrandGwsSegmentationGet;
var ListTournamentAmountsByTournamentIdGet = /** @class */ (function () {
    function ListTournamentAmountsByTournamentIdGet() {
    }
    ListTournamentAmountsByTournamentIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTournamentAmountsByTournamentIdGet.api_name = "api.admin.bonus.tournaments.amounts.listtournamentamountsbytournamentidget";
    return ListTournamentAmountsByTournamentIdGet;
}());
exports.ListTournamentAmountsByTournamentIdGet = ListTournamentAmountsByTournamentIdGet;
var DetailsWagerOnDepBonusInstanceConfigGet = /** @class */ (function () {
    function DetailsWagerOnDepBonusInstanceConfigGet() {
    }
    DetailsWagerOnDepBonusInstanceConfigGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsWagerOnDepBonusInstanceConfigGet.api_name = "api.admin.users.players.bonuses.config.wager_on_dep.detailswagerondepbonusinstanceconfigget";
    return DetailsWagerOnDepBonusInstanceConfigGet;
}());
exports.DetailsWagerOnDepBonusInstanceConfigGet = DetailsWagerOnDepBonusInstanceConfigGet;
var DoDeletePlayerEventHandler = /** @class */ (function () {
    function DoDeletePlayerEventHandler() {
    }
    DoDeletePlayerEventHandler.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePlayerEventHandler.api_name = "api.admin.brands.players.events.handlers.dodeleteplayereventhandler";
    return DoDeletePlayerEventHandler;
}());
exports.DoDeletePlayerEventHandler = DoDeletePlayerEventHandler;
var DoSetPProgramAppCurrencyIsDefault = /** @class */ (function () {
    function DoSetPProgramAppCurrencyIsDefault() {
    }
    DoSetPProgramAppCurrencyIsDefault.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPProgramAppCurrencyIsDefault.api_name = "api.admin.aff.pprograms.app.currency.dosetpprogramappcurrencyisdefault";
    return DoSetPProgramAppCurrencyIsDefault;
}());
exports.DoSetPProgramAppCurrencyIsDefault = DoSetPProgramAppCurrencyIsDefault;
var ListBrandBannersByBrandsGet = /** @class */ (function () {
    function ListBrandBannersByBrandsGet() {
    }
    ListBrandBannersByBrandsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandBannersByBrandsGet.api_name = "api.admin.aff.brands.banners.control.listbrandbannersbybrandsget";
    return ListBrandBannersByBrandsGet;
}());
exports.ListBrandBannersByBrandsGet = ListBrandBannersByBrandsGet;
var DoDeleteCmsGameSetFreeSpinBetTarget = /** @class */ (function () {
    function DoDeleteCmsGameSetFreeSpinBetTarget() {
    }
    DoDeleteCmsGameSetFreeSpinBetTarget.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteCmsGameSetFreeSpinBetTarget.api_name = "api.admin.cms.gameset.freespin.bettargets.dodeletecmsgamesetfreespinbettarget";
    return DoDeleteCmsGameSetFreeSpinBetTarget;
}());
exports.DoDeleteCmsGameSetFreeSpinBetTarget = DoDeleteCmsGameSetFreeSpinBetTarget;
var DoAddTournamentLocale = /** @class */ (function () {
    function DoAddTournamentLocale() {
    }
    DoAddTournamentLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddTournamentLocale.api_name = "api.admin.bonus.tournaments.locales.doaddtournamentlocale";
    return DoAddTournamentLocale;
}());
exports.DoAddTournamentLocale = DoAddTournamentLocale;
var DoEditBrandAppPayout = /** @class */ (function () {
    function DoEditBrandAppPayout() {
    }
    DoEditBrandAppPayout.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandAppPayout.api_name = "api.admin.brands.partners.payout.control.doeditbrandapppayout";
    return DoEditBrandAppPayout;
}());
exports.DoEditBrandAppPayout = DoEditBrandAppPayout;
var DoDeleteGwsGameProvider = /** @class */ (function () {
    function DoDeleteGwsGameProvider() {
    }
    DoDeleteGwsGameProvider.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteGwsGameProvider.api_name = "api.admin.gws.gameprovider.control.dodeletegwsgameprovider";
    return DoDeleteGwsGameProvider;
}());
exports.DoDeleteGwsGameProvider = DoDeleteGwsGameProvider;
var ListForBrandStatPProgramsAvailGet = /** @class */ (function () {
    function ListForBrandStatPProgramsAvailGet() {
    }
    ListForBrandStatPProgramsAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListForBrandStatPProgramsAvailGet.api_name = "api.admin.brands.partners.forstat.listforbrandstatpprogramsavailget";
    return ListForBrandStatPProgramsAvailGet;
}());
exports.ListForBrandStatPProgramsAvailGet = ListForBrandStatPProgramsAvailGet;
var ListCmsPProgramsContentDirectoryAllowedGet = /** @class */ (function () {
    function ListCmsPProgramsContentDirectoryAllowedGet() {
    }
    ListCmsPProgramsContentDirectoryAllowedGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListCmsPProgramsContentDirectoryAllowedGet.api_name = "api.admin.aff.pprograms.cms.content.listcmspprogramscontentdirectoryallowedget";
    return ListCmsPProgramsContentDirectoryAllowedGet;
}());
exports.ListCmsPProgramsContentDirectoryAllowedGet = ListCmsPProgramsContentDirectoryAllowedGet;
var DoDeleteLanguage = /** @class */ (function () {
    function DoDeleteLanguage() {
    }
    DoDeleteLanguage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteLanguage.api_name = "api.admin.app.language.dodeletelanguage";
    return DoDeleteLanguage;
}());
exports.DoDeleteLanguage = DoDeleteLanguage;
var ListFireWallEventsAvailGet = /** @class */ (function () {
    function ListFireWallEventsAvailGet() {
    }
    ListFireWallEventsAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListFireWallEventsAvailGet.api_name = "api.admin.brands.security.firewall.listfirewalleventsavailget";
    return ListFireWallEventsAvailGet;
}());
exports.ListFireWallEventsAvailGet = ListFireWallEventsAvailGet;
var ListFSRangeGameSetsByFSRangeAndCurrencyGet = /** @class */ (function () {
    function ListFSRangeGameSetsByFSRangeAndCurrencyGet() {
    }
    ListFSRangeGameSetsByFSRangeAndCurrencyGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListFSRangeGameSetsByFSRangeAndCurrencyGet.api_name = "api.admin.bonus.fsranges.gamesets.listfsrangegamesetsbyfsrangeandcurrencyget";
    return ListFSRangeGameSetsByFSRangeAndCurrencyGet;
}());
exports.ListFSRangeGameSetsByFSRangeAndCurrencyGet = ListFSRangeGameSetsByFSRangeAndCurrencyGet;
var DoEditPProgram = /** @class */ (function () {
    function DoEditPProgram() {
    }
    DoEditPProgram.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgram.api_name = "api.admin.aff.pprograms.control.doeditpprogram";
    return DoEditPProgram;
}());
exports.DoEditPProgram = DoEditPProgram;
var DoClonePromoCodeTemplate = /** @class */ (function () {
    function DoClonePromoCodeTemplate() {
    }
    DoClonePromoCodeTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoClonePromoCodeTemplate.api_name = "api.admin.bonus.promocodes.templates.control.doclonepromocodetemplate";
    return DoClonePromoCodeTemplate;
}());
exports.DoClonePromoCodeTemplate = DoClonePromoCodeTemplate;
var DoDeleteFireWallRule = /** @class */ (function () {
    function DoDeleteFireWallRule() {
    }
    DoDeleteFireWallRule.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteFireWallRule.api_name = "api.admin.brands.security.firewall.dodeletefirewallrule";
    return DoDeleteFireWallRule;
}());
exports.DoDeleteFireWallRule = DoDeleteFireWallRule;
var DoEditWhiteIpAddr = /** @class */ (function () {
    function DoEditWhiteIpAddr() {
    }
    DoEditWhiteIpAddr.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditWhiteIpAddr.api_name = "api.admin.users.players.white.ipaddr.doeditwhiteipaddr";
    return DoEditWhiteIpAddr;
}());
exports.DoEditWhiteIpAddr = DoEditWhiteIpAddr;
var DoSetBrandPayProviderOrderNumber = /** @class */ (function () {
    function DoSetBrandPayProviderOrderNumber() {
    }
    DoSetBrandPayProviderOrderNumber.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandPayProviderOrderNumber.api_name = "api.admin.brand.deposit.providers.control.dosetbrandpayproviderordernumber";
    return DoSetBrandPayProviderOrderNumber;
}());
exports.DoSetBrandPayProviderOrderNumber = DoSetBrandPayProviderOrderNumber;
var ListFireWallTrustZonesAvailGet = /** @class */ (function () {
    function ListFireWallTrustZonesAvailGet() {
    }
    ListFireWallTrustZonesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListFireWallTrustZonesAvailGet.api_name = "api.admin.brands.security.firewall.listfirewalltrustzonesavailget";
    return ListFireWallTrustZonesAvailGet;
}());
exports.ListFireWallTrustZonesAvailGet = ListFireWallTrustZonesAvailGet;
var DoAddBonusTemplateConfigSegmentItem = /** @class */ (function () {
    function DoAddBonusTemplateConfigSegmentItem() {
    }
    DoAddBonusTemplateConfigSegmentItem.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusTemplateConfigSegmentItem.api_name = "api.admin.bonus.templates.config.segmentations.doaddbonustemplateconfigsegmentitem";
    return DoAddBonusTemplateConfigSegmentItem;
}());
exports.DoAddBonusTemplateConfigSegmentItem = DoAddBonusTemplateConfigSegmentItem;
var ListAvailBrandGwsGameZoneBehaviorsGet = /** @class */ (function () {
    function ListAvailBrandGwsGameZoneBehaviorsGet() {
    }
    ListAvailBrandGwsGameZoneBehaviorsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailBrandGwsGameZoneBehaviorsGet.api_name = "api.admin.brands.control.listavailbrandgwsgamezonebehaviorsget";
    return ListAvailBrandGwsGameZoneBehaviorsGet;
}());
exports.ListAvailBrandGwsGameZoneBehaviorsGet = ListAvailBrandGwsGameZoneBehaviorsGet;
var ListPlayerEventHandlersByBrandIdGet = /** @class */ (function () {
    function ListPlayerEventHandlersByBrandIdGet() {
    }
    ListPlayerEventHandlersByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayerEventHandlersByBrandIdGet.api_name = "api.admin.brands.players.events.handlers.listplayereventhandlersbybrandidget";
    return ListPlayerEventHandlersByBrandIdGet;
}());
exports.ListPlayerEventHandlersByBrandIdGet = ListPlayerEventHandlersByBrandIdGet;
var DoSetLanguageIsDeprecated = /** @class */ (function () {
    function DoSetLanguageIsDeprecated() {
    }
    DoSetLanguageIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetLanguageIsDeprecated.api_name = "api.admin.app.language.dosetlanguageisdeprecated";
    return DoSetLanguageIsDeprecated;
}());
exports.DoSetLanguageIsDeprecated = DoSetLanguageIsDeprecated;
var DoEditBonusPlayerLevelBetAmount = /** @class */ (function () {
    function DoEditBonusPlayerLevelBetAmount() {
    }
    DoEditBonusPlayerLevelBetAmount.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusPlayerLevelBetAmount.api_name = "api.admin.bonus.levels.betamounts.doeditbonusplayerlevelbetamount";
    return DoEditBonusPlayerLevelBetAmount;
}());
exports.DoEditBonusPlayerLevelBetAmount = DoEditBonusPlayerLevelBetAmount;
var ListBrandPromoTplReportByDateRangeGet = /** @class */ (function () {
    function ListBrandPromoTplReportByDateRangeGet() {
    }
    ListBrandPromoTplReportByDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandPromoTplReportByDateRangeGet.api_name = "api.admin.report.promocode.templates.listbrandpromotplreportbydaterangeget";
    return ListBrandPromoTplReportByDateRangeGet;
}());
exports.ListBrandPromoTplReportByDateRangeGet = ListBrandPromoTplReportByDateRangeGet;
var DoGenerateBotFutureWinsSequence = /** @class */ (function () {
    function DoGenerateBotFutureWinsSequence() {
    }
    DoGenerateBotFutureWinsSequence.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoGenerateBotFutureWinsSequence.api_name = "api.admin.bonus.tournaments.bots.control.dogeneratebotfuturewinssequence";
    return DoGenerateBotFutureWinsSequence;
}());
exports.DoGenerateBotFutureWinsSequence = DoGenerateBotFutureWinsSequence;
var DoTestImageJoin = /** @class */ (function () {
    function DoTestImageJoin() {
    }
    DoTestImageJoin.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoTestImageJoin.api_name = "api.admin.app.capchas.templates.control.dotestimagejoin";
    return DoTestImageJoin;
}());
exports.DoTestImageJoin = DoTestImageJoin;
var DoAddWhiteIpAddr = /** @class */ (function () {
    function DoAddWhiteIpAddr() {
    }
    DoAddWhiteIpAddr.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddWhiteIpAddr.api_name = "api.admin.users.players.white.ipaddr.doaddwhiteipaddr";
    return DoAddWhiteIpAddr;
}());
exports.DoAddWhiteIpAddr = DoAddWhiteIpAddr;
var DoNewWithdrawCommit = /** @class */ (function () {
    function DoNewWithdrawCommit() {
    }
    DoNewWithdrawCommit.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoNewWithdrawCommit.api_name = "api.admin.finance.control.donewwithdrawcommit";
    return DoNewWithdrawCommit;
}());
exports.DoNewWithdrawCommit = DoNewWithdrawCommit;
var ListBonusCancelTypesAvailGet = /** @class */ (function () {
    function ListBonusCancelTypesAvailGet() {
    }
    ListBonusCancelTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusCancelTypesAvailGet.api_name = "api.admin.bonus.templates.control.listbonuscanceltypesavailget";
    return ListBonusCancelTypesAvailGet;
}());
exports.ListBonusCancelTypesAvailGet = ListBonusCancelTypesAvailGet;
var DoDeleteUserPlayerFavoriteGame = /** @class */ (function () {
    function DoDeleteUserPlayerFavoriteGame() {
    }
    DoDeleteUserPlayerFavoriteGame.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteUserPlayerFavoriteGame.api_name = "api.admin.users.players.favoritegames.dodeleteuserplayerfavoritegame";
    return DoDeleteUserPlayerFavoriteGame;
}());
exports.DoDeleteUserPlayerFavoriteGame = DoDeleteUserPlayerFavoriteGame;
var ListPProgramNewsByPProgramId = /** @class */ (function () {
    function ListPProgramNewsByPProgramId() {
    }
    ListPProgramNewsByPProgramId.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramNewsByPProgramId.api_name = "api.admin.aff.pprograms.news.control.listpprogramnewsbypprogramid";
    return ListPProgramNewsByPProgramId;
}());
exports.ListPProgramNewsByPProgramId = ListPProgramNewsByPProgramId;
var DoAddBrandPlayerLevel = /** @class */ (function () {
    function DoAddBrandPlayerLevel() {
    }
    DoAddBrandPlayerLevel.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandPlayerLevel.api_name = "api.admin.bonus.levels.control.doaddbrandplayerlevel";
    return DoAddBrandPlayerLevel;
}());
exports.DoAddBrandPlayerLevel = DoAddBrandPlayerLevel;
var DoAddPlayerEventHandler = /** @class */ (function () {
    function DoAddPlayerEventHandler() {
    }
    DoAddPlayerEventHandler.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPlayerEventHandler.api_name = "api.admin.brands.players.events.handlers.doaddplayereventhandler";
    return DoAddPlayerEventHandler;
}());
exports.DoAddPlayerEventHandler = DoAddPlayerEventHandler;
var DoDepositPlayerBonusAmtByPlayerBonusId = /** @class */ (function () {
    function DoDepositPlayerBonusAmtByPlayerBonusId() {
    }
    DoDepositPlayerBonusAmtByPlayerBonusId.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDepositPlayerBonusAmtByPlayerBonusId.api_name = "api.admin.users.players.bonuses.control.dodepositplayerbonusamtbyplayerbonusid";
    return DoDepositPlayerBonusAmtByPlayerBonusId;
}());
exports.DoDepositPlayerBonusAmtByPlayerBonusId = DoDepositPlayerBonusAmtByPlayerBonusId;
var DoAddBonusPlayerLevelLocale = /** @class */ (function () {
    function DoAddBonusPlayerLevelLocale() {
    }
    DoAddBonusPlayerLevelLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusPlayerLevelLocale.api_name = "api.admin.bonus.levels.locales.doaddbonusplayerlevellocale";
    return DoAddBonusPlayerLevelLocale;
}());
exports.DoAddBonusPlayerLevelLocale = DoAddBonusPlayerLevelLocale;
var DoEditBrandOffer = /** @class */ (function () {
    function DoEditBrandOffer() {
    }
    DoEditBrandOffer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandOffer.api_name = "api.admin.aff.brands.offers.control.doeditbrandoffer";
    return DoEditBrandOffer;
}());
exports.DoEditBrandOffer = DoEditBrandOffer;
var DoGeneratePProgramPartnerPassword = /** @class */ (function () {
    function DoGeneratePProgramPartnerPassword() {
    }
    DoGeneratePProgramPartnerPassword.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoGeneratePProgramPartnerPassword.api_name = "api.admin.aff.pprograms.usr.partners.control.dogeneratepprogrampartnerpassword";
    return DoGeneratePProgramPartnerPassword;
}());
exports.DoGeneratePProgramPartnerPassword = DoGeneratePProgramPartnerPassword;
var DoEditCurrency = /** @class */ (function () {
    function DoEditCurrency() {
    }
    DoEditCurrency.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditCurrency.api_name = "api.admin.app.currency.doeditcurrency";
    return DoEditCurrency;
}());
exports.DoEditCurrency = DoEditCurrency;
var DoAddBrandBrandingLocale = /** @class */ (function () {
    function DoAddBrandBrandingLocale() {
    }
    DoAddBrandBrandingLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandBrandingLocale.api_name = "api.admin.aff.brands.brandings.locales.doaddbrandbrandinglocale";
    return DoAddBrandBrandingLocale;
}());
exports.DoAddBrandBrandingLocale = DoAddBrandBrandingLocale;
var DoDeleteTrustEventHandler = /** @class */ (function () {
    function DoDeleteTrustEventHandler() {
    }
    DoDeleteTrustEventHandler.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteTrustEventHandler.api_name = "api.admin.brands.security.trust.handlers.dodeletetrusteventhandler";
    return DoDeleteTrustEventHandler;
}());
exports.DoDeleteTrustEventHandler = DoDeleteTrustEventHandler;
var ListAvailPromoCodeTemplatesByBrandIdGet = /** @class */ (function () {
    function ListAvailPromoCodeTemplatesByBrandIdGet() {
    }
    ListAvailPromoCodeTemplatesByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailPromoCodeTemplatesByBrandIdGet.api_name = "api.admin.bonus.promocodes.templates.control.listavailpromocodetemplatesbybrandidget";
    return ListAvailPromoCodeTemplatesByBrandIdGet;
}());
exports.ListAvailPromoCodeTemplatesByBrandIdGet = ListAvailPromoCodeTemplatesByBrandIdGet;
var ListBrandLocalesByBrandIdGet = /** @class */ (function () {
    function ListBrandLocalesByBrandIdGet() {
    }
    ListBrandLocalesByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandLocalesByBrandIdGet.api_name = "api.admin.brands.locales.listbrandlocalesbybrandidget";
    return ListBrandLocalesByBrandIdGet;
}());
exports.ListBrandLocalesByBrandIdGet = ListBrandLocalesByBrandIdGet;
var DoAddBrandOfferAppCountry = /** @class */ (function () {
    function DoAddBrandOfferAppCountry() {
    }
    DoAddBrandOfferAppCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandOfferAppCountry.api_name = "api.admin.aff.brands.offers.country.doaddbrandofferappcountry";
    return DoAddBrandOfferAppCountry;
}());
exports.DoAddBrandOfferAppCountry = DoAddBrandOfferAppCountry;
var DoAddCmsGameSetFreeSpinBetTarget = /** @class */ (function () {
    function DoAddCmsGameSetFreeSpinBetTarget() {
    }
    DoAddCmsGameSetFreeSpinBetTarget.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddCmsGameSetFreeSpinBetTarget.api_name = "api.admin.cms.gameset.freespin.bettargets.doaddcmsgamesetfreespinbettarget";
    return DoAddCmsGameSetFreeSpinBetTarget;
}());
exports.DoAddCmsGameSetFreeSpinBetTarget = DoAddCmsGameSetFreeSpinBetTarget;
var ListPostRecordsByPostDataIdGet = /** @class */ (function () {
    function ListPostRecordsByPostDataIdGet() {
    }
    ListPostRecordsByPostDataIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPostRecordsByPostDataIdGet.api_name = "api.admin.cms.posts.records.control.listpostrecordsbypostdataidget";
    return ListPostRecordsByPostDataIdGet;
}());
exports.ListPostRecordsByPostDataIdGet = ListPostRecordsByPostDataIdGet;
var DoCmsBrandContentDirectoryDelete = /** @class */ (function () {
    function DoCmsBrandContentDirectoryDelete() {
    }
    DoCmsBrandContentDirectoryDelete.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsBrandContentDirectoryDelete.api_name = "api.admin.cms.brands.content.docmsbrandcontentdirectorydelete";
    return DoCmsBrandContentDirectoryDelete;
}());
exports.DoCmsBrandContentDirectoryDelete = DoCmsBrandContentDirectoryDelete;
var DoDeleteBonusEventBindingBonus = /** @class */ (function () {
    function DoDeleteBonusEventBindingBonus() {
    }
    DoDeleteBonusEventBindingBonus.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusEventBindingBonus.api_name = "api.admin.bonus.events.bindings.bonuses.dodeletebonuseventbindingbonus";
    return DoDeleteBonusEventBindingBonus;
}());
exports.DoDeleteBonusEventBindingBonus = DoDeleteBonusEventBindingBonus;
var ListBonusEventsBindingsByBrandIdGet = /** @class */ (function () {
    function ListBonusEventsBindingsByBrandIdGet() {
    }
    ListBonusEventsBindingsByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusEventsBindingsByBrandIdGet.api_name = "api.admin.bonus.events.bindings.control.listbonuseventsbindingsbybrandidget";
    return ListBonusEventsBindingsByBrandIdGet;
}());
exports.ListBonusEventsBindingsByBrandIdGet = ListBonusEventsBindingsByBrandIdGet;
var DoSetBrandLandingIsDeprecated = /** @class */ (function () {
    function DoSetBrandLandingIsDeprecated() {
    }
    DoSetBrandLandingIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandLandingIsDeprecated.api_name = "api.admin.aff.brands.landings.control.dosetbrandlandingisdeprecated";
    return DoSetBrandLandingIsDeprecated;
}());
exports.DoSetBrandLandingIsDeprecated = DoSetBrandLandingIsDeprecated;
var DoDeleteBrandEmailSetTemplate = /** @class */ (function () {
    function DoDeleteBrandEmailSetTemplate() {
    }
    DoDeleteBrandEmailSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandEmailSetTemplate.api_name = "api.admin.brands.templates.control.email.set.control.dodeletebrandemailsettemplate";
    return DoDeleteBrandEmailSetTemplate;
}());
exports.DoDeleteBrandEmailSetTemplate = DoDeleteBrandEmailSetTemplate;
var DoAddUsrPlayerFavoriteGame = /** @class */ (function () {
    function DoAddUsrPlayerFavoriteGame() {
    }
    DoAddUsrPlayerFavoriteGame.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddUsrPlayerFavoriteGame.api_name = "api.admin.users.players.favoritegames.doaddusrplayerfavoritegame";
    return DoAddUsrPlayerFavoriteGame;
}());
exports.DoAddUsrPlayerFavoriteGame = DoAddUsrPlayerFavoriteGame;
var DoAddPageRecord = /** @class */ (function () {
    function DoAddPageRecord() {
    }
    DoAddPageRecord.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPageRecord.api_name = "api.admin.cms.pages.records.control.doaddpagerecord";
    return DoAddPageRecord;
}());
exports.DoAddPageRecord = DoAddPageRecord;
var DoSetGameSetGameFreeSpinBet = /** @class */ (function () {
    function DoSetGameSetGameFreeSpinBet() {
    }
    DoSetGameSetGameFreeSpinBet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGameSetGameFreeSpinBet.api_name = "api.admin.cms.gameset.games.fsconfig.dosetgamesetgamefreespinbet";
    return DoSetGameSetGameFreeSpinBet;
}());
exports.DoSetGameSetGameFreeSpinBet = DoSetGameSetGameFreeSpinBet;
var ListFireWallRulesByBrandIdGet = /** @class */ (function () {
    function ListFireWallRulesByBrandIdGet() {
    }
    ListFireWallRulesByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListFireWallRulesByBrandIdGet.api_name = "api.admin.brands.security.firewall.listfirewallrulesbybrandidget";
    return ListFireWallRulesByBrandIdGet;
}());
exports.ListFireWallRulesByBrandIdGet = ListFireWallRulesByBrandIdGet;
var DoEditTrustEventHandler = /** @class */ (function () {
    function DoEditTrustEventHandler() {
    }
    DoEditTrustEventHandler.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditTrustEventHandler.api_name = "api.admin.brands.security.trust.handlers.doedittrusteventhandler";
    return DoEditTrustEventHandler;
}());
exports.DoEditTrustEventHandler = DoEditTrustEventHandler;
var DoCheckPProgramEmailSetTemplate = /** @class */ (function () {
    function DoCheckPProgramEmailSetTemplate() {
    }
    DoCheckPProgramEmailSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCheckPProgramEmailSetTemplate.api_name = "api.admin.aff.pprograms.email.set.templates.control.docheckpprogramemailsettemplate";
    return DoCheckPProgramEmailSetTemplate;
}());
exports.DoCheckPProgramEmailSetTemplate = DoCheckPProgramEmailSetTemplate;
var DoDeleteBrandOffer = /** @class */ (function () {
    function DoDeleteBrandOffer() {
    }
    DoDeleteBrandOffer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandOffer.api_name = "api.admin.aff.brands.offers.control.dodeletebrandoffer";
    return DoDeleteBrandOffer;
}());
exports.DoDeleteBrandOffer = DoDeleteBrandOffer;
var DoSetPlayerBonusStatusActivated = /** @class */ (function () {
    function DoSetPlayerBonusStatusActivated() {
    }
    DoSetPlayerBonusStatusActivated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPlayerBonusStatusActivated.api_name = "api.admin.users.players.bonuses.control.dosetplayerbonusstatusactivated";
    return DoSetPlayerBonusStatusActivated;
}());
exports.DoSetPlayerBonusStatusActivated = DoSetPlayerBonusStatusActivated;
var DoForcePlayerCashBack = /** @class */ (function () {
    function DoForcePlayerCashBack() {
    }
    DoForcePlayerCashBack.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoForcePlayerCashBack.api_name = "api.admin.users.players.control.doforceplayercashback";
    return DoForcePlayerCashBack;
}());
exports.DoForcePlayerCashBack = DoForcePlayerCashBack;
var DoAddLanguage = /** @class */ (function () {
    function DoAddLanguage() {
    }
    DoAddLanguage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddLanguage.api_name = "api.admin.app.language.doaddlanguage";
    return DoAddLanguage;
}());
exports.DoAddLanguage = DoAddLanguage;
var DoAddPProgramPartner = /** @class */ (function () {
    function DoAddPProgramPartner() {
    }
    DoAddPProgramPartner.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramPartner.api_name = "api.admin.aff.pprograms.usr.partners.control.doaddpprogrampartner";
    return DoAddPProgramPartner;
}());
exports.DoAddPProgramPartner = DoAddPProgramPartner;
var DoEditBrandBanner = /** @class */ (function () {
    function DoEditBrandBanner() {
    }
    DoEditBrandBanner.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandBanner.api_name = "api.admin.aff.brands.banners.control.doeditbrandbanner";
    return DoEditBrandBanner;
}());
exports.DoEditBrandBanner = DoEditBrandBanner;
var ListBonusJackpotTransferTypesAvailGet = /** @class */ (function () {
    function ListBonusJackpotTransferTypesAvailGet() {
    }
    ListBonusJackpotTransferTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusJackpotTransferTypesAvailGet.api_name = "api.admin.bonus.jackpots.transfers.listbonusjackpottransfertypesavailget";
    return ListBonusJackpotTransferTypesAvailGet;
}());
exports.ListBonusJackpotTransferTypesAvailGet = ListBonusJackpotTransferTypesAvailGet;
var GetPlayersCountCoveredByRule = /** @class */ (function () {
    function GetPlayersCountCoveredByRule() {
    }
    GetPlayersCountCoveredByRule.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    GetPlayersCountCoveredByRule.api_name = "api.admin.brands.security.firewall.getplayerscountcoveredbyrule";
    return GetPlayersCountCoveredByRule;
}());
exports.GetPlayersCountCoveredByRule = GetPlayersCountCoveredByRule;
var DoEditBonusPlayerLevelLocale = /** @class */ (function () {
    function DoEditBonusPlayerLevelLocale() {
    }
    DoEditBonusPlayerLevelLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusPlayerLevelLocale.api_name = "api.admin.bonus.levels.locales.doeditbonusplayerlevellocale";
    return DoEditBonusPlayerLevelLocale;
}());
exports.DoEditBonusPlayerLevelLocale = DoEditBonusPlayerLevelLocale;
var ListPromoTemplateCountriesByPromoTemplateIdGet = /** @class */ (function () {
    function ListPromoTemplateCountriesByPromoTemplateIdGet() {
    }
    ListPromoTemplateCountriesByPromoTemplateIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPromoTemplateCountriesByPromoTemplateIdGet.api_name = "api.admin.bonus.promocodes.templates.countries.listpromotemplatecountriesbypromotemplateidget";
    return ListPromoTemplateCountriesByPromoTemplateIdGet;
}());
exports.ListPromoTemplateCountriesByPromoTemplateIdGet = ListPromoTemplateCountriesByPromoTemplateIdGet;
var DoGetRawPProgramEmailSetMockObjectForTest = /** @class */ (function () {
    function DoGetRawPProgramEmailSetMockObjectForTest() {
    }
    DoGetRawPProgramEmailSetMockObjectForTest.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoGetRawPProgramEmailSetMockObjectForTest.api_name = "api.admin.aff.pprograms.email.set.templates.control.dogetrawpprogramemailsetmockobjectfortest";
    return DoGetRawPProgramEmailSetMockObjectForTest;
}());
exports.DoGetRawPProgramEmailSetMockObjectForTest = DoGetRawPProgramEmailSetMockObjectForTest;
var ListBonusTemplateRestrictedPlayerTagsGet = /** @class */ (function () {
    function ListBonusTemplateRestrictedPlayerTagsGet() {
    }
    ListBonusTemplateRestrictedPlayerTagsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusTemplateRestrictedPlayerTagsGet.api_name = "api.admin.bonus.templates.restricted_player_tags.listbonustemplaterestrictedplayertagsget";
    return ListBonusTemplateRestrictedPlayerTagsGet;
}());
exports.ListBonusTemplateRestrictedPlayerTagsGet = ListBonusTemplateRestrictedPlayerTagsGet;
var DoSetBonusPlayerLevelOfferIsLocked = /** @class */ (function () {
    function DoSetBonusPlayerLevelOfferIsLocked() {
    }
    DoSetBonusPlayerLevelOfferIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBonusPlayerLevelOfferIsLocked.api_name = "api.admin.bonus.levels.offers.dosetbonusplayerlevelofferislocked";
    return DoSetBonusPlayerLevelOfferIsLocked;
}());
exports.DoSetBonusPlayerLevelOfferIsLocked = DoSetBonusPlayerLevelOfferIsLocked;
var DoDeleteUsrPartnerMessage = /** @class */ (function () {
    function DoDeleteUsrPartnerMessage() {
    }
    DoDeleteUsrPartnerMessage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteUsrPartnerMessage.api_name = "api.admin.aff.pprograms.usr.partners.messages.dodeleteusrpartnermessage";
    return DoDeleteUsrPartnerMessage;
}());
exports.DoDeleteUsrPartnerMessage = DoDeleteUsrPartnerMessage;
var DoAddPlayerBonus = /** @class */ (function () {
    function DoAddPlayerBonus() {
    }
    DoAddPlayerBonus.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPlayerBonus.api_name = "api.admin.users.players.bonuses.control.doaddplayerbonus";
    return DoAddPlayerBonus;
}());
exports.DoAddPlayerBonus = DoAddPlayerBonus;
var ListAllowedPProgramPayoutsGet = /** @class */ (function () {
    function ListAllowedPProgramPayoutsGet() {
    }
    ListAllowedPProgramPayoutsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedPProgramPayoutsGet.api_name = "api.admin.aff.pprograms.usr.partners.paydetails.listallowedpprogrampayoutsget";
    return ListAllowedPProgramPayoutsGet;
}());
exports.ListAllowedPProgramPayoutsGet = ListAllowedPProgramPayoutsGet;
var DoDeleteBonusTemplate = /** @class */ (function () {
    function DoDeleteBonusTemplate() {
    }
    DoDeleteBonusTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusTemplate.api_name = "api.admin.bonus.templates.control.dodeletebonustemplate";
    return DoDeleteBonusTemplate;
}());
exports.DoDeleteBonusTemplate = DoDeleteBonusTemplate;
var DoEditBrandSmsSetTestJSONData = /** @class */ (function () {
    function DoEditBrandSmsSetTestJSONData() {
    }
    DoEditBrandSmsSetTestJSONData.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandSmsSetTestJSONData.api_name = "api.admin.brands.templates.control.sms.set.control.doeditbrandsmssettestjsondata";
    return DoEditBrandSmsSetTestJSONData;
}());
exports.DoEditBrandSmsSetTestJSONData = DoEditBrandSmsSetTestJSONData;
var ListPProgramPartnerOffersByPartnerIdGet = /** @class */ (function () {
    function ListPProgramPartnerOffersByPartnerIdGet() {
    }
    ListPProgramPartnerOffersByPartnerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramPartnerOffersByPartnerIdGet.api_name = "api.admin.aff.pprograms.usr.partners.offers.listpprogrampartneroffersbypartneridget";
    return ListPProgramPartnerOffersByPartnerIdGet;
}());
exports.ListPProgramPartnerOffersByPartnerIdGet = ListPProgramPartnerOffersByPartnerIdGet;
var DoAddTrustEventHandler = /** @class */ (function () {
    function DoAddTrustEventHandler() {
    }
    DoAddTrustEventHandler.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddTrustEventHandler.api_name = "api.admin.brands.security.trust.handlers.doaddtrusteventhandler";
    return DoAddTrustEventHandler;
}());
exports.DoAddTrustEventHandler = DoAddTrustEventHandler;
var DoEditFireWallRule = /** @class */ (function () {
    function DoEditFireWallRule() {
    }
    DoEditFireWallRule.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditFireWallRule.api_name = "api.admin.brands.security.firewall.doeditfirewallrule";
    return DoEditFireWallRule;
}());
exports.DoEditFireWallRule = DoEditFireWallRule;
var ListAllowedGwsGameProviderProviderCategoriesGet = /** @class */ (function () {
    function ListAllowedGwsGameProviderProviderCategoriesGet() {
    }
    ListAllowedGwsGameProviderProviderCategoriesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedGwsGameProviderProviderCategoriesGet.api_name = "api.admin.gws.gameprovider.control.listallowedgwsgameproviderprovidercategoriesget";
    return ListAllowedGwsGameProviderProviderCategoriesGet;
}());
exports.ListAllowedGwsGameProviderProviderCategoriesGet = ListAllowedGwsGameProviderProviderCategoriesGet;
var DoAddFSRange = /** @class */ (function () {
    function DoAddFSRange() {
    }
    DoAddFSRange.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddFSRange.api_name = "api.admin.bonus.fsranges.control.doaddfsrange";
    return DoAddFSRange;
}());
exports.DoAddFSRange = DoAddFSRange;
var ListAvailPProgramBrandsByPProgramIdGet = /** @class */ (function () {
    function ListAvailPProgramBrandsByPProgramIdGet() {
    }
    ListAvailPProgramBrandsByPProgramIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailPProgramBrandsByPProgramIdGet.api_name = "api.admin.aff.pprograms.brands.listavailpprogrambrandsbypprogramidget";
    return ListAvailPProgramBrandsByPProgramIdGet;
}());
exports.ListAvailPProgramBrandsByPProgramIdGet = ListAvailPProgramBrandsByPProgramIdGet;
var DoAddWinnerTop = /** @class */ (function () {
    function DoAddWinnerTop() {
    }
    DoAddWinnerTop.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddWinnerTop.api_name = "api.admin.cms.winners.top.doaddwinnertop";
    return DoAddWinnerTop;
}());
exports.DoAddWinnerTop = DoAddWinnerTop;
var ListWhiteIpAddressesByUsrPlayerIdGet = /** @class */ (function () {
    function ListWhiteIpAddressesByUsrPlayerIdGet() {
    }
    ListWhiteIpAddressesByUsrPlayerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListWhiteIpAddressesByUsrPlayerIdGet.api_name = "api.admin.users.players.white.ipaddr.listwhiteipaddressesbyusrplayeridget";
    return ListWhiteIpAddressesByUsrPlayerIdGet;
}());
exports.ListWhiteIpAddressesByUsrPlayerIdGet = ListWhiteIpAddressesByUsrPlayerIdGet;
var DoEditBrandAppPayoutKeyVal = /** @class */ (function () {
    function DoEditBrandAppPayoutKeyVal() {
    }
    DoEditBrandAppPayoutKeyVal.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandAppPayoutKeyVal.api_name = "api.admin.brands.partners.payout.keyval.doeditbrandapppayoutkeyval";
    return DoEditBrandAppPayoutKeyVal;
}());
exports.DoEditBrandAppPayoutKeyVal = DoEditBrandAppPayoutKeyVal;
var DoDeleteBonusEventBindingDescription = /** @class */ (function () {
    function DoDeleteBonusEventBindingDescription() {
    }
    DoDeleteBonusEventBindingDescription.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBonusEventBindingDescription.api_name = "api.admin.bonus.events.bindings.descriptions.dodeletebonuseventbindingdescription";
    return DoDeleteBonusEventBindingDescription;
}());
exports.DoDeleteBonusEventBindingDescription = DoDeleteBonusEventBindingDescription;
var DoEditWagerNoDepBonusInstanceConfig = /** @class */ (function () {
    function DoEditWagerNoDepBonusInstanceConfig() {
    }
    DoEditWagerNoDepBonusInstanceConfig.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditWagerNoDepBonusInstanceConfig.api_name = "api.admin.users.players.bonuses.config.wager_no_dep.doeditwagernodepbonusinstanceconfig";
    return DoEditWagerNoDepBonusInstanceConfig;
}());
exports.DoEditWagerNoDepBonusInstanceConfig = DoEditWagerNoDepBonusInstanceConfig;
var DoEditTournamentBet = /** @class */ (function () {
    function DoEditTournamentBet() {
    }
    DoEditTournamentBet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditTournamentBet.api_name = "api.admin.bonus.tournaments.bets.doedittournamentbet";
    return DoEditTournamentBet;
}());
exports.DoEditTournamentBet = DoEditTournamentBet;
var DoEditCmsGameProviderGameSetLocale = /** @class */ (function () {
    function DoEditCmsGameProviderGameSetLocale() {
    }
    DoEditCmsGameProviderGameSetLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditCmsGameProviderGameSetLocale.api_name = "api.admin.cms.gameset.locales.doeditcmsgameprovidergamesetlocale";
    return DoEditCmsGameProviderGameSetLocale;
}());
exports.DoEditCmsGameProviderGameSetLocale = DoEditCmsGameProviderGameSetLocale;
var ListBonusPlayerLevelBetAmountsByLevelIdGet = /** @class */ (function () {
    function ListBonusPlayerLevelBetAmountsByLevelIdGet() {
    }
    ListBonusPlayerLevelBetAmountsByLevelIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusPlayerLevelBetAmountsByLevelIdGet.api_name = "api.admin.bonus.levels.betamounts.listbonusplayerlevelbetamountsbylevelidget";
    return ListBonusPlayerLevelBetAmountsByLevelIdGet;
}());
exports.ListBonusPlayerLevelBetAmountsByLevelIdGet = ListBonusPlayerLevelBetAmountsByLevelIdGet;
var DoAddBrandGwsGameproviderSegmentation = /** @class */ (function () {
    function DoAddBrandGwsGameproviderSegmentation() {
    }
    DoAddBrandGwsGameproviderSegmentation.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandGwsGameproviderSegmentation.api_name = "api.admin.brands.gws.gameprovider.segmentation.doaddbrandgwsgameprovidersegmentation";
    return DoAddBrandGwsGameproviderSegmentation;
}());
exports.DoAddBrandGwsGameproviderSegmentation = DoAddBrandGwsGameproviderSegmentation;
var DoSetInnerPayWalletIsLocked = /** @class */ (function () {
    function DoSetInnerPayWalletIsLocked() {
    }
    DoSetInnerPayWalletIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetInnerPayWalletIsLocked.api_name = "api.admin.app.innerpay.wallets.control.dosetinnerpaywalletislocked";
    return DoSetInnerPayWalletIsLocked;
}());
exports.DoSetInnerPayWalletIsLocked = DoSetInnerPayWalletIsLocked;
var ListUsrPartnerAuthLogsByUsrPartnerIdGet = /** @class */ (function () {
    function ListUsrPartnerAuthLogsByUsrPartnerIdGet() {
    }
    ListUsrPartnerAuthLogsByUsrPartnerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListUsrPartnerAuthLogsByUsrPartnerIdGet.api_name = "api.admin.aff.pprograms.usr.partners.authlogs.listusrpartnerauthlogsbyusrpartneridget";
    return ListUsrPartnerAuthLogsByUsrPartnerIdGet;
}());
exports.ListUsrPartnerAuthLogsByUsrPartnerIdGet = ListUsrPartnerAuthLogsByUsrPartnerIdGet;
var ListPProgramPartnersByPProgramsGet = /** @class */ (function () {
    function ListPProgramPartnersByPProgramsGet() {
    }
    ListPProgramPartnersByPProgramsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramPartnersByPProgramsGet.api_name = "api.admin.aff.pprograms.usr.partners.control.listpprogrampartnersbypprogramsget";
    return ListPProgramPartnersByPProgramsGet;
}());
exports.ListPProgramPartnersByPProgramsGet = ListPProgramPartnersByPProgramsGet;
var DoAddBonusTemplate = /** @class */ (function () {
    function DoAddBonusTemplate() {
    }
    DoAddBonusTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusTemplate.api_name = "api.admin.bonus.templates.control.doaddbonustemplate";
    return DoAddBonusTemplate;
}());
exports.DoAddBonusTemplate = DoAddBonusTemplate;
var DoEditPageRecordContent = /** @class */ (function () {
    function DoEditPageRecordContent() {
    }
    DoEditPageRecordContent.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPageRecordContent.api_name = "api.admin.cms.pages.records.control.doeditpagerecordcontent";
    return DoEditPageRecordContent;
}());
exports.DoEditPageRecordContent = DoEditPageRecordContent;
var DoAddBonusJackpot = /** @class */ (function () {
    function DoAddBonusJackpot() {
    }
    DoAddBonusJackpot.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusJackpot.api_name = "api.admin.bonus.jackpots.control.doaddbonusjackpot";
    return DoAddBonusJackpot;
}());
exports.DoAddBonusJackpot = DoAddBonusJackpot;
var ListBannersRoutesByBrandIdGet = /** @class */ (function () {
    function ListBannersRoutesByBrandIdGet() {
    }
    ListBannersRoutesByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBannersRoutesByBrandIdGet.api_name = "api.admin.cms.banners.routes.control.listbannersroutesbybrandidget";
    return ListBannersRoutesByBrandIdGet;
}());
exports.ListBannersRoutesByBrandIdGet = ListBannersRoutesByBrandIdGet;
var DoPProgramPartnerRevshareReject = /** @class */ (function () {
    function DoPProgramPartnerRevshareReject() {
    }
    DoPProgramPartnerRevshareReject.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoPProgramPartnerRevshareReject.api_name = "api.admin.aff.pprograms.usr.partners.revshares.dopprogrampartnerrevsharereject";
    return DoPProgramPartnerRevshareReject;
}());
exports.DoPProgramPartnerRevshareReject = DoPProgramPartnerRevshareReject;
var DoAddCmsGameSet = /** @class */ (function () {
    function DoAddCmsGameSet() {
    }
    DoAddCmsGameSet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddCmsGameSet.api_name = "api.admin.cms.gameset.control.doaddcmsgameset";
    return DoAddCmsGameSet;
}());
exports.DoAddCmsGameSet = DoAddCmsGameSet;
var DoSendUsrPartnerBroadcastMessageRaw = /** @class */ (function () {
    function DoSendUsrPartnerBroadcastMessageRaw() {
    }
    DoSendUsrPartnerBroadcastMessageRaw.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSendUsrPartnerBroadcastMessageRaw.api_name = "api.admin.aff.pprograms.usr.partners.messages.dosendusrpartnerbroadcastmessageraw";
    return DoSendUsrPartnerBroadcastMessageRaw;
}());
exports.DoSendUsrPartnerBroadcastMessageRaw = DoSendUsrPartnerBroadcastMessageRaw;
var DoEditTournamentTicket = /** @class */ (function () {
    function DoEditTournamentTicket() {
    }
    DoEditTournamentTicket.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditTournamentTicket.api_name = "api.admin.bonus.tournaments.tickets.doedittournamentticket";
    return DoEditTournamentTicket;
}());
exports.DoEditTournamentTicket = DoEditTournamentTicket;
var ListWinnersYearAndMonthAvail = /** @class */ (function () {
    function ListWinnersYearAndMonthAvail() {
    }
    ListWinnersYearAndMonthAvail.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListWinnersYearAndMonthAvail.api_name = "api.admin.cms.winners.top.listwinnersyearandmonthavail";
    return ListWinnersYearAndMonthAvail;
}());
exports.ListWinnersYearAndMonthAvail = ListWinnersYearAndMonthAvail;
var ListAvailBrandEmailActionsGet = /** @class */ (function () {
    function ListAvailBrandEmailActionsGet() {
    }
    ListAvailBrandEmailActionsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailBrandEmailActionsGet.api_name = "api.admin.brands.templates.control.email.set.control.listavailbrandemailactionsget";
    return ListAvailBrandEmailActionsGet;
}());
exports.ListAvailBrandEmailActionsGet = ListAvailBrandEmailActionsGet;
var DoSetBrandAppCurrencyIsTournament = /** @class */ (function () {
    function DoSetBrandAppCurrencyIsTournament() {
    }
    DoSetBrandAppCurrencyIsTournament.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandAppCurrencyIsTournament.api_name = "api.admin.brands.app.currency.dosetbrandappcurrencyistournament";
    return DoSetBrandAppCurrencyIsTournament;
}());
exports.DoSetBrandAppCurrencyIsTournament = DoSetBrandAppCurrencyIsTournament;
var DoNewWithdrawReject = /** @class */ (function () {
    function DoNewWithdrawReject() {
    }
    DoNewWithdrawReject.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoNewWithdrawReject.api_name = "api.admin.finance.control.donewwithdrawreject";
    return DoNewWithdrawReject;
}());
exports.DoNewWithdrawReject = DoNewWithdrawReject;
var DoDeleteBrandLandingLocale = /** @class */ (function () {
    function DoDeleteBrandLandingLocale() {
    }
    DoDeleteBrandLandingLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandLandingLocale.api_name = "api.admin.aff.brands.landings.locales.dodeletebrandlandinglocale";
    return DoDeleteBrandLandingLocale;
}());
exports.DoDeleteBrandLandingLocale = DoDeleteBrandLandingLocale;
var ListBrandAppCountryByBrandIdGet = /** @class */ (function () {
    function ListBrandAppCountryByBrandIdGet() {
    }
    ListBrandAppCountryByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandAppCountryByBrandIdGet.api_name = "api.admin.brands.app.country.listbrandappcountrybybrandidget";
    return ListBrandAppCountryByBrandIdGet;
}());
exports.ListBrandAppCountryByBrandIdGet = ListBrandAppCountryByBrandIdGet;
var DoEditBonusTournament = /** @class */ (function () {
    function DoEditBonusTournament() {
    }
    DoEditBonusTournament.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusTournament.api_name = "api.admin.bonus.tournaments.control.doeditbonustournament";
    return DoEditBonusTournament;
}());
exports.DoEditBonusTournament = DoEditBonusTournament;
var ListBrandDomainKindsAvailGet = /** @class */ (function () {
    function ListBrandDomainKindsAvailGet() {
    }
    ListBrandDomainKindsAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandDomainKindsAvailGet.api_name = "api.admin.brands.domains.control.listbranddomainkindsavailget";
    return ListBrandDomainKindsAvailGet;
}());
exports.ListBrandDomainKindsAvailGet = ListBrandDomainKindsAvailGet;
var DoDeleteBrandOfferAppCountry = /** @class */ (function () {
    function DoDeleteBrandOfferAppCountry() {
    }
    DoDeleteBrandOfferAppCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandOfferAppCountry.api_name = "api.admin.aff.brands.offers.country.dodeletebrandofferappcountry";
    return DoDeleteBrandOfferAppCountry;
}());
exports.DoDeleteBrandOfferAppCountry = DoDeleteBrandOfferAppCountry;
var ListAllowedBonusTemplateByUsrPlayerIdGet = /** @class */ (function () {
    function ListAllowedBonusTemplateByUsrPlayerIdGet() {
    }
    ListAllowedBonusTemplateByUsrPlayerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedBonusTemplateByUsrPlayerIdGet.api_name = "api.admin.bonus.templates.control.listallowedbonustemplatebyusrplayeridget";
    return ListAllowedBonusTemplateByUsrPlayerIdGet;
}());
exports.ListAllowedBonusTemplateByUsrPlayerIdGet = ListAllowedBonusTemplateByUsrPlayerIdGet;
var ListPageRecordsByPageDataIdGet = /** @class */ (function () {
    function ListPageRecordsByPageDataIdGet() {
    }
    ListPageRecordsByPageDataIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPageRecordsByPageDataIdGet.api_name = "api.admin.cms.pages.records.control.listpagerecordsbypagedataidget";
    return ListPageRecordsByPageDataIdGet;
}());
exports.ListPageRecordsByPageDataIdGet = ListPageRecordsByPageDataIdGet;
var DoDeletePostRecord = /** @class */ (function () {
    function DoDeletePostRecord() {
    }
    DoDeletePostRecord.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePostRecord.api_name = "api.admin.cms.posts.records.control.dodeletepostrecord";
    return DoDeletePostRecord;
}());
exports.DoDeletePostRecord = DoDeletePostRecord;
var DoAddPProgramPartnerRevshare = /** @class */ (function () {
    function DoAddPProgramPartnerRevshare() {
    }
    DoAddPProgramPartnerRevshare.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramPartnerRevshare.api_name = "api.admin.aff.pprograms.usr.partners.revshares.doaddpprogrampartnerrevshare";
    return DoAddPProgramPartnerRevshare;
}());
exports.DoAddPProgramPartnerRevshare = DoAddPProgramPartnerRevshare;
var DoCheckGwsGameProviderConnection = /** @class */ (function () {
    function DoCheckGwsGameProviderConnection() {
    }
    DoCheckGwsGameProviderConnection.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCheckGwsGameProviderConnection.api_name = "api.admin.gws.gameprovider.control.docheckgwsgameproviderconnection";
    return DoCheckGwsGameProviderConnection;
}());
exports.DoCheckGwsGameProviderConnection = DoCheckGwsGameProviderConnection;
var DoAddBonusPromocodeTemplateCountry = /** @class */ (function () {
    function DoAddBonusPromocodeTemplateCountry() {
    }
    DoAddBonusPromocodeTemplateCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusPromocodeTemplateCountry.api_name = "api.admin.bonus.promocodes.templates.countries.doaddbonuspromocodetemplatecountry";
    return DoAddBonusPromocodeTemplateCountry;
}());
exports.DoAddBonusPromocodeTemplateCountry = DoAddBonusPromocodeTemplateCountry;
var ListAllowedCurrencyGet = /** @class */ (function () {
    function ListAllowedCurrencyGet() {
    }
    ListAllowedCurrencyGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedCurrencyGet.api_name = "api.admin.app.currency.listallowedcurrencyget";
    return ListAllowedCurrencyGet;
}());
exports.ListAllowedCurrencyGet = ListAllowedCurrencyGet;
var DoDeletePProgramEmailSetTemplate = /** @class */ (function () {
    function DoDeletePProgramEmailSetTemplate() {
    }
    DoDeletePProgramEmailSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramEmailSetTemplate.api_name = "api.admin.aff.pprograms.email.set.templates.control.dodeletepprogramemailsettemplate";
    return DoDeletePProgramEmailSetTemplate;
}());
exports.DoDeletePProgramEmailSetTemplate = DoDeletePProgramEmailSetTemplate;
var DoAddBonusTemplateZone = /** @class */ (function () {
    function DoAddBonusTemplateZone() {
    }
    DoAddBonusTemplateZone.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusTemplateZone.api_name = "api.admin.bonus.templates.zones.doaddbonustemplatezone";
    return DoAddBonusTemplateZone;
}());
exports.DoAddBonusTemplateZone = DoAddBonusTemplateZone;
var ListBonusTemplatesForTournamentsByBrandIdGet = /** @class */ (function () {
    function ListBonusTemplatesForTournamentsByBrandIdGet() {
    }
    ListBonusTemplatesForTournamentsByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusTemplatesForTournamentsByBrandIdGet.api_name = "api.admin.bonus.tournaments.prizes.listbonustemplatesfortournamentsbybrandidget";
    return ListBonusTemplatesForTournamentsByBrandIdGet;
}());
exports.ListBonusTemplatesForTournamentsByBrandIdGet = ListBonusTemplatesForTournamentsByBrandIdGet;
var DoEditPProgramNewsLocaleContent = /** @class */ (function () {
    function DoEditPProgramNewsLocaleContent() {
    }
    DoEditPProgramNewsLocaleContent.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgramNewsLocaleContent.api_name = "api.admin.aff.pprograms.news.locales.doeditpprogramnewslocalecontent";
    return DoEditPProgramNewsLocaleContent;
}());
exports.DoEditPProgramNewsLocaleContent = DoEditPProgramNewsLocaleContent;
var DoAddBrandAdminAccess = /** @class */ (function () {
    function DoAddBrandAdminAccess() {
    }
    DoAddBrandAdminAccess.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandAdminAccess.api_name = "api.admin.access.brands.doaddbrandadminaccess";
    return DoAddBrandAdminAccess;
}());
exports.DoAddBrandAdminAccess = DoAddBrandAdminAccess;
var DoAddBrandBannerCountry = /** @class */ (function () {
    function DoAddBrandBannerCountry() {
    }
    DoAddBrandBannerCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandBannerCountry.api_name = "api.admin.aff.brands.banners.country.doaddbrandbannercountry";
    return DoAddBrandBannerCountry;
}());
exports.DoAddBrandBannerCountry = DoAddBrandBannerCountry;
var DoEditPProgramEmailSetTemplateImage = /** @class */ (function () {
    function DoEditPProgramEmailSetTemplateImage() {
    }
    DoEditPProgramEmailSetTemplateImage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgramEmailSetTemplateImage.api_name = "api.admin.aff.pprograms.email.set.templates.images.doeditpprogramemailsettemplateimage";
    return DoEditPProgramEmailSetTemplateImage;
}());
exports.DoEditPProgramEmailSetTemplateImage = DoEditPProgramEmailSetTemplateImage;
var ListAllowedAccessTypesByDocIdGet = /** @class */ (function () {
    function ListAllowedAccessTypesByDocIdGet() {
    }
    ListAllowedAccessTypesByDocIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedAccessTypesByDocIdGet.api_name = "api.admin.permissions.docs.control.listallowedaccesstypesbydocidget";
    return ListAllowedAccessTypesByDocIdGet;
}());
exports.ListAllowedAccessTypesByDocIdGet = ListAllowedAccessTypesByDocIdGet;
var ListBrandPayProvidersByBrandIdGet = /** @class */ (function () {
    function ListBrandPayProvidersByBrandIdGet() {
    }
    ListBrandPayProvidersByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandPayProvidersByBrandIdGet.api_name = "api.admin.brand.deposit.providers.control.listbrandpayprovidersbybrandidget";
    return ListBrandPayProvidersByBrandIdGet;
}());
exports.ListBrandPayProvidersByBrandIdGet = ListBrandPayProvidersByBrandIdGet;
var DoFillBrandPayProvidersToTrustZone = /** @class */ (function () {
    function DoFillBrandPayProvidersToTrustZone() {
    }
    DoFillBrandPayProvidersToTrustZone.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoFillBrandPayProvidersToTrustZone.api_name = "api.admin.brand.deposit.providers.by.trust.zones.dofillbrandpayproviderstotrustzone";
    return DoFillBrandPayProvidersToTrustZone;
}());
exports.DoFillBrandPayProvidersToTrustZone = DoFillBrandPayProvidersToTrustZone;
var ListBrandOfferAppCountryByOfferIdGet = /** @class */ (function () {
    function ListBrandOfferAppCountryByOfferIdGet() {
    }
    ListBrandOfferAppCountryByOfferIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandOfferAppCountryByOfferIdGet.api_name = "api.admin.aff.brands.offers.country.listbrandofferappcountrybyofferidget";
    return ListBrandOfferAppCountryByOfferIdGet;
}());
exports.ListBrandOfferAppCountryByOfferIdGet = ListBrandOfferAppCountryByOfferIdGet;
var ListAllowedPProgramOffersByPProgramIdGet = /** @class */ (function () {
    function ListAllowedPProgramOffersByPProgramIdGet() {
    }
    ListAllowedPProgramOffersByPProgramIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedPProgramOffersByPProgramIdGet.api_name = "api.admin.aff.pprograms.pub.offers.listallowedpprogramoffersbypprogramidget";
    return ListAllowedPProgramOffersByPProgramIdGet;
}());
exports.ListAllowedPProgramOffersByPProgramIdGet = ListAllowedPProgramOffersByPProgramIdGet;
var DoSetBonusTemplateZoneIsLocked = /** @class */ (function () {
    function DoSetBonusTemplateZoneIsLocked() {
    }
    DoSetBonusTemplateZoneIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBonusTemplateZoneIsLocked.api_name = "api.admin.bonus.templates.zones.dosetbonustemplatezoneislocked";
    return DoSetBonusTemplateZoneIsLocked;
}());
exports.DoSetBonusTemplateZoneIsLocked = DoSetBonusTemplateZoneIsLocked;
var DoSetBrandBlackIpDescription = /** @class */ (function () {
    function DoSetBrandBlackIpDescription() {
    }
    DoSetBrandBlackIpDescription.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandBlackIpDescription.api_name = "api.admin.brand.black.ip.dosetbrandblackipdescription";
    return DoSetBrandBlackIpDescription;
}());
exports.DoSetBrandBlackIpDescription = DoSetBrandBlackIpDescription;
var ListAvailOfferInheritanceTypesGet = /** @class */ (function () {
    function ListAvailOfferInheritanceTypesGet() {
    }
    ListAvailOfferInheritanceTypesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailOfferInheritanceTypesGet.api_name = "api.admin.aff.pprograms.usr.partners.control.listavailofferinheritancetypesget";
    return ListAvailOfferInheritanceTypesGet;
}());
exports.ListAvailOfferInheritanceTypesGet = ListAvailOfferInheritanceTypesGet;
var DoSetGwsGameProviderGamePercentWithdraw = /** @class */ (function () {
    function DoSetGwsGameProviderGamePercentWithdraw() {
    }
    DoSetGwsGameProviderGamePercentWithdraw.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGwsGameProviderGamePercentWithdraw.api_name = "api.admin.gws.gameprovider.games.dosetgwsgameprovidergamepercentwithdraw";
    return DoSetGwsGameProviderGamePercentWithdraw;
}());
exports.DoSetGwsGameProviderGamePercentWithdraw = DoSetGwsGameProviderGamePercentWithdraw;
var ListBrandAppLanguagesByBrandIdGet = /** @class */ (function () {
    function ListBrandAppLanguagesByBrandIdGet() {
    }
    ListBrandAppLanguagesByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandAppLanguagesByBrandIdGet.api_name = "api.admin.brands.app.languages.listbrandapplanguagesbybrandidget";
    return ListBrandAppLanguagesByBrandIdGet;
}());
exports.ListBrandAppLanguagesByBrandIdGet = ListBrandAppLanguagesByBrandIdGet;
var DoDeleteTournamentLocale = /** @class */ (function () {
    function DoDeleteTournamentLocale() {
    }
    DoDeleteTournamentLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteTournamentLocale.api_name = "api.admin.bonus.tournaments.locales.dodeletetournamentlocale";
    return DoDeleteTournamentLocale;
}());
exports.DoDeleteTournamentLocale = DoDeleteTournamentLocale;
var DoEditAppUsrPlayerTag = /** @class */ (function () {
    function DoEditAppUsrPlayerTag() {
    }
    DoEditAppUsrPlayerTag.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditAppUsrPlayerTag.api_name = "api.admin.app.usr.players.tags.doeditappusrplayertag";
    return DoEditAppUsrPlayerTag;
}());
exports.DoEditAppUsrPlayerTag = DoEditAppUsrPlayerTag;
var DoAddBonusPlayerLevelOffer = /** @class */ (function () {
    function DoAddBonusPlayerLevelOffer() {
    }
    DoAddBonusPlayerLevelOffer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusPlayerLevelOffer.api_name = "api.admin.bonus.levels.offers.doaddbonusplayerleveloffer";
    return DoAddBonusPlayerLevelOffer;
}());
exports.DoAddBonusPlayerLevelOffer = DoAddBonusPlayerLevelOffer;
var DoAddPProgramPublicOffer = /** @class */ (function () {
    function DoAddPProgramPublicOffer() {
    }
    DoAddPProgramPublicOffer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramPublicOffer.api_name = "api.admin.aff.pprograms.pub.offers.doaddpprogrampublicoffer";
    return DoAddPProgramPublicOffer;
}());
exports.DoAddPProgramPublicOffer = DoAddPProgramPublicOffer;
var ListPlayersAvailByFireWallRuleGet = /** @class */ (function () {
    function ListPlayersAvailByFireWallRuleGet() {
    }
    ListPlayersAvailByFireWallRuleGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayersAvailByFireWallRuleGet.api_name = "api.admin.brands.security.firewall.listplayersavailbyfirewallruleget";
    return ListPlayersAvailByFireWallRuleGet;
}());
exports.ListPlayersAvailByFireWallRuleGet = ListPlayersAvailByFireWallRuleGet;
var ListBrandAndPartnersProfitReportByDateRangeGet = /** @class */ (function () {
    function ListBrandAndPartnersProfitReportByDateRangeGet() {
    }
    ListBrandAndPartnersProfitReportByDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandAndPartnersProfitReportByDateRangeGet.api_name = "api.admin.report.profit.listbrandandpartnersprofitreportbydaterangeget";
    return ListBrandAndPartnersProfitReportByDateRangeGet;
}());
exports.ListBrandAndPartnersProfitReportByDateRangeGet = ListBrandAndPartnersProfitReportByDateRangeGet;
var DoSetPlayerIsCardsAllowed = /** @class */ (function () {
    function DoSetPlayerIsCardsAllowed() {
    }
    DoSetPlayerIsCardsAllowed.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPlayerIsCardsAllowed.api_name = "api.admin.users.players.control.dosetplayeriscardsallowed";
    return DoSetPlayerIsCardsAllowed;
}());
exports.DoSetPlayerIsCardsAllowed = DoSetPlayerIsCardsAllowed;
var DoEditPProgramPartnerPayDetails = /** @class */ (function () {
    function DoEditPProgramPartnerPayDetails() {
    }
    DoEditPProgramPartnerPayDetails.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgramPartnerPayDetails.api_name = "api.admin.aff.pprograms.usr.partners.paydetails.doeditpprogrampartnerpaydetails";
    return DoEditPProgramPartnerPayDetails;
}());
exports.DoEditPProgramPartnerPayDetails = DoEditPProgramPartnerPayDetails;
var ListAppUsrPlayerTagTypesGet = /** @class */ (function () {
    function ListAppUsrPlayerTagTypesGet() {
    }
    ListAppUsrPlayerTagTypesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAppUsrPlayerTagTypesGet.api_name = "api.admin.app.usr.players.tags.listappusrplayertagtypesget";
    return ListAppUsrPlayerTagTypesGet;
}());
exports.ListAppUsrPlayerTagTypesGet = ListAppUsrPlayerTagTypesGet;
var DoMakeJackpotTransfer = /** @class */ (function () {
    function DoMakeJackpotTransfer() {
    }
    DoMakeJackpotTransfer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoMakeJackpotTransfer.api_name = "api.admin.bonus.jackpots.transfers.domakejackpottransfer";
    return DoMakeJackpotTransfer;
}());
exports.DoMakeJackpotTransfer = DoMakeJackpotTransfer;
var DoAddCmsBot = /** @class */ (function () {
    function DoAddCmsBot() {
    }
    DoAddCmsBot.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddCmsBot.api_name = "api.admin.cms.bots.doaddcmsbot";
    return DoAddCmsBot;
}());
exports.DoAddCmsBot = DoAddCmsBot;
var ListGwsGameProviderGamesByGameProviderIdGet = /** @class */ (function () {
    function ListGwsGameProviderGamesByGameProviderIdGet() {
    }
    ListGwsGameProviderGamesByGameProviderIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListGwsGameProviderGamesByGameProviderIdGet.api_name = "api.admin.gws.gameprovider.games.listgwsgameprovidergamesbygameprovideridget";
    return ListGwsGameProviderGamesByGameProviderIdGet;
}());
exports.ListGwsGameProviderGamesByGameProviderIdGet = ListGwsGameProviderGamesByGameProviderIdGet;
var DoFillDocumentsByPermission = /** @class */ (function () {
    function DoFillDocumentsByPermission() {
    }
    DoFillDocumentsByPermission.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoFillDocumentsByPermission.api_name = "api.admin.permissions.docs.control.dofilldocumentsbypermission";
    return DoFillDocumentsByPermission;
}());
exports.DoFillDocumentsByPermission = DoFillDocumentsByPermission;
var DoDeleteBrandLanding = /** @class */ (function () {
    function DoDeleteBrandLanding() {
    }
    DoDeleteBrandLanding.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandLanding.api_name = "api.admin.aff.brands.landings.control.dodeletebrandlanding";
    return DoDeleteBrandLanding;
}());
exports.DoDeleteBrandLanding = DoDeleteBrandLanding;
var DoAddPromoCodeTemplate = /** @class */ (function () {
    function DoAddPromoCodeTemplate() {
    }
    DoAddPromoCodeTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPromoCodeTemplate.api_name = "api.admin.bonus.promocodes.templates.control.doaddpromocodetemplate";
    return DoAddPromoCodeTemplate;
}());
exports.DoAddPromoCodeTemplate = DoAddPromoCodeTemplate;
var DoAddGwsGameProviderAdminAccess = /** @class */ (function () {
    function DoAddGwsGameProviderAdminAccess() {
    }
    DoAddGwsGameProviderAdminAccess.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddGwsGameProviderAdminAccess.api_name = "api.admin.access.gws.gameproviders.doaddgwsgameprovideradminaccess";
    return DoAddGwsGameProviderAdminAccess;
}());
exports.DoAddGwsGameProviderAdminAccess = DoAddGwsGameProviderAdminAccess;
var DoAddAdmin = /** @class */ (function () {
    function DoAddAdmin() {
    }
    DoAddAdmin.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddAdmin.api_name = "api.admin.users.admins.doaddadmin";
    return DoAddAdmin;
}());
exports.DoAddAdmin = DoAddAdmin;
var DoDeleteBrandAppPayoutKeyVal = /** @class */ (function () {
    function DoDeleteBrandAppPayoutKeyVal() {
    }
    DoDeleteBrandAppPayoutKeyVal.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandAppPayoutKeyVal.api_name = "api.admin.brands.partners.payout.keyval.dodeletebrandapppayoutkeyval";
    return DoDeleteBrandAppPayoutKeyVal;
}());
exports.DoDeleteBrandAppPayoutKeyVal = DoDeleteBrandAppPayoutKeyVal;
var DoAddUsrPartnerMessage = /** @class */ (function () {
    function DoAddUsrPartnerMessage() {
    }
    DoAddUsrPartnerMessage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddUsrPartnerMessage.api_name = "api.admin.aff.pprograms.usr.partners.messages.doaddusrpartnermessage";
    return DoAddUsrPartnerMessage;
}());
exports.DoAddUsrPartnerMessage = DoAddUsrPartnerMessage;
var DoSetPlayerIsConfirmedPhone = /** @class */ (function () {
    function DoSetPlayerIsConfirmedPhone() {
    }
    DoSetPlayerIsConfirmedPhone.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPlayerIsConfirmedPhone.api_name = "api.admin.users.players.control.dosetplayerisconfirmedphone";
    return DoSetPlayerIsConfirmedPhone;
}());
exports.DoSetPlayerIsConfirmedPhone = DoSetPlayerIsConfirmedPhone;
var DoWithdrawPlayerBonusAmtByPlayerBonusId = /** @class */ (function () {
    function DoWithdrawPlayerBonusAmtByPlayerBonusId() {
    }
    DoWithdrawPlayerBonusAmtByPlayerBonusId.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoWithdrawPlayerBonusAmtByPlayerBonusId.api_name = "api.admin.users.players.bonuses.control.dowithdrawplayerbonusamtbyplayerbonusid";
    return DoWithdrawPlayerBonusAmtByPlayerBonusId;
}());
exports.DoWithdrawPlayerBonusAmtByPlayerBonusId = DoWithdrawPlayerBonusAmtByPlayerBonusId;
var DoEditPageRecord = /** @class */ (function () {
    function DoEditPageRecord() {
    }
    DoEditPageRecord.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPageRecord.api_name = "api.admin.cms.pages.records.control.doeditpagerecord";
    return DoEditPageRecord;
}());
exports.DoEditPageRecord = DoEditPageRecord;
var DoDepositPlayerTotalBetAmtByPlayerBonusId = /** @class */ (function () {
    function DoDepositPlayerTotalBetAmtByPlayerBonusId() {
    }
    DoDepositPlayerTotalBetAmtByPlayerBonusId.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDepositPlayerTotalBetAmtByPlayerBonusId.api_name = "api.admin.users.players.bonuses.control.dodepositplayertotalbetamtbyplayerbonusid";
    return DoDepositPlayerTotalBetAmtByPlayerBonusId;
}());
exports.DoDepositPlayerTotalBetAmtByPlayerBonusId = DoDepositPlayerTotalBetAmtByPlayerBonusId;
var DoSetGameSetGameFreeSpinLines = /** @class */ (function () {
    function DoSetGameSetGameFreeSpinLines() {
    }
    DoSetGameSetGameFreeSpinLines.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGameSetGameFreeSpinLines.api_name = "api.admin.cms.gameset.games.fsconfig.dosetgamesetgamefreespinlines";
    return DoSetGameSetGameFreeSpinLines;
}());
exports.DoSetGameSetGameFreeSpinLines = DoSetGameSetGameFreeSpinLines;
var DoDeleteAdmin = /** @class */ (function () {
    function DoDeleteAdmin() {
    }
    DoDeleteAdmin.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteAdmin.api_name = "api.admin.users.admins.dodeleteadmin";
    return DoDeleteAdmin;
}());
exports.DoDeleteAdmin = DoDeleteAdmin;
var ListPlayerAvailableBonusesByPlayerIdGet = /** @class */ (function () {
    function ListPlayerAvailableBonusesByPlayerIdGet() {
    }
    ListPlayerAvailableBonusesByPlayerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayerAvailableBonusesByPlayerIdGet.api_name = "api.admin.users.players.bonuses.control.listplayeravailablebonusesbyplayeridget";
    return ListPlayerAvailableBonusesByPlayerIdGet;
}());
exports.ListPlayerAvailableBonusesByPlayerIdGet = ListPlayerAvailableBonusesByPlayerIdGet;
var DetailsDashBoardCommonStatGet = /** @class */ (function () {
    function DetailsDashBoardCommonStatGet() {
    }
    DetailsDashBoardCommonStatGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsDashBoardCommonStatGet.api_name = "api.admin.dashboard.detailsdashboardcommonstatget";
    return DetailsDashBoardCommonStatGet;
}());
exports.DetailsDashBoardCommonStatGet = DetailsDashBoardCommonStatGet;
var ListDepositsByBrandIdAndDateRangeGetEx = /** @class */ (function () {
    function ListDepositsByBrandIdAndDateRangeGetEx() {
    }
    ListDepositsByBrandIdAndDateRangeGetEx.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListDepositsByBrandIdAndDateRangeGetEx.api_name = "api.admin.finance.control.listdepositsbybrandidanddaterangegetex";
    return ListDepositsByBrandIdAndDateRangeGetEx;
}());
exports.ListDepositsByBrandIdAndDateRangeGetEx = ListDepositsByBrandIdAndDateRangeGetEx;
var ListPProgramsGet = /** @class */ (function () {
    function ListPProgramsGet() {
    }
    ListPProgramsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramsGet.api_name = "api.admin.aff.pprograms.control.listpprogramsget";
    return ListPProgramsGet;
}());
exports.ListPProgramsGet = ListPProgramsGet;
var DoGetPlayerPassword = /** @class */ (function () {
    function DoGetPlayerPassword() {
    }
    DoGetPlayerPassword.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoGetPlayerPassword.api_name = "api.admin.users.players.control.dogetplayerpassword";
    return DoGetPlayerPassword;
}());
exports.DoGetPlayerPassword = DoGetPlayerPassword;
var DoSetBrandAppCurrencyIsDefault = /** @class */ (function () {
    function DoSetBrandAppCurrencyIsDefault() {
    }
    DoSetBrandAppCurrencyIsDefault.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandAppCurrencyIsDefault.api_name = "api.admin.brands.app.currency.dosetbrandappcurrencyisdefault";
    return DoSetBrandAppCurrencyIsDefault;
}());
exports.DoSetBrandAppCurrencyIsDefault = DoSetBrandAppCurrencyIsDefault;
var DetailsPostRecordContentGet = /** @class */ (function () {
    function DetailsPostRecordContentGet() {
    }
    DetailsPostRecordContentGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsPostRecordContentGet.api_name = "api.admin.cms.posts.records.control.detailspostrecordcontentget";
    return DetailsPostRecordContentGet;
}());
exports.DetailsPostRecordContentGet = DetailsPostRecordContentGet;
var DoAddCapchaTemplate = /** @class */ (function () {
    function DoAddCapchaTemplate() {
    }
    DoAddCapchaTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddCapchaTemplate.api_name = "api.admin.app.capchas.templates.control.doaddcapchatemplate";
    return DoAddCapchaTemplate;
}());
exports.DoAddCapchaTemplate = DoAddCapchaTemplate;
var DoEditTournamentBot = /** @class */ (function () {
    function DoEditTournamentBot() {
    }
    DoEditTournamentBot.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditTournamentBot.api_name = "api.admin.bonus.tournaments.bots.control.doedittournamentbot";
    return DoEditTournamentBot;
}());
exports.DoEditTournamentBot = DoEditTournamentBot;
var DoSetPProgramAppLanguageIsDefault = /** @class */ (function () {
    function DoSetPProgramAppLanguageIsDefault() {
    }
    DoSetPProgramAppLanguageIsDefault.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPProgramAppLanguageIsDefault.api_name = "api.admin.aff.pprograms.app.language.dosetpprogramapplanguageisdefault";
    return DoSetPProgramAppLanguageIsDefault;
}());
exports.DoSetPProgramAppLanguageIsDefault = DoSetPProgramAppLanguageIsDefault;
var ListAllowedCmsGameSetsByBrandIdAndAppCurrencyIdGet = /** @class */ (function () {
    function ListAllowedCmsGameSetsByBrandIdAndAppCurrencyIdGet() {
    }
    ListAllowedCmsGameSetsByBrandIdAndAppCurrencyIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedCmsGameSetsByBrandIdAndAppCurrencyIdGet.api_name = "api.admin.cms.gameset.control.listallowedcmsgamesetsbybrandidandappcurrencyidget";
    return ListAllowedCmsGameSetsByBrandIdAndAppCurrencyIdGet;
}());
exports.ListAllowedCmsGameSetsByBrandIdAndAppCurrencyIdGet = ListAllowedCmsGameSetsByBrandIdAndAppCurrencyIdGet;
var DetailsGameProviderGwsConfigGet = /** @class */ (function () {
    function DetailsGameProviderGwsConfigGet() {
    }
    DetailsGameProviderGwsConfigGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsGameProviderGwsConfigGet.api_name = "api.admin.gws.gameprovider.config.detailsgameprovidergwsconfigget";
    return DetailsGameProviderGwsConfigGet;
}());
exports.DetailsGameProviderGwsConfigGet = DetailsGameProviderGwsConfigGet;
var DoEditPlayerBonus = /** @class */ (function () {
    function DoEditPlayerBonus() {
    }
    DoEditPlayerBonus.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPlayerBonus.api_name = "api.admin.users.players.bonuses.control.doeditplayerbonus";
    return DoEditPlayerBonus;
}());
exports.DoEditPlayerBonus = DoEditPlayerBonus;
var DoEditPromoCodeTemplate = /** @class */ (function () {
    function DoEditPromoCodeTemplate() {
    }
    DoEditPromoCodeTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPromoCodeTemplate.api_name = "api.admin.bonus.promocodes.templates.control.doeditpromocodetemplate";
    return DoEditPromoCodeTemplate;
}());
exports.DoEditPromoCodeTemplate = DoEditPromoCodeTemplate;
var ListPlayersAvailBotsByFilterGet = /** @class */ (function () {
    function ListPlayersAvailBotsByFilterGet() {
    }
    ListPlayersAvailBotsByFilterGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayersAvailBotsByFilterGet.api_name = "api.admin.users.players.control.listplayersavailbotsbyfilterget";
    return ListPlayersAvailBotsByFilterGet;
}());
exports.ListPlayersAvailBotsByFilterGet = ListPlayersAvailBotsByFilterGet;
var ListCmsTopGamesByBrandIdGet = /** @class */ (function () {
    function ListCmsTopGamesByBrandIdGet() {
    }
    ListCmsTopGamesByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListCmsTopGamesByBrandIdGet.api_name = "api.admin.cms.top.games.listcmstopgamesbybrandidget";
    return ListCmsTopGamesByBrandIdGet;
}());
exports.ListCmsTopGamesByBrandIdGet = ListCmsTopGamesByBrandIdGet;
var DoSetBonusTemplateCurrencyConfigIsDefault = /** @class */ (function () {
    function DoSetBonusTemplateCurrencyConfigIsDefault() {
    }
    DoSetBonusTemplateCurrencyConfigIsDefault.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBonusTemplateCurrencyConfigIsDefault.api_name = "api.admin.bonus.templates.currency.config.dosetbonustemplatecurrencyconfigisdefault";
    return DoSetBonusTemplateCurrencyConfigIsDefault;
}());
exports.DoSetBonusTemplateCurrencyConfigIsDefault = DoSetBonusTemplateCurrencyConfigIsDefault;
var ListPlayersByFiltersGet = /** @class */ (function () {
    function ListPlayersByFiltersGet() {
    }
    ListPlayersByFiltersGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayersByFiltersGet.api_name = "api.admin.users.players.control.listplayersbyfiltersget";
    return ListPlayersByFiltersGet;
}());
exports.ListPlayersByFiltersGet = ListPlayersByFiltersGet;
var DoAddBrandAppCurrency = /** @class */ (function () {
    function DoAddBrandAppCurrency() {
    }
    DoAddBrandAppCurrency.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandAppCurrency.api_name = "api.admin.brands.app.currency.doaddbrandappcurrency";
    return DoAddBrandAppCurrency;
}());
exports.DoAddBrandAppCurrency = DoAddBrandAppCurrency;
var ListWithdrawsByPlayerIdAndDateRangeGet = /** @class */ (function () {
    function ListWithdrawsByPlayerIdAndDateRangeGet() {
    }
    ListWithdrawsByPlayerIdAndDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListWithdrawsByPlayerIdAndDateRangeGet.api_name = "api.admin.users.players.finance.listwithdrawsbyplayeridanddaterangeget";
    return ListWithdrawsByPlayerIdAndDateRangeGet;
}());
exports.ListWithdrawsByPlayerIdAndDateRangeGet = ListWithdrawsByPlayerIdAndDateRangeGet;
var DoAddUserPlayerTag = /** @class */ (function () {
    function DoAddUserPlayerTag() {
    }
    DoAddUserPlayerTag.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddUserPlayerTag.api_name = "api.admin.users.players.tags.doadduserplayertag";
    return DoAddUserPlayerTag;
}());
exports.DoAddUserPlayerTag = DoAddUserPlayerTag;
var DoDeletePProgramAppCountry = /** @class */ (function () {
    function DoDeletePProgramAppCountry() {
    }
    DoDeletePProgramAppCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramAppCountry.api_name = "api.admin.aff.pprograms.app.country.dodeletepprogramappcountry";
    return DoDeletePProgramAppCountry;
}());
exports.DoDeletePProgramAppCountry = DoDeletePProgramAppCountry;
var DoAddFireWallRule = /** @class */ (function () {
    function DoAddFireWallRule() {
    }
    DoAddFireWallRule.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddFireWallRule.api_name = "api.admin.brands.security.firewall.doaddfirewallrule";
    return DoAddFireWallRule;
}());
exports.DoAddFireWallRule = DoAddFireWallRule;
var ListInnerPayWalletsGet = /** @class */ (function () {
    function ListInnerPayWalletsGet() {
    }
    ListInnerPayWalletsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListInnerPayWalletsGet.api_name = "api.admin.app.innerpay.wallets.control.listinnerpaywalletsget";
    return ListInnerPayWalletsGet;
}());
exports.ListInnerPayWalletsGet = ListInnerPayWalletsGet;
var DoSetFireWallRuleIsLocked = /** @class */ (function () {
    function DoSetFireWallRuleIsLocked() {
    }
    DoSetFireWallRuleIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetFireWallRuleIsLocked.api_name = "api.admin.brands.security.firewall.dosetfirewallruleislocked";
    return DoSetFireWallRuleIsLocked;
}());
exports.DoSetFireWallRuleIsLocked = DoSetFireWallRuleIsLocked;
var DoFillReconciliationPartnersByReconciliationId = /** @class */ (function () {
    function DoFillReconciliationPartnersByReconciliationId() {
    }
    DoFillReconciliationPartnersByReconciliationId.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoFillReconciliationPartnersByReconciliationId.api_name = "api.admin.aff.pprograms.reconciliations.control.dofillreconciliationpartnersbyreconciliationid";
    return DoFillReconciliationPartnersByReconciliationId;
}());
exports.DoFillReconciliationPartnersByReconciliationId = DoFillReconciliationPartnersByReconciliationId;
var ListAvailBannersFormatGet = /** @class */ (function () {
    function ListAvailBannersFormatGet() {
    }
    ListAvailBannersFormatGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailBannersFormatGet.api_name = "api.admin.aff.brands.banners.control.listavailbannersformatget";
    return ListAvailBannersFormatGet;
}());
exports.ListAvailBannersFormatGet = ListAvailBannersFormatGet;
var ListBotWinsTypesAvailGet = /** @class */ (function () {
    function ListBotWinsTypesAvailGet() {
    }
    ListBotWinsTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBotWinsTypesAvailGet.api_name = "api.admin.cms.gameset.games.botwins.listbotwinstypesavailget";
    return ListBotWinsTypesAvailGet;
}());
exports.ListBotWinsTypesAvailGet = ListBotWinsTypesAvailGet;
var DoSetPromoCodeTemplateBonusIsLocked = /** @class */ (function () {
    function DoSetPromoCodeTemplateBonusIsLocked() {
    }
    DoSetPromoCodeTemplateBonusIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPromoCodeTemplateBonusIsLocked.api_name = "api.admin.bonus.promocodes.templates.bonuses.dosetpromocodetemplatebonusislocked";
    return DoSetPromoCodeTemplateBonusIsLocked;
}());
exports.DoSetPromoCodeTemplateBonusIsLocked = DoSetPromoCodeTemplateBonusIsLocked;
var ListAvailPlayerListByPlayerEmailPart = /** @class */ (function () {
    function ListAvailPlayerListByPlayerEmailPart() {
    }
    ListAvailPlayerListByPlayerEmailPart.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailPlayerListByPlayerEmailPart.api_name = "api.admin.support.player.listavailplayerlistbyplayeremailpart";
    return ListAvailPlayerListByPlayerEmailPart;
}());
exports.ListAvailPlayerListByPlayerEmailPart = ListAvailPlayerListByPlayerEmailPart;
var ListCmsGameProvidersGameSetLocalesGet = /** @class */ (function () {
    function ListCmsGameProvidersGameSetLocalesGet() {
    }
    ListCmsGameProvidersGameSetLocalesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListCmsGameProvidersGameSetLocalesGet.api_name = "api.admin.cms.gameset.locales.listcmsgameprovidersgamesetlocalesget";
    return ListCmsGameProvidersGameSetLocalesGet;
}());
exports.ListCmsGameProvidersGameSetLocalesGet = ListCmsGameProvidersGameSetLocalesGet;
var ListAvailPProgramsBrandsByPartnerIdGet = /** @class */ (function () {
    function ListAvailPProgramsBrandsByPartnerIdGet() {
    }
    ListAvailPProgramsBrandsByPartnerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailPProgramsBrandsByPartnerIdGet.api_name = "api.admin.aff.pprograms.brands.listavailpprogramsbrandsbypartneridget";
    return ListAvailPProgramsBrandsByPartnerIdGet;
}());
exports.ListAvailPProgramsBrandsByPartnerIdGet = ListAvailPProgramsBrandsByPartnerIdGet;
var DoSetBrandOfferIsDeprecated = /** @class */ (function () {
    function DoSetBrandOfferIsDeprecated() {
    }
    DoSetBrandOfferIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandOfferIsDeprecated.api_name = "api.admin.aff.brands.offers.control.dosetbrandofferisdeprecated";
    return DoSetBrandOfferIsDeprecated;
}());
exports.DoSetBrandOfferIsDeprecated = DoSetBrandOfferIsDeprecated;
var ListPlayerTrustZonesAvailGet = /** @class */ (function () {
    function ListPlayerTrustZonesAvailGet() {
    }
    ListPlayerTrustZonesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayerTrustZonesAvailGet.api_name = "api.admin.users.players.control.listplayertrustzonesavailget";
    return ListPlayerTrustZonesAvailGet;
}());
exports.ListPlayerTrustZonesAvailGet = ListPlayerTrustZonesAvailGet;
var ListInnerPayWalletLocksByPayWalletIdGet = /** @class */ (function () {
    function ListInnerPayWalletLocksByPayWalletIdGet() {
    }
    ListInnerPayWalletLocksByPayWalletIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListInnerPayWalletLocksByPayWalletIdGet.api_name = "api.admin.app.innerpay.wallets.locks.listinnerpaywalletlocksbypaywalletidget";
    return ListInnerPayWalletLocksByPayWalletIdGet;
}());
exports.ListInnerPayWalletLocksByPayWalletIdGet = ListInnerPayWalletLocksByPayWalletIdGet;
var DoAddPProgramPartnerTracker = /** @class */ (function () {
    function DoAddPProgramPartnerTracker() {
    }
    DoAddPProgramPartnerTracker.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddPProgramPartnerTracker.api_name = "api.admin.aff.pprograms.usr.partners.trackers.doaddpprogrampartnertracker";
    return DoAddPProgramPartnerTracker;
}());
exports.DoAddPProgramPartnerTracker = DoAddPProgramPartnerTracker;
var DetailsPageRecordContentGet = /** @class */ (function () {
    function DetailsPageRecordContentGet() {
    }
    DetailsPageRecordContentGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsPageRecordContentGet.api_name = "api.admin.cms.pages.records.control.detailspagerecordcontentget";
    return DetailsPageRecordContentGet;
}());
exports.DetailsPageRecordContentGet = DetailsPageRecordContentGet;
var ListPlayerGameLogsByPlayerIdGet = /** @class */ (function () {
    function ListPlayerGameLogsByPlayerIdGet() {
    }
    ListPlayerGameLogsByPlayerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayerGameLogsByPlayerIdGet.api_name = "api.admin.users.players.logs.games.listplayergamelogsbyplayeridget";
    return ListPlayerGameLogsByPlayerIdGet;
}());
exports.ListPlayerGameLogsByPlayerIdGet = ListPlayerGameLogsByPlayerIdGet;
var DoEditBrandLandingCountry = /** @class */ (function () {
    function DoEditBrandLandingCountry() {
    }
    DoEditBrandLandingCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandLandingCountry.api_name = "api.admin.aff.brands.landings.country.doeditbrandlandingcountry";
    return DoEditBrandLandingCountry;
}());
exports.DoEditBrandLandingCountry = DoEditBrandLandingCountry;
var ListBrandBrandingsByBrandsGet = /** @class */ (function () {
    function ListBrandBrandingsByBrandsGet() {
    }
    ListBrandBrandingsByBrandsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandBrandingsByBrandsGet.api_name = "api.admin.aff.brands.brandings.control.listbrandbrandingsbybrandsget";
    return ListBrandBrandingsByBrandsGet;
}());
exports.ListBrandBrandingsByBrandsGet = ListBrandBrandingsByBrandsGet;
var DoAddBrandAppPayoutKeyVal = /** @class */ (function () {
    function DoAddBrandAppPayoutKeyVal() {
    }
    DoAddBrandAppPayoutKeyVal.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandAppPayoutKeyVal.api_name = "api.admin.brands.partners.payout.keyval.doaddbrandapppayoutkeyval";
    return DoAddBrandAppPayoutKeyVal;
}());
exports.DoAddBrandAppPayoutKeyVal = DoAddBrandAppPayoutKeyVal;
var DoCmsPProgramContentFileUploadAll = /** @class */ (function () {
    function DoCmsPProgramContentFileUploadAll() {
    }
    DoCmsPProgramContentFileUploadAll.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCmsPProgramContentFileUploadAll.api_name = "api.admin.aff.pprograms.cms.content.docmspprogramcontentfileuploadall";
    return DoCmsPProgramContentFileUploadAll;
}());
exports.DoCmsPProgramContentFileUploadAll = DoCmsPProgramContentFileUploadAll;
var DoDeletePProgramAppLanguage = /** @class */ (function () {
    function DoDeletePProgramAppLanguage() {
    }
    DoDeletePProgramAppLanguage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramAppLanguage.api_name = "api.admin.aff.pprograms.app.language.dodeletepprogramapplanguage";
    return DoDeletePProgramAppLanguage;
}());
exports.DoDeletePProgramAppLanguage = DoDeletePProgramAppLanguage;
var DoAddBrandAppCountry = /** @class */ (function () {
    function DoAddBrandAppCountry() {
    }
    DoAddBrandAppCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandAppCountry.api_name = "api.admin.brands.app.country.doaddbrandappcountry";
    return DoAddBrandAppCountry;
}());
exports.DoAddBrandAppCountry = DoAddBrandAppCountry;
var ListWithdrawsByBrandIdAndDateRangeGet = /** @class */ (function () {
    function ListWithdrawsByBrandIdAndDateRangeGet() {
    }
    ListWithdrawsByBrandIdAndDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListWithdrawsByBrandIdAndDateRangeGet.api_name = "api.admin.finance.control.listwithdrawsbybrandidanddaterangeget";
    return ListWithdrawsByBrandIdAndDateRangeGet;
}());
exports.ListWithdrawsByBrandIdAndDateRangeGet = ListWithdrawsByBrandIdAndDateRangeGet;
var DoSetReconciliationPartnerIsLocked = /** @class */ (function () {
    function DoSetReconciliationPartnerIsLocked() {
    }
    DoSetReconciliationPartnerIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetReconciliationPartnerIsLocked.api_name = "api.admin.aff.pprograms.reconciliations.partners.dosetreconciliationpartnerislocked";
    return DoSetReconciliationPartnerIsLocked;
}());
exports.DoSetReconciliationPartnerIsLocked = DoSetReconciliationPartnerIsLocked;
var DoDeletePromoCodeTemplateCode = /** @class */ (function () {
    function DoDeletePromoCodeTemplateCode() {
    }
    DoDeletePromoCodeTemplateCode.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePromoCodeTemplateCode.api_name = "api.admin.bonus.promocodes.templates.codes.dodeletepromocodetemplatecode";
    return DoDeletePromoCodeTemplateCode;
}());
exports.DoDeletePromoCodeTemplateCode = DoDeletePromoCodeTemplateCode;
var DoEditBrandSmsSetTemplateData = /** @class */ (function () {
    function DoEditBrandSmsSetTemplateData() {
    }
    DoEditBrandSmsSetTemplateData.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandSmsSetTemplateData.api_name = "api.admin.brands.templates.control.sms.set.control.doeditbrandsmssettemplatedata";
    return DoEditBrandSmsSetTemplateData;
}());
exports.DoEditBrandSmsSetTemplateData = DoEditBrandSmsSetTemplateData;
var ListPlayerBehaviorTypesAvailGet = /** @class */ (function () {
    function ListPlayerBehaviorTypesAvailGet() {
    }
    ListPlayerBehaviorTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayerBehaviorTypesAvailGet.api_name = "api.admin.users.players.control.listplayerbehaviortypesavailget";
    return ListPlayerBehaviorTypesAvailGet;
}());
exports.ListPlayerBehaviorTypesAvailGet = ListPlayerBehaviorTypesAvailGet;
var DoDeletePlayerBonus = /** @class */ (function () {
    function DoDeletePlayerBonus() {
    }
    DoDeletePlayerBonus.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePlayerBonus.api_name = "api.admin.users.players.bonuses.control.dodeleteplayerbonus";
    return DoDeletePlayerBonus;
}());
exports.DoDeletePlayerBonus = DoDeletePlayerBonus;
var ListAllowedPromoCodeTemplateTypesGet = /** @class */ (function () {
    function ListAllowedPromoCodeTemplateTypesGet() {
    }
    ListAllowedPromoCodeTemplateTypesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedPromoCodeTemplateTypesGet.api_name = "api.admin.bonus.promocodes.templates.control.listallowedpromocodetemplatetypesget";
    return ListAllowedPromoCodeTemplateTypesGet;
}());
exports.ListAllowedPromoCodeTemplateTypesGet = ListAllowedPromoCodeTemplateTypesGet;
var DoSetPProgramAppPayoutIsDeprecated = /** @class */ (function () {
    function DoSetPProgramAppPayoutIsDeprecated() {
    }
    DoSetPProgramAppPayoutIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPProgramAppPayoutIsDeprecated.api_name = "api.admin.aff.pprograms.app.payout.dosetpprogramapppayoutisdeprecated";
    return DoSetPProgramAppPayoutIsDeprecated;
}());
exports.DoSetPProgramAppPayoutIsDeprecated = DoSetPProgramAppPayoutIsDeprecated;
var DoSetPromoCodeTemplateCodeIsLocked = /** @class */ (function () {
    function DoSetPromoCodeTemplateCodeIsLocked() {
    }
    DoSetPromoCodeTemplateCodeIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPromoCodeTemplateCodeIsLocked.api_name = "api.admin.bonus.promocodes.templates.codes.dosetpromocodetemplatecodeislocked";
    return DoSetPromoCodeTemplateCodeIsLocked;
}());
exports.DoSetPromoCodeTemplateCodeIsLocked = DoSetPromoCodeTemplateCodeIsLocked;
var ListAvailPProgramPartnersByPProgramIdGet = /** @class */ (function () {
    function ListAvailPProgramPartnersByPProgramIdGet() {
    }
    ListAvailPProgramPartnersByPProgramIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailPProgramPartnersByPProgramIdGet.api_name = "api.admin.aff.pprograms.usr.partners.control.listavailpprogrampartnersbypprogramidget";
    return ListAvailPProgramPartnersByPProgramIdGet;
}());
exports.ListAvailPProgramPartnersByPProgramIdGet = ListAvailPProgramPartnersByPProgramIdGet;
var ListBrandPartnersForStatGet = /** @class */ (function () {
    function ListBrandPartnersForStatGet() {
    }
    ListBrandPartnersForStatGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandPartnersForStatGet.api_name = "api.admin.brands.partners.forstat.listbrandpartnersforstatget";
    return ListBrandPartnersForStatGet;
}());
exports.ListBrandPartnersForStatGet = ListBrandPartnersForStatGet;
var DoSetPlayerNewPassword = /** @class */ (function () {
    function DoSetPlayerNewPassword() {
    }
    DoSetPlayerNewPassword.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPlayerNewPassword.api_name = "api.admin.users.players.control.dosetplayernewpassword";
    return DoSetPlayerNewPassword;
}());
exports.DoSetPlayerNewPassword = DoSetPlayerNewPassword;
var DoDeletePProgramNews = /** @class */ (function () {
    function DoDeletePProgramNews() {
    }
    DoDeletePProgramNews.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramNews.api_name = "api.admin.aff.pprograms.news.control.dodeletepprogramnews";
    return DoDeletePProgramNews;
}());
exports.DoDeletePProgramNews = DoDeletePProgramNews;
var DoGeneratePProgramPartnersRevshares = /** @class */ (function () {
    function DoGeneratePProgramPartnersRevshares() {
    }
    DoGeneratePProgramPartnersRevshares.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoGeneratePProgramPartnersRevshares.api_name = "api.admin.aff.pprograms.usr.partners.revshares.dogeneratepprogrampartnersrevshares";
    return DoGeneratePProgramPartnersRevshares;
}());
exports.DoGeneratePProgramPartnersRevshares = DoGeneratePProgramPartnersRevshares;
var DoEditAppTrustZone = /** @class */ (function () {
    function DoEditAppTrustZone() {
    }
    DoEditAppTrustZone.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditAppTrustZone.api_name = "api.admin.app.trust.zones.doeditapptrustzone";
    return DoEditAppTrustZone;
}());
exports.DoEditAppTrustZone = DoEditAppTrustZone;
var DoSetGwsGameProviderGameIsNew = /** @class */ (function () {
    function DoSetGwsGameProviderGameIsNew() {
    }
    DoSetGwsGameProviderGameIsNew.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetGwsGameProviderGameIsNew.api_name = "api.admin.gws.gameprovider.games.dosetgwsgameprovidergameisnew";
    return DoSetGwsGameProviderGameIsNew;
}());
exports.DoSetGwsGameProviderGameIsNew = DoSetGwsGameProviderGameIsNew;
var DoAddBrandSmsSetTemplate = /** @class */ (function () {
    function DoAddBrandSmsSetTemplate() {
    }
    DoAddBrandSmsSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandSmsSetTemplate.api_name = "api.admin.brands.templates.control.sms.set.control.doaddbrandsmssettemplate";
    return DoAddBrandSmsSetTemplate;
}());
exports.DoAddBrandSmsSetTemplate = DoAddBrandSmsSetTemplate;
var ListBrandEmailSetTemplateImagesGet = /** @class */ (function () {
    function ListBrandEmailSetTemplateImagesGet() {
    }
    ListBrandEmailSetTemplateImagesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandEmailSetTemplateImagesGet.api_name = "api.admin.brands.templates.control.email.set.images.listbrandemailsettemplateimagesget";
    return ListBrandEmailSetTemplateImagesGet;
}());
exports.ListBrandEmailSetTemplateImagesGet = ListBrandEmailSetTemplateImagesGet;
var ListBrandLandingsByBrandsGet = /** @class */ (function () {
    function ListBrandLandingsByBrandsGet() {
    }
    ListBrandLandingsByBrandsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandLandingsByBrandsGet.api_name = "api.admin.aff.brands.landings.control.listbrandlandingsbybrandsget";
    return ListBrandLandingsByBrandsGet;
}());
exports.ListBrandLandingsByBrandsGet = ListBrandLandingsByBrandsGet;
var DoExportPlayersList = /** @class */ (function () {
    function DoExportPlayersList() {
    }
    DoExportPlayersList.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoExportPlayersList.api_name = "api.admin.users.players.control.doexportplayerslist";
    return DoExportPlayersList;
}());
exports.DoExportPlayersList = DoExportPlayersList;
var ListPProgramAppLanguagesByPProgramIdGet = /** @class */ (function () {
    function ListPProgramAppLanguagesByPProgramIdGet() {
    }
    ListPProgramAppLanguagesByPProgramIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramAppLanguagesByPProgramIdGet.api_name = "api.admin.aff.pprograms.app.language.listpprogramapplanguagesbypprogramidget";
    return ListPProgramAppLanguagesByPProgramIdGet;
}());
exports.ListPProgramAppLanguagesByPProgramIdGet = ListPProgramAppLanguagesByPProgramIdGet;
var ListInnerCryptoCurrencyTypesAvailGet = /** @class */ (function () {
    function ListInnerCryptoCurrencyTypesAvailGet() {
    }
    ListInnerCryptoCurrencyTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListInnerCryptoCurrencyTypesAvailGet.api_name = "api.admin.app.innerpay.wallets.control.listinnercryptocurrencytypesavailget";
    return ListInnerCryptoCurrencyTypesAvailGet;
}());
exports.ListInnerCryptoCurrencyTypesAvailGet = ListInnerCryptoCurrencyTypesAvailGet;
var ListAllowedAdminsGet = /** @class */ (function () {
    function ListAllowedAdminsGet() {
    }
    ListAllowedAdminsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedAdminsGet.api_name = "api.admin.users.admins.listallowedadminsget";
    return ListAllowedAdminsGet;
}());
exports.ListAllowedAdminsGet = ListAllowedAdminsGet;
var DoGeneratePromoCodeTemplateUniqueCode = /** @class */ (function () {
    function DoGeneratePromoCodeTemplateUniqueCode() {
    }
    DoGeneratePromoCodeTemplateUniqueCode.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoGeneratePromoCodeTemplateUniqueCode.api_name = "api.admin.bonus.promocodes.templates.codes.dogeneratepromocodetemplateuniquecode";
    return DoGeneratePromoCodeTemplateUniqueCode;
}());
exports.DoGeneratePromoCodeTemplateUniqueCode = DoGeneratePromoCodeTemplateUniqueCode;
var ListTournamentTicketsByTournamentIdGet = /** @class */ (function () {
    function ListTournamentTicketsByTournamentIdGet() {
    }
    ListTournamentTicketsByTournamentIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTournamentTicketsByTournamentIdGet.api_name = "api.admin.bonus.tournaments.tickets.listtournamentticketsbytournamentidget";
    return ListTournamentTicketsByTournamentIdGet;
}());
exports.ListTournamentTicketsByTournamentIdGet = ListTournamentTicketsByTournamentIdGet;
var DoDeleteInnerPayWallet = /** @class */ (function () {
    function DoDeleteInnerPayWallet() {
    }
    DoDeleteInnerPayWallet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteInnerPayWallet.api_name = "api.admin.app.innerpay.wallets.control.dodeleteinnerpaywallet";
    return DoDeleteInnerPayWallet;
}());
exports.DoDeleteInnerPayWallet = DoDeleteInnerPayWallet;
var DoSetUsrPartnerTopPartner = /** @class */ (function () {
    function DoSetUsrPartnerTopPartner() {
    }
    DoSetUsrPartnerTopPartner.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetUsrPartnerTopPartner.api_name = "api.admin.aff.pprograms.usr.partners.control.dosetusrpartnertoppartner";
    return DoSetUsrPartnerTopPartner;
}());
exports.DoSetUsrPartnerTopPartner = DoSetUsrPartnerTopPartner;
var ListUserPlayerMessagesByUserPlayerIdGet = /** @class */ (function () {
    function ListUserPlayerMessagesByUserPlayerIdGet() {
    }
    ListUserPlayerMessagesByUserPlayerIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListUserPlayerMessagesByUserPlayerIdGet.api_name = "api.admin.users.players.messages.listuserplayermessagesbyuserplayeridget";
    return ListUserPlayerMessagesByUserPlayerIdGet;
}());
exports.ListUserPlayerMessagesByUserPlayerIdGet = ListUserPlayerMessagesByUserPlayerIdGet;
var DoDeleteCssClass = /** @class */ (function () {
    function DoDeleteCssClass() {
    }
    DoDeleteCssClass.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteCssClass.api_name = "api.admin.app.cssclass.dodeletecssclass";
    return DoDeleteCssClass;
}());
exports.DoDeleteCssClass = DoDeleteCssClass;
var DoEditPageData = /** @class */ (function () {
    function DoEditPageData() {
    }
    DoEditPageData.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPageData.api_name = "api.admin.cms.pages.category.control.doeditpagedata";
    return DoEditPageData;
}());
exports.DoEditPageData = DoEditPageData;
var DoEditPostRecord = /** @class */ (function () {
    function DoEditPostRecord() {
    }
    DoEditPostRecord.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPostRecord.api_name = "api.admin.cms.posts.records.control.doeditpostrecord";
    return DoEditPostRecord;
}());
exports.DoEditPostRecord = DoEditPostRecord;
var ListCmsTopGamesTypesGet = /** @class */ (function () {
    function ListCmsTopGamesTypesGet() {
    }
    ListCmsTopGamesTypesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListCmsTopGamesTypesGet.api_name = "api.admin.cms.top.games.listcmstopgamestypesget";
    return ListCmsTopGamesTypesGet;
}());
exports.ListCmsTopGamesTypesGet = ListCmsTopGamesTypesGet;
var DoEditFSRange = /** @class */ (function () {
    function DoEditFSRange() {
    }
    DoEditFSRange.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditFSRange.api_name = "api.admin.bonus.fsranges.control.doeditfsrange";
    return DoEditFSRange;
}());
exports.DoEditFSRange = DoEditFSRange;
var DoDeleteFSRangeGameSet = /** @class */ (function () {
    function DoDeleteFSRangeGameSet() {
    }
    DoDeleteFSRangeGameSet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteFSRangeGameSet.api_name = "api.admin.bonus.fsranges.gamesets.dodeletefsrangegameset";
    return DoDeleteFSRangeGameSet;
}());
exports.DoDeleteFSRangeGameSet = DoDeleteFSRangeGameSet;
var ListPlayersByBrandIdGetEx = /** @class */ (function () {
    function ListPlayersByBrandIdGetEx() {
    }
    ListPlayersByBrandIdGetEx.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPlayersByBrandIdGetEx.api_name = "api.admin.users.players.control.listplayersbybrandidgetex";
    return ListPlayersByBrandIdGetEx;
}());
exports.ListPlayersByBrandIdGetEx = ListPlayersByBrandIdGetEx;
var DoDeleteBrandPartnerForStat = /** @class */ (function () {
    function DoDeleteBrandPartnerForStat() {
    }
    DoDeleteBrandPartnerForStat.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandPartnerForStat.api_name = "api.admin.brands.partners.forstat.dodeletebrandpartnerforstat";
    return DoDeleteBrandPartnerForStat;
}());
exports.DoDeleteBrandPartnerForStat = DoDeleteBrandPartnerForStat;
var DoDeleteBrandPlayerLevel = /** @class */ (function () {
    function DoDeleteBrandPlayerLevel() {
    }
    DoDeleteBrandPlayerLevel.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandPlayerLevel.api_name = "api.admin.bonus.levels.control.dodeletebrandplayerlevel";
    return DoDeleteBrandPlayerLevel;
}());
exports.DoDeleteBrandPlayerLevel = DoDeleteBrandPlayerLevel;
var ListPProgramEmailSetTemplatesByPProgramIdGet = /** @class */ (function () {
    function ListPProgramEmailSetTemplatesByPProgramIdGet() {
    }
    ListPProgramEmailSetTemplatesByPProgramIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramEmailSetTemplatesByPProgramIdGet.api_name = "api.admin.aff.pprograms.email.set.templates.control.listpprogramemailsettemplatesbypprogramidget";
    return ListPProgramEmailSetTemplatesByPProgramIdGet;
}());
exports.ListPProgramEmailSetTemplatesByPProgramIdGet = ListPProgramEmailSetTemplatesByPProgramIdGet;
var ListAvailPromoCodesListByPromoCodePart = /** @class */ (function () {
    function ListAvailPromoCodesListByPromoCodePart() {
    }
    ListAvailPromoCodesListByPromoCodePart.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailPromoCodesListByPromoCodePart.api_name = "api.admin.support.promocode.listavailpromocodeslistbypromocodepart";
    return ListAvailPromoCodesListByPromoCodePart;
}());
exports.ListAvailPromoCodesListByPromoCodePart = ListAvailPromoCodesListByPromoCodePart;
var DoSetAppTrustZoneOrderNumber = /** @class */ (function () {
    function DoSetAppTrustZoneOrderNumber() {
    }
    DoSetAppTrustZoneOrderNumber.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetAppTrustZoneOrderNumber.api_name = "api.admin.app.trust.zones.dosetapptrustzoneordernumber";
    return DoSetAppTrustZoneOrderNumber;
}());
exports.DoSetAppTrustZoneOrderNumber = DoSetAppTrustZoneOrderNumber;
var DoSetPlayerBonusStatusCancelled = /** @class */ (function () {
    function DoSetPlayerBonusStatusCancelled() {
    }
    DoSetPlayerBonusStatusCancelled.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPlayerBonusStatusCancelled.api_name = "api.admin.users.players.bonuses.control.dosetplayerbonusstatuscancelled";
    return DoSetPlayerBonusStatusCancelled;
}());
exports.DoSetPlayerBonusStatusCancelled = DoSetPlayerBonusStatusCancelled;
var DoDeleteUsrPartnerAuthLog = /** @class */ (function () {
    function DoDeleteUsrPartnerAuthLog() {
    }
    DoDeleteUsrPartnerAuthLog.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteUsrPartnerAuthLog.api_name = "api.admin.aff.pprograms.usr.partners.authlogs.dodeleteusrpartnerauthlog";
    return DoDeleteUsrPartnerAuthLog;
}());
exports.DoDeleteUsrPartnerAuthLog = DoDeleteUsrPartnerAuthLog;
var DoDeleteWinnerTop = /** @class */ (function () {
    function DoDeleteWinnerTop() {
    }
    DoDeleteWinnerTop.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteWinnerTop.api_name = "api.admin.cms.winners.top.dodeletewinnertop";
    return DoDeleteWinnerTop;
}());
exports.DoDeleteWinnerTop = DoDeleteWinnerTop;
var DoCheckBrandMessageSetTemplate = /** @class */ (function () {
    function DoCheckBrandMessageSetTemplate() {
    }
    DoCheckBrandMessageSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCheckBrandMessageSetTemplate.api_name = "api.admin.brands.templates.control.message.set.control.docheckbrandmessagesettemplate";
    return DoCheckBrandMessageSetTemplate;
}());
exports.DoCheckBrandMessageSetTemplate = DoCheckBrandMessageSetTemplate;
var ListBonusWithdrawalBehaviorTypesAvailGet = /** @class */ (function () {
    function ListBonusWithdrawalBehaviorTypesAvailGet() {
    }
    ListBonusWithdrawalBehaviorTypesAvailGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusWithdrawalBehaviorTypesAvailGet.api_name = "api.admin.bonus.templates.control.listbonuswithdrawalbehaviortypesavailget";
    return ListBonusWithdrawalBehaviorTypesAvailGet;
}());
exports.ListBonusWithdrawalBehaviorTypesAvailGet = ListBonusWithdrawalBehaviorTypesAvailGet;
var ListTournamentBotsByTournamentIdGet = /** @class */ (function () {
    function ListTournamentBotsByTournamentIdGet() {
    }
    ListTournamentBotsByTournamentIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTournamentBotsByTournamentIdGet.api_name = "api.admin.bonus.tournaments.bots.control.listtournamentbotsbytournamentidget";
    return ListTournamentBotsByTournamentIdGet;
}());
exports.ListTournamentBotsByTournamentIdGet = ListTournamentBotsByTournamentIdGet;
var DoAddBrand = /** @class */ (function () {
    function DoAddBrand() {
    }
    DoAddBrand.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrand.api_name = "api.admin.brands.control.doaddbrand";
    return DoAddBrand;
}());
exports.DoAddBrand = DoAddBrand;
var DoAddInnerPayWallet = /** @class */ (function () {
    function DoAddInnerPayWallet() {
    }
    DoAddInnerPayWallet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddInnerPayWallet.api_name = "api.admin.app.innerpay.wallets.control.doaddinnerpaywallet";
    return DoAddInnerPayWallet;
}());
exports.DoAddInnerPayWallet = DoAddInnerPayWallet;
var DoDeletePProgramPartnerTracker = /** @class */ (function () {
    function DoDeletePProgramPartnerTracker() {
    }
    DoDeletePProgramPartnerTracker.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramPartnerTracker.api_name = "api.admin.aff.pprograms.usr.partners.trackers.dodeletepprogrampartnertracker";
    return DoDeletePProgramPartnerTracker;
}());
exports.DoDeletePProgramPartnerTracker = DoDeletePProgramPartnerTracker;
var DoDeleteCmsTopGame = /** @class */ (function () {
    function DoDeleteCmsTopGame() {
    }
    DoDeleteCmsTopGame.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteCmsTopGame.api_name = "api.admin.cms.top.games.dodeletecmstopgame";
    return DoDeleteCmsTopGame;
}());
exports.DoDeleteCmsTopGame = DoDeleteCmsTopGame;
var ListPromoTemplatesByPProgramIdGet = /** @class */ (function () {
    function ListPromoTemplatesByPProgramIdGet() {
    }
    ListPromoTemplatesByPProgramIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPromoTemplatesByPProgramIdGet.api_name = "api.admin.aff.pprograms.pub.promo.templates.listpromotemplatesbypprogramidget";
    return ListPromoTemplatesByPProgramIdGet;
}());
exports.ListPromoTemplatesByPProgramIdGet = ListPromoTemplatesByPProgramIdGet;
var DoAddBonusTemplateLocale = /** @class */ (function () {
    function DoAddBonusTemplateLocale() {
    }
    DoAddBonusTemplateLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusTemplateLocale.api_name = "api.admin.bonus.templates.locales.doaddbonustemplatelocale";
    return DoAddBonusTemplateLocale;
}());
exports.DoAddBonusTemplateLocale = DoAddBonusTemplateLocale;
var DoSetBrandAutoWithdrawIsLocked = /** @class */ (function () {
    function DoSetBrandAutoWithdrawIsLocked() {
    }
    DoSetBrandAutoWithdrawIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBrandAutoWithdrawIsLocked.api_name = "api.admin.brand.auto.withdraw.dosetbrandautowithdrawislocked";
    return DoSetBrandAutoWithdrawIsLocked;
}());
exports.DoSetBrandAutoWithdrawIsLocked = DoSetBrandAutoWithdrawIsLocked;
var DoEditBrandAppCurrency = /** @class */ (function () {
    function DoEditBrandAppCurrency() {
    }
    DoEditBrandAppCurrency.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandAppCurrency.api_name = "api.admin.brands.app.currency.doeditbrandappcurrency";
    return DoEditBrandAppCurrency;
}());
exports.DoEditBrandAppCurrency = DoEditBrandAppCurrency;
var DoDeleteSmsLogListItem = /** @class */ (function () {
    function DoDeleteSmsLogListItem() {
    }
    DoDeleteSmsLogListItem.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteSmsLogListItem.api_name = "api.admin.users.players.logs.sms.dodeletesmsloglistitem";
    return DoDeleteSmsLogListItem;
}());
exports.DoDeleteSmsLogListItem = DoDeleteSmsLogListItem;
var DoEditBrandSmsSetTemplate = /** @class */ (function () {
    function DoEditBrandSmsSetTemplate() {
    }
    DoEditBrandSmsSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandSmsSetTemplate.api_name = "api.admin.brands.templates.control.sms.set.control.doeditbrandsmssettemplate";
    return DoEditBrandSmsSetTemplate;
}());
exports.DoEditBrandSmsSetTemplate = DoEditBrandSmsSetTemplate;
var ListTournamentPrizesByTournamentIdGet = /** @class */ (function () {
    function ListTournamentPrizesByTournamentIdGet() {
    }
    ListTournamentPrizesByTournamentIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListTournamentPrizesByTournamentIdGet.api_name = "api.admin.bonus.tournaments.prizes.listtournamentprizesbytournamentidget";
    return ListTournamentPrizesByTournamentIdGet;
}());
exports.ListTournamentPrizesByTournamentIdGet = ListTournamentPrizesByTournamentIdGet;
var DoDeletePProgramNewsLocale = /** @class */ (function () {
    function DoDeletePProgramNewsLocale() {
    }
    DoDeletePProgramNewsLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramNewsLocale.api_name = "api.admin.aff.pprograms.news.locales.dodeletepprogramnewslocale";
    return DoDeletePProgramNewsLocale;
}());
exports.DoDeletePProgramNewsLocale = DoDeletePProgramNewsLocale;
var DoEditBrandBannerCountry = /** @class */ (function () {
    function DoEditBrandBannerCountry() {
    }
    DoEditBrandBannerCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandBannerCountry.api_name = "api.admin.aff.brands.banners.country.doeditbrandbannercountry";
    return DoEditBrandBannerCountry;
}());
exports.DoEditBrandBannerCountry = DoEditBrandBannerCountry;
var ListAppTrustZonesGet = /** @class */ (function () {
    function ListAppTrustZonesGet() {
    }
    ListAppTrustZonesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAppTrustZonesGet.api_name = "api.admin.app.trust.zones.listapptrustzonesget";
    return ListAppTrustZonesGet;
}());
exports.ListAppTrustZonesGet = ListAppTrustZonesGet;
var ListBrandLandingCountryByLandingIdGet = /** @class */ (function () {
    function ListBrandLandingCountryByLandingIdGet() {
    }
    ListBrandLandingCountryByLandingIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandLandingCountryByLandingIdGet.api_name = "api.admin.aff.brands.landings.country.listbrandlandingcountrybylandingidget";
    return ListBrandLandingCountryByLandingIdGet;
}());
exports.ListBrandLandingCountryByLandingIdGet = ListBrandLandingCountryByLandingIdGet;
var DoAddInnerPayService = /** @class */ (function () {
    function DoAddInnerPayService() {
    }
    DoAddInnerPayService.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddInnerPayService.api_name = "api.admin.app.innerpay.services.control.doaddinnerpayservice";
    return DoAddInnerPayService;
}());
exports.DoAddInnerPayService = DoAddInnerPayService;
var DoSetBonusTemplateIsLocked = /** @class */ (function () {
    function DoSetBonusTemplateIsLocked() {
    }
    DoSetBonusTemplateIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBonusTemplateIsLocked.api_name = "api.admin.bonus.templates.control.dosetbonustemplateislocked";
    return DoSetBonusTemplateIsLocked;
}());
exports.DoSetBonusTemplateIsLocked = DoSetBonusTemplateIsLocked;
var DoEditBrandEmailSetTemplateImage = /** @class */ (function () {
    function DoEditBrandEmailSetTemplateImage() {
    }
    DoEditBrandEmailSetTemplateImage.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandEmailSetTemplateImage.api_name = "api.admin.brands.templates.control.email.set.images.doeditbrandemailsettemplateimage";
    return DoEditBrandEmailSetTemplateImage;
}());
exports.DoEditBrandEmailSetTemplateImage = DoEditBrandEmailSetTemplateImage;
var ListBonusTournamentGameLogsByTournamentSessionIdGet = /** @class */ (function () {
    function ListBonusTournamentGameLogsByTournamentSessionIdGet() {
    }
    ListBonusTournamentGameLogsByTournamentSessionIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBonusTournamentGameLogsByTournamentSessionIdGet.api_name = "api.admin.bonus.tournaments.sessions.gamelogs.listbonustournamentgamelogsbytournamentsessionidget";
    return ListBonusTournamentGameLogsByTournamentSessionIdGet;
}());
exports.ListBonusTournamentGameLogsByTournamentSessionIdGet = ListBonusTournamentGameLogsByTournamentSessionIdGet;
var DoAddBonusPromocodeTemplateLocale = /** @class */ (function () {
    function DoAddBonusPromocodeTemplateLocale() {
    }
    DoAddBonusPromocodeTemplateLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusPromocodeTemplateLocale.api_name = "api.admin.bonus.promocodes.templates.locales.doaddbonuspromocodetemplatelocale";
    return DoAddBonusPromocodeTemplateLocale;
}());
exports.DoAddBonusPromocodeTemplateLocale = DoAddBonusPromocodeTemplateLocale;
var ListBrandEmailSetTemplatesByBrandIdGet = /** @class */ (function () {
    function ListBrandEmailSetTemplatesByBrandIdGet() {
    }
    ListBrandEmailSetTemplatesByBrandIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandEmailSetTemplatesByBrandIdGet.api_name = "api.admin.brands.templates.control.email.set.control.listbrandemailsettemplatesbybrandidget";
    return ListBrandEmailSetTemplatesByBrandIdGet;
}());
exports.ListBrandEmailSetTemplatesByBrandIdGet = ListBrandEmailSetTemplatesByBrandIdGet;
var DoAddBonusEventBinding = /** @class */ (function () {
    function DoAddBonusEventBinding() {
    }
    DoAddBonusEventBinding.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusEventBinding.api_name = "api.admin.bonus.events.bindings.control.doaddbonuseventbinding";
    return DoAddBonusEventBinding;
}());
exports.DoAddBonusEventBinding = DoAddBonusEventBinding;
var DoEditBonusEventBindingBonus = /** @class */ (function () {
    function DoEditBonusEventBindingBonus() {
    }
    DoEditBonusEventBindingBonus.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusEventBindingBonus.api_name = "api.admin.bonus.events.bindings.bonuses.doeditbonuseventbindingbonus";
    return DoEditBonusEventBindingBonus;
}());
exports.DoEditBonusEventBindingBonus = DoEditBonusEventBindingBonus;
var DoManualPlayerDepositCreate = /** @class */ (function () {
    function DoManualPlayerDepositCreate() {
    }
    DoManualPlayerDepositCreate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoManualPlayerDepositCreate.api_name = "api.admin.users.players.finance.domanualplayerdepositcreate";
    return DoManualPlayerDepositCreate;
}());
exports.DoManualPlayerDepositCreate = DoManualPlayerDepositCreate;
var DoSetCssClassIsDeprecated = /** @class */ (function () {
    function DoSetCssClassIsDeprecated() {
    }
    DoSetCssClassIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetCssClassIsDeprecated.api_name = "api.admin.app.cssclass.dosetcssclassisdeprecated";
    return DoSetCssClassIsDeprecated;
}());
exports.DoSetCssClassIsDeprecated = DoSetCssClassIsDeprecated;
var DoEditPProgramNewsLocale = /** @class */ (function () {
    function DoEditPProgramNewsLocale() {
    }
    DoEditPProgramNewsLocale.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgramNewsLocale.api_name = "api.admin.aff.pprograms.news.locales.doeditpprogramnewslocale";
    return DoEditPProgramNewsLocale;
}());
exports.DoEditPProgramNewsLocale = DoEditPProgramNewsLocale;
var DoDeleteBrandBlackIp = /** @class */ (function () {
    function DoDeleteBrandBlackIp() {
    }
    DoDeleteBrandBlackIp.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandBlackIp.api_name = "api.admin.brand.black.ip.dodeletebrandblackip";
    return DoDeleteBrandBlackIp;
}());
exports.DoDeleteBrandBlackIp = DoDeleteBrandBlackIp;
var ListAllowedLanguagesGet = /** @class */ (function () {
    function ListAllowedLanguagesGet() {
    }
    ListAllowedLanguagesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedLanguagesGet.api_name = "api.admin.app.language.listallowedlanguagesget";
    return ListAllowedLanguagesGet;
}());
exports.ListAllowedLanguagesGet = ListAllowedLanguagesGet;
var ListAllowedBonusTemplatesByAppCurrencyIdGet = /** @class */ (function () {
    function ListAllowedBonusTemplatesByAppCurrencyIdGet() {
    }
    ListAllowedBonusTemplatesByAppCurrencyIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedBonusTemplatesByAppCurrencyIdGet.api_name = "api.admin.bonus.templates.control.listallowedbonustemplatesbyappcurrencyidget";
    return ListAllowedBonusTemplatesByAppCurrencyIdGet;
}());
exports.ListAllowedBonusTemplatesByAppCurrencyIdGet = ListAllowedBonusTemplatesByAppCurrencyIdGet;
var ListBrandAppPayoutKeyValsGet = /** @class */ (function () {
    function ListBrandAppPayoutKeyValsGet() {
    }
    ListBrandAppPayoutKeyValsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListBrandAppPayoutKeyValsGet.api_name = "api.admin.brands.partners.payout.keyval.listbrandapppayoutkeyvalsget";
    return ListBrandAppPayoutKeyValsGet;
}());
exports.ListBrandAppPayoutKeyValsGet = ListBrandAppPayoutKeyValsGet;
var DoEditPlayer = /** @class */ (function () {
    function DoEditPlayer() {
    }
    DoEditPlayer.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPlayer.api_name = "api.admin.users.players.control.doeditplayer";
    return DoEditPlayer;
}());
exports.DoEditPlayer = DoEditPlayer;
var DoDeleteUserPlayerTag = /** @class */ (function () {
    function DoDeleteUserPlayerTag() {
    }
    DoDeleteUserPlayerTag.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteUserPlayerTag.api_name = "api.admin.users.players.tags.dodeleteuserplayertag";
    return DoDeleteUserPlayerTag;
}());
exports.DoDeleteUserPlayerTag = DoDeleteUserPlayerTag;
var DoDeleteBrandAutoWithdraw = /** @class */ (function () {
    function DoDeleteBrandAutoWithdraw() {
    }
    DoDeleteBrandAutoWithdraw.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandAutoWithdraw.api_name = "api.admin.brand.auto.withdraw.dodeletebrandautowithdraw";
    return DoDeleteBrandAutoWithdraw;
}());
exports.DoDeleteBrandAutoWithdraw = DoDeleteBrandAutoWithdraw;
var DoEditPProgramNews = /** @class */ (function () {
    function DoEditPProgramNews() {
    }
    DoEditPProgramNews.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditPProgramNews.api_name = "api.admin.aff.pprograms.news.control.doeditpprogramnews";
    return DoEditPProgramNews;
}());
exports.DoEditPProgramNews = DoEditPProgramNews;
var DoDeletePProgramAppCurrency = /** @class */ (function () {
    function DoDeletePProgramAppCurrency() {
    }
    DoDeletePProgramAppCurrency.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePProgramAppCurrency.api_name = "api.admin.aff.pprograms.app.currency.dodeletepprogramappcurrency";
    return DoDeletePProgramAppCurrency;
}());
exports.DoDeletePProgramAppCurrency = DoDeletePProgramAppCurrency;
var DoAddCountry = /** @class */ (function () {
    function DoAddCountry() {
    }
    DoAddCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddCountry.api_name = "api.admin.app.country.control.doaddcountry";
    return DoAddCountry;
}());
exports.DoAddCountry = DoAddCountry;
var ListAvailTrustZonesGet = /** @class */ (function () {
    function ListAvailTrustZonesGet() {
    }
    ListAvailTrustZonesGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAvailTrustZonesGet.api_name = "api.admin.app.trust.zones.listavailtrustzonesget";
    return ListAvailTrustZonesGet;
}());
exports.ListAvailTrustZonesGet = ListAvailTrustZonesGet;
var ListAllowedGwsGameProviderByGrantAdminIdGet = /** @class */ (function () {
    function ListAllowedGwsGameProviderByGrantAdminIdGet() {
    }
    ListAllowedGwsGameProviderByGrantAdminIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedGwsGameProviderByGrantAdminIdGet.api_name = "api.admin.access.gws.gameproviders.listallowedgwsgameproviderbygrantadminidget";
    return ListAllowedGwsGameProviderByGrantAdminIdGet;
}());
exports.ListAllowedGwsGameProviderByGrantAdminIdGet = ListAllowedGwsGameProviderByGrantAdminIdGet;
var DoAddBonusPlayerLevelBetAmount = /** @class */ (function () {
    function DoAddBonusPlayerLevelBetAmount() {
    }
    DoAddBonusPlayerLevelBetAmount.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBonusPlayerLevelBetAmount.api_name = "api.admin.bonus.levels.betamounts.doaddbonusplayerlevelbetamount";
    return DoAddBonusPlayerLevelBetAmount;
}());
exports.DoAddBonusPlayerLevelBetAmount = DoAddBonusPlayerLevelBetAmount;
var DoDeletePartnerReconciliation = /** @class */ (function () {
    function DoDeletePartnerReconciliation() {
    }
    DoDeletePartnerReconciliation.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeletePartnerReconciliation.api_name = "api.admin.aff.pprograms.reconciliations.control.dodeletepartnerreconciliation";
    return DoDeletePartnerReconciliation;
}());
exports.DoDeletePartnerReconciliation = DoDeletePartnerReconciliation;
var ListCmsBrandsContentDirectoryAllowedGet = /** @class */ (function () {
    function ListCmsBrandsContentDirectoryAllowedGet() {
    }
    ListCmsBrandsContentDirectoryAllowedGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListCmsBrandsContentDirectoryAllowedGet.api_name = "api.admin.cms.brands.content.listcmsbrandscontentdirectoryallowedget";
    return ListCmsBrandsContentDirectoryAllowedGet;
}());
exports.ListCmsBrandsContentDirectoryAllowedGet = ListCmsBrandsContentDirectoryAllowedGet;
var DoDeleteCmsGameSet = /** @class */ (function () {
    function DoDeleteCmsGameSet() {
    }
    DoDeleteCmsGameSet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteCmsGameSet.api_name = "api.admin.cms.gameset.control.dodeletecmsgameset";
    return DoDeleteCmsGameSet;
}());
exports.DoDeleteCmsGameSet = DoDeleteCmsGameSet;
var ListAllowedCmsGameSetsGet = /** @class */ (function () {
    function ListAllowedCmsGameSetsGet() {
    }
    ListAllowedCmsGameSetsGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListAllowedCmsGameSetsGet.api_name = "api.admin.cms.gameset.control.listallowedcmsgamesetsget";
    return ListAllowedCmsGameSetsGet;
}());
exports.ListAllowedCmsGameSetsGet = ListAllowedCmsGameSetsGet;
var DoSetAdminIsLocked = /** @class */ (function () {
    function DoSetAdminIsLocked() {
    }
    DoSetAdminIsLocked.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetAdminIsLocked.api_name = "api.admin.users.admins.dosetadminislocked";
    return DoSetAdminIsLocked;
}());
exports.DoSetAdminIsLocked = DoSetAdminIsLocked;
var DoEditBonusTemplateConfigSegmentItem = /** @class */ (function () {
    function DoEditBonusTemplateConfigSegmentItem() {
    }
    DoEditBonusTemplateConfigSegmentItem.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBonusTemplateConfigSegmentItem.api_name = "api.admin.bonus.templates.config.segmentations.doeditbonustemplateconfigsegmentitem";
    return DoEditBonusTemplateConfigSegmentItem;
}());
exports.DoEditBonusTemplateConfigSegmentItem = DoEditBonusTemplateConfigSegmentItem;
var DetailsWagerCashBackBonusTemplateConfigGet = /** @class */ (function () {
    function DetailsWagerCashBackBonusTemplateConfigGet() {
    }
    DetailsWagerCashBackBonusTemplateConfigGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DetailsWagerCashBackBonusTemplateConfigGet.api_name = "api.admin.bonus.templates.config.wager_cashback.detailswagercashbackbonustemplateconfigget";
    return DetailsWagerCashBackBonusTemplateConfigGet;
}());
exports.DetailsWagerCashBackBonusTemplateConfigGet = DetailsWagerCashBackBonusTemplateConfigGet;
var DoEditBrandMessageSetTemplateData = /** @class */ (function () {
    function DoEditBrandMessageSetTemplateData() {
    }
    DoEditBrandMessageSetTemplateData.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditBrandMessageSetTemplateData.api_name = "api.admin.brands.templates.control.message.set.control.doeditbrandmessagesettemplatedata";
    return DoEditBrandMessageSetTemplateData;
}());
exports.DoEditBrandMessageSetTemplateData = DoEditBrandMessageSetTemplateData;
var DoSetPProgramPublicOfferIsDeprecated = /** @class */ (function () {
    function DoSetPProgramPublicOfferIsDeprecated() {
    }
    DoSetPProgramPublicOfferIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetPProgramPublicOfferIsDeprecated.api_name = "api.admin.aff.pprograms.pub.offers.dosetpprogrampublicofferisdeprecated";
    return DoSetPProgramPublicOfferIsDeprecated;
}());
exports.DoSetPProgramPublicOfferIsDeprecated = DoSetPProgramPublicOfferIsDeprecated;
var ListJackpotTransfersByJpIdAndDateRangeGet = /** @class */ (function () {
    function ListJackpotTransfersByJpIdAndDateRangeGet() {
    }
    ListJackpotTransfersByJpIdAndDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListJackpotTransfersByJpIdAndDateRangeGet.api_name = "api.admin.bonus.jackpots.transfers.listjackpottransfersbyjpidanddaterangeget";
    return ListJackpotTransfersByJpIdAndDateRangeGet;
}());
exports.ListJackpotTransfersByJpIdAndDateRangeGet = ListJackpotTransfersByJpIdAndDateRangeGet;
var DoWithdrawPlayerTotalBetAmtByPlayerBonusId = /** @class */ (function () {
    function DoWithdrawPlayerTotalBetAmtByPlayerBonusId() {
    }
    DoWithdrawPlayerTotalBetAmtByPlayerBonusId.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoWithdrawPlayerTotalBetAmtByPlayerBonusId.api_name = "api.admin.users.players.bonuses.control.dowithdrawplayertotalbetamtbyplayerbonusid";
    return DoWithdrawPlayerTotalBetAmtByPlayerBonusId;
}());
exports.DoWithdrawPlayerTotalBetAmtByPlayerBonusId = DoWithdrawPlayerTotalBetAmtByPlayerBonusId;
var DoCheckBrandSmsSetTemplate = /** @class */ (function () {
    function DoCheckBrandSmsSetTemplate() {
    }
    DoCheckBrandSmsSetTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoCheckBrandSmsSetTemplate.api_name = "api.admin.brands.templates.control.sms.set.control.docheckbrandsmssettemplate";
    return DoCheckBrandSmsSetTemplate;
}());
exports.DoCheckBrandSmsSetTemplate = DoCheckBrandSmsSetTemplate;
var DoAddFSRangeGameSet = /** @class */ (function () {
    function DoAddFSRangeGameSet() {
    }
    DoAddFSRangeGameSet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddFSRangeGameSet.api_name = "api.admin.bonus.fsranges.gamesets.doaddfsrangegameset";
    return DoAddFSRangeGameSet;
}());
exports.DoAddFSRangeGameSet = DoAddFSRangeGameSet;
var DoAddInnerPayServicePayWay = /** @class */ (function () {
    function DoAddInnerPayServicePayWay() {
    }
    DoAddInnerPayServicePayWay.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddInnerPayServicePayWay.api_name = "api.admin.app.innerpay.services.payways.doaddinnerpayservicepayway";
    return DoAddInnerPayServicePayWay;
}());
exports.DoAddInnerPayServicePayWay = DoAddInnerPayServicePayWay;
var DoSetBonusTemplateIsDeprecated = /** @class */ (function () {
    function DoSetBonusTemplateIsDeprecated() {
    }
    DoSetBonusTemplateIsDeprecated.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBonusTemplateIsDeprecated.api_name = "api.admin.bonus.templates.control.dosetbonustemplateisdeprecated";
    return DoSetBonusTemplateIsDeprecated;
}());
exports.DoSetBonusTemplateIsDeprecated = DoSetBonusTemplateIsDeprecated;
var DoAddBrandBlackIp = /** @class */ (function () {
    function DoAddBrandBlackIp() {
    }
    DoAddBrandBlackIp.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoAddBrandBlackIp.api_name = "api.admin.brand.black.ip.doaddbrandblackip";
    return DoAddBrandBlackIp;
}());
exports.DoAddBrandBlackIp = DoAddBrandBlackIp;
var ListDepositsByUsrPlayerIdAndDateRangeGet = /** @class */ (function () {
    function ListDepositsByUsrPlayerIdAndDateRangeGet() {
    }
    ListDepositsByUsrPlayerIdAndDateRangeGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListDepositsByUsrPlayerIdAndDateRangeGet.api_name = "api.admin.users.players.finance.listdepositsbyusrplayeridanddaterangeget";
    return ListDepositsByUsrPlayerIdAndDateRangeGet;
}());
exports.ListDepositsByUsrPlayerIdAndDateRangeGet = ListDepositsByUsrPlayerIdAndDateRangeGet;
var ListPProgramPublicOffersByPProgramIdGet = /** @class */ (function () {
    function ListPProgramPublicOffersByPProgramIdGet() {
    }
    ListPProgramPublicOffersByPProgramIdGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListPProgramPublicOffersByPProgramIdGet.api_name = "api.admin.aff.pprograms.pub.offers.listpprogrampublicoffersbypprogramidget";
    return ListPProgramPublicOffersByPProgramIdGet;
}());
exports.ListPProgramPublicOffersByPProgramIdGet = ListPProgramPublicOffersByPProgramIdGet;
var DoDeleteBrandAppPayout = /** @class */ (function () {
    function DoDeleteBrandAppPayout() {
    }
    DoDeleteBrandAppPayout.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandAppPayout.api_name = "api.admin.brands.partners.payout.control.dodeletebrandapppayout";
    return DoDeleteBrandAppPayout;
}());
exports.DoDeleteBrandAppPayout = DoDeleteBrandAppPayout;
var ListDashBoardBrandsStatGet = /** @class */ (function () {
    function ListDashBoardBrandsStatGet() {
    }
    ListDashBoardBrandsStatGet.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    ListDashBoardBrandsStatGet.api_name = "api.admin.dashboard.listdashboardbrandsstatget";
    return ListDashBoardBrandsStatGet;
}());
exports.ListDashBoardBrandsStatGet = ListDashBoardBrandsStatGet;
var DoDeleteCapchaTemplate = /** @class */ (function () {
    function DoDeleteCapchaTemplate() {
    }
    DoDeleteCapchaTemplate.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteCapchaTemplate.api_name = "api.admin.app.capchas.templates.control.dodeletecapchatemplate";
    return DoDeleteCapchaTemplate;
}());
exports.DoDeleteCapchaTemplate = DoDeleteCapchaTemplate;
var DoDeleteFSRange = /** @class */ (function () {
    function DoDeleteFSRange() {
    }
    DoDeleteFSRange.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteFSRange.api_name = "api.admin.bonus.fsranges.control.dodeletefsrange";
    return DoDeleteFSRange;
}());
exports.DoDeleteFSRange = DoDeleteFSRange;
var DoEditCountry = /** @class */ (function () {
    function DoEditCountry() {
    }
    DoEditCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoEditCountry.api_name = "api.admin.app.country.control.doeditcountry";
    return DoEditCountry;
}());
exports.DoEditCountry = DoEditCountry;
var DoDeleteBrandBannerCountry = /** @class */ (function () {
    function DoDeleteBrandBannerCountry() {
    }
    DoDeleteBrandBannerCountry.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoDeleteBrandBannerCountry.api_name = "api.admin.aff.brands.banners.country.dodeletebrandbannercountry";
    return DoDeleteBrandBannerCountry;
}());
exports.DoDeleteBrandBannerCountry = DoDeleteBrandBannerCountry;
var DoSetBonusPlayerLevelOfferPriority = /** @class */ (function () {
    function DoSetBonusPlayerLevelOfferPriority() {
    }
    DoSetBonusPlayerLevelOfferPriority.exec = function (req, onSuccess, onError) {
        req.api = this.api_name;
        req.lang = webTransport_1.webTransport.getLang();
        webTransport_1.webTransport.execAction(req, onSuccess, onError);
    };
    DoSetBonusPlayerLevelOfferPriority.api_name = "api.admin.bonus.levels.offers.dosetbonusplayerlevelofferpriority";
    return DoSetBonusPlayerLevelOfferPriority;
}());
exports.DoSetBonusPlayerLevelOfferPriority = DoSetBonusPlayerLevelOfferPriority;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/api/webAApi.ts
// module id = 5
// module chunks = 0